(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire5d92"];
var parcelRegister = parcelRequire.register;
parcelRegister("9frE0", function(module, exports) {

$parcel$export(module.exports, "QuizCollection", function () { return (parcelRequire("dcsJ5")).QuizCollection; });

var $dcsJ5 = parcelRequire("dcsJ5");

});
parcelRegister("dcsJ5", function(module, exports) {

$parcel$export(module.exports, "useQuizContext", function () { return $91ccc2532441fceb$export$3467042c26dd6dce; });
$parcel$export(module.exports, "QuizCollection", function () { return $91ccc2532441fceb$export$5b3d1daad675ae5b; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $a4Y4S = parcelRequire("a4Y4S");

var $8mtd7 = parcelRequire("8mtd7");

var $bpC5m = parcelRequire("bpC5m");

var $7mAg3 = parcelRequire("7mAg3");
const $91ccc2532441fceb$export$29b8d8cc58af37a0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).createContext({});
const $91ccc2532441fceb$export$3467042c26dd6dce = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useContext($91ccc2532441fceb$export$29b8d8cc58af37a0);
const $91ccc2532441fceb$export$5b3d1daad675ae5b = ({ json: json })=>{
    const { quiz: quiz, setSearchState: setSearchState } = (0, $7mAg3.usePLPContext)();
    //Context Functions
    const [currentAnswers, setCurrentAnswers] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    const [hasSubmitted, setHasSubmitted] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    //Quiz Functions
    const handleQuizReset = async ()=>{
        // setFadeEffect('fadeout')
        setCurrentAnswers([]);
        setCurrentStep(0);
        quiz.setQuizAnswers([]);
        await delay(50);
    // setFadeEffect('fadein')
    };
    const title = json.title;
    const questions = json.questions;
    const [currentStep, setCurrentStep] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(0);
    const totalSteps = json.questions.length - 1;
    /* Push to GA DataLayer */ const handleDataLayer = (category, action)=>{
        console.log({
            "event": "QuizCollection",
            "Quiz_Category": category,
            "Quiz_Action": action,
            "Quiz_Pathname": window.location.pathname,
            "Quiz_Results": currentAnswers,
            "Quiz_Email_Registered": hasSubmitted
        });
        dataLayer.push({
            "event": "QuizCollection",
            "Quiz_Category": category,
            "Quiz_Action": action,
            "Quiz_Pathname": window.location.pathname,
            "Quiz_Results": currentAnswers,
            "Quiz_Email_Registered": hasSubmitted
        });
    };
    const [fadeEffect, setFadeEffect] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("fadeout");
    const delay = (ms)=>new Promise((res)=>setTimeout(res, ms));
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        delay(50);
        setFadeEffect("fadein");
    }, []);
    const nextStep = async ()=>{
        // setFadeEffect('fadeout')
        await delay(300);
        console.log({
            currentAnswers: currentAnswers
        });
        if (currentStep <= totalSteps) {
            quiz.setQuizAnswers(currentAnswers);
            setCurrentStep(currentStep + 1);
        }
        if (currentStep == totalSteps) {
            quiz.setQuizAnswers(currentAnswers);
            let quizData = [];
            quiz.quizAnswers.filter((data)=>data?.facet).forEach((data)=>{
                quizData[data.facet] = data.answers;
            });
            console.log(quizData);
            setSearchState((prev)=>({
                    ...prev,
                    refinementList: quizData
                }));
        }
        // await delay(50)
        // setFadeEffect('fadein')
        handleDataLayer("Quiz_Navigation", "Forward");
    };
    const prevousStep = async ()=>{
        // setFadeEffect('fadeout')
        // await delay(300) 
        // quiz.setQuizAnswers([])
        if (currentStep != 0) setCurrentStep(currentStep - 1);
        await delay(50);
        // setFadeEffect('fadein')
        handleDataLayer("Quiz_Navigation", "Backward");
    };
    return /*#__PURE__*/ (0, $drmv2.jsx)($91ccc2532441fceb$export$29b8d8cc58af37a0.Provider, {
        value: {
            quizFunctions: {
                title: title,
                currentAnswers: currentAnswers,
                setCurrentAnswers: setCurrentAnswers,
                nextStep: nextStep,
                prevousStep: prevousStep,
                currentStep: currentStep,
                totalSteps: totalSteps,
                setHasSubmitted: setHasSubmitted,
                handleQuizReset: handleQuizReset,
                fadeEffect: fadeEffect,
                handleDataLayer: handleDataLayer
            }
        },
        children: /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
            children: [
                questions.map((data, index)=>/*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        children: index == currentStep && /*#__PURE__*/ (0, $drmv2.jsx)((0, $a4Y4S.Question), {
                            data: data
                        }, index)
                    }, index)),
                /*#__PURE__*/ (0, $drmv2.jsx)("br", {}),
                questions[currentStep] == undefined && !hasSubmitted && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                    children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $8mtd7.CustomerForm), {
                        list_ID: json.list_ID
                    })
                }),
                questions[currentStep] == undefined && quiz.quizSubmittedOrSkipped && /*#__PURE__*/ (0, $drmv2.jsx)((0, $bpC5m.Results), {})
            ]
        })
    });
};

});
parcelRegister("a4Y4S", function(module, exports) {

$parcel$export(module.exports, "Question", function () { return $c2c5a0d1ff9e8f85$export$38435c7d2fecd2f; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $dcsJ5 = parcelRequire("dcsJ5");
const $c2c5a0d1ff9e8f85$export$38435c7d2fecd2f = ({ data: data })=>{
    //Global quiz functions
    const { quizFunctions: quizFunctions } = (0, $dcsJ5.useQuizContext)();
    const question = data.question;
    const image = data.image;
    const filter = data.filter;
    const facet = data?.facet ? data.facet : false;
    const answers = data.answers;
    const multiple_choice = data?.multiple_choice;
    const [filterString, setFilterString] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("");
    //Check for preselected answers when quiz is progressed backwards
    let preselectedAnswers = quizFunctions?.currentAnswers.find((q)=>q.question.includes(question)) ? quizFunctions?.currentAnswers.find((q)=>q.question.includes(question))?.answers : [];
    const [answersSelected, setanswerSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(preselectedAnswers);
    let totalStepsArray = new Array(quizFunctions.totalSteps + 1).fill("");
    const handleClick = (e)=>{
        if (!multiple_choice) {
            document.querySelectorAll("input:checked").forEach((input)=>{
                if (input != e.target) {
                    input.checked = false;
                    input.disabled = false;
                }
            });
            e.target.disabled = true;
            setanswerSelected([
                e.target.value
            ]);
        } else e.target.checked == true ? setanswerSelected([
            ...answersSelected,
            e.target.value
        ]) : setanswerSelected(answersSelected.filter((ans)=>ans !== e.target.value));
    };
    // Functionality revisions
    const handleQuizProgress = ()=>{
        //Progress quiz onto next step
        quizFunctions.nextStep();
        //Save current answers & question to quiz state
        let backtrackArray = {
            "question": question,
            "filter": filter,
            "facet": facet,
            "answers": answersSelected
        };
        if (!quizFunctions.currentAnswers.find((q)=>q.question.includes(question))) quizFunctions.currentAnswers.push(backtrackArray);
        else if (answersSelected.length) quizFunctions.currentAnswers.find((q)=>q.question.includes(question)).answers = answersSelected;
    };
    //Enable or Disable progress button
    const handleCanProgress = ()=>{
        if (answersSelected.length == 0) return true;
        if (answersSelected.length == 0 && preselectedAnswers.length != 0) return false;
        if (!answersSelected.length) return true;
    };
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: (0, $biy3n.default)("question-step", {
            "fadein": quizFunctions.fadeEffect == "fadein"
        }),
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: "question-content-wrapper",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "indicator-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("p", {
                                className: "indicator-question-label",
                                children: [
                                    "Question ",
                                    quizFunctions.currentStep + 1,
                                    " of ",
                                    quizFunctions.totalSteps + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: "indicator-bars-wrapper",
                                children: /*#__PURE__*/ (0, $drmv2.jsx)("progress", {
                                    id: "quizProgress",
                                    max: (quizFunctions.totalSteps + 1) * 10,
                                    value: (quizFunctions.currentStep + 1) * 10
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "question",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("h2", {
                                children: question
                            }),
                            multiple_choice ? /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                children: "Select all answers that apply."
                            }) : /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                children: "Select one answer."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "answers-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                className: "activity-label",
                                children: filter
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: "answers",
                                children: answers.map((ans, index)=>{
                                    return(// { 'locked' : (!multiple_choice && answersSelected.length != 0 && !answersSelected.includes(ans.value)) }
                                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                        className: (0, $biy3n.default)("answer"),
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                                id: `${filter}-${index}`,
                                                type: "checkbox",
                                                className: "visually-hidden",
                                                name: filter + "[]",
                                                value: ans.value,
                                                defaultChecked: preselectedAnswers?.includes(ans.value) ? true : false,
                                                onChange: handleClick
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("label", {
                                                htmlFor: `${filter}-${index}`,
                                                children: ans.answer
                                            })
                                        ]
                                    }, index));
                                })
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: "action-buttons-wrapper",
                                children: [
                                    quizFunctions.currentStep != 0 && /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                        className: "previous",
                                        onClick: quizFunctions.prevousStep,
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                        className: "button button--contained",
                                        disabled: handleCanProgress(),
                                        onClick: handleQuizProgress,
                                        children: "Continue"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "question-image",
                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    className: "aspect-ratio-box",
                    children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: "aspect-content",
                        children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                            className: "media",
                            src: image
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("biy3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $839bca7858d06d65$export$2e2bcd8739ae039; });
function $839bca7858d06d65$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $839bca7858d06d65$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $839bca7858d06d65$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $839bca7858d06d65$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $839bca7858d06d65$export$2e2bcd8739ae039 = $839bca7858d06d65$export$4f5d2d50c9deca37;

});


parcelRegister("8mtd7", function(module, exports) {

$parcel$export(module.exports, "CustomerForm", function () { return $aaa875ca7c68e9a4$export$469647c275cdc784; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $7mAg3 = parcelRequire("7mAg3");

var $dcsJ5 = parcelRequire("dcsJ5");
const $aaa875ca7c68e9a4$export$469647c275cdc784 = ({ list_ID: list_ID })=>{
    const { quiz: quiz } = (0, $7mAg3.usePLPContext)();
    const { quizFunctions: quizFunctions } = (0, $dcsJ5.useQuizContext)();
    const [email, setEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("");
    const handleEmailChange = (e)=>{
        setEmail(e.target.value);
    };
    const [phoneNum, setPhoneNum] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("");
    const handlePhoneChange = (e)=>{
        setPhoneNum(e.target.value);
    };
    const [phoneNumValid, setPhoneNumValid] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        // The component has loaded
        attachPropertiesToForm();
        const debounceFormInput = (callback, wait)=>{
            let timeoutId = null;
            return (...args)=>{
                window.clearTimeout(timeoutId);
                timeoutId = window.setTimeout(()=>{
                    callback.apply(null, args);
                }, wait);
            };
        };
        // Phone Number validation.
        const phoneInputFieldKlaviyo = document.querySelector("#phone_number");
        const phoneInputKlaviyo = window.intlTelInput(phoneInputFieldKlaviyo, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
            initialCountry: "AU",
            preferredCountries: [
                "AU",
                "NZ",
                "US",
                "GB"
            ]
        });
        const checkPhoneNumberKlaviyo = debounceFormInput((ev)=>{
            if (phoneInputKlaviyo.isValidNumber()) setPhoneNumValid(true);
            else setPhoneNumValid(false);
        }, 500);
        phoneInputFieldKlaviyo.addEventListener("keyup", checkPhoneNumberKlaviyo);
    }, []);
    const handleSubmit = ()=>{
        quizFunctions.setHasSubmitted(true);
        quiz.setQuizSubmittedOrSkipped(true);
        quizFunctions.handleDataLayer("Quiz_Signup", "Email & Phone number recorded");
    };
    const handleSkip = ()=>{
        quiz.setQuizSubmittedOrSkipped(true);
    };
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: (0, $biy3n.default)("customer-form container", {
            "fadein": quizFunctions.fadeEffect == "fadein"
        }),
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: "form-content-container",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "customer-form-heading-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("h2", {
                                children: "Save 10% on your order!"
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                children: "Enter your email & receive 10% off discount code to use on your leggings purchase!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("form", {
                        id: "Form-" + list_ID,
                        className: "klaviyo_form",
                        action: "//manage.kmail-lists.com/subscriptions/subscribe",
                        "data-ajax-submit": "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
                        method: "GET",
                        novalidate: "novalidate",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                type: "hidden",
                                name: "g",
                                value: list_ID
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                className: "form_field full",
                                type: "email",
                                value: email,
                                name: "email",
                                id: "k_id_email",
                                placeholder: "Your Email *",
                                onChange: handleEmailChange
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                type: "hidden",
                                className: "phone-input",
                                name: "$phone_number",
                                value: phoneNum
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                className: "form_field full",
                                id: "phone_number",
                                type: "tel",
                                name: "phone_number_field",
                                placeholder: "Phone Number *",
                                value: phoneNum,
                                onChange: handlePhoneChange
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: "klaviyo_form_actions show-results",
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                        id: "k_submit_button",
                                        className: "klaviyo_submit_button button button--contained",
                                        disabled: email.length == 0 || !phoneNumValid,
                                        children: "See My Results"
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                        className: "skip-signup",
                                        onClick: handleSkip,
                                        style: {
                                            padding: "4px 14px",
                                            borderRadius: "100px",
                                            margin: "0 auto"
                                        },
                                        children: "Skip & Show Results"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "question-image",
                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    className: "aspect-ratio-box",
                    children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: "aspect-content",
                        children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                            className: "media",
                            src: "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291"
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("7mAg3", function(module, exports) {

$parcel$export(module.exports, "usePLPContext", function () { return $c0c747072129a763$export$5e1caa312ebe0b4b; });
$parcel$export(module.exports, "indexMap", function () { return $c0c747072129a763$export$b36c351a52b93778; });
$parcel$export(module.exports, "ProductListingPage", function () { return $c0c747072129a763$export$8e405dc553cfe7db; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $g2L0U = parcelRequire("g2L0U");

var $bJc1o = parcelRequire("bJc1o");
var $eyCFI = parcelRequire("eyCFI");

var $e5Hn4 = parcelRequire("e5Hn4");

var $76vbA = parcelRequire("76vbA");

var $cbKYU = parcelRequire("cbKYU");

var $j9Ac6 = parcelRequire("j9Ac6");

var $cOTy9 = parcelRequire("cOTy9");

var $8kzkJ = parcelRequire("8kzkJ");

var $47EJY = parcelRequire("47EJY");

var $iMC13 = parcelRequire("iMC13");

var $jkqLX = parcelRequire("jkqLX");
parcelRequire("9frE0");
var $dcsJ5 = parcelRequire("dcsJ5");
const $c0c747072129a763$export$a83c99206af82533 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).createContext({});
const $c0c747072129a763$export$5e1caa312ebe0b4b = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useContext($c0c747072129a763$export$a83c99206af82533);
const $c0c747072129a763$var$productsPrefix = "shopify_products";
const $c0c747072129a763$export$b36c351a52b93778 = {
    default: [
        "production",
        $c0c747072129a763$var$productsPrefix
    ].join("_"),
    "price-ascending": [
        "production",
        $c0c747072129a763$var$productsPrefix,
        "price_asc"
    ].join("_"),
    "price-descending": [
        "production",
        $c0c747072129a763$var$productsPrefix,
        "price_desc"
    ].join("_"),
    "created-descending": [
        "production",
        $c0c747072129a763$var$productsPrefix,
        "newest"
    ].join("_")
};
const $c0c747072129a763$var$sortByToIndex = (sortBy)=>sortBy in $c0c747072129a763$export$b36c351a52b93778 ? $c0c747072129a763$export$b36c351a52b93778[sortBy] : $c0c747072129a763$export$b36c351a52b93778["default"];
const $c0c747072129a763$var$indexToSortBy = (index)=>{
    const invertedMap = Object.entries($c0c747072129a763$export$b36c351a52b93778).reduce((obj, [key, value])=>{
        obj[value] = key;
        return obj;
    }, {});
    return index in invertedMap ? invertedMap[index] : "default";
};
const $c0c747072129a763$export$8e405dc553cfe7db = ({ tagFilters: tagFilters = [], query: query = "", handle: handle, defaultSortBy: defaultSortBy, userToken: userToken, adverts: adverts, tabName: tabName, bubbleFilters: bubbleFilters, bundleType: bundleType = "no_bundle", bundleKey: bundleKey, bundleOfferText: bundleOfferText, athleteCollectionTag: athleteCollectionTag, enableWishlistTrap: enableWishlistTrap = false, bogoBundleValue: bogoBundleValue, fixedPriceBundleValue: fixedPriceBundleValue, bundleSetCount: bundleSetCount, isQuiz: isQuiz = false, isCollectionTabs: isCollectionTabs = false, highestPriceProduct: highestPriceProduct, lowestPriceProduct: lowestPriceProduct, b2b: b2b = "", customerTags: customerTags = [], showOutOfStock: showOutOfStock = false, visual_percentage_off_tab: visual_percentage_off_tab = 0, json: json = "" })=>{
    const isDesktopViewport = (0, $g2L0U.useMediaQuery)({
        query: "(min-width: 768px)"
    });
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const previousSearchStateRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const optionalFilters = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>{
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        const { boost: boost } = parsed;
        if (typeof boost === "string") return boost.split(";").join(" AND ");
    }, []);
    // Check for Quiz answers
    const [quizAnswers, setQuizAnswers] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    const [quizSubmittedOrSkipped, setQuizSubmittedOrSkipped] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const [searchState, setSearchState] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(()=>{
        let searchQuery = {};
        if (isCollectionTabs) {
            const preferedTab = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(window.location.search, {
                ignoreQueryPrefix: true
            }).tab;
            tabName == preferedTab ? searchQuery = window.location.search : searchQuery = {
                "page": "1",
                "sortBy": "default"
            };
        } else searchQuery = window.location.search;
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(searchQuery, {
            ignoreQueryPrefix: true
        });
        // const { page, sortBy = defaultSortBy, refine, toggle } = parsed;
        let { page: page, sortBy: sortBy = defaultSortBy, refine: refine, toggle: toggle, range: range } = parsed;
        // Automatically add toggle value if B2B available.
        if (b2b) {
            if (toggle && toggle[b2b] == undefined) toggle = {
                ...toggle,
                [b2b]: "true"
            } //toggle.push({'facets.Bras': true})
            ;
            else if (toggle && toggle[b2b]) toggle[b2b] = true;
            else toggle = {
                [b2b]: "true"
            };
        }
        return {
            page: typeof page === "string" ? Number(page) : 1,
            sortBy: typeof sortBy === "string" && $c0c747072129a763$var$sortByToIndex(sortBy) || $c0c747072129a763$var$sortByToIndex("default"),
            refinementList: refine != undefined ? Object.fromEntries(Object.entries(refine).filter(([key, value])=>value !== "")) : {},
            toggle: toggle,
            range: range != undefined ? range : undefined
        };
    });
    const [refinementToggle, setRefinementToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState({
        boolean: searchState?.toggle != undefined ? searchState?.toggle : false,
        ...searchState?.refinementList
    });
    // const [energyDrinkLimit, setEnergyDrinkLimit] = React.useState(false)
    // Energy Drink limit checker
    // Current Cart Items
    // const checkCart = async () => { 
    //   fetch('/cart.js')
    //   .then(response => response.json())
    //   .then(async (cart) => {
    //     let items = cart.items;
    //     let totalQuantity = 0;
    //     items.forEach(item => {
    //       if(item.product_type == "Energy Drink"){
    //         totalQuantity = totalQuantity + item.quantity
    //       }
    //     })
    //     if(totalQuantity >= 2){
    //       // setEnergyDrinkLimit(true)
    //     }
    //   })
    // }
    // const [bundleItem, setBundleState] = React.useState([]);
    const [bundleProducts, setBundleProducts] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    const bundleMax = parseInt(bundleSetCount);
    let discountAmount = 0;
    //Unsure if I need to parse the bundleDiscountValue coming from the bundle-offer.liquid section
    if (bundleType == "bogo") discountAmount = parseFloat(bogoBundleValue);
    else if (bundleType == "fixed-price-bundle" || bundleType == "rollover-bundle") discountAmount = parseFloat(fixedPriceBundleValue);
    const bundleDiscount = discountAmount;
    const [bundleCount, setBundleCount] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(0);
    // const [bundleCanAddMore, setBundleCanAddMore] = React.useState(true)
    const [triggerSummary, setTriggerSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const [lowestProduct, setLowestProduct] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    const [totalSaved, setTotalSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(0);
    // const [totalBundlePrice, setTotalBundlePrice] = React.useState(0)
    const currentMax = ()=>{
        return bundleCount < bundleMax ? bundleMax : Math.ceil(bundleCount / bundleMax) * bundleMax;
    };
    // const updateTotalBundlePrice = (item) => {
    //   setTotalBundlePrice(totalBundlePrice + parseFloat(item.price));
    // }
    const clearBundleProducts = ()=>{
        setBundleProducts([]);
        setLowestProduct([]);
        setBundleCount(0);
    };
    const handleTriggerSummary = ()=>{
        setTimeout(()=>{
            setTriggerSummary(!triggerSummary);
        // setTimeout(()=> {
        //   setTriggerSummary(!triggerSummary)
        // },200)
        }, 850);
    };
    const bundleCanAddMore = ()=>{
        // return bundleCount < bundleMax
        return true;
    };
    const productVariantInBundle = (prod_id)=>{
        return bundleProducts.find((ele)=>ele.product_id == prod_id) != undefined;
    };
    const updateBundleProducts = (arr)=>{
        const tmpBundles = bundleProducts;
        if (arr) arr.forEach((item)=>{
            //Track total bundle price
            const exists = tmpBundles.find((el)=>el.id == item.id);
            const existsIndex = tmpBundles.indexOf(exists);
            if (exists && exists.quantity > 0) tmpBundles[existsIndex].quantity = exists.quantity;
            else if (exists && item.quantity == 0) tmpBundles.splice(existsIndex, 1);
            else if (item.quantity > 0) tmpBundles.push(item);
        });
        let productCount = 0;
        tmpBundles.forEach((item)=>{
            productCount = productCount + item.quantity;
        });
        setBundleProducts(tmpBundles);
        setBundleCount(productCount);
        handleLowestProduct();
    };
    const handleBundleCount = ()=>{
        let productCount = 0;
        if (bundleProducts.length) bundleProducts.forEach((item)=>{
            productCount = productCount + item.quantity;
        });
        setBundleCount(productCount);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        handleBundleCount();
    }, [
        bundleProducts
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        setTimeout(()=>{
            if (bundleCount % bundleMax === 0) handleTriggerSummary();
        }, 850);
    }, [
        bundleCount
    ]);
    /* Find lowest product */ const handleLowestProduct = ()=>{
        let lowest = [];
        setTotalSaved(0);
        setLowestProduct([]);
        // BOGO Style discount logic
        if (bundleType == "bogo") {
            if (bundleCount >= bundleMax) {
                let currentMaxItems = Math.floor(bundleCount / bundleMax) //currentMax() - bundleCount == 0 ? bundleCount : (bundleCount - (currentMax() - bundleCount))
                ;
                let ttlSaved = 0;
                bundleProducts.forEach((prod)=>{
                    let quantityToDiscount = 0;
                    if (currentMaxItems > 0) {
                        if (currentMaxItems >= prod.quantity) {
                            currentMaxItems = currentMaxItems - prod.quantity;
                            quantityToDiscount = prod.quantity;
                        } else {
                            quantityToDiscount = prod.quantity - currentMaxItems;
                            currentMaxItems = currentMaxItems - prod.quantity <= 0 ? 0 : prod.quantity - currentMaxItems;
                        }
                        prod.quantityToDiscount = quantityToDiscount;
                        prod.saved = parseFloat(prod.price) - parseFloat(prod.price) * (1 - bundleDiscount);
                        ttlSaved = ttlSaved + prod.saved * prod.quantityToDiscount;
                        lowest.push(prod);
                    }
                });
                setTotalSaved(ttlSaved);
                setLowestProduct(lowest);
            }
        } else if (bundleType == "fixed-price-bundle") {
            if (bundleCount >= bundleMax) {
                let currentMaxItems = currentMax() - bundleCount == 0 ? bundleCount : bundleCount - (currentMax() - bundleCount);
                let ttlSaved = 0;
                let totalPriceAfterDiscounts = 0;
                bundleProducts.forEach((prod)=>{
                    let quantityToDiscount = 0;
                    if (currentMaxItems) {
                        if (currentMaxItems >= prod.quantity) {
                            quantityToDiscount = prod.quantity;
                            currentMaxItems = currentMaxItems - prod.quantity;
                        } else {
                            quantityToDiscount = prod.quantity - currentMaxItems;
                            currentMaxItems = currentMaxItems <= 0 ? 0 : prod.quantity - currentMaxItems;
                        }
                        totalPriceAfterDiscounts = parseFloat(prod.price) - parseFloat(prod.saved);
                        prod.saved = prod.price - parseFloat(bundleDiscount / bundleMax);
                        prod.quantityToDiscount = quantityToDiscount;
                        ttlSaved = ttlSaved + prod.saved * prod.quantityToDiscount;
                        lowest.push(prod);
                    }
                });
                //Pass this amount through to the globally managed state
                setTotalSaved(ttlSaved);
                setLowestProduct(lowest);
            }
        } else if (bundleType == "rollover-bundle") {
            if (bundleCount >= parseInt(bundleSetCount)) {
                let ttlSaved = 0;
                let totalPriceAfterDiscounts = 0 // This may be useless
                ;
                bundleProducts.forEach((prod)=>{
                    let quantityToDiscount = 0;
                    quantityToDiscount = prod.quantity;
                    totalPriceAfterDiscounts = parseFloat(prod.price) - parseFloat(prod.saved) // This may be useless
                    ;
                    prod.saved = prod.price * (parseFloat(bundleDiscount) / 100);
                    prod.quantityToDiscount = quantityToDiscount;
                    ttlSaved = ttlSaved + prod.saved * prod.quantityToDiscount;
                    lowest.push(prod);
                });
                //Pass this amount through to the globally managed state
                setTotalSaved(ttlSaved);
                setLowestProduct(lowest);
            }
        }
    };
    /* This needs work */ const removeFromBundle = (product)=>{
        let TMPbundle = bundleProducts;
        let currentSaved = 0;
        TMPbundle.forEach((prod, i)=>{
            if (prod.id == product.id) {
                product.saved = parseFloat("0.00");
                prod.quantity = prod.quantity - 1;
            }
        });
        setBundleProducts(TMPbundle.filter((prod)=>prod.quantity > 0));
        handleLowestProduct();
    };
    /*
   * This code is to apply a 'load-more' feature to desktop devices
   * by manipulating the URL with get variables.
   * Only works on non-collection-tab collections.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (isDesktopViewport && !isCollectionTabs) {
            const previousQuery = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(window.location.search, {
                ignoreQueryPrefix: true
            });
            window.history.replaceState({}, "", `${window.location.pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).stringify({
                ...previousQuery,
                page: searchState.page,
                sortBy: $c0c747072129a763$var$indexToSortBy(searchState.sortBy),
                refine: searchState.refinementList != undefined ? Object.fromEntries(Object.entries(searchState.refinementList).filter(([key, value])=>value !== "")) : undefined,
                toggle: searchState.toggle
            }, {
                encodeValuesOnly: true
            })}`);
        }
    }, [
        searchState
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        // checkCart(); 
        if (previousSearchStateRef.current) {
            const previousSearchState = previousSearchStateRef.current;
            const pathsToCompare = [
                "sortBy",
                "refinementList",
                "toggle"
            ];
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($47EJY)))((0, (/*@__PURE__*/$parcel$interopDefault($iMC13)))(previousSearchState, pathsToCompare), (0, (/*@__PURE__*/$parcel$interopDefault($iMC13)))(searchState, pathsToCompare))) {
                const top = isCollectionTabs ? document.querySelector("#collection-tabs-anchor").getBoundingClientRect().y + document.querySelector("#collection-tabs-anchor").getBoundingClientRect().height : document.querySelector(".collection__info h1") ? document.querySelector(".collection__info h1").getBoundingClientRect().y + document.querySelector(".collection__info h1").getBoundingClientRect().height : 0;
                document.querySelector("sticky-header").dispatchEvent(new CustomEvent("preventHeaderReveal"));
                window.scrollBy({
                    top: top
                });
            }
        }
        return ()=>{
            previousSearchStateRef.current = searchState;
        };
    }, [
        searchState
    ]);
    const filters = [];
    if (handle) filters.push(`smartCollectionHandles:${handle}`);
    filters.push(`is_published:true`);
    if (!showOutOfStock) filters.push(`total_units > 0`);
    const athleteTag = athleteCollectionTag ? athleteCollectionTag : false;
    const forceWishlist = enableWishlistTrap ? enableWishlistTrap : false;
    const womensCollection = handle != null && (handle.includes("womens") || handle.includes("graphic-tees")) ? true : false;
    const buffer = isCollectionTabs ? -38 : 0;
    /*
   * Filter Query that will update the listing output.
   */ const filterQuery = filters.join(" AND ");
    return /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
        children: /*#__PURE__*/ (0, $drmv2.jsxs)($c0c747072129a763$export$a83c99206af82533.Provider, {
            value: {
                searchState: searchState,
                setSearchState: setSearchState,
                refinementToggle: refinementToggle,
                setRefinementToggle: setRefinementToggle,
                handle: handle,
                query: query,
                defaultSortBy: defaultSortBy,
                b2b: b2b,
                visual_percentage_off_tab: visual_percentage_off_tab,
                customerTags: customerTags,
                collection: {
                    athleteTag: athleteTag,
                    forceWishlist: forceWishlist,
                    womensCollection: womensCollection
                },
                bundleFunctions: {
                    bundleProducts: // totalBundlePrice,
                    bundleProducts,
                    bundleType: bundleType,
                    bundleKey: bundleKey,
                    bundleMax: bundleMax,
                    bundleCount: bundleCount,
                    bundleCanAddMore: bundleCanAddMore,
                    updateBundleProducts: updateBundleProducts,
                    productVariantInBundle: // handleBundleCanAddMore,
                    productVariantInBundle,
                    removeFromBundle: removeFromBundle,
                    triggerSummary: triggerSummary,
                    handleTriggerSummary: handleTriggerSummary,
                    setTriggerSummary: setTriggerSummary,
                    handleLowestProduct: handleLowestProduct,
                    clearBundleProducts: clearBundleProducts,
                    lowestProduct: lowestProduct,
                    currentMax: currentMax,
                    bundleDiscount: bundleDiscount,
                    totalSaved: totalSaved,
                    bundleOfferText: bundleOfferText
                },
                quiz: {
                    isQuiz: isQuiz,
                    quizAnswers: quizAnswers,
                    setQuizAnswers: setQuizAnswers,
                    quizSubmittedOrSkipped: quizSubmittedOrSkipped,
                    setQuizSubmittedOrSkipped: setQuizSubmittedOrSkipped
                }
            },
            children: [
                isQuiz && /*#__PURE__*/ (0, $drmv2.jsx)((0, $dcsJ5.QuizCollection), {
                    json: json
                }),
                isQuiz && quizAnswers.length == json.questions.length && quizSubmittedOrSkipped || !isQuiz ? /*#__PURE__*/ (0, $drmv2.jsxs)((0, $eyCFI.default), {
                    indexName: $c0c747072129a763$export$b36c351a52b93778["default"],
                    searchClient: (0, $76vbA.searchClient),
                    searchState: searchState,
                    onSearchStateChange: setSearchState,
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsx)((0, $bJc1o.default), {
                            query: query,
                            optionalFilters: optionalFilters,
                            filters: filterQuery,
                            tagFilters: tagFilters,
                            hitsPerPage: 48,
                            clickAnalytics: true,
                            enableRules: true,
                            userToken: userToken || undefined,
                            analyticsTags: [
                                handle,
                                ...tagFilters
                            ],
                            ruleContexts: [
                                handle
                            ]
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            ref: rootRef,
                            className: $j9Ac6.root + " component__productListingPage",
                            children: /*#__PURE__*/ (0, $drmv2.jsxs)((0, $8kzkJ.StickyBoundary), {
                                buffer: buffer,
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                        className: "container",
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)((0, $cbKYU.Refinement), {
                                                handle: handle,
                                                isCollectionTabs: isCollectionTabs,
                                                bubbleFilters: bubbleFilters,
                                                tabName: tabName,
                                                setSearchState: setSearchState,
                                                highestPriceProduct: highestPriceProduct,
                                                lowestPriceProduct: lowestPriceProduct
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)((0, $cOTy9.ProductContainer), {
                                                handle: handle,
                                                adverts: adverts
                                            })
                                        ]
                                    }),
                                    bundleType != undefined && bundleType != "no_bundle" && /*#__PURE__*/ (0, $drmv2.jsx)((0, $jkqLX.Summary), {
                                        bundle: bundleProducts,
                                        offerText: bundleOfferText
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {})
            ]
        })
    });
};

});
parcelRegister("g2L0U", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("1vrWl")));
})(module.exports, (__WEBPACK_EXTERNAL_MODULE_react__)=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/css-mediaquery/index.js": /*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ exports.match = matchQuery;
                exports.parse = parseQuery;
                // -----------------------------------------------------------------------------
                var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
                function matchQuery(mediaQuery, values) {
                    return parseQuery(mediaQuery).some(function(query) {
                        var inverse = query.inverse;
                        // Either the parsed or specified `type` is "all", or the types must be
                        // equal for a match.
                        var typeMatch = query.type === "all" || values.type === query.type;
                        // Quit early when `type` doesn't match, but take "not" into account.
                        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
                        var expressionsMatch = query.expressions.every(function(expression) {
                            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                            // Missing or falsy values don't match.
                            if (!value) return false;
                            switch(feature){
                                case "orientation":
                                case "scan":
                                    return value.toLowerCase() === expValue.toLowerCase();
                                case "width":
                                case "height":
                                case "device-width":
                                case "device-height":
                                    expValue = toPx(expValue);
                                    value = toPx(value);
                                    break;
                                case "resolution":
                                    expValue = toDpi(expValue);
                                    value = toDpi(value);
                                    break;
                                case "aspect-ratio":
                                case "device-aspect-ratio":
                                case /* Deprecated */ "device-pixel-ratio":
                                    expValue = toDecimal(expValue);
                                    value = toDecimal(value);
                                    break;
                                case "grid":
                                case "color":
                                case "color-index":
                                case "monochrome":
                                    expValue = parseInt(expValue, 10) || 1;
                                    value = parseInt(value, 10) || 0;
                                    break;
                            }
                            switch(modifier){
                                case "min":
                                    return value >= expValue;
                                case "max":
                                    return value <= expValue;
                                default:
                                    return value === expValue;
                            }
                        });
                        return expressionsMatch && !inverse || !expressionsMatch && inverse;
                    });
                }
                function parseQuery(mediaQuery) {
                    return mediaQuery.split(",").map(function(query) {
                        query = query.trim();
                        var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                        parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
                        parsed.type = type ? type.toLowerCase() : "all";
                        // Split expressions into a list.
                        expressions = expressions.match(/\([^\)]+\)/g) || [];
                        parsed.expressions = expressions.map(function(expression) {
                            var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                            return {
                                modifier: feature[1],
                                feature: feature[2],
                                value: captures[2]
                            };
                        });
                        return parsed;
                    });
                }
                // -- Utilities ----------------------------------------------------------------
                function toDecimal(ratio) {
                    var decimal = Number(ratio), numbers;
                    if (!decimal) {
                        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                        decimal = numbers[1] / numbers[2];
                    }
                    return decimal;
                }
                function toDpi(resolution) {
                    var value = parseFloat(resolution), units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
                    switch(units){
                        case "dpcm":
                            return value / 2.54;
                        case "dppx":
                            return value * 96;
                        default:
                            return value;
                    }
                }
                function toPx(length) {
                    var value = parseFloat(length), units = String(length).match(RE_LENGTH_UNIT)[1];
                    switch(units){
                        case "em":
                            return value * 16;
                        case "rem":
                            return value * 16;
                        case "cm":
                            return value * 96 / 2.54;
                        case "mm":
                            return value * 96 / 2.54 / 10;
                        case "in":
                            return value * 96;
                        case "pt":
                            return value * 72;
                        case "pc":
                            return value * 72 / 12;
                        default:
                            return value;
                    }
                }
            /***/ },
            /***/ "./node_modules/hyphenate-style-name/index.js": /*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                /* eslint-disable no-var, prefer-template */ var uppercasePattern = /[A-Z]/g;
                var msPattern = /^ms-/;
                var cache = {};
                function toHyphenLower(match) {
                    return "-" + match.toLowerCase();
                }
                function hyphenateStyleName(name) {
                    if (cache.hasOwnProperty(name)) return cache[name];
                    var hName = name.replace(uppercasePattern, toHyphenLower);
                    return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
                }
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;
            /***/ },
            /***/ "./node_modules/matchmediaquery/index.js": /*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var staticMatch = __webpack_require__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match;
                var dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
                // our fake MediaQueryList
                function Mql(query, values, forceStatic) {
                    var self = this;
                    if (dynamicMatch && !forceStatic) {
                        var mql = dynamicMatch.call(window, query);
                        this.matches = mql.matches;
                        this.media = mql.media;
                        // TODO: is there a time it makes sense to remove this listener?
                        mql.addListener(update);
                    } else {
                        this.matches = staticMatch(query, values);
                        this.media = query;
                    }
                    this.addListener = addListener;
                    this.removeListener = removeListener;
                    this.dispose = dispose;
                    function addListener(listener) {
                        if (mql) mql.addListener(listener);
                    }
                    function removeListener(listener) {
                        if (mql) mql.removeListener(listener);
                    }
                    // update ourselves!
                    function update(evt) {
                        self.matches = evt.matches;
                        self.media = evt.media;
                    }
                    function dispose() {
                        if (mql) mql.removeListener(update);
                    }
                }
                function matchMedia(query, values, forceStatic) {
                    return new Mql(query, values, forceStatic);
                }
                module1.exports = matchMedia;
            /***/ },
            /***/ "./node_modules/object-assign/index.js": /*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/ /***/ (module1)=>{
                "use strict";
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            /***/ },
            /***/ "./node_modules/prop-types/checkPropTypes.js": /*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var printWarning = function() {};
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var loggedTypeFailures = {};
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                /**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            if (typeof typeSpecs[typeSpecName] !== "function") {
                                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                                err.name = "Invariant Violation";
                                throw err;
                            }
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
                        }
                    }
                }
                /**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
                    loggedTypeFailures = {};
                };
                module1.exports = checkPropTypes;
            /***/ },
            /***/ "./node_modules/prop-types/factoryWithTypeCheckers.js": /*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                var assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                var checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");
                var printWarning = function() {};
                printWarning = function(text) {
                    var message = "Warning: " + text;
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                function emptyFunctionThatReturnsNull() {
                    return null;
                }
                module1.exports = function(isValidElement, throwOnDirectAccess) {
                    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
                        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                        if (typeof iteratorFn === "function") return iteratorFn;
                    }
                    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
                    // Important!
                    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                    var ReactPropTypes = {
                        array: createPrimitiveTypeChecker("array"),
                        bigint: createPrimitiveTypeChecker("bigint"),
                        bool: createPrimitiveTypeChecker("boolean"),
                        func: createPrimitiveTypeChecker("function"),
                        number: createPrimitiveTypeChecker("number"),
                        object: createPrimitiveTypeChecker("object"),
                        string: createPrimitiveTypeChecker("string"),
                        symbol: createPrimitiveTypeChecker("symbol"),
                        any: createAnyTypeChecker(),
                        arrayOf: createArrayOfTypeChecker,
                        element: createElementTypeChecker(),
                        elementType: createElementTypeTypeChecker(),
                        instanceOf: createInstanceTypeChecker,
                        node: createNodeChecker(),
                        objectOf: createObjectOfTypeChecker,
                        oneOf: createEnumTypeChecker,
                        oneOfType: createUnionTypeChecker,
                        shape: createShapeTypeChecker,
                        exact: createStrictShapeTypeChecker
                    };
                    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                        // SameValue algorithm
                        if (x === y) // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                        else // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
                        this.message = message;
                        this.data = data && typeof data === "object" ? data : {};
                        this.stack = "";
                    }
                    // Make `instanceof Error` still work for returned errors.
                    PropTypeError.prototype = Error.prototype;
                    function createChainableTypeChecker(validate) {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                            componentName = componentName || ANONYMOUS;
                            propFullName = propFullName || propName;
                            if (secret !== ReactPropTypesSecret) {
                                if (throwOnDirectAccess) {
                                    // New behavior only for users of `prop-types` package
                                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                    err.name = "Invariant Violation";
                                    throw err;
                                } else if (typeof console !== "undefined") {
                                    // Old behavior for people using React.PropTypes
                                    var cacheKey = componentName + ":" + propName;
                                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                    manualPropTypeWarningCount < 3) {
                                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                                        manualPropTypeCallCache[cacheKey] = true;
                                        manualPropTypeWarningCount++;
                                    }
                                }
                            }
                            if (props[propName] == null) {
                                if (isRequired) {
                                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                                }
                                return null;
                            } else return validate(props, propName, componentName, location, propFullName);
                        }
                        var chainedCheckType = checkType.bind(null, false);
                        chainedCheckType.isRequired = checkType.bind(null, true);
                        return chainedCheckType;
                    }
                    function createPrimitiveTypeChecker(expectedType) {
                        function validate(props, propName, componentName, location, propFullName, secret) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== expectedType) {
                                // `propValue` being instance of, say, date/regexp, pass the 'object'
                                // check, but we can offer a more precise error message here rather than
                                // 'of type `object`'.
                                var preciseType = getPreciseType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                                    expectedType: expectedType
                                });
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createAnyTypeChecker() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }
                    function createArrayOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                            var propValue = props[propName];
                            if (!Array.isArray(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                            }
                            for(var i = 0; i < propValue.length; i++){
                                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!ReactIs.isValidElementType(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createInstanceTypeChecker(expectedClass) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!(props[propName] instanceof expectedClass)) {
                                var expectedClassName = expectedClass.name || ANONYMOUS;
                                var actualClassName = getClassName(props[propName]);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createEnumTypeChecker(expectedValues) {
                        if (!Array.isArray(expectedValues)) {
                            {
                                if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                                else printWarning("Invalid argument supplied to oneOf, expected an array.");
                            }
                            return emptyFunctionThatReturnsNull;
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            for(var i = 0; i < expectedValues.length; i++){
                                if (is(propValue, expectedValues[i])) return null;
                            }
                            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                                var type = getPreciseType(value);
                                if (type === "symbol") return String(value);
                                return value;
                            });
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createObjectOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                            for(var key in propValue)if (has(propValue, key)) {
                                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createUnionTypeChecker(arrayOfTypeCheckers) {
                        if (!Array.isArray(arrayOfTypeCheckers)) {
                            printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
                            return emptyFunctionThatReturnsNull;
                        }
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (typeof checker !== "function") {
                                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                                return emptyFunctionThatReturnsNull;
                            }
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var expectedTypes = [];
                            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                                var checker = arrayOfTypeCheckers[i];
                                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                                if (checkerResult == null) return null;
                                if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
                            }
                            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createNodeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function invalidValidatorError(componentName, location, propFullName, key, type) {
                        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
                    }
                    function createShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            for(var key in shapeTypes){
                                var checker = shapeTypes[key];
                                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createStrictShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                            // We need to check all keys in case some are required but missing from props.
                            var allKeys = assign({}, props[propName], shapeTypes);
                            for(var key in allKeys){
                                var checker = shapeTypes[key];
                                if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function isNode(propValue) {
                        switch(typeof propValue){
                            case "number":
                            case "string":
                            case "undefined":
                                return true;
                            case "boolean":
                                return !propValue;
                            case "object":
                                if (Array.isArray(propValue)) return propValue.every(isNode);
                                if (propValue === null || isValidElement(propValue)) return true;
                                var iteratorFn = getIteratorFn(propValue);
                                if (iteratorFn) {
                                    var iterator = iteratorFn.call(propValue);
                                    var step;
                                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                        if (!isNode(step.value)) return false;
                                    }
                                    else // Iterator will provide entry [k,v] tuples rather than values.
                                    while(!(step = iterator.next()).done){
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) return false;
                                        }
                                    }
                                } else return false;
                                return true;
                            default:
                                return false;
                        }
                    }
                    function isSymbol(propType, propValue) {
                        // Native Symbol.
                        if (propType === "symbol") return true;
                        // falsy value can't be a Symbol
                        if (!propValue) return false;
                        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                        if (propValue["@@toStringTag"] === "Symbol") return true;
                        // Fallback for non-spec compliant Symbols which are polyfilled.
                        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                        return false;
                    }
                    // Equivalent of `typeof` but with special handling for array and regexp.
                    function getPropType(propValue) {
                        var propType = typeof propValue;
                        if (Array.isArray(propValue)) return "array";
                        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return "object";
                        if (isSymbol(propType, propValue)) return "symbol";
                        return propType;
                    }
                    // This handles more types than `getPropType`. Only used for error messages.
                    // See `createPrimitiveTypeChecker`.
                    function getPreciseType(propValue) {
                        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                        var propType = getPropType(propValue);
                        if (propType === "object") {
                            if (propValue instanceof Date) return "date";
                            else if (propValue instanceof RegExp) return "regexp";
                        }
                        return propType;
                    }
                    // Returns a string that is postfixed to a warning about an invalid type.
                    // For example, "undefined" or "of type array"
                    function getPostfixForTypeWarning(value) {
                        var type = getPreciseType(value);
                        switch(type){
                            case "array":
                            case "object":
                                return "an " + type;
                            case "boolean":
                            case "date":
                            case "regexp":
                                return "a " + type;
                            default:
                                return type;
                        }
                    }
                    // Returns class name of the object, if any.
                    function getClassName(propValue) {
                        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                        return propValue.constructor.name;
                    }
                    ReactPropTypes.checkPropTypes = checkPropTypes;
                    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            /***/ },
            /***/ "./node_modules/prop-types/index.js": /*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
            /***/ },
            /***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js": /*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/ /***/ (module1)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                module1.exports = ReactPropTypesSecret;
            /***/ },
            /***/ "./node_modules/prop-types/lib/has.js": /*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/ /***/ (module1)=>{
                module1.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            /***/ },
            /***/ "./node_modules/react-is/cjs/react-is.development.js": /*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                (function() {
                    "use strict";
                    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                    // nor polyfill, then a plain number is used for performance.
                    var hasSymbol = typeof Symbol === "function" && Symbol.for;
                    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
                    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
                    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
                    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
                    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
                    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
                    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
                    // (unstable) APIs that have been removed. Can we remove the symbols?
                    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
                    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
                    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
                    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
                    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
                    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
                    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
                    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
                    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
                    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
                    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
                    function isValidElementType(type) {
                        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                    }
                    function typeOf(object) {
                        if (typeof object === "object" && object !== null) {
                            var $$typeof = object.$$typeof;
                            switch($$typeof){
                                case REACT_ELEMENT_TYPE:
                                    var type = object.type;
                                    switch(type){
                                        case REACT_ASYNC_MODE_TYPE:
                                        case REACT_CONCURRENT_MODE_TYPE:
                                        case REACT_FRAGMENT_TYPE:
                                        case REACT_PROFILER_TYPE:
                                        case REACT_STRICT_MODE_TYPE:
                                        case REACT_SUSPENSE_TYPE:
                                            return type;
                                        default:
                                            var $$typeofType = type && type.$$typeof;
                                            switch($$typeofType){
                                                case REACT_CONTEXT_TYPE:
                                                case REACT_FORWARD_REF_TYPE:
                                                case REACT_LAZY_TYPE:
                                                case REACT_MEMO_TYPE:
                                                case REACT_PROVIDER_TYPE:
                                                    return $$typeofType;
                                                default:
                                                    return $$typeof;
                                            }
                                    }
                                case REACT_PORTAL_TYPE:
                                    return $$typeof;
                            }
                        }
                        return undefined;
                    } // AsyncMode is deprecated along with isAsyncMode
                    var AsyncMode = REACT_ASYNC_MODE_TYPE;
                    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                    var ContextConsumer = REACT_CONTEXT_TYPE;
                    var ContextProvider = REACT_PROVIDER_TYPE;
                    var Element = REACT_ELEMENT_TYPE;
                    var ForwardRef = REACT_FORWARD_REF_TYPE;
                    var Fragment = REACT_FRAGMENT_TYPE;
                    var Lazy = REACT_LAZY_TYPE;
                    var Memo = REACT_MEMO_TYPE;
                    var Portal = REACT_PORTAL_TYPE;
                    var Profiler = REACT_PROFILER_TYPE;
                    var StrictMode = REACT_STRICT_MODE_TYPE;
                    var Suspense = REACT_SUSPENSE_TYPE;
                    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
                    function isAsyncMode(object) {
                        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
                            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                        }
                        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                    }
                    function isConcurrentMode(object) {
                        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                    }
                    function isContextConsumer(object) {
                        return typeOf(object) === REACT_CONTEXT_TYPE;
                    }
                    function isContextProvider(object) {
                        return typeOf(object) === REACT_PROVIDER_TYPE;
                    }
                    function isElement(object) {
                        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                    }
                    function isForwardRef(object) {
                        return typeOf(object) === REACT_FORWARD_REF_TYPE;
                    }
                    function isFragment(object) {
                        return typeOf(object) === REACT_FRAGMENT_TYPE;
                    }
                    function isLazy(object) {
                        return typeOf(object) === REACT_LAZY_TYPE;
                    }
                    function isMemo(object) {
                        return typeOf(object) === REACT_MEMO_TYPE;
                    }
                    function isPortal(object) {
                        return typeOf(object) === REACT_PORTAL_TYPE;
                    }
                    function isProfiler(object) {
                        return typeOf(object) === REACT_PROFILER_TYPE;
                    }
                    function isStrictMode(object) {
                        return typeOf(object) === REACT_STRICT_MODE_TYPE;
                    }
                    function isSuspense(object) {
                        return typeOf(object) === REACT_SUSPENSE_TYPE;
                    }
                    exports.AsyncMode = AsyncMode;
                    exports.ConcurrentMode = ConcurrentMode;
                    exports.ContextConsumer = ContextConsumer;
                    exports.ContextProvider = ContextProvider;
                    exports.Element = Element;
                    exports.ForwardRef = ForwardRef;
                    exports.Fragment = Fragment;
                    exports.Lazy = Lazy;
                    exports.Memo = Memo;
                    exports.Portal = Portal;
                    exports.Profiler = Profiler;
                    exports.StrictMode = StrictMode;
                    exports.Suspense = Suspense;
                    exports.isAsyncMode = isAsyncMode;
                    exports.isConcurrentMode = isConcurrentMode;
                    exports.isContextConsumer = isContextConsumer;
                    exports.isContextProvider = isContextProvider;
                    exports.isElement = isElement;
                    exports.isForwardRef = isForwardRef;
                    exports.isFragment = isFragment;
                    exports.isLazy = isLazy;
                    exports.isMemo = isMemo;
                    exports.isPortal = isPortal;
                    exports.isProfiler = isProfiler;
                    exports.isStrictMode = isStrictMode;
                    exports.isSuspense = isSuspense;
                    exports.isValidElementType = isValidElementType;
                    exports.typeOf = typeOf;
                })();
            /***/ },
            /***/ "./node_modules/react-is/index.js": /*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
            /***/ },
            /***/ "./node_modules/shallow-equal/dist/index.esm.js": /*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "shallowEqualArrays": ()=>/* binding */ shallowEqualArrays,
                    /* harmony export */ "shallowEqualObjects": ()=>/* binding */ shallowEqualObjects
                });
                function shallowEqualObjects(objA, objB) {
                    if (objA === objB) return true;
                    if (!objA || !objB) return false;
                    var aKeys = Object.keys(objA);
                    var bKeys = Object.keys(objB);
                    var len = aKeys.length;
                    if (bKeys.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        var key = aKeys[i];
                        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
                    }
                    return true;
                }
                function shallowEqualArrays(arrA, arrB) {
                    if (arrA === arrB) return true;
                    if (!arrA || !arrB) return false;
                    var len = arrA.length;
                    if (arrB.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        if (arrA[i] !== arrB[i]) return false;
                    }
                    return true;
                }
            /***/ },
            /***/ "./src/Component.ts": /*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
                var MediaQuery = function(_a) {
                    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, [
                        "children",
                        "device",
                        "onChange"
                    ]);
                    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
                    if (typeof children === "function") return children(matches);
                    return matches ? children : null;
                };
                exports["default"] = MediaQuery;
            /***/ },
            /***/ "./src/Context.ts": /*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var Context = (0, react_1.createContext)(undefined);
                exports["default"] = Context;
            /***/ },
            /***/ "./src/index.ts": /*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                exports.useMediaQuery = useMediaQuery_1.default;
                var Component_1 = __importDefault(__webpack_require__(/*! ./Component */ "./src/Component.ts"));
                exports["default"] = Component_1.default;
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                exports.toQuery = toQuery_1.default;
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                exports.Context = Context_1.default;
            /***/ },
            /***/ "./src/mediaQuery.ts": /*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var prop_types_1 = __importDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));
                var stringOrNumber = prop_types_1.default.oneOfType([
                    prop_types_1.default.string,
                    prop_types_1.default.number
                ]);
                // media types
                var types = {
                    all: prop_types_1.default.bool,
                    grid: prop_types_1.default.bool,
                    aural: prop_types_1.default.bool,
                    braille: prop_types_1.default.bool,
                    handheld: prop_types_1.default.bool,
                    print: prop_types_1.default.bool,
                    projection: prop_types_1.default.bool,
                    screen: prop_types_1.default.bool,
                    tty: prop_types_1.default.bool,
                    tv: prop_types_1.default.bool,
                    embossed: prop_types_1.default.bool
                };
                // properties that match media queries
                var matchers = {
                    orientation: prop_types_1.default.oneOf([
                        "portrait",
                        "landscape"
                    ]),
                    scan: prop_types_1.default.oneOf([
                        "progressive",
                        "interlace"
                    ]),
                    aspectRatio: prop_types_1.default.string,
                    deviceAspectRatio: prop_types_1.default.string,
                    height: stringOrNumber,
                    deviceHeight: stringOrNumber,
                    width: stringOrNumber,
                    deviceWidth: stringOrNumber,
                    color: prop_types_1.default.bool,
                    colorIndex: prop_types_1.default.bool,
                    monochrome: prop_types_1.default.bool,
                    resolution: stringOrNumber,
                    type: Object.keys(types)
                };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var type = matchers.type, featureMatchers = __rest(matchers, [
                    "type"
                ]);
                // media features
                var features = __assign({
                    minAspectRatio: prop_types_1.default.string,
                    maxAspectRatio: prop_types_1.default.string,
                    minDeviceAspectRatio: prop_types_1.default.string,
                    maxDeviceAspectRatio: prop_types_1.default.string,
                    minHeight: stringOrNumber,
                    maxHeight: stringOrNumber,
                    minDeviceHeight: stringOrNumber,
                    maxDeviceHeight: stringOrNumber,
                    minWidth: stringOrNumber,
                    maxWidth: stringOrNumber,
                    minDeviceWidth: stringOrNumber,
                    maxDeviceWidth: stringOrNumber,
                    minColor: prop_types_1.default.number,
                    maxColor: prop_types_1.default.number,
                    minColorIndex: prop_types_1.default.number,
                    maxColorIndex: prop_types_1.default.number,
                    minMonochrome: prop_types_1.default.number,
                    maxMonochrome: prop_types_1.default.number,
                    minResolution: stringOrNumber,
                    maxResolution: stringOrNumber
                }, featureMatchers);
                var all = __assign(__assign({}, types), features);
                exports["default"] = {
                    all: all,
                    types: types,
                    matchers: matchers,
                    features: features
                };
            /***/ },
            /***/ "./src/toQuery.ts": /*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var mediaQuery_1 = __importDefault(__webpack_require__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
                var negate = function(cond) {
                    return "not ".concat(cond);
                };
                var keyVal = function(k, v) {
                    var realKey = (0, hyphenate_style_name_1.default)(k);
                    // px shorthand
                    if (typeof v === "number") v = "".concat(v, "px");
                    if (v === true) return realKey;
                    if (v === false) return negate(realKey);
                    return "(".concat(realKey, ": ").concat(v, ")");
                };
                var join = function(conds) {
                    return conds.join(" and ");
                };
                var toQuery = function(obj) {
                    var rules = [];
                    Object.keys(mediaQuery_1.default.all).forEach(function(k) {
                        var v = obj[k];
                        if (v != null) rules.push(keyVal(k, v));
                    });
                    return join(rules);
                };
                exports["default"] = toQuery;
            /***/ },
            /***/ "./src/useMediaQuery.ts": /*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var matchmediaquery_1 = __importDefault(__webpack_require__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var shallow_equal_1 = __webpack_require__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                var makeQuery = function(settings) {
                    return settings.query || (0, toQuery_1.default)(settings);
                };
                var hyphenateKeys = function(obj) {
                    if (!obj) return undefined;
                    var keys = Object.keys(obj);
                    return keys.reduce(function(result, key) {
                        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                        return result;
                    }, {});
                };
                var useIsUpdate = function() {
                    var ref = (0, react_1.useRef)(false);
                    (0, react_1.useEffect)(function() {
                        ref.current = true;
                    }, []);
                    return ref.current;
                };
                var useDevice = function(deviceFromProps) {
                    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
                    var getDevice = function() {
                        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
                    };
                    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newDevice = getDevice();
                        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) setDevice(newDevice);
                    }, [
                        deviceFromProps,
                        deviceFromContext
                    ]);
                    return device;
                };
                var useQuery = function(settings) {
                    var getQuery = function() {
                        return makeQuery(settings);
                    };
                    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newQuery = getQuery();
                        if (query !== newQuery) setQuery(newQuery);
                    }, [
                        settings
                    ]);
                    return query;
                };
                var useMatchMedia = function(query, device) {
                    var getMatchMedia = function() {
                        return (0, matchmediaquery_1.default)(query, device || {}, !!device);
                    };
                    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate) {
                            // skip on mounting, it has already been set
                            var newMq_1 = getMatchMedia();
                            setMq(newMq_1);
                            return function() {
                                if (newMq_1) newMq_1.dispose();
                            };
                        }
                    }, [
                        query,
                        device
                    ]);
                    return mq;
                };
                var useMatches = function(mediaQuery) {
                    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
                    (0, react_1.useEffect)(function() {
                        var updateMatches = function(ev) {
                            setMatches(ev.matches);
                        };
                        mediaQuery.addListener(updateMatches);
                        setMatches(mediaQuery.matches);
                        return function() {
                            mediaQuery.removeListener(updateMatches);
                        };
                    }, [
                        mediaQuery
                    ]);
                    return matches;
                };
                var useMediaQuery = function(settings, device, onChange) {
                    var deviceSettings = useDevice(device);
                    var query = useQuery(settings);
                    if (!query) throw new Error("Invalid or missing MediaQuery!");
                    var mq = useMatchMedia(query, deviceSettings);
                    var matches = useMatches(mq);
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate && onChange) onChange(matches);
                    }, [
                        matches
                    ]);
                    (0, react_1.useEffect)(function() {
                        return function() {
                            if (mq) mq.dispose();
                        };
                    }, []);
                    return matches;
                };
                exports["default"] = useMediaQuery;
            /***/ },
            /***/ "react": /*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/ /***/ (module1)=>{
                "use strict";
                module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/index.ts");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});

});

parcelRegister("e5Hn4", function(module, exports) {
"use strict";

var $eUxou = parcelRequire("eUxou");

var $5UdfO = parcelRequire("5UdfO");

var $fRIlK = parcelRequire("fRIlK");
module.exports = {
    formats: $fRIlK,
    parse: $5UdfO,
    stringify: $eUxou
};

});
parcelRegister("eUxou", function(module, exports) {
"use strict";

var $jynlu = parcelRequire("jynlu");

var $4p8cw = parcelRequire("4p8cw");

var $fRIlK = parcelRequire("fRIlK");
var $adb032fcb60d5dab$var$has = Object.prototype.hasOwnProperty;
var $adb032fcb60d5dab$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $adb032fcb60d5dab$var$isArray = Array.isArray;
var $adb032fcb60d5dab$var$push = Array.prototype.push;
var $adb032fcb60d5dab$var$pushToArray = function(arr, valueOrArray) {
    $adb032fcb60d5dab$var$push.apply(arr, $adb032fcb60d5dab$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $adb032fcb60d5dab$var$toISO = Date.prototype.toISOString;
var $adb032fcb60d5dab$var$defaultFormat = $fRIlK.default;
var $adb032fcb60d5dab$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $4p8cw.encode,
    encodeValuesOnly: false,
    format: $adb032fcb60d5dab$var$defaultFormat,
    formatter: $fRIlK.formatters[$adb032fcb60d5dab$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $adb032fcb60d5dab$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $adb032fcb60d5dab$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $adb032fcb60d5dab$var$sentinel = {};
var $adb032fcb60d5dab$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($adb032fcb60d5dab$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($adb032fcb60d5dab$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $adb032fcb60d5dab$var$isArray(obj)) obj = $4p8cw.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $adb032fcb60d5dab$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($adb032fcb60d5dab$var$isNonNullishPrimitive(obj) || $4p8cw.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $adb032fcb60d5dab$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $adb032fcb60d5dab$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $adb032fcb60d5dab$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $4p8cw.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($adb032fcb60d5dab$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $adb032fcb60d5dab$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $adb032fcb60d5dab$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $adb032fcb60d5dab$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $jynlu();
        valueSideChannel.set($adb032fcb60d5dab$var$sentinel, sideChannel);
        $adb032fcb60d5dab$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $adb032fcb60d5dab$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $adb032fcb60d5dab$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $adb032fcb60d5dab$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $adb032fcb60d5dab$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $fRIlK.default;
    if (typeof opts.format !== "undefined") {
        if (!$adb032fcb60d5dab$var$has.call($fRIlK.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $fRIlK.formatters[format];
    var filter = $adb032fcb60d5dab$var$defaults.filter;
    if (typeof opts.filter === "function" || $adb032fcb60d5dab$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $adb032fcb60d5dab$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $adb032fcb60d5dab$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $adb032fcb60d5dab$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $adb032fcb60d5dab$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $adb032fcb60d5dab$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $adb032fcb60d5dab$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $adb032fcb60d5dab$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $adb032fcb60d5dab$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $adb032fcb60d5dab$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $adb032fcb60d5dab$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $adb032fcb60d5dab$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $adb032fcb60d5dab$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $adb032fcb60d5dab$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $adb032fcb60d5dab$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $adb032fcb60d5dab$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($adb032fcb60d5dab$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $adb032fcb60d5dab$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $jynlu();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $adb032fcb60d5dab$var$pushToArray(keys, $adb032fcb60d5dab$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("jynlu", function(module, exports) {
"use strict";

var $eZYUs = parcelRequire("eZYUs");

var $d8cyw = parcelRequire("d8cyw");

var $em2Ob = parcelRequire("em2Ob");

var $8ELwa = parcelRequire("8ELwa");
var $e3c34d442d0476ff$var$$WeakMap = $eZYUs("%WeakMap%", true);
var $e3c34d442d0476ff$var$$Map = $eZYUs("%Map%", true);
var $e3c34d442d0476ff$var$$weakMapGet = $d8cyw("WeakMap.prototype.get", true);
var $e3c34d442d0476ff$var$$weakMapSet = $d8cyw("WeakMap.prototype.set", true);
var $e3c34d442d0476ff$var$$weakMapHas = $d8cyw("WeakMap.prototype.has", true);
var $e3c34d442d0476ff$var$$mapGet = $d8cyw("Map.prototype.get", true);
var $e3c34d442d0476ff$var$$mapSet = $d8cyw("Map.prototype.set", true);
var $e3c34d442d0476ff$var$$mapHas = $d8cyw("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $e3c34d442d0476ff$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $e3c34d442d0476ff$var$listGet = function(objects, key) {
    var node = $e3c34d442d0476ff$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $e3c34d442d0476ff$var$listSet = function(objects, key, value) {
    var node = $e3c34d442d0476ff$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $e3c34d442d0476ff$var$listHas = function(objects, key) {
    return !!$e3c34d442d0476ff$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $8ELwa("Side channel does not contain " + $em2Ob(key));
        },
        get: function(key) {
            if ($e3c34d442d0476ff$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $e3c34d442d0476ff$var$$weakMapGet($wm, key);
            } else if ($e3c34d442d0476ff$var$$Map) {
                if ($m) return $e3c34d442d0476ff$var$$mapGet($m, key);
            } else {
                if ($o) return $e3c34d442d0476ff$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($e3c34d442d0476ff$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $e3c34d442d0476ff$var$$weakMapHas($wm, key);
            } else if ($e3c34d442d0476ff$var$$Map) {
                if ($m) return $e3c34d442d0476ff$var$$mapHas($m, key);
            } else {
                if ($o) return $e3c34d442d0476ff$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($e3c34d442d0476ff$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $e3c34d442d0476ff$var$$WeakMap();
                $e3c34d442d0476ff$var$$weakMapSet($wm, key, value);
            } else if ($e3c34d442d0476ff$var$$Map) {
                if (!$m) $m = new $e3c34d442d0476ff$var$$Map();
                $e3c34d442d0476ff$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $e3c34d442d0476ff$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("eZYUs", function(module, exports) {
"use strict";
var $aeb6028e17247ccb$var$undefined1;

var $6YlRD = parcelRequire("6YlRD");

var $5oshl = parcelRequire("5oshl");

var $7MXJO = parcelRequire("7MXJO");

var $afTLh = parcelRequire("afTLh");

var $dMmUi = parcelRequire("dMmUi");

var $8ELwa = parcelRequire("8ELwa");

var $7go2o = parcelRequire("7go2o");
var $aeb6028e17247ccb$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $aeb6028e17247ccb$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $aeb6028e17247ccb$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $aeb6028e17247ccb$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($aeb6028e17247ccb$var$$gOPD) try {
    $aeb6028e17247ccb$var$$gOPD({}, "");
} catch (e) {
    $aeb6028e17247ccb$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $aeb6028e17247ccb$var$throwTypeError = function() {
    throw new $8ELwa();
};
var $aeb6028e17247ccb$var$ThrowTypeError = $aeb6028e17247ccb$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $aeb6028e17247ccb$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $aeb6028e17247ccb$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $aeb6028e17247ccb$var$throwTypeError;
        }
    }
}() : $aeb6028e17247ccb$var$throwTypeError;

var $aeb6028e17247ccb$var$hasSymbols = (parcelRequire("gBdxY"))();

var $aeb6028e17247ccb$var$hasProto = (parcelRequire("9hKML"))();
var $aeb6028e17247ccb$var$getProto = Object.getPrototypeOf || ($aeb6028e17247ccb$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $aeb6028e17247ccb$var$needsEval = {};
var $aeb6028e17247ccb$var$TypedArray = typeof Uint8Array === "undefined" || !$aeb6028e17247ccb$var$getProto ? undefined : $aeb6028e17247ccb$var$getProto(Uint8Array);
var $aeb6028e17247ccb$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $aeb6028e17247ccb$var$hasSymbols && $aeb6028e17247ccb$var$getProto ? $aeb6028e17247ccb$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $aeb6028e17247ccb$var$needsEval,
    "%AsyncGenerator%": $aeb6028e17247ccb$var$needsEval,
    "%AsyncGeneratorFunction%": $aeb6028e17247ccb$var$needsEval,
    "%AsyncIteratorPrototype%": $aeb6028e17247ccb$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $6YlRD,
    "%eval%": eval,
    "%EvalError%": $5oshl,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $aeb6028e17247ccb$var$$Function,
    "%GeneratorFunction%": $aeb6028e17247ccb$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $aeb6028e17247ccb$var$hasSymbols && $aeb6028e17247ccb$var$getProto ? $aeb6028e17247ccb$var$getProto($aeb6028e17247ccb$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$aeb6028e17247ccb$var$hasSymbols || !$aeb6028e17247ccb$var$getProto ? undefined : $aeb6028e17247ccb$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $7MXJO,
    "%ReferenceError%": $afTLh,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$aeb6028e17247ccb$var$hasSymbols || !$aeb6028e17247ccb$var$getProto ? undefined : $aeb6028e17247ccb$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $aeb6028e17247ccb$var$hasSymbols && $aeb6028e17247ccb$var$getProto ? $aeb6028e17247ccb$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $aeb6028e17247ccb$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $dMmUi,
    "%ThrowTypeError%": $aeb6028e17247ccb$var$ThrowTypeError,
    "%TypedArray%": $aeb6028e17247ccb$var$TypedArray,
    "%TypeError%": $8ELwa,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $7go2o,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($aeb6028e17247ccb$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $aeb6028e17247ccb$var$errorProto = $aeb6028e17247ccb$var$getProto($aeb6028e17247ccb$var$getProto(e));
    $aeb6028e17247ccb$var$INTRINSICS["%Error.prototype%"] = $aeb6028e17247ccb$var$errorProto;
}
var $aeb6028e17247ccb$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $aeb6028e17247ccb$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $aeb6028e17247ccb$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $aeb6028e17247ccb$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $aeb6028e17247ccb$var$getProto) value = $aeb6028e17247ccb$var$getProto(gen.prototype);
    }
    $aeb6028e17247ccb$var$INTRINSICS[name] = value;
    return value;
};
var $aeb6028e17247ccb$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gCKEZ = parcelRequire("gCKEZ");

var $6MhcD = parcelRequire("6MhcD");
var $aeb6028e17247ccb$var$$concat = $gCKEZ.call(Function.call, Array.prototype.concat);
var $aeb6028e17247ccb$var$$spliceApply = $gCKEZ.call(Function.apply, Array.prototype.splice);
var $aeb6028e17247ccb$var$$replace = $gCKEZ.call(Function.call, String.prototype.replace);
var $aeb6028e17247ccb$var$$strSlice = $gCKEZ.call(Function.call, String.prototype.slice);
var $aeb6028e17247ccb$var$$exec = $gCKEZ.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $aeb6028e17247ccb$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $aeb6028e17247ccb$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $aeb6028e17247ccb$var$stringToPath = function stringToPath(string) {
    var first = $aeb6028e17247ccb$var$$strSlice(string, 0, 1);
    var last = $aeb6028e17247ccb$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $dMmUi("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $dMmUi("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $aeb6028e17247ccb$var$$replace(string, $aeb6028e17247ccb$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $aeb6028e17247ccb$var$$replace(subString, $aeb6028e17247ccb$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $aeb6028e17247ccb$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($6MhcD($aeb6028e17247ccb$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $aeb6028e17247ccb$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($6MhcD($aeb6028e17247ccb$var$INTRINSICS, intrinsicName)) {
        var value = $aeb6028e17247ccb$var$INTRINSICS[intrinsicName];
        if (value === $aeb6028e17247ccb$var$needsEval) value = $aeb6028e17247ccb$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $8ELwa("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $dMmUi("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $8ELwa("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $8ELwa('"allowMissing" argument must be a boolean');
    if ($aeb6028e17247ccb$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $dMmUi("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $aeb6028e17247ccb$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $aeb6028e17247ccb$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $aeb6028e17247ccb$var$$spliceApply(parts, $aeb6028e17247ccb$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $aeb6028e17247ccb$var$$strSlice(part, 0, 1);
        var last = $aeb6028e17247ccb$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $dMmUi("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($6MhcD($aeb6028e17247ccb$var$INTRINSICS, intrinsicRealName)) value = $aeb6028e17247ccb$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $8ELwa("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($aeb6028e17247ccb$var$$gOPD && i + 1 >= parts.length) {
                var desc = $aeb6028e17247ccb$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $6MhcD(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $aeb6028e17247ccb$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("6YlRD", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("5oshl", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("7MXJO", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("afTLh", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("dMmUi", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("8ELwa", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("7go2o", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("gBdxY", function(module, exports) {
"use strict";
var $c15a9c2fe1c39d8f$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $eTqIJ = parcelRequire("eTqIJ");
module.exports = function hasNativeSymbols() {
    if (typeof $c15a9c2fe1c39d8f$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $c15a9c2fe1c39d8f$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $eTqIJ();
};

});
parcelRegister("eTqIJ", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9hKML", function(module, exports) {
"use strict";
var $6c29fe313ed0cfe9$var$test = {
    __proto__: null,
    foo: {}
};
var $6c29fe313ed0cfe9$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $6c29fe313ed0cfe9$var$test
    }).foo === $6c29fe313ed0cfe9$var$test.foo && !($6c29fe313ed0cfe9$var$test instanceof $6c29fe313ed0cfe9$var$$Object);
};

});

parcelRegister("gCKEZ", function(module, exports) {
"use strict";

var $2qBF6 = parcelRequire("2qBF6");
module.exports = Function.prototype.bind || $2qBF6;

});
parcelRegister("2qBF6", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $1c4b395c0af4ac3a$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $1c4b395c0af4ac3a$var$toStr = Object.prototype.toString;
var $1c4b395c0af4ac3a$var$max = Math.max;
var $1c4b395c0af4ac3a$var$funcType = "[object Function]";
var $1c4b395c0af4ac3a$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $1c4b395c0af4ac3a$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $1c4b395c0af4ac3a$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $1c4b395c0af4ac3a$var$toStr.apply(target) !== $1c4b395c0af4ac3a$var$funcType) throw new TypeError($1c4b395c0af4ac3a$var$ERROR_MESSAGE + target);
    var args = $1c4b395c0af4ac3a$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $1c4b395c0af4ac3a$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $1c4b395c0af4ac3a$var$concatty(args, arguments));
    };
    var boundLength = $1c4b395c0af4ac3a$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $1c4b395c0af4ac3a$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("6MhcD", function(module, exports) {
"use strict";
var $4ef491dfd9488b71$var$call = Function.prototype.call;
var $4ef491dfd9488b71$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gCKEZ = parcelRequire("gCKEZ");
/** @type {import('.')} */ module.exports = $gCKEZ.call($4ef491dfd9488b71$var$call, $4ef491dfd9488b71$var$$hasOwn);

});


parcelRegister("d8cyw", function(module, exports) {
"use strict";

var $eZYUs = parcelRequire("eZYUs");

var $lKjcS = parcelRequire("lKjcS");
var $98f5c306d173dfea$var$$indexOf = $lKjcS($eZYUs("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $eZYUs(name, !!allowMissing);
    if (typeof intrinsic === "function" && $98f5c306d173dfea$var$$indexOf(name, ".prototype.") > -1) return $lKjcS(intrinsic);
    return intrinsic;
};

});
parcelRegister("lKjcS", function(module, exports) {
"use strict";

var $gCKEZ = parcelRequire("gCKEZ");

var $eZYUs = parcelRequire("eZYUs");

var $5BIpW = parcelRequire("5BIpW");

var $8ELwa = parcelRequire("8ELwa");
var $fd4ccaea37996c93$var$$apply = $eZYUs("%Function.prototype.apply%");
var $fd4ccaea37996c93$var$$call = $eZYUs("%Function.prototype.call%");
var $fd4ccaea37996c93$var$$reflectApply = $eZYUs("%Reflect.apply%", true) || $gCKEZ.call($fd4ccaea37996c93$var$$call, $fd4ccaea37996c93$var$$apply);

var $gcTfA = parcelRequire("gcTfA");
var $fd4ccaea37996c93$var$$max = $eZYUs("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $8ELwa("a function is required");
    var func = $fd4ccaea37996c93$var$$reflectApply($gCKEZ, $fd4ccaea37996c93$var$$call, arguments);
    return $5BIpW(func, 1 + $fd4ccaea37996c93$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $fd4ccaea37996c93$var$applyBind = function applyBind() {
    return $fd4ccaea37996c93$var$$reflectApply($gCKEZ, $fd4ccaea37996c93$var$$apply, arguments);
};
if ($gcTfA) $gcTfA(module.exports, "apply", {
    value: $fd4ccaea37996c93$var$applyBind
});
else module.exports.apply = $fd4ccaea37996c93$var$applyBind;

});
parcelRegister("5BIpW", function(module, exports) {
"use strict";

var $eZYUs = parcelRequire("eZYUs");

var $fiT4I = parcelRequire("fiT4I");

var $4152dcd068ed5792$var$hasDescriptors = (parcelRequire("cL1iF"))();

var $04aqq = parcelRequire("04aqq");

var $8ELwa = parcelRequire("8ELwa");
var $4152dcd068ed5792$var$$floor = $eZYUs("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $8ELwa("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $4152dcd068ed5792$var$$floor(length) !== length) throw new $8ELwa("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $04aqq) {
        var desc = $04aqq(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($4152dcd068ed5792$var$hasDescriptors) $fiT4I(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $fiT4I(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("fiT4I", function(module, exports) {
"use strict";

var $gcTfA = parcelRequire("gcTfA");

var $dMmUi = parcelRequire("dMmUi");

var $8ELwa = parcelRequire("8ELwa");

var $04aqq = parcelRequire("04aqq");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $8ELwa("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $8ELwa("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $8ELwa("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $8ELwa("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $8ELwa("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $8ELwa("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$04aqq && $04aqq(obj, property);
    if ($gcTfA) $gcTfA(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $dMmUi("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("gcTfA", function(module, exports) {
"use strict";

var $eZYUs = parcelRequire("eZYUs");
/** @type {import('.')} */ var $bcc89fe384249fa2$var$$defineProperty = $eZYUs("%Object.defineProperty%", true) || false;
if ($bcc89fe384249fa2$var$$defineProperty) try {
    $bcc89fe384249fa2$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $bcc89fe384249fa2$var$$defineProperty = false;
}
module.exports = $bcc89fe384249fa2$var$$defineProperty;

});

parcelRegister("04aqq", function(module, exports) {
"use strict";

var $eZYUs = parcelRequire("eZYUs");
var $00c87612252e0d9a$var$$gOPD = $eZYUs("%Object.getOwnPropertyDescriptor%", true);
if ($00c87612252e0d9a$var$$gOPD) try {
    $00c87612252e0d9a$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $00c87612252e0d9a$var$$gOPD = null;
}
module.exports = $00c87612252e0d9a$var$$gOPD;

});


parcelRegister("cL1iF", function(module, exports) {
"use strict";

var $gcTfA = parcelRequire("gcTfA");
var $949ae1ff81004533$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$gcTfA;
};
$949ae1ff81004533$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$gcTfA) return null;
    try {
        return $gcTfA([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $949ae1ff81004533$var$hasPropertyDescriptors;

});




parcelRegister("em2Ob", function(module, exports) {
var $a7354c767d0d03f6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a7354c767d0d03f6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a7354c767d0d03f6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a7354c767d0d03f6$var$mapSize = $a7354c767d0d03f6$var$hasMap && $a7354c767d0d03f6$var$mapSizeDescriptor && typeof $a7354c767d0d03f6$var$mapSizeDescriptor.get === "function" ? $a7354c767d0d03f6$var$mapSizeDescriptor.get : null;
var $a7354c767d0d03f6$var$mapForEach = $a7354c767d0d03f6$var$hasMap && Map.prototype.forEach;
var $a7354c767d0d03f6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a7354c767d0d03f6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a7354c767d0d03f6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a7354c767d0d03f6$var$setSize = $a7354c767d0d03f6$var$hasSet && $a7354c767d0d03f6$var$setSizeDescriptor && typeof $a7354c767d0d03f6$var$setSizeDescriptor.get === "function" ? $a7354c767d0d03f6$var$setSizeDescriptor.get : null;
var $a7354c767d0d03f6$var$setForEach = $a7354c767d0d03f6$var$hasSet && Set.prototype.forEach;
var $a7354c767d0d03f6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a7354c767d0d03f6$var$weakMapHas = $a7354c767d0d03f6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a7354c767d0d03f6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a7354c767d0d03f6$var$weakSetHas = $a7354c767d0d03f6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a7354c767d0d03f6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a7354c767d0d03f6$var$weakRefDeref = $a7354c767d0d03f6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a7354c767d0d03f6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a7354c767d0d03f6$var$objectToString = Object.prototype.toString;
var $a7354c767d0d03f6$var$functionToString = Function.prototype.toString;
var $a7354c767d0d03f6$var$$match = String.prototype.match;
var $a7354c767d0d03f6$var$$slice = String.prototype.slice;
var $a7354c767d0d03f6$var$$replace = String.prototype.replace;
var $a7354c767d0d03f6$var$$toUpperCase = String.prototype.toUpperCase;
var $a7354c767d0d03f6$var$$toLowerCase = String.prototype.toLowerCase;
var $a7354c767d0d03f6$var$$test = RegExp.prototype.test;
var $a7354c767d0d03f6$var$$concat = Array.prototype.concat;
var $a7354c767d0d03f6$var$$join = Array.prototype.join;
var $a7354c767d0d03f6$var$$arrSlice = Array.prototype.slice;
var $a7354c767d0d03f6$var$$floor = Math.floor;
var $a7354c767d0d03f6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a7354c767d0d03f6$var$gOPS = Object.getOwnPropertySymbols;
var $a7354c767d0d03f6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a7354c767d0d03f6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a7354c767d0d03f6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a7354c767d0d03f6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a7354c767d0d03f6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a7354c767d0d03f6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a7354c767d0d03f6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a7354c767d0d03f6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a7354c767d0d03f6$var$$floor(-num) : $a7354c767d0d03f6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a7354c767d0d03f6$var$$slice.call(str, intStr.length + 1);
            return $a7354c767d0d03f6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a7354c767d0d03f6$var$$replace.call($a7354c767d0d03f6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a7354c767d0d03f6$var$$replace.call(str, sepRegex, "$&_");
}

var $ewp99 = parcelRequire("ewp99");
var $a7354c767d0d03f6$var$inspectCustom = $ewp99.custom;
var $a7354c767d0d03f6$var$inspectSymbol = $a7354c767d0d03f6$var$isSymbol($a7354c767d0d03f6$var$inspectCustom) ? $a7354c767d0d03f6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a7354c767d0d03f6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a7354c767d0d03f6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a7354c767d0d03f6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a7354c767d0d03f6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a7354c767d0d03f6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a7354c767d0d03f6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a7354c767d0d03f6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a7354c767d0d03f6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a7354c767d0d03f6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a7354c767d0d03f6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a7354c767d0d03f6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a7354c767d0d03f6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a7354c767d0d03f6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a7354c767d0d03f6$var$isRegExp(obj)) {
        var name = $a7354c767d0d03f6$var$nameOf(obj);
        var keys = $a7354c767d0d03f6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a7354c767d0d03f6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a7354c767d0d03f6$var$isSymbol(obj)) {
        var symString = $a7354c767d0d03f6$var$hasShammedSymbols ? $a7354c767d0d03f6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a7354c767d0d03f6$var$symToString.call(obj);
        return typeof obj === "object" && !$a7354c767d0d03f6$var$hasShammedSymbols ? $a7354c767d0d03f6$var$markBoxed(symString) : symString;
    }
    if ($a7354c767d0d03f6$var$isElement(obj)) {
        var s = "<" + $a7354c767d0d03f6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a7354c767d0d03f6$var$wrapQuotes($a7354c767d0d03f6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a7354c767d0d03f6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a7354c767d0d03f6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a7354c767d0d03f6$var$arrObjKeys(obj, inspect);
        if (indent && !$a7354c767d0d03f6$var$singleLineValues(xs)) return "[" + $a7354c767d0d03f6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a7354c767d0d03f6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a7354c767d0d03f6$var$isError(obj)) {
        var parts = $a7354c767d0d03f6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a7354c767d0d03f6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a7354c767d0d03f6$var$$join.call($a7354c767d0d03f6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a7354c767d0d03f6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a7354c767d0d03f6$var$inspectSymbol && typeof obj[$a7354c767d0d03f6$var$inspectSymbol] === "function" && $ewp99) return $ewp99(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a7354c767d0d03f6$var$isMap(obj)) {
        var mapParts = [];
        if ($a7354c767d0d03f6$var$mapForEach) $a7354c767d0d03f6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a7354c767d0d03f6$var$collectionOf("Map", $a7354c767d0d03f6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a7354c767d0d03f6$var$isSet(obj)) {
        var setParts = [];
        if ($a7354c767d0d03f6$var$setForEach) $a7354c767d0d03f6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a7354c767d0d03f6$var$collectionOf("Set", $a7354c767d0d03f6$var$setSize.call(obj), setParts, indent);
    }
    if ($a7354c767d0d03f6$var$isWeakMap(obj)) return $a7354c767d0d03f6$var$weakCollectionOf("WeakMap");
    if ($a7354c767d0d03f6$var$isWeakSet(obj)) return $a7354c767d0d03f6$var$weakCollectionOf("WeakSet");
    if ($a7354c767d0d03f6$var$isWeakRef(obj)) return $a7354c767d0d03f6$var$weakCollectionOf("WeakRef");
    if ($a7354c767d0d03f6$var$isNumber(obj)) return $a7354c767d0d03f6$var$markBoxed(inspect(Number(obj)));
    if ($a7354c767d0d03f6$var$isBigInt(obj)) return $a7354c767d0d03f6$var$markBoxed(inspect($a7354c767d0d03f6$var$bigIntValueOf.call(obj)));
    if ($a7354c767d0d03f6$var$isBoolean(obj)) return $a7354c767d0d03f6$var$markBoxed($a7354c767d0d03f6$var$booleanValueOf.call(obj));
    if ($a7354c767d0d03f6$var$isString(obj)) return $a7354c767d0d03f6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a7354c767d0d03f6$var$isDate(obj) && !$a7354c767d0d03f6$var$isRegExp(obj)) {
        var ys = $a7354c767d0d03f6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a7354c767d0d03f6$var$gPO ? $a7354c767d0d03f6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a7354c767d0d03f6$var$toStringTag && Object(obj) === obj && $a7354c767d0d03f6$var$toStringTag in obj ? $a7354c767d0d03f6$var$$slice.call($a7354c767d0d03f6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a7354c767d0d03f6$var$$join.call($a7354c767d0d03f6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a7354c767d0d03f6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a7354c767d0d03f6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a7354c767d0d03f6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a7354c767d0d03f6$var$quote(s) {
    return $a7354c767d0d03f6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a7354c767d0d03f6$var$isArray(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object Array]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isDate(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object Date]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isRegExp(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object RegExp]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isError(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object Error]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isString(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object String]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isNumber(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object Number]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
function $a7354c767d0d03f6$var$isBoolean(obj) {
    return $a7354c767d0d03f6$var$toStr(obj) === "[object Boolean]" && (!$a7354c767d0d03f6$var$toStringTag || !(typeof obj === "object" && $a7354c767d0d03f6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a7354c767d0d03f6$var$isSymbol(obj) {
    if ($a7354c767d0d03f6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a7354c767d0d03f6$var$symToString) return false;
    try {
        $a7354c767d0d03f6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a7354c767d0d03f6$var$bigIntValueOf) return false;
    try {
        $a7354c767d0d03f6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a7354c767d0d03f6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a7354c767d0d03f6$var$has(obj, key) {
    return $a7354c767d0d03f6$var$hasOwn.call(obj, key);
}
function $a7354c767d0d03f6$var$toStr(obj) {
    return $a7354c767d0d03f6$var$objectToString.call(obj);
}
function $a7354c767d0d03f6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a7354c767d0d03f6$var$$match.call($a7354c767d0d03f6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a7354c767d0d03f6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a7354c767d0d03f6$var$isMap(x) {
    if (!$a7354c767d0d03f6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a7354c767d0d03f6$var$mapSize.call(x);
        try {
            $a7354c767d0d03f6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isWeakMap(x) {
    if (!$a7354c767d0d03f6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a7354c767d0d03f6$var$weakMapHas.call(x, $a7354c767d0d03f6$var$weakMapHas);
        try {
            $a7354c767d0d03f6$var$weakSetHas.call(x, $a7354c767d0d03f6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isWeakRef(x) {
    if (!$a7354c767d0d03f6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a7354c767d0d03f6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isSet(x) {
    if (!$a7354c767d0d03f6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a7354c767d0d03f6$var$setSize.call(x);
        try {
            $a7354c767d0d03f6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isWeakSet(x) {
    if (!$a7354c767d0d03f6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a7354c767d0d03f6$var$weakSetHas.call(x, $a7354c767d0d03f6$var$weakSetHas);
        try {
            $a7354c767d0d03f6$var$weakMapHas.call(x, $a7354c767d0d03f6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a7354c767d0d03f6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a7354c767d0d03f6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a7354c767d0d03f6$var$inspectString($a7354c767d0d03f6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a7354c767d0d03f6$var$$replace.call($a7354c767d0d03f6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a7354c767d0d03f6$var$lowbyte);
    return $a7354c767d0d03f6$var$wrapQuotes(s, "single", opts);
}
function $a7354c767d0d03f6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a7354c767d0d03f6$var$$toUpperCase.call(n.toString(16));
}
function $a7354c767d0d03f6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a7354c767d0d03f6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a7354c767d0d03f6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a7354c767d0d03f6$var$indentedJoin(entries, indent) : $a7354c767d0d03f6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a7354c767d0d03f6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a7354c767d0d03f6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a7354c767d0d03f6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a7354c767d0d03f6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a7354c767d0d03f6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a7354c767d0d03f6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a7354c767d0d03f6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a7354c767d0d03f6$var$arrObjKeys(obj, inspect) {
    var isArr = $a7354c767d0d03f6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a7354c767d0d03f6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a7354c767d0d03f6$var$gOPS === "function" ? $a7354c767d0d03f6$var$gOPS(obj) : [];
    var symMap;
    if ($a7354c767d0d03f6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a7354c767d0d03f6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a7354c767d0d03f6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a7354c767d0d03f6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a7354c767d0d03f6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a7354c767d0d03f6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("ewp99", function(module, exports) {
"use strict";

});



parcelRegister("4p8cw", function(module, exports) {
"use strict";

var $fRIlK = parcelRequire("fRIlK");
var $334fdbc53ebb0a37$var$has = Object.prototype.hasOwnProperty;
var $334fdbc53ebb0a37$var$isArray = Array.isArray;
var $334fdbc53ebb0a37$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $334fdbc53ebb0a37$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($334fdbc53ebb0a37$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $334fdbc53ebb0a37$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $334fdbc53ebb0a37$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($334fdbc53ebb0a37$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$334fdbc53ebb0a37$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($334fdbc53ebb0a37$var$isArray(target) && !$334fdbc53ebb0a37$var$isArray(source)) mergeTarget = $334fdbc53ebb0a37$var$arrayToObject(target, options);
    if ($334fdbc53ebb0a37$var$isArray(target) && $334fdbc53ebb0a37$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($334fdbc53ebb0a37$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($334fdbc53ebb0a37$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $334fdbc53ebb0a37$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $334fdbc53ebb0a37$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $334fdbc53ebb0a37$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $334fdbc53ebb0a37$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $334fdbc53ebb0a37$var$limit){
        var segment = string.length >= $334fdbc53ebb0a37$var$limit ? string.slice(j, j + $334fdbc53ebb0a37$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $fRIlK.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $334fdbc53ebb0a37$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $334fdbc53ebb0a37$var$hexTable[0xC0 | c >> 6] + $334fdbc53ebb0a37$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $334fdbc53ebb0a37$var$hexTable[0xE0 | c >> 12] + $334fdbc53ebb0a37$var$hexTable[0x80 | c >> 6 & 0x3F] + $334fdbc53ebb0a37$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $334fdbc53ebb0a37$var$hexTable[0xF0 | c >> 18] + $334fdbc53ebb0a37$var$hexTable[0x80 | c >> 12 & 0x3F] + $334fdbc53ebb0a37$var$hexTable[0x80 | c >> 6 & 0x3F] + $334fdbc53ebb0a37$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $334fdbc53ebb0a37$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $334fdbc53ebb0a37$var$compactQueue(queue);
    return value;
};
var $334fdbc53ebb0a37$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $334fdbc53ebb0a37$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $334fdbc53ebb0a37$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $334fdbc53ebb0a37$var$maybeMap = function maybeMap(val, fn) {
    if ($334fdbc53ebb0a37$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $334fdbc53ebb0a37$var$arrayToObject,
    assign: $334fdbc53ebb0a37$var$assign,
    combine: $334fdbc53ebb0a37$var$combine,
    compact: $334fdbc53ebb0a37$var$compact,
    decode: $334fdbc53ebb0a37$var$decode,
    encode: $334fdbc53ebb0a37$var$encode,
    isBuffer: $334fdbc53ebb0a37$var$isBuffer,
    isRegExp: $334fdbc53ebb0a37$var$isRegExp,
    maybeMap: $334fdbc53ebb0a37$var$maybeMap,
    merge: $334fdbc53ebb0a37$var$merge
};

});
parcelRegister("fRIlK", function(module, exports) {
"use strict";
var $b8ce352b7339c5c4$var$replace = String.prototype.replace;
var $b8ce352b7339c5c4$var$percentTwenties = /%20/g;
var $b8ce352b7339c5c4$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $b8ce352b7339c5c4$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $b8ce352b7339c5c4$var$replace.call(value, $b8ce352b7339c5c4$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $b8ce352b7339c5c4$var$Format.RFC1738,
    RFC3986: $b8ce352b7339c5c4$var$Format.RFC3986
};

});



parcelRegister("5UdfO", function(module, exports) {
"use strict";

var $4p8cw = parcelRequire("4p8cw");
var $44cc76adb2f8cfb5$var$has = Object.prototype.hasOwnProperty;
var $44cc76adb2f8cfb5$var$isArray = Array.isArray;
var $44cc76adb2f8cfb5$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $4p8cw.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $44cc76adb2f8cfb5$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $44cc76adb2f8cfb5$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $44cc76adb2f8cfb5$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $44cc76adb2f8cfb5$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $44cc76adb2f8cfb5$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $44cc76adb2f8cfb5$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $44cc76adb2f8cfb5$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $44cc76adb2f8cfb5$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $44cc76adb2f8cfb5$var$defaults.decoder, charset, "key");
            val = $4p8cw.maybeMap($44cc76adb2f8cfb5$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $44cc76adb2f8cfb5$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $44cc76adb2f8cfb5$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $44cc76adb2f8cfb5$var$isArray(val) ? [
            val
        ] : val;
        var existing = $44cc76adb2f8cfb5$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $4p8cw.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $44cc76adb2f8cfb5$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $44cc76adb2f8cfb5$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $44cc76adb2f8cfb5$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $44cc76adb2f8cfb5$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $44cc76adb2f8cfb5$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $44cc76adb2f8cfb5$var$parseObject(keys, val, options, valuesParsed);
};
var $44cc76adb2f8cfb5$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $44cc76adb2f8cfb5$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $44cc76adb2f8cfb5$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $44cc76adb2f8cfb5$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $44cc76adb2f8cfb5$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $44cc76adb2f8cfb5$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $44cc76adb2f8cfb5$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $44cc76adb2f8cfb5$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $44cc76adb2f8cfb5$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $44cc76adb2f8cfb5$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $44cc76adb2f8cfb5$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $44cc76adb2f8cfb5$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $44cc76adb2f8cfb5$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $4p8cw.isRegExp(opts.delimiter) ? opts.delimiter : $44cc76adb2f8cfb5$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $44cc76adb2f8cfb5$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $44cc76adb2f8cfb5$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $44cc76adb2f8cfb5$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $44cc76adb2f8cfb5$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $44cc76adb2f8cfb5$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $44cc76adb2f8cfb5$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $44cc76adb2f8cfb5$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $44cc76adb2f8cfb5$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $4p8cw.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $4p8cw.compact(obj);
};

});


parcelRegister("cbKYU", function(module, exports) {

$parcel$export(module.exports, "Refinement", function () { return $233627e2f745b2e1$export$5e0e38c9ee9e8a0b; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $33dni = parcelRequire("33dni");

var $gH7Rp = parcelRequire("gH7Rp");

var $bLLzi = parcelRequire("bLLzi");
var $TDsMS = parcelRequire("TDsMS");
var $bmfcN = parcelRequire("bmfcN");
var $eWPzc = parcelRequire("eWPzc");
var $SMyUQ = parcelRequire("SMyUQ");

var $ealH9 = parcelRequire("ealH9");

var $3aT1w = parcelRequire("3aT1w");
var $7RS04 = parcelRequire("7RS04");
var $fw3dV = parcelRequire("fw3dV");

var $8kzkJ = parcelRequire("8kzkJ");

var $grDIL = parcelRequire("grDIL");

var $gLiL7 = parcelRequire("gLiL7");

var $7mAg3 = parcelRequire("7mAg3");

var $60uP6 = parcelRequire("60uP6");

var $7mAg3 = parcelRequire("7mAg3");
const $233627e2f745b2e1$export$5e0e38c9ee9e8a0b = (0, $bLLzi.default)(({ searchResults: searchResults, searchState: searchState, bubbleFilters: bubbleFilters, tabName: tabName, setSearchState: setSearchState, handle: handle, highestPriceProduct: highestPriceProduct, lowestPriceProduct: lowestPriceProduct })=>{
    const { b2b: b2b, refinementToggle: refinementToggle, setRefinementToggle: setRefinementToggle } = (0, $7mAg3.usePLPContext)();
    const handleClearAll = ()=>{
        setFilterTray(false);
        setSearchState((prev)=>({
                ...prev,
                page: 1,
                refinementList: undefined,
                sortBy: "production_shopify_products",
                toggle: b2b ? {
                    [b2b]: "true"
                } : undefined,
                range: undefined
            }));
        setActiveFilters([]);
        setClearRange(true);
        setRefinementToggle({
            boolean: ""
        });
    };
    const isDesktop = (0, $7RS04.default)("(min-width: 768px)");
    const { stickyElementRef: stickyElementRef, isStuck: isStuck } = (0, $8kzkJ.useStickyContext)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const handleOpen = ()=>{
        setOpen((prev)=>!prev);
    };
    const [filterTray, setFilterTray] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const handleFilterTray = ()=>{
        setFilterTray((prev)=>!prev);
    };
    const [SearchStateTrigger, setSearchStateTrigger] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("");
    const [userSelect, setUserSelect] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState("");
    const [scrolled, setScrolled] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const handleScroll = (event)=>{
        setScrolled(event.target.scrollLeft ? true : false);
    };
    const [currentlyRefined, setCurrentlyRefined] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState();
    const [ClearRange, setClearRange] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const defaultSortBy = ()=>{
        setSearchState((prev)=>({
                ...prev,
                sortBy: "production_shopify_products"
            }));
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (filterTray) {
            document.body.classList.add("overflow-hidden");
            document.querySelector("#shopify-section-header").classList.add("outOfFocus");
            if (isStuck) document.body.classList.add("shopify-section-header-hidden");
            return ()=>{
                document.body.classList.remove("overflow-hidden");
                document.querySelector("#shopify-section-header").classList.remove("outOfFocus");
            };
        }
    }, [
        filterTray
    ]);
    const [ActiveSearchFilters, setActiveFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    let filterLength = [];
    let filters = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        let clearFilters = true;
        let activeFilters = searchState?.refinementList;
        for(const filter in activeFilters)if (activeFilters[filter] != "") {
            clearFilters = false;
            filterLength.push(activeFilters[filter].length);
            activeFilters[filter].map((item)=>{
                filters.push(item);
                setActiveFilters(filters);
            });
        }
        if (clearFilters) {
            if (SearchStateTrigger != "UsersortBy" && searchState?.sortBy === "production_shopify_products_newest" && currentlyRefined === undefined && userSelect != "newest") defaultSortBy();
            setActiveFilters([]);
        }
    }, [
        searchState
    ]);
    const [maxScroll, setMaxScroll] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const [minScroll, setMinScroll] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const watchScroll = function(e) {
        const scrollPosition = Math.round(e.target.scrollTop);
        const maxElementScroll = e.target.scrollHeight - e.target.clientHeight;
        if (scrollPosition == maxElementScroll || scrollPosition >= maxElementScroll - 40) setMaxScroll(true);
        else setMaxScroll(false);
        if (scrollPosition > 0) setMinScroll(true);
        else setMinScroll(false);
    };
    // if (!searchResults) return null;
    // const facets = searchResults.renderingContent.facetOrdering?.facets.order || [];
    // const facets = searchResults?.renderingContent?.facetOrdering?.facets.order
    //   ? searchResults.renderingContent.facetOrdering?.facets.order
    //   : [];
    // const facets = [
    //   "optionAvailability.Size",
    //   "facets.Colour",
    //   "facets.Support",
    //   "facets.Browse_all",
    //   "facets.Gender",
    //   "product_type",
    //   "available",
    //   "facets.Diet",
    //   "facets.Length",
    //   "facets.Material",
    //   "facets.Tops",
    //   "facets.Tees_tanks",
    //   "facets.Bras",
    //   "facets.Bralettes",
    //   "facets.Leggings",
    //   "facets.Shorts",
    //   "facets.Mens_shorts",
    //   "facets.Jumpers",
    //   "facets.Tracksuit_sets",
    //   "facets.Fit",
    //   "facets.Weight",
    //   "facets.Activity",
    //   "facets.Winter",
    //   "facets.Accessories",
    //   "facets.Maternity",
    //   "facets.Scrunch",
    //   "facets.Non-scrunch",
    //   "facets.Flavour",
    //   "facets.Caffeine Free",
    //   "facets.Pre_workout",
    //   "facets.Bars_snacks",
    //   "facets.Custard",
    //   "facets.Protein",
    //   "facets.Protein_snacks",
    //   "facets.Rtd",
    //   "facets.Daily_greens",
    //   "facets.Protein_water",
    //   "facets.Protein_powder",
    //   "facets.Hydration",
    //   "facets.Vegan_friendly",
    //   "facets.Gluten_free",
    //   "discounted",
    //   "sale_percentage"
    // ];
    const facets = window.facets_order;
    // const supportHasBraToggles = facets.includes('facets.Bras') || facets.includes('facets.Bralettes')
    const supportHasBraToggles = searchResults?.renderingContent?.facetOrdering?.facets.order.includes("facets.Bras") || searchResults?.renderingContent?.facetOrdering?.facets.order.includes("facets.Bralettes");
    const refinementList = searchState.refinementList;
    const hasNoFilters = facets.every((facet)=>window.facets[facet]?.type == "boolean");
    const filtersActive = ActiveSearchFilters.length != 0;
    const handleLink = (url)=>()=>{
            window.location.href = `${url}`;
        };
    return /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                ref: stickyElementRef,
                className: "component__refinement_wrapper",
                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    className: "sortby-container",
                    children: isDesktop && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: "sortby-wrapper",
                        children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                            className: "sortby",
                            children: [
                                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                    children: "Sort By"
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$SortOptionsDropdown, {
                                    searchState: searchState,
                                    SearchStateTrigger: SearchStateTrigger,
                                    setSearchStateTrigger: setSearchStateTrigger,
                                    setUserSelect: setUserSelect,
                                    items: Object.entries((0, $7mAg3.indexMap)).map(([key, value])=>({
                                            value: value,
                                            label: window.collectionStrings.indices[key]
                                        }))
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                    className: `sort-wrapper ${open ? "open" : ""}`,
                                    onMouseLeave: handleOpen,
                                    children: /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$SortOptions, {
                                        searchState: searchState,
                                        SearchStateTrigger: SearchStateTrigger,
                                        setSearchStateTrigger: setSearchStateTrigger,
                                        setUserSelect: setUserSelect,
                                        items: Object.entries((0, $7mAg3.indexMap)).map(([key, value])=>({
                                                value: value,
                                                label: window.collectionStrings.indices[key]
                                            }))
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: (0, $biy3n.default)(`filter-wrapper`, {
                    stuck: isStuck
                }),
                children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                    className: `filters`,
                    children: [
                        !isDesktop && /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                            className: (0, $biy3n.default)(`filter`, filtersActive ? " active" : ""),
                            onClick: handleFilterTray,
                            children: [
                                /*#__PURE__*/ (0, $drmv2.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "10",
                                    viewBox: "0 0 12 10",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M2.23389 9.3052L2.23389 6.0105",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M2.23389 4.12795L2.23389 0.833252",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M5.99951 9.30538L5.99951 5.06934",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M5.99951 3.18661L5.99951 0.833252",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M9.76465 9.30575V6.95239",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M9.76465 5.06929L9.76465 0.833252",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M0.822266 6.0105L3.64629 6.0105",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M4.58789 3.18677L7.41192 3.18677",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M8.35254 6.95239L11.1766 6.95239",
                                            stroke: "#18181B",
                                            "stroke-width": "1.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                    className: scrolled ? "scrolled" : "",
                                    children: filtersActive ? "Filters Active" : "Filter"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            className: `booleans-wrapper`,
                            onScroll: handleScroll,
                            children: facets?.map((facet)=>{
                                let facetType = window.facets[facet]?.type;
                                if (facetType == "boolean") return /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$ToggleRefinement, {
                                    attribute: facet,
                                    label: window.collectionStrings.facets[facet],
                                    value: true,
                                    searchState: searchState,
                                    setSearchState: setSearchState,
                                    setCurrentlyRefined: setCurrentlyRefined,
                                    currentlyRefined: currentlyRefined,
                                    searchResults: searchResults
                                }, facet);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: (0, $biy3n.default)($ealH9.root + " component__refinement", {
                    [$ealH9.stuck]: isStuck,
                    ["mobile"]: !isDesktop,
                    ["open"]: filterTray,
                    ["hidden"]: isDesktop && hasNoFilters
                }),
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: (0, $biy3n.default)($ealH9.backdrop, {
                            [$ealH9.open]: filterTray
                        }),
                        onClick: handleFilterTray
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: (0, $biy3n.default)("refinement-list-wrapper component__refinement", {
                            ["open"]: filterTray
                        }),
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: (0, $biy3n.default)("clear_all" + `${minScroll ? " shadowEnabled" : ""}`, {}),
                                children: [
                                    !isDesktop && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        className: (0, $biy3n.default)("clear_all_wrapper" + `${isDesktop ? " disabled" : " enabled"}`, {}),
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                            onClick: handleFilterTray,
                                            type: "button",
                                            "aria-label": "Close refinement menu",
                                            className: (0, $biy3n.default)("fab close", $ealH9.refinementMenuCloseButton),
                                            children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                                                width: 16,
                                                height: 16,
                                                icon: (0, $gH7Rp.faXmark)
                                            })
                                        })
                                    }),
                                    isDesktop ? /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        children: "Filters"
                                    }) : /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        children: "Sort & Filter"
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                            onClick: handleClearAll,
                                            className: (0, $biy3n.default)("clear_all_button" + `${ActiveSearchFilters.length != 0 || searchState?.range || searchState?.sortBy != "production_shopify_products" ? "" : " disabled"}`, {}),
                                            children: "Clear All"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: (0, $biy3n.default)($ealH9.innerTray),
                                onScroll: watchScroll,
                                children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: $ealH9.list + " refinement-list",
                                    children: [
                                        !isDesktop && /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$Menu, {
                                            count: 0,
                                            buttonLabel: `Sort By`,
                                            menuLabel: `Sort By`,
                                            children: /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$SortOptions, {
                                                searchState: searchState,
                                                SearchStateTrigger: SearchStateTrigger,
                                                setSearchStateTrigger: setSearchStateTrigger,
                                                setUserSelect: setUserSelect,
                                                items: Object.entries((0, $7mAg3.indexMap)).map(([key, value])=>({
                                                        value: value,
                                                        label: window.collectionStrings.indices[key]
                                                    }))
                                            })
                                        }),
                                        window.dynamicFilterCollections && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                            children: window?.dynamicFilterCollections?.map((collection, key)=>{
                                                return /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$Menu, {
                                                    count: collection.data.length,
                                                    buttonLabel: collection.name,
                                                    menuLabel: collection.name,
                                                    children: collection.data.map((item, key)=>/*#__PURE__*/ (0, $drmv2.jsx)("label", {
                                                            children: /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                onClick: handleLink(item.url),
                                                                style: {
                                                                    cursor: "pointer"
                                                                },
                                                                children: item.title
                                                            })
                                                        }, key))
                                                }, key);
                                            })
                                        }),
                                        facets?.map((facet)=>{
                                            let facetType = window.facets[facet]?.type;
                                            let facetMenuLabel = window.collectionStrings.facets[facet];
                                            const facetNoDisplay = facetType != "boolean" && facetMenuLabel != undefined;
                                            /* If 'Support' facet is available and Bras / Bralettes boolean toggle are available,
                   * hide Support unless Bra / Bralettes is toggled on.
                   */ // let displaySupport = searchState?.toggle && (searchState?.toggle['facets.Bralettes'] || searchState?.toggle['facets.Bras']) && facet == 'facets.Support' || supportHasBraToggles && facet != 'facets.Support' || !supportHasBraToggles
                                            // if (facetNoDisplay && displaySupport) {
                                            if (facetNoDisplay) return /*#__PURE__*/ (0, $drmv2.jsxs)($233627e2f745b2e1$var$Menu, {
                                                attribute: facet,
                                                count: refinementList ? refinementList[facet]?.length : 0,
                                                buttonLabel: window.collectionStrings.facets[facet],
                                                menuLabel: facetMenuLabel,
                                                searchResults: searchResults,
                                                children: [
                                                    facet == "facets.Price_slider" && /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$RangeSlider, {
                                                        highestPriceProduct: highestPriceProduct,
                                                        lowestPriceProduct: lowestPriceProduct,
                                                        defaultRefinement: {
                                                            min: lowestPriceProduct,
                                                            max: highestPriceProduct
                                                        },
                                                        attribute: "price",
                                                        ClearRange: ClearRange,
                                                        setClearRange: setClearRange,
                                                        searchState: searchState,
                                                        setSearchState: setSearchState
                                                    }),
                                                    /*#__PURE__*/ (0, $drmv2.jsx)($233627e2f745b2e1$var$MenuRefinement, {
                                                        attribute: facet,
                                                        searchState: searchState,
                                                        setSearchState: setSearchState,
                                                        handle: handle,
                                                        limit: 15,
                                                        SearchStateTrigger: SearchStateTrigger,
                                                        setSearchStateTrigger: setSearchStateTrigger
                                                    })
                                                ]
                                            }, facet);
                                        })
                                    ]
                                })
                            }),
                            !isDesktop && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: (0, $biy3n.default)($ealH9.applyFiltersWrapper + " " + `${maxScroll ? $ealH9.shadowDisabled : ""}`),
                                children: /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                                    onClick: handleFilterTray,
                                    className: (0, $biy3n.default)($ealH9.applyFiltersButton + ` ${ActiveSearchFilters.length != 0 || searchState?.range ? "" : $ealH9.disabled}` + ` button button--contained button--full-width`),
                                    children: [
                                        "Apply Filters ",
                                        ActiveSearchFilters.length != 0 || searchState?.range ? "(" + searchResults?.nbHits + ")" : ""
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $233627e2f745b2e1$var$RangeSlider = (0, $TDsMS.default)(({ refine: refine, defaultRefinement: defaultRefinement, searchState: searchState, setSearchState: setSearchState, attribute: attribute, start: start, range: range, min: min, max: max, highestPriceProduct: highestPriceProduct, lowestPriceProduct: lowestPriceProduct, ClearRange: ClearRange, setClearRange: setClearRange })=>{
    const [maxRange, setMaxRange] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(highestPriceProduct);
    const [minSliderRange, setMinSliderRange] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(lowestPriceProduct);
    const [maxSliderRange, setMaxSliderRange] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(highestPriceProduct);
    function adjustRange() {
        const lowerSlider = document.querySelector("#fromSlider");
        const upperSlider = document.querySelector("#toSlider");
        let lowerVal = parseInt(lowerSlider.value);
        let upperVal = parseInt(upperSlider.value);
        setMinSliderRange(lowerSlider.value);
        setMaxSliderRange(upperSlider.value);
        if (upperVal < lowerVal + 8) {
            lowerSlider.value = upperVal - 8;
            if (lowerVal == lowerSlider.min) upperSlider.value = 8;
        }
        if (lowerVal > upperVal - 8) {
            upperSlider.value = lowerVal + 8;
            if (upperVal == upperSlider.max) lowerSlider.value = parseInt(upperSlider.max) - 8;
        }
        //  Adjust width of bar in center
        let leftHandSide = (document.querySelector("#fromSlider").value - document.querySelector("#fromSlider").min) / (document.querySelector("#fromSlider").max - document.querySelector("#fromSlider").min) * (document.querySelector("#fromSlider").clientWidth - 16 + 16);
        let rightHandSide = document.querySelector("#toSlider").clientWidth - (document.querySelector("#toSlider").value - document.querySelector("#toSlider").min) / (document.querySelector("#toSlider").max - document.querySelector("#toSlider").min) * (document.querySelector("#toSlider").clientWidth - 16 + 16);
        let widthOfSlider = document.querySelector("#toSlider").clientWidth - leftHandSide - rightHandSide;
        document.querySelector(".progressFollower").style.left = leftHandSide + "px";
        document.querySelector(".progressFollower").style.width = widthOfSlider + "px";
    }
    function handleRangeChange() {
        setSearchState((prev)=>({
                ...prev,
                range: {
                    "price": {
                        "min": minSliderRange,
                        "max": maxSliderRange
                    }
                }
            }));
    }
    function clearRange() {
        const lowerSlider = document.querySelector("#fromSlider");
        const upperSlider = document.querySelector("#toSlider");
        const progressFollower = document.querySelector(".progressFollower");
        setMinSliderRange(lowestPriceProduct);
        setMaxSliderRange(highestPriceProduct);
        progressFollower.style.left = "0px";
        progressFollower.style.right = document.querySelector("#toSlider").clientWidth + "px";
        progressFollower.style.width = document.querySelector("#toSlider").clientWidth + "px";
        lowerSlider.value = parseInt(lowerSlider.min);
        upperSlider.value = parseInt(upperSlider.max);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (ClearRange == true) {
            clearRange();
            setClearRange(false);
        }
    }, [
        ClearRange
    ]);
    return /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
        children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
            className: "range_container",
            children: [
                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                    className: "progressBackground"
                }),
                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                    className: "sliders_control",
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                            className: "progressFollower"
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                            type: "range",
                            onInput: adjustRange,
                            onTouchEnd: handleRangeChange,
                            onMouseUp: handleRangeChange,
                            id: "fromSlider",
                            min: lowestPriceProduct,
                            max: highestPriceProduct,
                            defaultValue: minSliderRange
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                            type: "range",
                            onInput: adjustRange,
                            onTouchEnd: handleRangeChange,
                            onMouseUp: handleRangeChange,
                            id: "toSlider",
                            min: lowestPriceProduct,
                            max: highestPriceProduct,
                            defaultValue: maxSliderRange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                    className: "slider_labels",
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsxs)("label", {
                            "aria-label": "min price range",
                            children: [
                                "$",
                                minSliderRange
                            ]
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsxs)("label", {
                            "aria-label": "max price range",
                            children: [
                                "$",
                                maxSliderRange
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $233627e2f745b2e1$var$ToggleRefinement = (0, $bmfcN.default)(({ searchResults: searchResults, currentRefinement: currentRefinement, label: label, count: count, value: value, setSearchState: setSearchState, attribute: attribute, currentlyRefined: currentlyRefined, setCurrentlyRefined: setCurrentlyRefined, searchState: searchState })=>{
    const { b2b: b2b, refinementToggle: refinementToggle, setRefinementToggle: setRefinementToggle } = (0, $7mAg3.usePLPContext)();
    return /*#__PURE__*/ (0, $drmv2.jsx)("button", {
        "aria-pressed": currentRefinement,
        onClick: ()=>{
            setRefinementToggle((prev)=>({
                    ...prev,
                    boolean: refinementToggle?.boolean[attribute] == true ? "" : {
                        [attribute]: true
                    }
                }));
            setTimeout(()=>{
                setCurrentlyRefined(currentRefinement ? undefined : attribute);
                setSearchState((prev)=>({
                        ...prev,
                        // ...(searchState.sortBy === 'production_shopify_products' && window?.collectionType != "supplements" ? {sortBy:'production_shopify_products_newest'} : {}),
                        page: 1,
                        ...currentRefinement ? b2b ? {
                            toggle: {
                                [b2b]: "true"
                            }
                        } : {
                            toggle: {}
                        } : b2b ? {
                            toggle: {
                                [attribute]: !currentRefinement,
                                [b2b]: "true"
                            }
                        } : {
                            toggle: {
                                [attribute]: !currentRefinement
                            }
                        }
                    }));
            }, 100);
        },
        className: `boolean-refinement refinementButton-boolean 
          ${searchResults?.renderingContent?.facetOrdering?.facets.order.includes(attribute) ? "" : "hidden"} 
          ${label} 
          ${(0, $biy3n.default)("", {
            [$ealH9.open + " open"]: refinementToggle?.boolean[attribute] != undefined ? true : false
        })}`,
        children: label
    });
});
const $233627e2f745b2e1$var$ToggleRefinementImage = (0, $bmfcN.default)(({ refine: refine, currentRefinement: currentRefinement, label: label, tabName: tabName, count: count, value: value })=>{
    return /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
        "aria-pressed": currentRefinement ? "true" : "false",
        onClick: ()=>{
            refine(!currentRefinement);
        },
        className: "boolean-refinement refinementButton-boolean-withImage " + label + " " + (0, $biy3n.default)($ealH9.refinementButton, {
            [$ealH9.open]: currentRefinement
        }),
        children: [
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "refinement-image-container",
                children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                    className: "refinement-image " + tabName + " " + label
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                children: label
            })
        ]
    });
});
const $233627e2f745b2e1$var$Menu = ({ buttonLabel: buttonLabel = null, buttonIcon: buttonIcon = null, menuLabel: menuLabel = null, children: children, count: count = 0, attribute: attribute = null, searchResults: searchResults = null })=>{
    const isWide = (0, $7RS04.default)("(min-width: 640px)");
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const listRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(isWide || !isWide && (menuLabel == "Sort By" || menuLabel == "Padding") ? true : false);
    const popperButtonRef = isWide ? buttonRef.current : null;
    const { styles: styles, attributes: attributes } = (0, $grDIL.usePopper)(popperButtonRef, menuRef.current, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            }
        ]
    });
    const { y: listY } = (0, $fw3dV.default)(listRef);
    const [listMeasureRef, { height: listHeight }] = (0, $3aT1w.default)();
    const listScrollHeight = listRef.current ? listRef.current.scrollHeight : 0;
    const listCombinedRef = (0, $60uP6.default)(listRef, listMeasureRef);
    const headerId = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>`MenuHeader-${(0, $gLiL7.default)()}`, []);
    // React.useEffect(() => {
    //   if (open) {
    //     window.trapFocus(menuRef.current);
    //     document.body.classList.add("overflow-hidden--small-down");
    //     return () => {
    //       window.removeTrapFocus(buttonRef.current);
    //       document.body.classList.remove("overflow-hidden--small-down");
    //     };
    //   }
    // }, [open]);
    // React.useEffect(() => {
    //   if (open && !isWide) {
    //     if(window?.GorgiasChat && window?.GorgiasChat?.hideOnMobile(true)){
    //       return () => {
    //         window.GorgiasChat && window.GorgiasChat.hideOnMobile(false);
    //       };
    //     }
    //   }
    // }, [open, isWide]); 
    const handleClick = ()=>{
        setOpen((prev)=>!prev);
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "Escape":
                setOpen(false);
                break;
            default:
                break;
        }
    };
    const showMenu = searchResults?._rawResults[0].facets[attribute] != undefined;
    return /*#__PURE__*/ (0, $drmv2.jsx)("div", {
        className: `refinementButton-sort ${showMenu && (searchResults?.renderingContent?.facetOrdering?.facets.order.includes(attribute) || attribute == undefined) ? "" : "hidden"}`,
        "data-filter": menuLabel,
        children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
            className: "refinementButton-sort-wrapper" + ` ${open ? "open" : ""}`,
            tabIndex: -1,
            "aria-labelledby": headerId,
            ref: menuRef,
            onKeyDown: handleKeyDown,
            ...isWide && attributes.popper,
            children: [
                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                    id: headerId,
                    className: $ealH9.refinementMenuHeader + ` refinementMenuHeader ${open ? "open" : ""}`,
                    // onClick={handleClick}
                    onMouseUp: handleClick,
                    children: [
                        menuLabel,
                        /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                            width: 16,
                            height: 16,
                            icon: (0, $gH7Rp.faChevronDown)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    ref: listCombinedRef,
                    className: (0, $biy3n.default)($ealH9.refinementMenuList + ` refinementMenu ${open ? "open" : ""}`, {}),
                    children: children
                })
            ]
        })
    });
};
const $233627e2f745b2e1$var$updateVariantTitle = (title)=>{
    const percentages = [
        "0.1",
        "0.2",
        "0.3",
        "0.4",
        "0.5",
        "0.6",
        "0.7",
        "0.8",
        "0.9"
    ];
    switch(title){
        case "XXS":
            title = "2XS";
            break;
        case "XXL":
            title = "2XL";
            break;
        case "XXXL":
            title = "3XL";
            break;
        case "XXXXL":
            title = "4XL";
            break;
        default:
            break;
    }
    if (percentages.includes(title)) title = 100 - parseFloat(title) * 100 + "%";
    return title;
};
const $233627e2f745b2e1$var$hiddenSizes = [
    "One Size",
    "ONE",
    "one",
    "US 6",
    "US 7.5",
    "US 9",
    "US 12",
    "S/M/L",
    "1",
    "2",
    "3",
    "4",
    "1-2",
    "Default Title"
];
const $233627e2f745b2e1$var$approvedSizes = [
    "XXS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL",
    "XXXXL"
];
const $233627e2f745b2e1$var$MenuRefinement = (0, $eWPzc.default)(({ items: items, refine: refine, currentRefinement: currentRefinement, attribute: attribute, searchState: searchState, setSearchState: setSearchState, handle: handle, setSearchStateTrigger: setSearchStateTrigger, SearchStateTrigger: SearchStateTrigger })=>{
    const { refinementToggle: refinementToggle, setRefinementToggle: setRefinementToggle } = (0, $7mAg3.usePLPContext)();
    const refinements = refinementToggle[attribute] != undefined ? refinementToggle[attribute] : [];
    const handleCheckboxClick = (value)=>{
        let newValues = [
            ...refinements
        ];
        if (newValues.includes(value)) newValues = newValues.filter((item)=>item != value);
        else newValues.push(value);
        setRefinementToggle((prev)=>({
                ...prev,
                [attribute]: newValues
            }));
    };
    return items.filter((item)=>attribute == "optionAvailability.Size" ? $233627e2f745b2e1$var$approvedSizes.includes(item.label) : !$233627e2f745b2e1$var$hiddenSizes.includes(item.label)).map(({ value: value, label: label, count: count, isRefined: isRefined }, index)=>{
        const id = `Checkbox-${window.Shopify.handleize(attribute)}-${window.Shopify.handleize(label)}-${handle}`;
        const backgroundImagePrint = label == "Print" ? {
            backgroundImage: "url(https://cdn.shopify.com/s/files/1/0017/6075/5779/files/421569129_644452027736798_5860997571310260696_n_430x.png"
        } : {};
        return /*#__PURE__*/ (0, $drmv2.jsxs)("label", {
            id: id,
            className: $ealH9.option + " option",
            "data-option": $233627e2f745b2e1$var$updateVariantTitle(label),
            "data-type": attribute,
            children: [
                /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                    id: id,
                    type: "checkbox",
                    value: value,
                    name: attribute,
                    onClick: ()=>{
                        handleCheckboxClick(label);
                    },
                    onChange: ()=>{
                        // refine(value);
                        // setSearchStateTrigger('Userrefineclick')
                        setTimeout(()=>{
                            refine(value);
                            setSearchStateTrigger("Userrefineclick");
                        }, 100);
                    },
                    checked: refinements?.includes(label)
                }),
                attribute == "facets.Colour" && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    className: `color-bubble ${$233627e2f745b2e1$var$updateVariantTitle(label)}`,
                    style: backgroundImagePrint
                }),
                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                    children: $233627e2f745b2e1$var$updateVariantTitle(label)
                })
            ]
        }, index);
    });
});
const $233627e2f745b2e1$var$SortOptionsDropdown = (0, $SMyUQ.default)(({ items: items, min: min, max: max, refine: refine, searchState: searchState, setSearchStateTrigger: setSearchStateTrigger, SearchStateTrigger: SearchStateTrigger, setUserSelect: setUserSelect })=>{
    return /*#__PURE__*/ (0, $drmv2.jsx)("select", {
        onChange: (e)=>{
            setSearchStateTrigger("UsersortBy");
            e.target.value === "production_shopify_products_newest" && window?.collectionType != "supplements" ? setUserSelect("newest") : setUserSelect(e.target.value);
            refine(e.target.value);
        },
        children: items.map(({ label: label, value: value, isRefined: isRefined })=>{
            return /*#__PURE__*/ (0, $drmv2.jsx)("option", {
                selected: searchState?.sortBy == "production_shopify_products_newest" && value == "production_shopify_products_newest" || searchState?.sortBy == "production_shopify_products" && value == "production_shopify_products",
                value: value,
                children: label
            });
        })
    });
});
const $233627e2f745b2e1$var$SortOptions = (0, $SMyUQ.default)(({ items: items, refine: refine, searchState: searchState, setSearchStateTrigger: setSearchStateTrigger, SearchStateTrigger: SearchStateTrigger, setUserSelect: setUserSelect })=>items.map(({ label: label, value: value, isRefined: isRefined })=>{
        const id = `Radio-${window.Shopify.handleize(value)}`;
        return /*#__PURE__*/ (0, $drmv2.jsxs)("label", {
            className: $ealH9.option + " option " + (isRefined ? " checked" : ""),
            "data-type": "Sort By",
            children: [
                isRefined && /*#__PURE__*/ (0, $drmv2.jsx)("svg", {
                    className: "check",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                        d: "M11.7482 1.75152C12.083 2.08634 12.083 2.62741 11.7482 2.96223L4.89107 9.81937C4.55625 10.1542 4.01518 10.1542 3.68036 9.81937L0.251036 6.3908C-0.0836786 6.05598 -0.0836786 5.51491 0.251036 5.18009C0.585804 4.84527 1.12848 4.84527 1.4633 5.18009L4.26161 8.00062L10.5375 1.75152C10.8723 1.41616 11.4134 1.41616 11.7482 1.75152Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                    id: id,
                    className: "radio",
                    checked: isRefined,
                    type: "radio",
                    name: "sortBy",
                    value: value,
                    onChange: ()=>{
                        setSearchStateTrigger("UsersortBy");
                        value === "production_shopify_products_newest" && window?.collectionType != "supplements" ? setUserSelect("newest") : setUserSelect(value);
                        refine(value);
                    }
                }),
                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                    className: "bubble",
                    children: /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        className: "inner-bubble"
                    })
                })
            ]
        }, value);
    })); /*
const Accordion: React.FC<{ label: React.ReactNode }> = ({
  label,
  children,
}) => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div
      ref={rootRef}
      className={clsx(classes.accordion, {
        [classes.open]: open,
      })} 
    >
      <button
        type="button"
        aria-expanded={open ? "true" : "false"}
        onClick={handleClick} 
        className={classes.accordionButton}
      >
        <div className={classes.accordionButtonLabel}>{label}</div>
        {open ? (
          <FontAwesomeIcon icon={faChevronUp} width={16} height={16} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} width={16} height={16} />
        )} 
      </button>
      <div className={classes.accordionPanel}>{children}</div> 
    </div>
  );
};
*/ 

});
parcelRegister("TDsMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a73bfc2a3b8d196$export$2e2bcd8739ae039; });

var $3A6f9 = parcelRequire("3A6f9");

var $dcYkN = parcelRequire("dcYkN");

var $5zIY3 = parcelRequire("5zIY3");
function $0a73bfc2a3b8d196$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0a73bfc2a3b8d196$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0a73bfc2a3b8d196$var$_typeof(obj);
}
function $0a73bfc2a3b8d196$var$_defineProperty(obj, key, value) {
    key = $0a73bfc2a3b8d196$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a73bfc2a3b8d196$var$_toPropertyKey(arg) {
    var key = $0a73bfc2a3b8d196$var$_toPrimitive(arg, "string");
    return $0a73bfc2a3b8d196$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0a73bfc2a3b8d196$var$_toPrimitive(input, hint) {
    if ($0a73bfc2a3b8d196$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0a73bfc2a3b8d196$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * connectRange connector provides the logic to create connected
 * components that will give the ability for a user to refine results using
 * a numeric range.
 * @name connectRange
 * @kind connector
 * @requirements The attribute passed to the `attribute` prop must be present in “attributes for faceting”
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * The values inside the attribute must be JavaScript numbers (not strings).
 * @propType {string} attribute - Name of the attribute for faceting
 * @propType {{min?: number, max?: number}} [defaultRefinement] - Default searchState of the widget containing the start and the end of the range.
 * @propType {number} [min] - Minimum value. When this isn't set, the minimum value will be automatically computed by Algolia using the data in the index.
 * @propType {number} [max] - Maximum value. When this isn't set, the maximum value will be automatically computed by Algolia using the data in the index.
 * @propType {number} [precision=0] - Number of digits after decimal point to use.
 * @providedPropType {function} refine - a function to select a range.
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the refinement currently applied
 * @providedPropType {number} min - the minimum value available.
 * @providedPropType {number} max - the maximum value available.
 * @providedPropType {number} precision - Number of digits after decimal point to use.
 */ function $0a73bfc2a3b8d196$var$getId(props) {
    return props.attribute;
}
var $0a73bfc2a3b8d196$var$namespace = "range";
function $0a73bfc2a3b8d196$var$getCurrentRange(boundaries, stats, precision) {
    var pow = Math.pow(10, precision);
    var min;
    if (typeof boundaries.min === "number" && isFinite(boundaries.min)) min = boundaries.min;
    else if (typeof stats.min === "number" && isFinite(stats.min)) min = stats.min;
    else min = undefined;
    var max;
    if (typeof boundaries.max === "number" && isFinite(boundaries.max)) max = boundaries.max;
    else if (typeof stats.max === "number" && isFinite(stats.max)) max = stats.max;
    else max = undefined;
    return {
        min: min !== undefined ? Math.floor(min * pow) / pow : min,
        max: max !== undefined ? Math.ceil(max * pow) / pow : max
    };
}
function $0a73bfc2a3b8d196$var$getCurrentRefinement(props, searchState, currentRange, context) {
    var _getCurrentRefinement = (0, $5zIY3.getCurrentRefinementValue)(props, searchState, context, "".concat($0a73bfc2a3b8d196$var$namespace, ".").concat($0a73bfc2a3b8d196$var$getId(props)), {}), min = _getCurrentRefinement.min, max = _getCurrentRefinement.max;
    var isFloatPrecision = Boolean(props.precision);
    var nextMin = min;
    if (typeof nextMin === "string") nextMin = isFloatPrecision ? parseFloat(nextMin) : parseInt(nextMin, 10);
    var nextMax = max;
    if (typeof nextMax === "string") nextMax = isFloatPrecision ? parseFloat(nextMax) : parseInt(nextMax, 10);
    var refinement = {
        min: nextMin,
        max: nextMax
    };
    var hasMinBound = props.min !== undefined;
    var hasMaxBound = props.max !== undefined;
    var hasMinRefinment = refinement.min !== undefined;
    var hasMaxRefinment = refinement.max !== undefined;
    if (hasMinBound && hasMinRefinment && refinement.min < currentRange.min) throw Error("You can't provide min value lower than range.");
    if (hasMaxBound && hasMaxRefinment && refinement.max > currentRange.max) throw Error("You can't provide max value greater than range.");
    if (hasMinBound && !hasMinRefinment) refinement.min = currentRange.min;
    if (hasMaxBound && !hasMaxRefinment) refinement.max = currentRange.max;
    return refinement;
}
function $0a73bfc2a3b8d196$var$getCurrentRefinementWithRange(refinement, range) {
    return {
        min: refinement.min !== undefined ? refinement.min : range.min,
        max: refinement.max !== undefined ? refinement.max : range.max
    };
}
function $0a73bfc2a3b8d196$var$nextValueForRefinement(hasBound, isReset, range, value) {
    var next;
    if (!hasBound && range === value) next = undefined;
    else if (hasBound && isReset) next = range;
    else next = value;
    return next;
}
function $0a73bfc2a3b8d196$var$_refine(props, searchState, nextRefinement, currentRange, context) {
    var nextMin = nextRefinement.min, nextMax = nextRefinement.max;
    var currentMinRange = currentRange.min, currentMaxRange = currentRange.max;
    var isMinReset = nextMin === undefined || nextMin === "";
    var isMaxReset = nextMax === undefined || nextMax === "";
    var nextMinAsNumber = !isMinReset ? parseFloat(nextMin) : undefined;
    var nextMaxAsNumber = !isMaxReset ? parseFloat(nextMax) : undefined;
    var isNextMinValid = isMinReset || isFinite(nextMinAsNumber);
    var isNextMaxValid = isMaxReset || isFinite(nextMaxAsNumber);
    if (!isNextMinValid || !isNextMaxValid) throw Error("You can't provide non finite values to the range connector.");
    if (nextMinAsNumber < currentMinRange) throw Error("You can't provide min value lower than range.");
    if (nextMaxAsNumber > currentMaxRange) throw Error("You can't provide max value greater than range.");
    var id = $0a73bfc2a3b8d196$var$getId(props);
    var resetPage = true;
    var nextValue = $0a73bfc2a3b8d196$var$_defineProperty({}, id, {
        min: $0a73bfc2a3b8d196$var$nextValueForRefinement(props.min !== undefined, isMinReset, currentMinRange, nextMinAsNumber),
        max: $0a73bfc2a3b8d196$var$nextValueForRefinement(props.max !== undefined, isMaxReset, currentMaxRange, nextMaxAsNumber)
    });
    return (0, $5zIY3.refineValue)(searchState, nextValue, context, resetPage, $0a73bfc2a3b8d196$var$namespace);
}
function $0a73bfc2a3b8d196$var$_cleanUp(props, searchState, context) {
    return (0, $5zIY3.cleanUpValue)(searchState, context, "".concat($0a73bfc2a3b8d196$var$namespace, ".").concat($0a73bfc2a3b8d196$var$getId(props)));
}
var $0a73bfc2a3b8d196$export$2e2bcd8739ae039 = (0, $dcYkN.default)({
    displayName: "AlgoliaRange",
    $$type: "ais.range",
    propTypes: {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string,
        attribute: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string.isRequired,
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).shape({
            min: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
            max: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number
        }),
        min: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
        max: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
        precision: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
        header: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).node,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).node
    },
    defaultProps: {
        precision: 0
    },
    getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
        var attribute = props.attribute, precision = props.precision, minBound = props.min, maxBound = props.max;
        var results = (0, $5zIY3.getResults)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var hasFacet = results && results.getFacetByName(attribute);
        var stats = hasFacet ? results.getFacetStats(attribute) || {} : {};
        var facetValues = hasFacet ? results.getFacetValues(attribute) : [];
        var count = facetValues.map(function(v) {
            return {
                value: v.name,
                count: v.count
            };
        });
        var _getCurrentRange = $0a73bfc2a3b8d196$var$getCurrentRange({
            min: minBound,
            max: maxBound
        }, stats, precision), rangeMin = _getCurrentRange.min, rangeMax = _getCurrentRange.max;
        // The searchState is not always in sync with the helper state. For example
        // when we set boundaries on the first render the searchState don't have
        // the correct refinement. If this behavior change in the upcoming version
        // we could store the range inside the searchState instead of rely on `this`.
        this._currentRange = {
            min: rangeMin,
            max: rangeMax
        };
        var currentRefinement = $0a73bfc2a3b8d196$var$getCurrentRefinement(props, searchState, this._currentRange, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        return {
            min: rangeMin,
            max: rangeMax,
            canRefine: count.length > 0,
            currentRefinement: $0a73bfc2a3b8d196$var$getCurrentRefinementWithRange(currentRefinement, this._currentRange),
            count: count,
            precision: precision
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        return $0a73bfc2a3b8d196$var$_refine(props, searchState, nextRefinement, this._currentRange, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    cleanUp: function cleanUp(props, searchState) {
        return $0a73bfc2a3b8d196$var$_cleanUp(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    getSearchParameters: function getSearchParameters(params, props, searchState) {
        var attribute = props.attribute;
        var _getCurrentRefinement2 = $0a73bfc2a3b8d196$var$getCurrentRefinement(props, searchState, this._currentRange, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }), min = _getCurrentRefinement2.min, max = _getCurrentRefinement2.max;
        params = params.addDisjunctiveFacet(attribute);
        if (min !== undefined) params = params.addNumericRefinement(attribute, ">=", min);
        if (max !== undefined) params = params.addNumericRefinement(attribute, "<=", max);
        return params;
    },
    getMetadata: function getMetadata(props, searchState) {
        var _this = this;
        var _this$_currentRange = this._currentRange, minRange = _this$_currentRange.min, maxRange = _this$_currentRange.max;
        var _getCurrentRefinement3 = $0a73bfc2a3b8d196$var$getCurrentRefinement(props, searchState, this._currentRange, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }), minValue = _getCurrentRefinement3.min, maxValue = _getCurrentRefinement3.max;
        var items = [];
        var hasMin = minValue !== undefined;
        var hasMax = maxValue !== undefined;
        var shouldDisplayMinLabel = hasMin && minValue !== minRange;
        var shouldDisplayMaxLabel = hasMax && maxValue !== maxRange;
        if (shouldDisplayMinLabel || shouldDisplayMaxLabel) {
            var fragments = [
                hasMin ? "".concat(minValue, " <= ") : "",
                props.attribute,
                hasMax ? " <= ".concat(maxValue) : ""
            ];
            items.push({
                label: fragments.join(""),
                attribute: props.attribute,
                value: function value(nextState) {
                    return $0a73bfc2a3b8d196$var$_refine(props, nextState, {}, _this._currentRange, {
                        ais: props.contextValue,
                        multiIndexContext: props.indexContextValue
                    });
                },
                currentRefinement: $0a73bfc2a3b8d196$var$getCurrentRefinementWithRange({
                    min: minValue,
                    max: maxValue
                }, {
                    min: minRange,
                    max: maxRange
                })
            });
        }
        return {
            id: $0a73bfc2a3b8d196$var$getId(props),
            index: (0, $5zIY3.getIndexId)({
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            items: items
        };
    }
});

});
parcelRegister("3A6f9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $29b993b103f43674$var$ReactIs, $29b993b103f43674$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lPmZq"))();

});
parcelRegister("lPmZq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $gvkWW = parcelRequire("gvkWW");
function $fe4031b0281d5281$var$emptyFunction() {}
function $fe4031b0281d5281$var$emptyFunctionWithReset() {}
$fe4031b0281d5281$var$emptyFunctionWithReset.resetWarningCache = $fe4031b0281d5281$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gvkWW) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $fe4031b0281d5281$var$emptyFunctionWithReset,
        resetWarningCache: $fe4031b0281d5281$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("gvkWW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c03fcac84567310f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c03fcac84567310f$var$ReactPropTypesSecret;

});




parcelRegister("bmfcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844d8b4768762ba6$export$2e2bcd8739ae039; });

var $3A6f9 = parcelRequire("3A6f9");

var $dcYkN = parcelRequire("dcYkN");

var $5zIY3 = parcelRequire("5zIY3");

var $65mCe = parcelRequire("65mCe");
function $844d8b4768762ba6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $844d8b4768762ba6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $844d8b4768762ba6$var$_typeof(obj);
}
function $844d8b4768762ba6$var$_defineProperty(obj, key, value) {
    key = $844d8b4768762ba6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $844d8b4768762ba6$var$_toPropertyKey(arg) {
    var key = $844d8b4768762ba6$var$_toPrimitive(arg, "string");
    return $844d8b4768762ba6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $844d8b4768762ba6$var$_toPrimitive(input, hint) {
    if ($844d8b4768762ba6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($844d8b4768762ba6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $844d8b4768762ba6$var$getId(props) {
    return props.attribute;
}
var $844d8b4768762ba6$var$namespace = "toggle";
var $844d8b4768762ba6$var$falsyStrings = [
    "0",
    "false",
    "null",
    "undefined"
];
function $844d8b4768762ba6$var$getCurrentRefinement(props, searchState, context) {
    var currentRefinement = (0, $5zIY3.getCurrentRefinementValue)(props, searchState, context, "".concat($844d8b4768762ba6$var$namespace, ".").concat($844d8b4768762ba6$var$getId(props)), false);
    if ($844d8b4768762ba6$var$falsyStrings.indexOf(currentRefinement) !== -1) return false;
    return Boolean(currentRefinement);
}
function $844d8b4768762ba6$var$_refine(props, searchState, nextRefinement, context) {
    var id = $844d8b4768762ba6$var$getId(props);
    var nextValue = $844d8b4768762ba6$var$_defineProperty({}, id, nextRefinement ? nextRefinement : false);
    var resetPage = true;
    return (0, $5zIY3.refineValue)(searchState, nextValue, context, resetPage, $844d8b4768762ba6$var$namespace);
}
function $844d8b4768762ba6$var$_cleanUp(props, searchState, context) {
    return (0, $5zIY3.cleanUpValue)(searchState, context, "".concat($844d8b4768762ba6$var$namespace, ".").concat($844d8b4768762ba6$var$getId(props)));
}
var /**
 * connectToggleRefinement connector provides the logic to build a widget that will
 * provides an on/off filtering feature based on an attribute value.
 * @name connectToggleRefinement
 * @kind connector
 * @requirements To use this widget, you'll need an attribute to toggle on.
 *
 * You can't toggle on null or not-null values. If you want to address this particular use-case you'll need to compute an
 * extra boolean attribute saying if the value exists or not. See this [thread](https://discourse.algolia.com/t/how-to-create-a-toggle-for-the-absence-of-a-string-attribute/2460) for more details.
 *
 * @propType {string} attribute - Name of the attribute on which to apply the `value` refinement. Required when `value` is present.
 * @propType {string} label - Label for the toggle.
 * @propType {string} value - Value of the refinement to apply on `attribute`.
 * @propType {boolean} [defaultRefinement=false] - Default searchState of the widget. Should the toggle be checked by default?
 * @providedPropType {boolean} currentRefinement - `true` when the refinement is applied, `false` otherwise
 * @providedPropType {object} count - an object that contains the count for `checked` and `unchecked` state
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 */ $844d8b4768762ba6$export$2e2bcd8739ae039 = (0, $dcYkN.default)({
    displayName: "AlgoliaToggle",
    $$type: "ais.toggle",
    propTypes: {
        label: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string.isRequired,
        attribute: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).any.isRequired,
        filter: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).func,
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).bool
    },
    getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
        var attribute = props.attribute, value = props.value;
        var results = (0, $5zIY3.getResults)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var currentRefinement = $844d8b4768762ba6$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var allFacetValues = results && results.getFacetByName(attribute) ? results.getFacetValues(attribute) : null;
        var facetValue = // Use null to always be consistent with type of the value
        // count: number | null
        allFacetValues && allFacetValues.length ? (0, $65mCe.find)(allFacetValues, function(item) {
            return item.name === value.toString();
        }) : null;
        var facetValueCount = facetValue && facetValue.count;
        var allFacetValuesCount = // Use null to always be consistent with type of the value
        // count: number | null
        allFacetValues && allFacetValues.length ? allFacetValues.reduce(function(acc, item) {
            return acc + item.count;
        }, 0) : null;
        var canRefine = currentRefinement ? allFacetValuesCount !== null && allFacetValuesCount > 0 : facetValueCount !== null && facetValueCount > 0;
        var count = {
            checked: allFacetValuesCount,
            unchecked: facetValueCount
        };
        return {
            currentRefinement: currentRefinement,
            canRefine: canRefine,
            count: count
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        return $844d8b4768762ba6$var$_refine(props, searchState, nextRefinement, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    cleanUp: function cleanUp(props, searchState) {
        return $844d8b4768762ba6$var$_cleanUp(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        var attribute = props.attribute, value = props.value, filter = props.filter;
        var checked = $844d8b4768762ba6$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var nextSearchParameters = searchParameters.addDisjunctiveFacet(attribute);
        if (checked) {
            nextSearchParameters = nextSearchParameters.addDisjunctiveFacetRefinement(attribute, value);
            if (filter) nextSearchParameters = filter(nextSearchParameters);
        }
        return nextSearchParameters;
    },
    getMetadata: function getMetadata(props, searchState) {
        var id = $844d8b4768762ba6$var$getId(props);
        var checked = $844d8b4768762ba6$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var items = [];
        var index = (0, $5zIY3.getIndexId)({
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        if (checked) items.push({
            label: props.label,
            currentRefinement: checked,
            attribute: props.attribute,
            value: function value(nextState) {
                return $844d8b4768762ba6$var$_refine(props, nextState, false, {
                    ais: props.contextValue,
                    multiIndexContext: props.indexContextValue
                });
            }
        });
        return {
            id: id,
            index: index,
            items: items
        };
    }
});

});

parcelRegister("eWPzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1e7b8c1d815499$export$2e2bcd8739ae039; });

var $3A6f9 = parcelRequire("3A6f9");

var $dcYkN = parcelRequire("dcYkN");

var $5zIY3 = parcelRequire("5zIY3");

var $65mCe = parcelRequire("65mCe");
function $ae1e7b8c1d815499$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ae1e7b8c1d815499$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ae1e7b8c1d815499$var$_typeof(obj);
}
function $ae1e7b8c1d815499$var$_defineProperty(obj, key, value) {
    key = $ae1e7b8c1d815499$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae1e7b8c1d815499$var$_toPropertyKey(arg) {
    var key = $ae1e7b8c1d815499$var$_toPrimitive(arg, "string");
    return $ae1e7b8c1d815499$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ae1e7b8c1d815499$var$_toPrimitive(input, hint) {
    if ($ae1e7b8c1d815499$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ae1e7b8c1d815499$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ae1e7b8c1d815499$var$namespace = "refinementList";
function $ae1e7b8c1d815499$var$getId(props) {
    return props.attribute;
}
function $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, context) {
    var currentRefinement = (0, $5zIY3.getCurrentRefinementValue)(props, searchState, context, "".concat($ae1e7b8c1d815499$var$namespace, ".").concat($ae1e7b8c1d815499$var$getId(props)), []);
    if (typeof currentRefinement !== "string") return currentRefinement;
    if (currentRefinement) return [
        currentRefinement
    ];
    return [];
}
function $ae1e7b8c1d815499$var$getValue(value, props, searchState, context) {
    var currentRefinement = $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, context);
    var isAnewValue = currentRefinement.indexOf(value) === -1;
    var nextRefinement = isAnewValue ? currentRefinement.concat([
        value
    ]) // cannot use .push(), it mutates
     : currentRefinement.filter(function(selectedValue) {
        return selectedValue !== value;
    }); // cannot use .splice(), it mutates
    return nextRefinement;
}
function $ae1e7b8c1d815499$var$getLimit(_ref) {
    var showMore = _ref.showMore, limit = _ref.limit, showMoreLimit = _ref.showMoreLimit;
    return showMore ? showMoreLimit : limit;
}
function $ae1e7b8c1d815499$var$_refine(props, searchState, nextRefinement, context) {
    var id = $ae1e7b8c1d815499$var$getId(props);
    // Setting the value to an empty string ensures that it is persisted in
    // the URL as an empty value.
    // This is necessary in the case where `defaultRefinement` contains one
    // item and we try to deselect it. `nextSelected` would be an empty array,
    // which would not be persisted to the URL.
    // {foo: ['bar']} => "foo[0]=bar"
    // {foo: []} => ""
    var nextValue = $ae1e7b8c1d815499$var$_defineProperty({}, id, nextRefinement.length > 0 ? nextRefinement : "");
    var resetPage = true;
    return (0, $5zIY3.refineValue)(searchState, nextValue, context, resetPage, $ae1e7b8c1d815499$var$namespace);
}
function $ae1e7b8c1d815499$var$_cleanUp(props, searchState, context) {
    return (0, $5zIY3.cleanUpValue)(searchState, context, "".concat($ae1e7b8c1d815499$var$namespace, ".").concat($ae1e7b8c1d815499$var$getId(props)));
}
/**
 * connectRefinementList connector provides the logic to build a widget that will
 * give the user the ability to choose multiple values for a specific facet.
 * @name connectRefinementList
 * @kind connector
 * @requirements The attribute passed to the `attribute` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * @propType {string} attribute - the name of the attribute in the record
 * @propType {boolean} [searchable=false] - allow search inside values
 * @propType {string} [operator=or] - How to apply the refinements. Possible values: 'or' or 'and'.
 * @propType {boolean} [showMore=false] - true if the component should display a button that will expand the number of items
 * @propType {number} [limit=10] - the minimum number of displayed items
 * @propType {number} [showMoreLimit=20] - the maximun number of displayed items. Only used when showMore is set to `true`
 * @propType {string[]} defaultRefinement - the values of the items selected by default. The searchState of this widget takes the form of a list of `string`s, which correspond to the values of all selected refinements. However, when there are no refinements selected, the value of the searchState is an empty string.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string[]} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{count: number, isRefined: boolean, label: string, value: string}>} items - the list of items the RefinementList can display.
 * @providedPropType {function} searchForItems - a function to toggle a search inside items values
 * @providedPropType {boolean} isFromSearch - a boolean that says if the `items` props contains facet values from the global search or from the search inside items.
 * @providedPropType {boolean} canRefine - a boolean that says whether you can refine
 */ var $ae1e7b8c1d815499$var$sortBy = [
    "isRefined",
    "count:desc",
    "name:asc"
];
var $ae1e7b8c1d815499$export$2e2bcd8739ae039 = (0, $dcYkN.default)({
    displayName: "AlgoliaRefinementList",
    $$type: "ais.refinementList",
    propTypes: {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string,
        attribute: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string.isRequired,
        operator: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).oneOf([
            "and",
            "or"
        ]),
        showMore: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).bool,
        limit: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
        showMoreLimit: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number,
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).number
        ])),
        searchable: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).bool,
        transformItems: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).func,
        facetOrdering: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).bool
    },
    defaultProps: {
        operator: "or",
        showMore: false,
        limit: 10,
        showMoreLimit: 20,
        facetOrdering: true
    },
    getProvidedProps: function getProvidedProps(props, searchState, searchResults, metadata, searchForFacetValuesResults) {
        var attribute = props.attribute, searchable = props.searchable, indexContextValue = props.indexContextValue, facetOrdering = props.facetOrdering;
        var results = (0, $5zIY3.getResults)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var canRefine = Boolean(results) && Boolean(results.getFacetByName(attribute));
        var isFromSearch = Boolean(searchForFacetValuesResults && searchForFacetValuesResults[attribute] && searchForFacetValuesResults.query !== "");
        // Search For Facet Values is not available with derived helper (used for multi index search)
        if (searchable && indexContextValue) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
        if (!canRefine) return {
            items: [],
            currentRefinement: $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            canRefine: canRefine,
            isFromSearch: isFromSearch,
            searchable: searchable
        };
        var items = isFromSearch ? searchForFacetValuesResults[attribute].map(function(v) {
            return {
                label: v.value,
                value: $ae1e7b8c1d815499$var$getValue(v.escapedValue, props, searchState, {
                    ais: props.contextValue,
                    multiIndexContext: props.indexContextValue
                }),
                _highlightResult: {
                    label: {
                        value: v.highlighted
                    }
                },
                count: v.count,
                isRefined: v.isRefined
            };
        }) : results.getFacetValues(attribute, {
            sortBy: $ae1e7b8c1d815499$var$sortBy,
            facetOrdering: facetOrdering
        }).map(function(v) {
            return {
                label: v.name,
                value: $ae1e7b8c1d815499$var$getValue(v.escapedValue, props, searchState, {
                    ais: props.contextValue,
                    multiIndexContext: props.indexContextValue
                }),
                count: v.count,
                isRefined: v.isRefined
            };
        });
        var transformedItems = props.transformItems ? props.transformItems(items) : items;
        return {
            items: transformedItems.slice(0, $ae1e7b8c1d815499$var$getLimit(props)),
            currentRefinement: $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }),
            isFromSearch: isFromSearch,
            searchable: searchable,
            canRefine: transformedItems.length > 0
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        return $ae1e7b8c1d815499$var$_refine(props, searchState, nextRefinement, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    searchForFacetValues: function searchForFacetValues(props, searchState, nextRefinement) {
        return {
            facetName: props.attribute,
            query: nextRefinement,
            maxFacetHits: $ae1e7b8c1d815499$var$getLimit(props)
        };
    },
    cleanUp: function cleanUp(props, searchState) {
        return $ae1e7b8c1d815499$var$_cleanUp(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        var attribute = props.attribute, operator = props.operator;
        var addKey = operator === "and" ? "addFacet" : "addDisjunctiveFacet";
        var addRefinementKey = "".concat(addKey, "Refinement");
        searchParameters = searchParameters.setQueryParameters({
            maxValuesPerFacet: Math.max(searchParameters.maxValuesPerFacet || 0, $ae1e7b8c1d815499$var$getLimit(props))
        });
        searchParameters = searchParameters[addKey](attribute);
        return $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }).reduce(function(res, val) {
            return res[addRefinementKey](attribute, val);
        }, searchParameters);
    },
    getMetadata: function getMetadata(props, searchState) {
        var id = $ae1e7b8c1d815499$var$getId(props);
        var context = {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        };
        return {
            id: id,
            index: (0, $5zIY3.getIndexId)(context),
            items: $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, context).length > 0 ? [
                {
                    attribute: props.attribute,
                    label: "".concat(props.attribute, ": "),
                    currentRefinement: $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, context),
                    value: function value(nextState) {
                        return $ae1e7b8c1d815499$var$_refine(props, nextState, [], context);
                    },
                    items: $ae1e7b8c1d815499$var$getCurrentRefinement(props, searchState, context).map(function(item) {
                        return {
                            label: (0, $65mCe.unescapeFacetValue)("".concat(item)),
                            value: function value(nextState) {
                                var nextSelectedItems = $ae1e7b8c1d815499$var$getCurrentRefinement(props, nextState, context).filter(function(other) {
                                    return other !== item;
                                });
                                return $ae1e7b8c1d815499$var$_refine(props, searchState, nextSelectedItems, context);
                            }
                        };
                    })
                }
            ] : []
        };
    }
});

});

parcelRegister("SMyUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4ab6b177f51638$export$2e2bcd8739ae039; });

var $3A6f9 = parcelRequire("3A6f9");

var $dcYkN = parcelRequire("dcYkN");

var $5zIY3 = parcelRequire("5zIY3");
function $0a4ab6b177f51638$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0a4ab6b177f51638$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0a4ab6b177f51638$var$_typeof(obj);
}
function $0a4ab6b177f51638$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0a4ab6b177f51638$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0a4ab6b177f51638$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0a4ab6b177f51638$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0a4ab6b177f51638$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0a4ab6b177f51638$var$_defineProperty(obj, key, value) {
    key = $0a4ab6b177f51638$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a4ab6b177f51638$var$_toPropertyKey(arg) {
    var key = $0a4ab6b177f51638$var$_toPrimitive(arg, "string");
    return $0a4ab6b177f51638$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0a4ab6b177f51638$var$_toPrimitive(input, hint) {
    if ($0a4ab6b177f51638$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0a4ab6b177f51638$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0a4ab6b177f51638$var$getId() {
    return "sortBy";
}
function $0a4ab6b177f51638$var$getCurrentRefinement(props, searchState, context) {
    var id = $0a4ab6b177f51638$var$getId(props);
    var currentRefinement = (0, $5zIY3.getCurrentRefinementValue)(props, searchState, context, id, null);
    if (currentRefinement) return currentRefinement;
    return null;
}
var /**
 * The connectSortBy connector provides the logic to build a widget that will
 *  display a list of indices. This allows a user to change how the hits are being sorted.
 * @name connectSortBy
 * @requirements Algolia handles sorting by creating replica indices. [Read more about sorting](https://www.algolia.com/doc/guides/relevance/sorting/) on
 * the Algolia website.
 * @kind connector
 * @propType {string} defaultRefinement - The default selected index.
 * @propType {{value: string, label: string}[]} items - The list of indexes to search in.
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string[]} currentRefinement - the refinement currently applied
 * @providedPropType {array.<{isRefined: boolean, label?: string, value: string}>} items - the list of items the HitsPerPage can display.  If no label provided, the value will be displayed.
 */ $0a4ab6b177f51638$export$2e2bcd8739ae039 = (0, $dcYkN.default)({
    displayName: "AlgoliaSortBy",
    $$type: "ais.sortBy",
    propTypes: {
        defaultRefinement: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string,
        items: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).string.isRequired
        })).isRequired,
        transformItems: (0, (/*@__PURE__*/$parcel$interopDefault($3A6f9))).func
    },
    getProvidedProps: function getProvidedProps(props, searchState) {
        var currentRefinement = $0a4ab6b177f51638$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        var items = props.items.map(function(item) {
            return item.value === currentRefinement ? $0a4ab6b177f51638$var$_objectSpread($0a4ab6b177f51638$var$_objectSpread({}, item), {}, {
                isRefined: true
            }) : $0a4ab6b177f51638$var$_objectSpread($0a4ab6b177f51638$var$_objectSpread({}, item), {}, {
                isRefined: false
            });
        });
        return {
            items: props.transformItems ? props.transformItems(items) : items,
            currentRefinement: currentRefinement
        };
    },
    refine: function refine(props, searchState, nextRefinement) {
        var id = $0a4ab6b177f51638$var$getId();
        var nextValue = $0a4ab6b177f51638$var$_defineProperty({}, id, nextRefinement);
        var resetPage = true;
        return (0, $5zIY3.refineValue)(searchState, nextValue, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }, resetPage);
    },
    cleanUp: function cleanUp(props, searchState) {
        return (0, $5zIY3.cleanUpValue)(searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }, $0a4ab6b177f51638$var$getId());
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        var selectedIndex = $0a4ab6b177f51638$var$getCurrentRefinement(props, searchState, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        return searchParameters.setIndex(selectedIndex);
    },
    getMetadata: function getMetadata() {
        return {
            id: $0a4ab6b177f51638$var$getId()
        };
    }
});

});

parcelRegister("ealH9", function(module, exports) {

$parcel$export(module.exports, "applyFiltersButton", function () { return $a502d40351002af0$export$f0c695596f24efef; }, function (v) { return $a502d40351002af0$export$f0c695596f24efef = v; });
$parcel$export(module.exports, "applyFiltersWrapper", function () { return $a502d40351002af0$export$22f8b5e1b1287b36; }, function (v) { return $a502d40351002af0$export$22f8b5e1b1287b36 = v; });
$parcel$export(module.exports, "backdrop", function () { return $a502d40351002af0$export$48e901322468f6d5; }, function (v) { return $a502d40351002af0$export$48e901322468f6d5 = v; });
$parcel$export(module.exports, "disabled", function () { return $a502d40351002af0$export$683472f6198a076e; }, function (v) { return $a502d40351002af0$export$683472f6198a076e = v; });
$parcel$export(module.exports, "innerTray", function () { return $a502d40351002af0$export$9805532b8deaa6c9; }, function (v) { return $a502d40351002af0$export$9805532b8deaa6c9 = v; });
$parcel$export(module.exports, "list", function () { return $a502d40351002af0$export$8837f4fc672e936d; }, function (v) { return $a502d40351002af0$export$8837f4fc672e936d = v; });
$parcel$export(module.exports, "open", function () { return $a502d40351002af0$export$3ce6949f20cea765; }, function (v) { return $a502d40351002af0$export$3ce6949f20cea765 = v; });
$parcel$export(module.exports, "option", function () { return $a502d40351002af0$export$a75d1723e6bda2ec; }, function (v) { return $a502d40351002af0$export$a75d1723e6bda2ec = v; });
$parcel$export(module.exports, "refinementButton", function () { return $a502d40351002af0$export$fcc6d9aef5cf16a7; }, function (v) { return $a502d40351002af0$export$fcc6d9aef5cf16a7 = v; });
$parcel$export(module.exports, "refinementMenuCloseButton", function () { return $a502d40351002af0$export$c89e5f2b5f21ac42; }, function (v) { return $a502d40351002af0$export$c89e5f2b5f21ac42 = v; });
$parcel$export(module.exports, "refinementMenuHeader", function () { return $a502d40351002af0$export$81202dbd553f3af; }, function (v) { return $a502d40351002af0$export$81202dbd553f3af = v; });
$parcel$export(module.exports, "refinementMenuList", function () { return $a502d40351002af0$export$9b9abf76118257b; }, function (v) { return $a502d40351002af0$export$9b9abf76118257b = v; });
$parcel$export(module.exports, "root", function () { return $a502d40351002af0$export$e8e78c978b129247; }, function (v) { return $a502d40351002af0$export$e8e78c978b129247 = v; });
$parcel$export(module.exports, "shadowDisabled", function () { return $a502d40351002af0$export$234323586a13d839; }, function (v) { return $a502d40351002af0$export$234323586a13d839 = v; });
$parcel$export(module.exports, "stuck", function () { return $a502d40351002af0$export$2df70110fc714565; }, function (v) { return $a502d40351002af0$export$2df70110fc714565 = v; });
var $a502d40351002af0$export$77f5744dadf9dca6;
var $a502d40351002af0$export$66b34fdb1da35a9e;
var $a502d40351002af0$export$188169b9313873bd;
var $a502d40351002af0$export$452ed605ceab7fdd;
var $a502d40351002af0$export$f0c695596f24efef;
var $a502d40351002af0$export$22f8b5e1b1287b36;
var $a502d40351002af0$export$48e901322468f6d5;
var $a502d40351002af0$export$85b9a36db797e02b;
var $a502d40351002af0$export$683472f6198a076e;
var $a502d40351002af0$export$4df8d4373bc60300;
var $a502d40351002af0$export$74fe8f47b8747721;
var $a502d40351002af0$export$f4a42542cb683c10;
var $a502d40351002af0$export$45140f430b5a7f60;
var $a502d40351002af0$export$81207e5cc4186890;
var $a502d40351002af0$export$877c9c2e37d22fef;
var $a502d40351002af0$export$cc1a39a3fed59174;
var $a502d40351002af0$export$fff433835b7d04e7;
var $a502d40351002af0$export$9805532b8deaa6c9;
var $a502d40351002af0$export$8837f4fc672e936d;
var $a502d40351002af0$export$3ce6949f20cea765;
var $a502d40351002af0$export$a75d1723e6bda2ec;
var $a502d40351002af0$export$fcc6d9aef5cf16a7;
var $a502d40351002af0$export$956adb75da9b86fd;
var $a502d40351002af0$export$bade29824938c7dd;
var $a502d40351002af0$export$c89e5f2b5f21ac42;
var $a502d40351002af0$export$81202dbd553f3af;
var $a502d40351002af0$export$9b9abf76118257b;
var $a502d40351002af0$export$e8e78c978b129247;
var $a502d40351002af0$export$d3825739c2fce01e;
var $a502d40351002af0$export$d90250155de6d7e7;
var $a502d40351002af0$export$234323586a13d839;
var $a502d40351002af0$export$d174ec83970e3502;
var $a502d40351002af0$export$2df70110fc714565;
var $a502d40351002af0$export$cc74dcc53cfce4eb;
$a502d40351002af0$export$77f5744dadf9dca6 = `CdoHIG_accordion`;
$a502d40351002af0$export$66b34fdb1da35a9e = `CdoHIG_accordionButton`;
$a502d40351002af0$export$188169b9313873bd = `CdoHIG_accordionButtonLabel`;
$a502d40351002af0$export$452ed605ceab7fdd = `CdoHIG_accordionPanel`;
$a502d40351002af0$export$f0c695596f24efef = `CdoHIG_applyFiltersButton`;
$a502d40351002af0$export$22f8b5e1b1287b36 = `CdoHIG_applyFiltersWrapper`;
$a502d40351002af0$export$48e901322468f6d5 = `CdoHIG_backdrop`;
$a502d40351002af0$export$85b9a36db797e02b = `CdoHIG_count`;
$a502d40351002af0$export$683472f6198a076e = `CdoHIG_disabled`;
$a502d40351002af0$export$4df8d4373bc60300 = `CdoHIG_drawer`;
$a502d40351002af0$export$74fe8f47b8747721 = `CdoHIG_drawerButtons`;
$a502d40351002af0$export$f4a42542cb683c10 = `CdoHIG_drawerHeading`;
$a502d40351002af0$export$45140f430b5a7f60 = `CdoHIG_drawerWrapper`;
$a502d40351002af0$export$81207e5cc4186890 = `CdoHIG_dropdown`;
$a502d40351002af0$export$877c9c2e37d22fef = `CdoHIG_dropdownButton`;
$a502d40351002af0$export$cc1a39a3fed59174 = `CdoHIG_dropdownButtonLabel`;
$a502d40351002af0$export$fff433835b7d04e7 = `CdoHIG_dropdownPanel`;
$a502d40351002af0$export$9805532b8deaa6c9 = `CdoHIG_innerTray`;
$a502d40351002af0$export$8837f4fc672e936d = `CdoHIG_list`;
$a502d40351002af0$export$3ce6949f20cea765 = `CdoHIG_open`;
$a502d40351002af0$export$a75d1723e6bda2ec = `CdoHIG_option`;
$a502d40351002af0$export$fcc6d9aef5cf16a7 = `CdoHIG_refinementButton`;
$a502d40351002af0$export$956adb75da9b86fd = `CdoHIG_refinementMenu`;
$a502d40351002af0$export$bade29824938c7dd = `CdoHIG_refinementMenuButton`;
$a502d40351002af0$export$c89e5f2b5f21ac42 = `CdoHIG_refinementMenuCloseButton`;
$a502d40351002af0$export$81202dbd553f3af = `CdoHIG_refinementMenuHeader`;
$a502d40351002af0$export$9b9abf76118257b = `CdoHIG_refinementMenuList`;
$a502d40351002af0$export$e8e78c978b129247 = `CdoHIG_root`;
$a502d40351002af0$export$d3825739c2fce01e = `CdoHIG_safe-area-bottom-inset`;
$a502d40351002af0$export$d90250155de6d7e7 = `CdoHIG_selected`;
$a502d40351002af0$export$234323586a13d839 = `CdoHIG_shadowDisabled`;
$a502d40351002af0$export$d174ec83970e3502 = `CdoHIG_sortSelect`;
$a502d40351002af0$export$2df70110fc714565 = `CdoHIG_stuck`;
$a502d40351002af0$export$cc74dcc53cfce4eb = `CdoHIG_wrapper`;

});

parcelRegister("7RS04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba75ef5c88c1e47$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");

var $JGVrD = parcelRequire("JGVrD");
var $5ba75ef5c88c1e47$var$getInitialState = function(query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) return defaultState;
    if (0, $JGVrD.isBrowser) return window.matchMedia(query).matches;
    return false;
};
var $5ba75ef5c88c1e47$var$useMedia = function(query, defaultState) {
    var _a = (0, $1vrWl.useState)($5ba75ef5c88c1e47$var$getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0, $1vrWl.useEffect)(function() {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function() {
            if (!mounted) return;
            setState(!!mql.matches);
        };
        mql.addEventListener("change", onChange);
        setState(mql.matches);
        return function() {
            mounted = false;
            mql.removeEventListener("change", onChange);
        };
    }, [
        query
    ]);
    return state;
};
var $5ba75ef5c88c1e47$export$2e2bcd8739ae039 = $5ba75ef5c88c1e47$var$useMedia;

});

parcelRegister("fw3dV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4bc5850b126bf3e$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");

var $kw8L9 = parcelRequire("kw8L9");

var $JGVrD = parcelRequire("JGVrD");
var $b4bc5850b126bf3e$var$useScroll = function(ref) {
    var _a = (0, $kw8L9.default)({
        x: 0,
        y: 0
    }), state = _a[0], setState = _a[1];
    (0, $1vrWl.useEffect)(function() {
        var handler = function() {
            if (ref.current) setState({
                x: ref.current.scrollLeft,
                y: ref.current.scrollTop
            });
        };
        if (ref.current) (0, $JGVrD.on)(ref.current, "scroll", handler, {
            capture: false,
            passive: true
        });
        return function() {
            if (ref.current) (0, $JGVrD.off)(ref.current, "scroll", handler);
        };
    }, [
        ref
    ]);
    return state;
};
var $b4bc5850b126bf3e$export$2e2bcd8739ae039 = $b4bc5850b126bf3e$var$useScroll;

});
parcelRegister("kw8L9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eefd9745dfc3e9e6$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");

var $VTBRQ = parcelRequire("VTBRQ");
var $eefd9745dfc3e9e6$var$useRafState = function(initialState) {
    var frame = (0, $1vrWl.useRef)(0);
    var _a = (0, $1vrWl.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $1vrWl.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $VTBRQ.default)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $eefd9745dfc3e9e6$export$2e2bcd8739ae039 = $eefd9745dfc3e9e6$var$useRafState;

});
parcelRegister("VTBRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae075ed3a333155$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");

var $i1k3j = parcelRequire("i1k3j");
var $0ae075ed3a333155$var$useUnmount = function(fn) {
    var fnRef = (0, $1vrWl.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $i1k3j.default)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $0ae075ed3a333155$export$2e2bcd8739ae039 = $0ae075ed3a333155$var$useUnmount;

});
parcelRegister("i1k3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e7dff73ed5ed76$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");
var $d1e7dff73ed5ed76$var$useEffectOnce = function(effect) {
    (0, $1vrWl.useEffect)(effect, []);
};
var $d1e7dff73ed5ed76$export$2e2bcd8739ae039 = $d1e7dff73ed5ed76$var$useEffectOnce;

});




parcelRegister("8kzkJ", function(module, exports) {

$parcel$export(module.exports, "useStickyContext", function () { return $48d74830c9e93e35$export$c9c14de716c41f9; });
$parcel$export(module.exports, "StickyBoundary", function () { return $48d74830c9e93e35$export$ad997bc00331256d; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");
const $48d74830c9e93e35$export$e389eea70d22faa2 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
const $48d74830c9e93e35$export$26acbae003699fe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).createContext({});
const $48d74830c9e93e35$export$c9c14de716c41f9 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useContext($48d74830c9e93e35$export$26acbae003699fe6);
const $48d74830c9e93e35$export$ad997bc00331256d = ({ children: children, container: container = document, buffer: buffer })=>{
    const stickyBuffer = buffer;
    const topRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const bottomRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const [stickyElement, stickyElementRef] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(null);
    const [stickyElementRect, setStickyElementRect] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState($48d74830c9e93e35$export$e389eea70d22faa2);
    const [isStuck, setIsStuck] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const resizeObserver = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { x: x, y: y, width: width, height: height, top: top, left: left, bottom: bottom, right: right } = entry.contentRect;
                setStickyElementRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        }), []);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (!stickyElement) return;
        resizeObserver.observe(stickyElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        stickyElement
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const targetInfo = entry.boundingClientRect;
                const rootBoundsInfo = entry.rootBounds;
                if (targetInfo.bottom < rootBoundsInfo.top) setIsStuck(true);
                if (targetInfo.bottom >= rootBoundsInfo.top && targetInfo.bottom < rootBoundsInfo.bottom) setIsStuck(false);
            }
        }, {
            threshold: [
                0
            ],
            root: container
        });
        observer.observe(topRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        container
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                if (!stickyElement) return;
                const stickyInfo = stickyElement.getBoundingClientRect();
                const targetInfo = entry.boundingClientRect;
                const rootBoundsInfo = entry.rootBounds;
                const intersectionRatio = entry.intersectionRatio;
                if (targetInfo.bottom > rootBoundsInfo.top && intersectionRatio === 1 && stickyInfo.y === 0) setIsStuck(true);
                if (targetInfo.top < rootBoundsInfo.top && targetInfo.bottom < rootBoundsInfo.bottom) setIsStuck(false);
            }
        }, {
            threshold: [
                1
            ],
            root: container
        });
        observer.observe(bottomRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        container,
        stickyElement
    ]);
    return /*#__PURE__*/ (0, $drmv2.jsx)($48d74830c9e93e35$export$26acbae003699fe6.Provider, {
        value: {
            isStuck: isStuck,
            stickyElementRef: stickyElementRef,
            stickyElement: stickyElement
        },
        children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
            style: {
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    ref: topRef,
                    style: {
                        position: "absolute",
                        top: stickyBuffer,
                        left: 0,
                        right: 0,
                        visibility: "hidden",
                        display: "block"
                    }
                }),
                children,
                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    ref: bottomRef,
                    style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: stickyElementRect.height,
                        visibility: "hidden",
                        display: "block"
                    }
                })
            ]
        })
    });
};

});

parcelRegister("grDIL", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $0316ef660c0c3de4$export$f4d5bf230a36dd6e; });

var $1vrWl = parcelRequire("1vrWl");

var $iggOi = parcelRequire("iggOi");

var $4j6tV = parcelRequire("4j6tV");

var $8thbo = parcelRequire("8thbo");

var $jjNqT = parcelRequire("jjNqT");
var $0316ef660c0c3de4$var$EMPTY_MODIFIERS = [];
var $0316ef660c0c3de4$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $1vrWl.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $0316ef660c0c3de4$var$EMPTY_MODIFIERS
    };
    var _React$useState = $1vrWl.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $1vrWl.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $iggOi.flushSync(function() {
                    setState({
                        styles: (0, $jjNqT.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $jjNqT.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $1vrWl.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8thbo)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $1vrWl.useRef();
    (0, $jjNqT.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $jjNqT.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $4j6tV.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("4j6tV", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $322df6e57ef55969$export$8f7491d57c8f97a9; });

var $h07OK = parcelRequire("h07OK");

var $gLeE1 = parcelRequire("gLeE1");

var $epA4C = parcelRequire("epA4C");

var $d0OQI = parcelRequire("d0OQI");

var $l8gtO = parcelRequire("l8gtO");

var $7GzpU = parcelRequire("7GzpU");

var $fp964 = parcelRequire("fp964");

var $1raZc = parcelRequire("1raZc");

var $6WUKe = parcelRequire("6WUKe");

var $kD305 = parcelRequire("kD305");


var $322df6e57ef55969$export$d34966752335dd47 = [
    (0, $gLeE1.default),
    (0, $epA4C.default),
    (0, $d0OQI.default),
    (0, $l8gtO.default),
    (0, $7GzpU.default),
    (0, $fp964.default),
    (0, $1raZc.default),
    (0, $6WUKe.default),
    (0, $kD305.default)
];
var $322df6e57ef55969$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $h07OK.popperGenerator)({
    defaultModifiers: $322df6e57ef55969$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("h07OK", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $c608802bf9ea9260$export$ed5e13716264f202; });

var $jo3pe = parcelRequire("jo3pe");

var $6IOc5 = parcelRequire("6IOc5");

var $att5a = parcelRequire("att5a");

var $1Lj5p = parcelRequire("1Lj5p");

var $44oBT = parcelRequire("44oBT");

var $iGLKp = parcelRequire("iGLKp");

var $fnibW = parcelRequire("fnibW");


var $i4kc5 = parcelRequire("i4kc5");
var $c608802bf9ea9260$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $c608802bf9ea9260$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $c608802bf9ea9260$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c608802bf9ea9260$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $c608802bf9ea9260$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $i4kc5.isElement)(reference) ? (0, $att5a.default)(reference) : reference.contextElement ? (0, $att5a.default)(reference.contextElement) : [],
                    popper: (0, $att5a.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $44oBT.default)((0, $fnibW.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c608802bf9ea9260$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $jo3pe.default)(reference, (0, $1Lj5p.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $6IOc5.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $iGLKp.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c608802bf9ea9260$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c608802bf9ea9260$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c608802bf9ea9260$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("jo3pe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1d2e68ce0461dd6$export$2e2bcd8739ae039; });

var $8plva = parcelRequire("8plva");

var $3qrCM = parcelRequire("3qrCM");

var $bpK3Y = parcelRequire("bpK3Y");

var $i4kc5 = parcelRequire("i4kc5");

var $8W0mD = parcelRequire("8W0mD");

var $leucV = parcelRequire("leucV");

var $ElQWh = parcelRequire("ElQWh");

var $k8B9S = parcelRequire("k8B9S");
function $e1d2e68ce0461dd6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $k8B9S.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $k8B9S.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $e1d2e68ce0461dd6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $i4kc5.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $i4kc5.isHTMLElement)(offsetParent) && $e1d2e68ce0461dd6$var$isElementScaled(offsetParent);
    var documentElement = (0, $leucV.default)(offsetParent);
    var rect = (0, $8plva.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bpK3Y.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $ElQWh.default)(documentElement)) scroll = (0, $3qrCM.default)(offsetParent);
        if ((0, $i4kc5.isHTMLElement)(offsetParent)) {
            offsets = (0, $8plva.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8W0mD.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("8plva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61f1564f74b80a6c$export$2e2bcd8739ae039; });

var $i4kc5 = parcelRequire("i4kc5");

var $k8B9S = parcelRequire("k8B9S");

var $9LVTa = parcelRequire("9LVTa");

var $l17oR = parcelRequire("l17oR");
function $61f1564f74b80a6c$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $i4kc5.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $k8B9S.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $k8B9S.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $i4kc5.isElement)(element) ? (0, $9LVTa.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $l17oR.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("i4kc5", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0365095a167051ef$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0365095a167051ef$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0365095a167051ef$export$af51f0f06c0f328a; });

var $9LVTa = parcelRequire("9LVTa");
function $0365095a167051ef$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $9LVTa.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0365095a167051ef$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $9LVTa.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0365095a167051ef$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $9LVTa.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("9LVTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d56853a58391a2$export$2e2bcd8739ae039; });
function $71d56853a58391a2$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("k8B9S", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $ea9160dc63506fb3$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $ea9160dc63506fb3$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $ea9160dc63506fb3$export$2077e0241d6afd3c; });
var $ea9160dc63506fb3$export$8960430cfd85939f = Math.max;
var $ea9160dc63506fb3$export$96ec731ed4dcb222 = Math.min;
var $ea9160dc63506fb3$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("l17oR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4cf6e766e0d14ce$export$2e2bcd8739ae039; });

var $7nyhL = parcelRequire("7nyhL");
function $f4cf6e766e0d14ce$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $7nyhL.default)());
}

});
parcelRegister("7nyhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f546c63fb64920$export$2e2bcd8739ae039; });
function $55f546c63fb64920$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("3qrCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27e93a6fe6d21fdb$export$2e2bcd8739ae039; });

var $8FQ6L = parcelRequire("8FQ6L");

var $9LVTa = parcelRequire("9LVTa");

var $i4kc5 = parcelRequire("i4kc5");

var $lxhKm = parcelRequire("lxhKm");
function $27e93a6fe6d21fdb$export$2e2bcd8739ae039(node) {
    if (node === (0, $9LVTa.default)(node) || !(0, $i4kc5.isHTMLElement)(node)) return (0, $8FQ6L.default)(node);
    else return (0, $lxhKm.default)(node);
}

});
parcelRegister("8FQ6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650a92a9eeeb2d6c$export$2e2bcd8739ae039; });

var $9LVTa = parcelRequire("9LVTa");
function $650a92a9eeeb2d6c$export$2e2bcd8739ae039(node) {
    var win = (0, $9LVTa.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("lxhKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fada7228715f0bc1$export$2e2bcd8739ae039; });
function $fada7228715f0bc1$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("bpK3Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84f5c2a942ea0925$export$2e2bcd8739ae039; });
function $84f5c2a942ea0925$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("8W0mD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $681405cf2face7bf$export$2e2bcd8739ae039; });

var $8plva = parcelRequire("8plva");

var $leucV = parcelRequire("leucV");

var $8FQ6L = parcelRequire("8FQ6L");
function $681405cf2face7bf$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8plva.default)((0, $leucV.default)(element)).left + (0, $8FQ6L.default)(element).scrollLeft;
}

});
parcelRegister("leucV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7525659d2d74837$export$2e2bcd8739ae039; });

var $i4kc5 = parcelRequire("i4kc5");
function $f7525659d2d74837$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $i4kc5.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("ElQWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0794b0102863a84f$export$2e2bcd8739ae039; });

var $j5MMH = parcelRequire("j5MMH");
function $0794b0102863a84f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $j5MMH.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("j5MMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de6453879a2c169b$export$2e2bcd8739ae039; });

var $9LVTa = parcelRequire("9LVTa");
function $de6453879a2c169b$export$2e2bcd8739ae039(element) {
    return (0, $9LVTa.default)(element).getComputedStyle(element);
}

});



parcelRegister("6IOc5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e4dc9a00822dd07$export$2e2bcd8739ae039; });

var $8plva = parcelRequire("8plva");
function $4e4dc9a00822dd07$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8plva.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("att5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a032bf481798559$export$2e2bcd8739ae039; });

var $anumS = parcelRequire("anumS");

var $6fjhU = parcelRequire("6fjhU");

var $9LVTa = parcelRequire("9LVTa");

var $ElQWh = parcelRequire("ElQWh");
function $7a032bf481798559$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $anumS.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $9LVTa.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $ElQWh.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($7a032bf481798559$export$2e2bcd8739ae039((0, $6fjhU.default)(target)));
}

});
parcelRegister("anumS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78e39bd34848cc14$export$2e2bcd8739ae039; });

var $6fjhU = parcelRequire("6fjhU");

var $ElQWh = parcelRequire("ElQWh");

var $bpK3Y = parcelRequire("bpK3Y");

var $i4kc5 = parcelRequire("i4kc5");
function $78e39bd34848cc14$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $bpK3Y.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $i4kc5.isHTMLElement)(node) && (0, $ElQWh.default)(node)) return node;
    return $78e39bd34848cc14$export$2e2bcd8739ae039((0, $6fjhU.default)(node));
}

});
parcelRegister("6fjhU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c31af116781570$export$2e2bcd8739ae039; });

var $bpK3Y = parcelRequire("bpK3Y");

var $leucV = parcelRequire("leucV");

var $i4kc5 = parcelRequire("i4kc5");
function $48c31af116781570$export$2e2bcd8739ae039(element) {
    if ((0, $bpK3Y.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $i4kc5.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $leucV.default)(element) // fallback
    );
}

});



parcelRegister("1Lj5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1488fc5e63388cf7$export$2e2bcd8739ae039; });

var $9LVTa = parcelRequire("9LVTa");

var $bpK3Y = parcelRequire("bpK3Y");

var $j5MMH = parcelRequire("j5MMH");

var $i4kc5 = parcelRequire("i4kc5");

var $cbVib = parcelRequire("cbVib");

var $6fjhU = parcelRequire("6fjhU");

var $7nyhL = parcelRequire("7nyhL");
function $1488fc5e63388cf7$var$getTrueOffsetParent(element) {
    if (!(0, $i4kc5.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $j5MMH.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1488fc5e63388cf7$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $7nyhL.default)());
    var isIE = /Trident/i.test((0, $7nyhL.default)());
    if (isIE && (0, $i4kc5.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $j5MMH.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $6fjhU.default)(element);
    if ((0, $i4kc5.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $i4kc5.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $bpK3Y.default)(currentNode)) < 0){
        var css = (0, $j5MMH.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1488fc5e63388cf7$export$2e2bcd8739ae039(element) {
    var window = (0, $9LVTa.default)(element);
    var offsetParent = $1488fc5e63388cf7$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cbVib.default)(offsetParent) && (0, $j5MMH.default)(offsetParent).position === "static")offsetParent = $1488fc5e63388cf7$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bpK3Y.default)(offsetParent) === "html" || (0, $bpK3Y.default)(offsetParent) === "body" && (0, $j5MMH.default)(offsetParent).position === "static")) return window;
    return offsetParent || $1488fc5e63388cf7$var$getContainingBlock(element) || window;
}

});
parcelRegister("cbVib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e02f42ef168cb25$export$2e2bcd8739ae039; });

var $bpK3Y = parcelRequire("bpK3Y");
function $8e02f42ef168cb25$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $bpK3Y.default)(element)) >= 0;
}

});


parcelRegister("44oBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f6aa03863ed83a0$export$2e2bcd8739ae039; });

var $h6p3X = parcelRequire("h6p3X");
function $2f6aa03863ed83a0$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2f6aa03863ed83a0$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2f6aa03863ed83a0$var$order(modifiers); // order based on phase
    return (0, $h6p3X.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("h6p3X", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $c736702c097c1bfe$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $c736702c097c1bfe$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $c736702c097c1bfe$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $c736702c097c1bfe$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $c736702c097c1bfe$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $c736702c097c1bfe$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $c736702c097c1bfe$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $c736702c097c1bfe$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $c736702c097c1bfe$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $c736702c097c1bfe$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $c736702c097c1bfe$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $c736702c097c1bfe$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $c736702c097c1bfe$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $c736702c097c1bfe$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $c736702c097c1bfe$export$d087d3878fdf71d5; });
var $c736702c097c1bfe$export$1e95b668f3b82d = "top";
var $c736702c097c1bfe$export$40e543e69a8b3fbb = "bottom";
var $c736702c097c1bfe$export$79ffe56a765070d2 = "right";
var $c736702c097c1bfe$export$eabcd2c8791e7bf4 = "left";
var $c736702c097c1bfe$export$dfb5619354ba860 = "auto";
var $c736702c097c1bfe$export$aec2ce47c367b8c3 = [
    $c736702c097c1bfe$export$1e95b668f3b82d,
    $c736702c097c1bfe$export$40e543e69a8b3fbb,
    $c736702c097c1bfe$export$79ffe56a765070d2,
    $c736702c097c1bfe$export$eabcd2c8791e7bf4
];
var $c736702c097c1bfe$export$b3571188c770cc5a = "start";
var $c736702c097c1bfe$export$bd5df0f255a350f8 = "end";
var $c736702c097c1bfe$export$390fd549c5303b4d = "clippingParents";
var $c736702c097c1bfe$export$d7b7311ec04a3e8f = "viewport";
var $c736702c097c1bfe$export$ae5ab1c730825774 = "popper";
var $c736702c097c1bfe$export$ca50aac9f3ba507f = "reference";
var $c736702c097c1bfe$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c736702c097c1bfe$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c736702c097c1bfe$export$b3571188c770cc5a,
        placement + "-" + $c736702c097c1bfe$export$bd5df0f255a350f8
    ]);
}, []);
var $c736702c097c1bfe$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c736702c097c1bfe$export$aec2ce47c367b8c3, [
    $c736702c097c1bfe$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c736702c097c1bfe$export$b3571188c770cc5a,
        placement + "-" + $c736702c097c1bfe$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c736702c097c1bfe$export$421679a7c3d56e = "beforeRead";
var $c736702c097c1bfe$export$aafa59e2e03f2942 = "read";
var $c736702c097c1bfe$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $c736702c097c1bfe$export$c65e99957a05207c = "beforeMain";
var $c736702c097c1bfe$export$f22da7240b7add18 = "main";
var $c736702c097c1bfe$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c736702c097c1bfe$export$8d4d2d70e7d46032 = "beforeWrite";
var $c736702c097c1bfe$export$68d8715fc104d294 = "write";
var $c736702c097c1bfe$export$70a6e5159acce2e6 = "afterWrite";
var $c736702c097c1bfe$export$d087d3878fdf71d5 = [
    $c736702c097c1bfe$export$421679a7c3d56e,
    $c736702c097c1bfe$export$aafa59e2e03f2942,
    $c736702c097c1bfe$export$6964f6c886723980,
    $c736702c097c1bfe$export$c65e99957a05207c,
    $c736702c097c1bfe$export$f22da7240b7add18,
    $c736702c097c1bfe$export$bab79516f2d662fe,
    $c736702c097c1bfe$export$8d4d2d70e7d46032,
    $c736702c097c1bfe$export$68d8715fc104d294,
    $c736702c097c1bfe$export$70a6e5159acce2e6
];

});


parcelRegister("iGLKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9b12fec8aa8efb6$export$2e2bcd8739ae039; });
function $d9b12fec8aa8efb6$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("fnibW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3171d73db96150d$export$2e2bcd8739ae039; });
function $b3171d73db96150d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("gLeE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33c6532db727da1$export$2e2bcd8739ae039; });

var $9LVTa = parcelRequire("9LVTa");
var $c33c6532db727da1$var$passive = {
    passive: true
};
function $c33c6532db727da1$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $9LVTa.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $c33c6532db727da1$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $c33c6532db727da1$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $c33c6532db727da1$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $c33c6532db727da1$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $c33c6532db727da1$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $c33c6532db727da1$var$effect,
    data: {}
};

});

parcelRegister("epA4C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7df61eea703a471$export$2e2bcd8739ae039; });

var $hW9Ii = parcelRequire("hW9Ii");
function $a7df61eea703a471$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $hW9Ii.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a7df61eea703a471$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $a7df61eea703a471$var$popperOffsets,
    data: {}
};

});
parcelRegister("hW9Ii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0ef635b57298f6d$export$2e2bcd8739ae039; });

var $f9NNL = parcelRequire("f9NNL");

var $AKUM9 = parcelRequire("AKUM9");

var $2UoKc = parcelRequire("2UoKc");

var $h6p3X = parcelRequire("h6p3X");
function $d0ef635b57298f6d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f9NNL.default)(placement) : null;
    var variation = placement ? (0, $AKUM9.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $h6p3X.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $h6p3X.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $h6p3X.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $h6p3X.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2UoKc.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $h6p3X.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $h6p3X.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("f9NNL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08e53de87a9b4a2$export$2e2bcd8739ae039; });

function $b08e53de87a9b4a2$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("AKUM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06e7c13266d212e0$export$2e2bcd8739ae039; });
function $06e7c13266d212e0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("2UoKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21e40169ca7347f0$export$2e2bcd8739ae039; });
function $21e40169ca7347f0$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("d0OQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9792b813ba371473$export$2e2bcd8739ae039; });

var $h6p3X = parcelRequire("h6p3X");

var $1Lj5p = parcelRequire("1Lj5p");

var $9LVTa = parcelRequire("9LVTa");

var $leucV = parcelRequire("leucV");

var $j5MMH = parcelRequire("j5MMH");

var $f9NNL = parcelRequire("f9NNL");

var $AKUM9 = parcelRequire("AKUM9");

var $k8B9S = parcelRequire("k8B9S");
var $9792b813ba371473$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $9792b813ba371473$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $k8B9S.round)(x * dpr) / dpr || 0,
        y: (0, $k8B9S.round)(y * dpr) / dpr || 0
    };
}
function $9792b813ba371473$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $h6p3X.left);
    var sideY = (0, $h6p3X.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Lj5p.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $9LVTa.default)(popper)) {
            offsetParent = (0, $leucV.default)(popper);
            if ((0, $j5MMH.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $h6p3X.top) || (placement === (0, $h6p3X.left) || placement === (0, $h6p3X.right)) && variation === (0, $h6p3X.end)) {
            sideY = (0, $h6p3X.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $h6p3X.left) || (placement === (0, $h6p3X.top) || placement === (0, $h6p3X.bottom)) && variation === (0, $h6p3X.end)) {
            sideX = (0, $h6p3X.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $9792b813ba371473$var$unsetSides);
    var _ref4 = roundOffsets === true ? $9792b813ba371473$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $9LVTa.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $9792b813ba371473$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f9NNL.default)(state.placement),
        variation: (0, $AKUM9.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $9792b813ba371473$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $9792b813ba371473$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9792b813ba371473$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $9792b813ba371473$var$computeStyles,
    data: {}
};

});

parcelRegister("l8gtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f62720db9ba8cf08$export$2e2bcd8739ae039; });

var $bpK3Y = parcelRequire("bpK3Y");

var $i4kc5 = parcelRequire("i4kc5");
// and applies them to the HTMLElements such as popper and arrow
function $f62720db9ba8cf08$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $i4kc5.isHTMLElement)(element) || !(0, $bpK3Y.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $f62720db9ba8cf08$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $i4kc5.isHTMLElement)(element) || !(0, $bpK3Y.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f62720db9ba8cf08$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $f62720db9ba8cf08$var$applyStyles,
    effect: $f62720db9ba8cf08$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("7GzpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5987edb40a32a867$export$2e2bcd8739ae039; });

var $f9NNL = parcelRequire("f9NNL");

var $h6p3X = parcelRequire("h6p3X");
function $5987edb40a32a867$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f9NNL.default)(placement);
    var invertDistance = [
        (0, $h6p3X.left),
        (0, $h6p3X.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $h6p3X.left),
        (0, $h6p3X.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $5987edb40a32a867$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $h6p3X.placements).reduce(function(acc, placement) {
        acc[placement] = $5987edb40a32a867$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5987edb40a32a867$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $5987edb40a32a867$var$offset
};

});

parcelRegister("fp964", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3703f451f37a39c$export$2e2bcd8739ae039; });

var $3qEKs = parcelRequire("3qEKs");

var $f9NNL = parcelRequire("f9NNL");

var $288N0 = parcelRequire("288N0");

var $jeMcN = parcelRequire("jeMcN");

var $hEVxS = parcelRequire("hEVxS");

var $h6p3X = parcelRequire("h6p3X");

var $AKUM9 = parcelRequire("AKUM9");
function $b3703f451f37a39c$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f9NNL.default)(placement) === (0, $h6p3X.auto)) return [];
    var oppositePlacement = (0, $3qEKs.default)(placement);
    return [
        (0, $288N0.default)(placement),
        oppositePlacement,
        (0, $288N0.default)(oppositePlacement)
    ];
}
function $b3703f451f37a39c$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f9NNL.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3qEKs.default)(preferredPlacement)
    ] : $b3703f451f37a39c$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f9NNL.default)(placement) === (0, $h6p3X.auto) ? (0, $hEVxS.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f9NNL.default)(placement);
        var isStartVariation = (0, $AKUM9.default)(placement) === (0, $h6p3X.start);
        var isVertical = [
            (0, $h6p3X.top),
            (0, $h6p3X.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $jeMcN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $h6p3X.right) : (0, $h6p3X.left) : isStartVariation ? (0, $h6p3X.bottom) : (0, $h6p3X.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3qEKs.default)(mainVariationSide);
        var altVariationSide = (0, $3qEKs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b3703f451f37a39c$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b3703f451f37a39c$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3qEKs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f36898a5842bc6$export$2e2bcd8739ae039; });
var $27f36898a5842bc6$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $27f36898a5842bc6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $27f36898a5842bc6$var$hash[matched];
    });
}

});

parcelRegister("288N0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18d32580f233e5d8$export$2e2bcd8739ae039; });
var $18d32580f233e5d8$var$hash = {
    start: "end",
    end: "start"
};
function $18d32580f233e5d8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $18d32580f233e5d8$var$hash[matched];
    });
}

});

parcelRegister("jeMcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e014b7b372dbf778$export$2e2bcd8739ae039; });

var $jQqoV = parcelRequire("jQqoV");

var $leucV = parcelRequire("leucV");

var $8plva = parcelRequire("8plva");

var $hW9Ii = parcelRequire("hW9Ii");

var $3xYRy = parcelRequire("3xYRy");

var $h6p3X = parcelRequire("h6p3X");

var $i4kc5 = parcelRequire("i4kc5");

var $laIOp = parcelRequire("laIOp");

var $BoNCq = parcelRequire("BoNCq");
function $e014b7b372dbf778$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $h6p3X.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $h6p3X.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $h6p3X.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $laIOp.default)(typeof padding !== "number" ? padding : (0, $BoNCq.default)(padding, (0, $h6p3X.basePlacements)));
    var altContext = elementContext === (0, $h6p3X.popper) ? (0, $h6p3X.reference) : (0, $h6p3X.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jQqoV.default)((0, $i4kc5.isElement)(element) ? element : element.contextElement || (0, $leucV.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8plva.default)(state.elements.reference);
    var popperOffsets = (0, $hW9Ii.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $3xYRy.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $h6p3X.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $h6p3X.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $h6p3X.right),
                (0, $h6p3X.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $h6p3X.top),
                (0, $h6p3X.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jQqoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7275a5c02a5fc2e$export$2e2bcd8739ae039; });

var $h6p3X = parcelRequire("h6p3X");

var $iVzcw = parcelRequire("iVzcw");

var $8d1F5 = parcelRequire("8d1F5");

var $att5a = parcelRequire("att5a");

var $1Lj5p = parcelRequire("1Lj5p");

var $leucV = parcelRequire("leucV");

var $j5MMH = parcelRequire("j5MMH");

var $i4kc5 = parcelRequire("i4kc5");

var $8plva = parcelRequire("8plva");

var $6fjhU = parcelRequire("6fjhU");

var $eWYsX = parcelRequire("eWYsX");

var $bpK3Y = parcelRequire("bpK3Y");

var $3xYRy = parcelRequire("3xYRy");

var $k8B9S = parcelRequire("k8B9S");
function $e7275a5c02a5fc2e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8plva.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e7275a5c02a5fc2e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $h6p3X.viewport) ? (0, $3xYRy.default)((0, $iVzcw.default)(element, strategy)) : (0, $i4kc5.isElement)(clippingParent) ? $e7275a5c02a5fc2e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3xYRy.default)((0, $8d1F5.default)((0, $leucV.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e7275a5c02a5fc2e$var$getClippingParents(element) {
    var clippingParents = (0, $att5a.default)((0, $6fjhU.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $j5MMH.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $i4kc5.isHTMLElement)(element) ? (0, $1Lj5p.default)(element) : element;
    if (!(0, $i4kc5.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $i4kc5.isElement)(clippingParent) && (0, $eWYsX.default)(clippingParent, clipperElement) && (0, $bpK3Y.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e7275a5c02a5fc2e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $e7275a5c02a5fc2e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e7275a5c02a5fc2e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $k8B9S.max)(rect.top, accRect.top);
        accRect.right = (0, $k8B9S.min)(rect.right, accRect.right);
        accRect.bottom = (0, $k8B9S.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $k8B9S.max)(rect.left, accRect.left);
        return accRect;
    }, $e7275a5c02a5fc2e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("iVzcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc78db082eeda9cc$export$2e2bcd8739ae039; });

var $9LVTa = parcelRequire("9LVTa");

var $leucV = parcelRequire("leucV");

var $8W0mD = parcelRequire("8W0mD");

var $l17oR = parcelRequire("l17oR");
function $dc78db082eeda9cc$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $9LVTa.default)(element);
    var html = (0, $leucV.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $l17oR.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8W0mD.default)(element),
        y: y
    };
}

});

parcelRegister("8d1F5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fa0d395ac3b151b$export$2e2bcd8739ae039; });

var $leucV = parcelRequire("leucV");

var $j5MMH = parcelRequire("j5MMH");

var $8W0mD = parcelRequire("8W0mD");

var $8FQ6L = parcelRequire("8FQ6L");

var $k8B9S = parcelRequire("k8B9S");
function $5fa0d395ac3b151b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $leucV.default)(element);
    var winScroll = (0, $8FQ6L.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $k8B9S.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $k8B9S.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8W0mD.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $j5MMH.default)(body || html).direction === "rtl") x += (0, $k8B9S.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("eWYsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2562c91de63682$export$2e2bcd8739ae039; });

var $i4kc5 = parcelRequire("i4kc5");
function $ae2562c91de63682$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $i4kc5.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("3xYRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2953aa3dc9934313$export$2e2bcd8739ae039; });
function $2953aa3dc9934313$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("laIOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69d4ae059a71c80$export$2e2bcd8739ae039; });

var $k3eda = parcelRequire("k3eda");
function $f69d4ae059a71c80$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $k3eda.default)(), paddingObject);
}

});
parcelRegister("k3eda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e98f1c892d45ced8$export$2e2bcd8739ae039; });
function $e98f1c892d45ced8$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("BoNCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0706b170f303172d$export$2e2bcd8739ae039; });
function $0706b170f303172d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("hEVxS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb2cf6556908928$export$2e2bcd8739ae039; });

var $AKUM9 = parcelRequire("AKUM9");

var $h6p3X = parcelRequire("h6p3X");

var $jeMcN = parcelRequire("jeMcN");

var $f9NNL = parcelRequire("f9NNL");
function $cdb2cf6556908928$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $h6p3X.placements) : _options$allowedAutoP;
    var variation = (0, $AKUM9.default)(placement);
    var placements = variation ? flipVariations ? (0, $h6p3X.variationPlacements) : (0, $h6p3X.variationPlacements).filter(function(placement) {
        return (0, $AKUM9.default)(placement) === variation;
    }) : (0, $h6p3X.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $jeMcN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f9NNL.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1raZc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10c0d5aaebdafcfa$export$2e2bcd8739ae039; });

var $h6p3X = parcelRequire("h6p3X");

var $f9NNL = parcelRequire("f9NNL");

var $2UoKc = parcelRequire("2UoKc");

var $4qJ6w = parcelRequire("4qJ6w");

var $i9yM2 = parcelRequire("i9yM2");

var $6IOc5 = parcelRequire("6IOc5");

var $1Lj5p = parcelRequire("1Lj5p");

var $jeMcN = parcelRequire("jeMcN");

var $AKUM9 = parcelRequire("AKUM9");

var $k3eda = parcelRequire("k3eda");

var $k8B9S = parcelRequire("k8B9S");
function $10c0d5aaebdafcfa$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $jeMcN.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f9NNL.default)(state.placement);
    var variation = (0, $AKUM9.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2UoKc.default)(basePlacement);
    var altAxis = (0, $4qJ6w.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $h6p3X.top) : (0, $h6p3X.left);
        var altSide = mainAxis === "y" ? (0, $h6p3X.bottom) : (0, $h6p3X.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $h6p3X.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $h6p3X.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $6IOc5.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $k3eda.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $i9yM2.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Lj5p.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $i9yM2.within)(tether ? (0, $k8B9S.min)(min, tetherMin) : min, offset, tether ? (0, $k8B9S.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $h6p3X.top) : (0, $h6p3X.left);
        var _altSide = mainAxis === "x" ? (0, $h6p3X.bottom) : (0, $h6p3X.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $h6p3X.top),
            (0, $h6p3X.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $i9yM2.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $i9yM2.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $10c0d5aaebdafcfa$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $10c0d5aaebdafcfa$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("4qJ6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $339c93e3d43de856$export$2e2bcd8739ae039; });
function $339c93e3d43de856$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("i9yM2", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $d3740a9775c7a467$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $d3740a9775c7a467$export$86c8af6d3ef0b4a; });

var $k8B9S = parcelRequire("k8B9S");
function $d3740a9775c7a467$export$f28d906d67a997f3(min, value, max) {
    return (0, $k8B9S.max)(min, (0, $k8B9S.min)(value, max));
}
function $d3740a9775c7a467$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d3740a9775c7a467$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("6WUKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f42d2bcd870291$export$2e2bcd8739ae039; });

var $f9NNL = parcelRequire("f9NNL");

var $6IOc5 = parcelRequire("6IOc5");

var $eWYsX = parcelRequire("eWYsX");

var $1Lj5p = parcelRequire("1Lj5p");

var $2UoKc = parcelRequire("2UoKc");

var $i9yM2 = parcelRequire("i9yM2");

var $laIOp = parcelRequire("laIOp");

var $BoNCq = parcelRequire("BoNCq");

var $h6p3X = parcelRequire("h6p3X");
var $50f42d2bcd870291$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $laIOp.default)(typeof padding !== "number" ? padding : (0, $BoNCq.default)(padding, (0, $h6p3X.basePlacements)));
};
function $50f42d2bcd870291$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f9NNL.default)(state.placement);
    var axis = (0, $2UoKc.default)(basePlacement);
    var isVertical = [
        (0, $h6p3X.left),
        (0, $h6p3X.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $50f42d2bcd870291$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $6IOc5.default)(arrowElement);
    var minProp = axis === "y" ? (0, $h6p3X.top) : (0, $h6p3X.left);
    var maxProp = axis === "y" ? (0, $h6p3X.bottom) : (0, $h6p3X.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Lj5p.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $i9yM2.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $50f42d2bcd870291$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $eWYsX.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $50f42d2bcd870291$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $50f42d2bcd870291$var$arrow,
    effect: $50f42d2bcd870291$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("kD305", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f049c6fe2ba02e70$export$2e2bcd8739ae039; });

var $h6p3X = parcelRequire("h6p3X");

var $jeMcN = parcelRequire("jeMcN");
function $f049c6fe2ba02e70$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f049c6fe2ba02e70$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $h6p3X.top),
        (0, $h6p3X.right),
        (0, $h6p3X.bottom),
        (0, $h6p3X.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f049c6fe2ba02e70$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $jeMcN.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $jeMcN.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f049c6fe2ba02e70$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f049c6fe2ba02e70$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f049c6fe2ba02e70$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f049c6fe2ba02e70$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f049c6fe2ba02e70$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $f049c6fe2ba02e70$var$hide
};

});


parcelRegister("jjNqT", function(module, exports) {

$parcel$export(module.exports, "fromEntries", function () { return $e10622f73d7696ca$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $e10622f73d7696ca$export$700979bc83e7db82; });

var $1vrWl = parcelRequire("1vrWl");
var $e10622f73d7696ca$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $e10622f73d7696ca$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $e10622f73d7696ca$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $e10622f73d7696ca$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $e10622f73d7696ca$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $e10622f73d7696ca$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $1vrWl.useLayoutEffect : $1vrWl.useEffect;

});


parcelRegister("gLiL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33f96407a43a8be$export$2e2bcd8739ae039; });

var $lTFcg = parcelRequire("lTFcg");

var $8nExC = parcelRequire("8nExC");
function $c33f96407a43a8be$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $lTFcg.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8nExC.default)(rnds);
}
var $c33f96407a43a8be$export$2e2bcd8739ae039 = $c33f96407a43a8be$var$v4;

});
parcelRegister("lTFcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff0eb0db3935864b$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ff0eb0db3935864b$var$getRandomValues;
var $ff0eb0db3935864b$var$rnds8 = new Uint8Array(16);
function $ff0eb0db3935864b$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ff0eb0db3935864b$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ff0eb0db3935864b$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ff0eb0db3935864b$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ff0eb0db3935864b$var$getRandomValues($ff0eb0db3935864b$var$rnds8);
}

});

parcelRegister("8nExC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $619feb59edcc67fd$export$2e2bcd8739ae039; });

var $eOKtp = parcelRequire("eOKtp");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $619feb59edcc67fd$var$byteToHex = [];
for(var $619feb59edcc67fd$var$i = 0; $619feb59edcc67fd$var$i < 256; ++$619feb59edcc67fd$var$i)$619feb59edcc67fd$var$byteToHex.push(($619feb59edcc67fd$var$i + 0x100).toString(16).substr(1));
function $619feb59edcc67fd$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($619feb59edcc67fd$var$byteToHex[arr[offset + 0]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 1]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 2]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 3]] + "-" + $619feb59edcc67fd$var$byteToHex[arr[offset + 4]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 5]] + "-" + $619feb59edcc67fd$var$byteToHex[arr[offset + 6]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 7]] + "-" + $619feb59edcc67fd$var$byteToHex[arr[offset + 8]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 9]] + "-" + $619feb59edcc67fd$var$byteToHex[arr[offset + 10]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 11]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 12]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 13]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 14]] + $619feb59edcc67fd$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $eOKtp.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $619feb59edcc67fd$export$2e2bcd8739ae039 = $619feb59edcc67fd$var$stringify;

});
parcelRegister("eOKtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac99c8d4d65f11f0$export$2e2bcd8739ae039; });

var $dLKPL = parcelRequire("dLKPL");
function $ac99c8d4d65f11f0$var$validate(uuid) {
    return typeof uuid === "string" && (0, $dLKPL.default).test(uuid);
}
var $ac99c8d4d65f11f0$export$2e2bcd8739ae039 = $ac99c8d4d65f11f0$var$validate;

});
parcelRegister("dLKPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a063fe66eae28931$export$2e2bcd8739ae039; });
var $a063fe66eae28931$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("60uP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45faa706ec523689$export$2e2bcd8739ae039; });

var $1vrWl = parcelRequire("1vrWl");
/**
 * Credit to material-ui for this snippet
 */ function $45faa706ec523689$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
/**
 * useForkRef
 * Joins refs together and returns a combination of the two as a new ref
 * @param refA
 * @param refB
 */ function $45faa706ec523689$var$useForkRef(refA, refB) {
    /**
     * This will create a new function if the ref props change and are defined.
     * This means react will call the old forkRef with `null` and the new forkRef
     * with the ref. Cleanup naturally emerges from this behavior
     */ return (0, $1vrWl.useMemo)(()=>{
        if (refA == null && refB == null) return null;
        return (refValue)=>{
            $45faa706ec523689$var$setRef(refA, refValue);
            $45faa706ec523689$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
var $45faa706ec523689$export$2e2bcd8739ae039 = $45faa706ec523689$var$useForkRef;

});


parcelRegister("j9Ac6", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $df1aef0007a7abae$export$e8e78c978b129247; }, function (v) { return $df1aef0007a7abae$export$e8e78c978b129247 = v; });
var $df1aef0007a7abae$export$f1185b91c12c4c7f;
var $df1aef0007a7abae$export$e8e78c978b129247;
$df1aef0007a7abae$export$f1185b91c12c4c7f = `uWLW9q_horizontalRule`;
$df1aef0007a7abae$export$e8e78c978b129247 = `uWLW9q_root`;

});

parcelRegister("cOTy9", function(module, exports) {

$parcel$export(module.exports, "ProductContainer", function () { return $976f1b18f3e43527$export$a2562875824074d7; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $g2L0U = parcelRequire("g2L0U");

var $fCQJX = parcelRequire("fCQJX");
var $bLLzi = parcelRequire("bLLzi");

var $1Lcud = parcelRequire("1Lcud");

var $biy3n = parcelRequire("biy3n");

var $33dni = parcelRequire("33dni");

var $gH7Rp = parcelRequire("gH7Rp");
parcelRequire("3AWie");
var $bJE9e = parcelRequire("bJE9e");

var $2a9eH = parcelRequire("2a9eH");
const $976f1b18f3e43527$export$a2562875824074d7 = (0, $fCQJX.default)((0, $bLLzi.default)(({ hits: hits, hasPrevious: hasPrevious, hasMore: hasMore, refineNext: refineNext, refinePrevious: refinePrevious, isSearchStalled: isSearchStalled, searchResults: searchResults, adverts: adverts, hitsPerPage: hitsPerPage = 48 })=>{
    const isDesktopViewport = (0, $g2L0U.useMediaQuery)({
        query: "(min-width: 768px)"
    });
    const searchIndex = searchResults?.index;
    const queryID = searchResults?.queryID;
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (queryID) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                queryID: queryID,
                searchIndex: searchIndex
            });
            const value = window.localStorage.getItem("algolia-insights");
            let json;
            try {
                json = JSON.parse(value);
                json.queries.push({
                    queryID: queryID,
                    searchIndex: searchIndex
                });
            } catch (error) {
                json = {
                    products: {},
                    queries: [
                        {
                            queryID: queryID,
                            searchIndex: searchIndex
                        }
                    ]
                };
            }
            window.localStorage.setItem("algolia-insights", JSON.stringify(json));
        }
    }, [
        queryID,
        searchIndex
    ]);
    if (!hits.length && !isSearchStalled) return null;
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    //Check if Load More Checker is in view
    function onVisibilityChange(isVisible) {
        if (isVisible) refineNext();
    }
    let cardCountStarted = false;
    let cardCount = 0;
    const cardCountUpdate = ()=>{
        cardCount = cardCount + 1;
    };
    const resetCardCount = ()=>{
        cardCount = 0;
    };
    let advertCount = 0;
    const updateAdvertCount = ()=>{
        advertCount = advertCount + 1;
    // if(adverts[advertCount + 1] !== undefined) // if there is another advert, up count.
    //   advertCount = advertCount + 1
    // else // If there is no more adverts, loop back to start.
    /// resetAdvertCount()
    };
    const resetAdvertCount = ()=>{
        advertCount = 0;
    };
    const advertExists = (key)=>{
        return adverts && adverts[key] !== undefined;
    };
    let lastAdvertWasLarge = false;
    const advertPositions = (currentPosition, advert)=>{
        let found = false;
        let isLargeAdvert = advert.creative.aspect_ratio > 1;
        // If ad service has been started.
        // Add advert cards to the left and right.
        if (cardCountStarted) {
            if (cardCount == 4) {
                found = true;
                cardCountUpdate();
            } else if (isLargeAdvert && cardCount == 14 //For larger ads.
             || cardCount == 15) {
                found = true;
                resetCardCount() // Reset cardCount to add adverts to the left and right again.
                ;
            }
        }
        // Start the ad service.
        if (cardCount == 6 && isLargeAdvert && !cardCountStarted // For larger ads.
         || currentPosition == 7 && !cardCountStarted) {
            found = true;
            cardCountStarted = true;
            resetCardCount();
        }
        lastAdvertWasLarge = isLargeAdvert;
        return found;
    };
    const LoadingButton = ()=>{
        return /*#__PURE__*/ (0, $drmv2.jsx)("button", {
            className: (0, $biy3n.default)("button", "button--contained"),
            children: "Loading..."
        });
    };
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: (0, $biy3n.default)($1Lcud.root + " product-cards"),
        children: [
            hasPrevious && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: $1Lcud.buttons + " load-prev-buttons",
                children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                    children: isSearchStalled ? /*#__PURE__*/ (0, $drmv2.jsx)(LoadingButton, {}) : /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                        className: (0, $biy3n.default)("button", "button--contained"),
                        onClick: ()=>{
                            refinePrevious();
                        },
                        children: "Load previous"
                    })
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: $1Lcud.grid,
                children: hits.length === 0 && isSearchStalled ? Array.from({
                    length: 36
                }, (_, i)=>/*#__PURE__*/ (0, $drmv2.jsx)((0, $bJE9e.ProductCard).Skeleton, {}, i)) : /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                    children: hits.map((hit, i)=>/*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
                            children: [
                                advertExists(advertCount) && advertPositions(i, adverts[advertCount]) && /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                            className: (0, $biy3n.default)($1Lcud.advert + " advert", {
                                                [$1Lcud.large]: adverts[advertCount].creative.aspect_ratio > 1
                                            }),
                                            children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $2a9eH.Advert), {
                                                advert: adverts[advertCount],
                                                slot: i
                                            })
                                        }, i),
                                        updateAdvertCount()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsx)((0, $bJE9e.ProductCard), {
                                    hit: hit
                                }, hit.objectID),
                                cardCountUpdate()
                            ]
                        }))
                })
            }),
            searchResults && /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $1Lcud.progress + " progress",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("b", {
                                children: Math.max(hits.length, searchResults.page * hitsPerPage)
                            }),
                            " ",
                            "out of ",
                            /*#__PURE__*/ (0, $drmv2.jsx)("b", {
                                children: searchResults.nbHits
                            }),
                            " products"
                        ]
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: $1Lcud.progressWrapper,
                        children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            className: $1Lcud.progressBar,
                            style: {
                                transform: `translateX(${Math.min(0, -100 * (1 - Math.max(hits.length, searchResults.page * hitsPerPage) / searchResults.nbHits))}%)`
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $1Lcud.buttons + " load-more-buttons",
                children: [
                    hasMore && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                        children: isSearchStalled ? /*#__PURE__*/ (0, $drmv2.jsx)(LoadingButton, {}) : /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                            className: (0, $biy3n.default)("button", "button--contained"),
                            onClick: ()=>{
                                refineNext();
                            },
                            children: "Load more"
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                        className: (0, $biy3n.default)("icon-button", "icon-button--outlined"),
                        "aria-label": "back to top",
                        onClick: handleBackToTop,
                        children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                            icon: (0, $gH7Rp.faChevronUp),
                            width: 14,
                            height: 14
                        })
                    })
                ]
            })
        ]
    });
}));

});
parcelRegister("fCQJX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b60350c2db6bdea9$export$2e2bcd8739ae039; });

var $8thbo = parcelRequire("8thbo");

var $dcYkN = parcelRequire("dcYkN");

var $5zIY3 = parcelRequire("5zIY3");

var $65mCe = parcelRequire("65mCe");
function $b60350c2db6bdea9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b60350c2db6bdea9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b60350c2db6bdea9$var$_typeof(obj);
}
var $b60350c2db6bdea9$var$_excluded = [
    "page"
];
function $b60350c2db6bdea9$var$_defineProperty(obj, key, value) {
    key = $b60350c2db6bdea9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b60350c2db6bdea9$var$_toPropertyKey(arg) {
    var key = $b60350c2db6bdea9$var$_toPrimitive(arg, "string");
    return $b60350c2db6bdea9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b60350c2db6bdea9$var$_toPrimitive(input, hint) {
    if ($b60350c2db6bdea9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b60350c2db6bdea9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b60350c2db6bdea9$var$_toConsumableArray(arr) {
    return $b60350c2db6bdea9$var$_arrayWithoutHoles(arr) || $b60350c2db6bdea9$var$_iterableToArray(arr) || $b60350c2db6bdea9$var$_unsupportedIterableToArray(arr) || $b60350c2db6bdea9$var$_nonIterableSpread();
}
function $b60350c2db6bdea9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b60350c2db6bdea9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b60350c2db6bdea9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b60350c2db6bdea9$var$_arrayLikeToArray(o, minLen);
}
function $b60350c2db6bdea9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b60350c2db6bdea9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b60350c2db6bdea9$var$_arrayLikeToArray(arr);
}
function $b60350c2db6bdea9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b60350c2db6bdea9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b60350c2db6bdea9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b60350c2db6bdea9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b60350c2db6bdea9$var$getId() {
    return "page";
}
function $b60350c2db6bdea9$var$getCurrentRefinement(props, searchState, context) {
    var id = $b60350c2db6bdea9$var$getId();
    var page = 1;
    var currentRefinement = (0, $5zIY3.getCurrentRefinementValue)(props, searchState, context, id, page);
    if (typeof currentRefinement === "string") return parseInt(currentRefinement, 10);
    return currentRefinement;
}
function $b60350c2db6bdea9$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $b60350c2db6bdea9$var$_objectWithoutProperties(_ref, $b60350c2db6bdea9$var$_excluded);
    return rest;
}
function $b60350c2db6bdea9$var$getInMemoryCache() {
    var cachedHits = undefined;
    var cachedState = undefined;
    return {
        read: function read(_ref2) {
            var state = _ref2.state;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8thbo)))(cachedState, $b60350c2db6bdea9$var$getStateWithoutPage(state)) ? cachedHits : null;
        },
        write: function write(_ref3) {
            var state = _ref3.state, hits = _ref3.hits;
            cachedState = $b60350c2db6bdea9$var$getStateWithoutPage(state);
            cachedHits = hits;
        }
    };
}
function $b60350c2db6bdea9$var$extractHitsFromCachedHits(cachedHits) {
    return Object.keys(cachedHits).map(Number).sort(function(a, b) {
        return a - b;
    }).reduce(function(acc, page) {
        return acc.concat(cachedHits[page]);
    }, []);
}
var /**
 * InfiniteHits connector provides the logic to create connected
 * components that will render an continuous list of results retrieved from
 * Algolia. This connector provides a function to load more results.
 * @name connectInfiniteHits
 * @kind connector
 * @providedPropType {array.<object>} hits - the records that matched the search state
 * @providedPropType {boolean} hasMore - indicates if there are more pages to load
 * @providedPropType {function} refine - call to load more results
 */ $b60350c2db6bdea9$export$2e2bcd8739ae039 = (0, $dcYkN.default)({
    displayName: "AlgoliaInfiniteHits",
    $$type: "ais.infiniteHits",
    getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
        var _this = this;
        var results = (0, $5zIY3.getResults)(searchResults, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        });
        if (!results) return {
            hits: [],
            hasPrevious: false,
            hasMore: false,
            refine: function refine() {},
            refinePrevious: function refinePrevious() {},
            refineNext: function refineNext() {}
        };
        var page = results.page, hits = results.hits, hitsPerPage = results.hitsPerPage, nbPages = results.nbPages, state = results._state;
        this._cache = props.cache ? props.cache : this._cache || $b60350c2db6bdea9$var$getInMemoryCache();
        var cachedHits = this._cache.read({
            state: state
        }) || {};
        var hitsWithPositions = (0, $65mCe.addAbsolutePositions)(hits, hitsPerPage, page);
        var hitsWithPositionsAndQueryID = (0, $65mCe.addQueryID)(hitsWithPositions, results.queryID);
        cachedHits[page] = hitsWithPositionsAndQueryID;
        this._cache.write({
            state: state,
            hits: cachedHits
        });
        /*
      Math.min() and Math.max() returns Infinity or -Infinity when no argument is given.
      But there is always something in this point because of `cachedHits[page]`.
    */ var firstReceivedPage = Math.min.apply(Math, $b60350c2db6bdea9$var$_toConsumableArray(Object.keys(cachedHits).map(Number)));
        var lastReceivedPage = Math.max.apply(Math, $b60350c2db6bdea9$var$_toConsumableArray(Object.keys(cachedHits).map(Number)));
        var hasPrevious = firstReceivedPage > 0;
        var lastPageIndex = nbPages - 1;
        var hasMore = lastReceivedPage < lastPageIndex;
        var refinePrevious = function refinePrevious(event) {
            return _this.refine(event, firstReceivedPage - 1);
        };
        var refineNext = function refineNext(event) {
            return _this.refine(event, lastReceivedPage + 1);
        };
        return {
            hits: $b60350c2db6bdea9$var$extractHitsFromCachedHits(cachedHits),
            hasPrevious: hasPrevious,
            hasMore: hasMore,
            refinePrevious: refinePrevious,
            refineNext: refineNext
        };
    },
    getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
        return searchParameters.setQueryParameters({
            page: $b60350c2db6bdea9$var$getCurrentRefinement(props, searchState, {
                ais: props.contextValue,
                multiIndexContext: props.indexContextValue
            }) - 1
        });
    },
    refine: function refine(props, searchState, event, index) {
        var id = $b60350c2db6bdea9$var$getId();
        var nextValue = $b60350c2db6bdea9$var$_defineProperty({}, id, index + 1);
        var resetPage = false;
        return (0, $5zIY3.refineValue)(searchState, nextValue, {
            ais: props.contextValue,
            multiIndexContext: props.indexContextValue
        }, resetPage);
    }
});

});

parcelRegister("1Lcud", function(module, exports) {

$parcel$export(module.exports, "advert", function () { return $1483ddbc36b98881$export$fec86d37f1b64e30; }, function (v) { return $1483ddbc36b98881$export$fec86d37f1b64e30 = v; });
$parcel$export(module.exports, "buttons", function () { return $1483ddbc36b98881$export$bbea856fdb3e3c5f; }, function (v) { return $1483ddbc36b98881$export$bbea856fdb3e3c5f = v; });
$parcel$export(module.exports, "grid", function () { return $1483ddbc36b98881$export$85fc379452d91af0; }, function (v) { return $1483ddbc36b98881$export$85fc379452d91af0 = v; });
$parcel$export(module.exports, "large", function () { return $1483ddbc36b98881$export$f09585a853dddd32; }, function (v) { return $1483ddbc36b98881$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "progress", function () { return $1483ddbc36b98881$export$504d7abb21fa8c9; }, function (v) { return $1483ddbc36b98881$export$504d7abb21fa8c9 = v; });
$parcel$export(module.exports, "progressBar", function () { return $1483ddbc36b98881$export$9d1298853f0e77f7; }, function (v) { return $1483ddbc36b98881$export$9d1298853f0e77f7 = v; });
$parcel$export(module.exports, "progressWrapper", function () { return $1483ddbc36b98881$export$7167043a758adbb2; }, function (v) { return $1483ddbc36b98881$export$7167043a758adbb2 = v; });
$parcel$export(module.exports, "root", function () { return $1483ddbc36b98881$export$e8e78c978b129247; }, function (v) { return $1483ddbc36b98881$export$e8e78c978b129247 = v; });
var $1483ddbc36b98881$export$fec86d37f1b64e30;
var $1483ddbc36b98881$export$bbea856fdb3e3c5f;
var $1483ddbc36b98881$export$85fc379452d91af0;
var $1483ddbc36b98881$export$f09585a853dddd32;
var $1483ddbc36b98881$export$504d7abb21fa8c9;
var $1483ddbc36b98881$export$9d1298853f0e77f7;
var $1483ddbc36b98881$export$7167043a758adbb2;
var $1483ddbc36b98881$export$e8e78c978b129247;
$1483ddbc36b98881$export$fec86d37f1b64e30 = `eNo1Uq_advert`;
$1483ddbc36b98881$export$bbea856fdb3e3c5f = `eNo1Uq_buttons`;
$1483ddbc36b98881$export$85fc379452d91af0 = `eNo1Uq_grid`;
$1483ddbc36b98881$export$f09585a853dddd32 = `eNo1Uq_large`;
$1483ddbc36b98881$export$504d7abb21fa8c9 = `eNo1Uq_progress`;
$1483ddbc36b98881$export$9d1298853f0e77f7 = `eNo1Uq_progressBar`;
$1483ddbc36b98881$export$7167043a758adbb2 = `eNo1Uq_progressWrapper`;
$1483ddbc36b98881$export$e8e78c978b129247 = `eNo1Uq_root`;

});

parcelRegister("3AWie", function(module, exports) {

$parcel$export(module.exports, "ProductCard", function () { return (parcelRequire("bJE9e")).ProductCard; });

var $bJE9e = parcelRequire("bJE9e");

});
parcelRegister("bJE9e", function(module, exports) {

$parcel$export(module.exports, "ProductCard", function () { return $aeac63bef46804c0$export$e6cbe35324ccf844; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $5dGri = parcelRequire("5dGri");

var $keJQj = parcelRequire("keJQj");

var $e5Hn4 = parcelRequire("e5Hn4");

var $7mAg3 = parcelRequire("7mAg3");

var $cwQIK = parcelRequire("cwQIK");

var $7RS04 = parcelRequire("7RS04");
parcelRequire("dkhsa");
var $bf1Az = parcelRequire("bf1Az");

var $6dE6X = parcelRequire("6dE6X");

var $lga73 = parcelRequire("lga73");

var $363gu = parcelRequire("363gu");

var $7i1rO = parcelRequire("7i1rO");

var $20OPj = parcelRequire("20OPj");
const $aeac63bef46804c0$var$classes = $keJQj;
const $aeac63bef46804c0$var$Dialog = ({ open: open = false, onClose: onClose, children: children, onKeyDown: onKeyDown, lockScroll: lockScroll = true, ...props })=>{
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (open) {
            window.trapFocus(rootRef.current);
            return ()=>{
                window.removeTrapFocus();
            };
        }
    }, [
        open
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (open && lockScroll) {
            document.body.classList.add("overflow-hidden");
            return ()=>{
                document.body.classList.remove("overflow-hidden");
            };
        }
    }, [
        open,
        lockScroll
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (open) {
            const onClickAway = (event)=>{
                if (!rootRef.current.contains(event.target)) {
                    event.preventDefault();
                    onClose("clickAway");
                }
            };
            document.addEventListener("click", onClickAway);
            return ()=>{
                document.removeEventListener("click", onClickAway);
            };
        }
    }, [
        open
    ]);
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "Escape":
                event.preventDefault();
                onClose("escapeKey");
                break;
            default:
                break;
        }
        onKeyDown && onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $drmv2.jsx)("div", {
        ...props,
        ref: rootRef,
        role: "dialog",
        "aria-modal": "true",
        tabIndex: -1,
        onKeyDown: handleKeyDown,
        children: children
    });
};
const $aeac63bef46804c0$export$e6cbe35324ccf844 = ({ hit: hit, queryID: queryID })=>{
    const { b2b: b2b, handle: handle, collection: collection, customerTags: customerTags, visual_percentage_off_tab: visual_percentage_off_tab } = (0, $7mAg3.usePLPContext)();
    const isMedium = (0, $7RS04.default)("(min-width: 768px)");
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const [cartState, setCartState] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState({
        loading: null,
        open: false
    });
    const [wishState, setWishState] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState({
        loading: null,
        open: false,
        ready: false,
        wishedVariants: {}
    });
    const title = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>hit.title.split(" - ")[0], [
        hit.title
    ]);
    const subtitle = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>hit.title.split(" - ").slice(1).join(" - "), [
        hit.title
    ]);
    //Only used if product is a Group Product
    const selectionText = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>hit.title.split(" - ")[1], [
        hit.title
    ]);
    const [currency, setCurrency] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(()=>{
        return window.localStorage.getItem("activeCurrency") || window.default_currency;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const onCurrencyChange = (event)=>{
            setCurrency(event.detail.currency);
        };
        window.addEventListener("currency_changed", onCurrencyChange);
        return ()=>{
            window.removeEventListener("currency_changed", onCurrencyChange);
        };
    }, []);
    /**
   * Handle scroll restoration on product listing pages. Only applicable for
   * browsers other than Safari that do not restore the page from a cache.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const handlePageShow = (event)=>{
            if (event.persisted) history.scrollRestoration = "auto";
            else {
                history.scrollRestoration = "manual";
                const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(window.location.search, {
                    ignoreQueryPrefix: true
                });
                if (parsed.id === hit.objectID) {
                    if (rootRef.current) rootRef.current.scrollIntoView();
                }
            }
        };
        window.addEventListener("pageshow", handlePageShow);
        window.addEventListener("popstate", handlePageShow);
        return ()=>{
            window.removeEventListener("pageshow", handlePageShow);
            window.removeEventListener("popstate", handlePageShow);
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        let mounted = true;
        const onInit = (products)=>{
            const wishedVariants = products.filter(({ empi: empi })=>empi === hit.id && !isGroupProduct || isGroupProduct && variants.filter((x)=>x.prod === empi)).reduce((acc, { epi: epi })=>({
                    ...acc,
                    [epi]: true
                }), {});
            if (mounted) setWishState((prev)=>({
                    ...prev,
                    ready: true,
                    wishedVariants: wishedVariants
                }));
        };
        if ("_swat" in window) window._swat.fetch(onInit);
        else {
            window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymCallbacks.push((swat)=>{
                swat.fetch(onInit);
            });
        }
        return ()=>{
            mounted = false;
        };
    }, []);
    // Check for athlete tag
    let atheleTagImage = false;
    let athleteProperty = {};
    if (collection?.athleteTag) hit.images.forEach((img)=>{
        if (img.src.split("ATHLETE_")[1]?.split(".")[0] == collection.athleteTag) {
            atheleTagImage = img;
            athleteProperty = {
                "_Athlete": `ATHLETE_${collection.athleteTag}`
            };
        }
    });
    const url = (handle ? `/collections/${handle}` : "") + `/products/${hit.handle}` + `${collection?.athleteTag ? "?athlete=" + collection?.athleteTag : ""}`;
    const handleClickThrough = (event)=>{
        const previousQuery = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        const nextQuery = (0, (/*@__PURE__*/$parcel$interopDefault($e5Hn4))).stringify({
            ...previousQuery,
            id: hit.objectID
        }, {
            encodeValuesOnly: true
        });
        window.history.replaceState({}, null, `${window.location.pathname}?${nextQuery}`);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "hitClick",
            eventModel: {
                objectID: [
                    hit.objectID
                ],
                position: [
                    hit.__position
                ],
                queryID: queryID
            }
        });
    };
    const isBra = hit.product_type.toLowerCase() === "sports bras" || hit.product_type.toLowerCase() === "bralettes"; //Check if Bra
    const isTee = hit.product_type.toLowerCase() === "t-shirts"; //Check if Tee
    const seamlessFabric = hit.tags.some((tag)=>tag.toLowerCase().includes("seamless-fabric"));
    const fabricWeight = isTee && hit.tags.some((tag)=>tag.toLowerCase().includes("facet:weight")) ? window.textContent.facets.weight[hit.tags.filter((tag)=>tag.toLowerCase().includes("facet:weight"))[0].toLowerCase()] : false;
    const productCut = hit.tags.some((tag)=>tag.toLowerCase().includes("facet:cut")) ? window.textContent.facets.cut[hit.tags.filter((tag)=>tag.toLowerCase().includes("facet:cut"))[0].toLowerCase()] : false;
    const supportType = isBra && hit.tags.some((tag)=>tag.toLowerCase().includes("facet:support")) ? window.textContent.facets.support[hit.tags.filter((tag)=>tag.toLowerCase().includes("facet:support"))[0].toLowerCase()] : false;
    const veganFriendly = hit.tags.some((tag)=>tag.toLowerCase().includes("badge:vegan friendly"));
    const newFormula = hit.tags.some((tag)=>tag.toLowerCase().includes("badge:new formula"));
    const isSupplement = hit.tags.some((tag)=>tag.toLowerCase().includes("all products: supplements")); //Check if Supplement Product
    const isGroupProduct = hit.tags.some((tag)=>tag.toLowerCase().includes("group:")); //Check if Grouped Product
    const setTag = String(hit.tags.filter((tag)=>{
        if (tag.toLowerCase().includes("group:")) return tag;
        else return "";
    }));
    const limitOne = hit.tags.some((tag)=>tag.toLowerCase().includes("limit-1"));
    const variants = isGroupProduct ? // JSON.parse(window.groupedProducts).groupedProducts
    JSON.parse(window.groupedProducts).filter((p)=>p.tags.includes(setTag.split("group:")[1])) : hit.variants; //Checks to see if product is a Group Product. If it is, it will look for custom JSON variant feed and supply it instead of hit.variants
    const unavailableVariants = variants.filter((v)=>v.inventory_policy === "deny" && v.inventory_quantity <= 0);
    const isAvailable = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>variants.some(({ inventory_quantity: inventory_quantity, inventory_policy: inventory_policy })=>inventory_policy === "continue" || inventory_quantity > 0), [
        hit
    ]);
    // Total count of products over all variants.
    const inventoryTotalCount = variants.reduce((accumulator, variant)=>accumulator + variant.inventory_quantity, 0);
    // Checks if the product is checking for the 'preorder:#' tag and check
    // if the inventory total is lower than the preorder check.
    const preorderCheck = ()=>{
        let approved = false;
        hit.tags.forEach((tag)=>{
            if (tag.toLowerCase().indexOf("preorder:") !== -1) {
                if (Number(tag.toLowerCase().split("preorder:")[1]) > inventoryTotalCount) approved = true;
            }
        });
        return approved;
    };
    const capitalise = (str)=>{
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    // const shop_at = hit.tags.some((tag) => tag.toLowerCase().includes('shop_at:')) ? () => {
    //   let shop = hit.tags.filter((tag) => tag.toLocaleLowerCase().includes('shop_at:'))[0].split(':')[1].trim()
    //   return shop.charAt(0).toUpperCase() + shop.slice(1)
    // } : false;
    const ignoreSoonTag = customerTags ? customerTags.some((tag)=>tag.toLowerCase().includes("ignore-soon")) : false; // Ignore Soon tag | Meant for Admin product testing.
    const hasSoonTag = ignoreSoonTag ? false : hit.tags.some((tag)=>tag.toLowerCase() === "soon");
    const shop_at = hit.tags.some((tag)=>tag.toLowerCase().includes("shop_at:")) ? capitalise(hit.tags.filter((tag)=>tag.toLocaleLowerCase().includes("shop_at:"))[0].split(":")[1].trim()) : false;
    const loginRequired = hit.tags.some((tag)=>tag.toLowerCase() === "login-required") && document.querySelector("body.logged-in");
    const hasPreorderTag = hit.tags.some((tag)=>tag.toLowerCase() === "preorder") || preorderCheck();
    const isSoldAtColes = hit.tags.some((tag)=>tag.toLowerCase() === "coles");
    const hasRolloverTag = hit.tags.some((tag)=>tag.toLowerCase() === "rollover-bundle");
    const isChemistWarehouse = hit.tags.some((tag)=>tag.toLowerCase() === "chemist-warehouse");
    // const onlyAtColes = hit.tags.some((tag) => tag.toLowerCase() === "coles");
    const appExclusive = hit.tags.some((tag)=>tag.toLowerCase() === "app-exclusive") && !hasSoonTag;
    // const hasVariant = hit.options.some(({ name }) => name.toLowerCase() === "size");
    const hasSizeVariant = hit.options.some(({ name: name })=>name.toLowerCase() === "size");
    const hasVariant = hit.options;
    const hasOneVariant = variants.length === 1;
    const isRTD12Pack = hit.tags.includes("rtd-12-pack");
    // const productLimit = utilities.energyDrinkLimit && isRTD12Pack;
    const notForSale = [
        "not-for-sale"
    ].some((tag)=>hit.tags.includes(tag));
    const isRestocking = hit.tags.includes("restocking");
    const notRestocking = hit.tags.includes("not-restocking");
    const enableSignup = hit.tags.includes("signups-on");
    const isLaunching = ignoreSoonTag ? false : [
        "prelaunch",
        "soon"
    ].some((tag)=>hit.tags.includes(tag));
    const womensPhotoPreferred = collection?.womensCollection && hit.tags.includes("womens-photo-preferred") && hit.images.filter((img)=>img.src.includes("-WOMENS-1"))[0] != undefined;
    const grocerSupplement = hit.tags.includes("chemist-warehouse") || hit.tags.includes("coles") || shop_at;
    const lowCarbSupplement = hit.tags.includes("Low Carb");
    // Figure out if product is on Sale
    let enableVisualDiscount = false;
    if (visual_percentage_off_tab) enableVisualDiscount = true;
    else if (window?.sale != null && window?.sale > 0 && window?.sale_tag != null && !window?.B2B) enableVisualDiscount = hit.tags.some((tag)=>tag.toLowerCase().includes(window?.sale_tag)); //Check if product has window sale tag
    else if (window?.sale != null && window?.sale > 0 && !window?.B2B) enableVisualDiscount = true;
    const visualPercentageApplies = b2b ? true : hit.compare_at_price == 0 && enableVisualDiscount;
    const productOnSale = hit.compare_at_price != null && hit.price < hit.compare_at_price || visualPercentageApplies;
    const comingSoonSignup = isLaunching && enableSignup || enableSignup;
    const isBundle = hit.product_type === "Bundle";
    const canAddToCart = (hasVariant || hasOneVariant) && !notForSale && !isLaunching && !isBundle && !hasSoonTag && // !productLimit &&
    (isAvailable || !isAvailable && hasPreorderTag);
    // const canWishlist = !notForSale && !isBundle && !isSoldAtColes;
    const canWishlist = !isBundle;
    const isSoldOut = !isAvailable && !isLaunching && !notForSale;
    const handleCartClick = async (variantId, bundle = false)=>{
        setCartState((prev)=>({
                ...prev,
                loading: variantId
            }));
        const cartNotification = document.querySelector("cart-notification");
        try {
            const json = await fetch(window.routes.cart_add_url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: `application/javascript`
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                    sections: cartNotification.getSectionsToRender().map((section)=>section.section),
                    sections_url: window.location.pathname,
                    properties: bundle ? bundle : athleteProperty
                })
            }).then((response)=>response.json());
            cartNotification.renderContents(json);
            // Check for AutoGift
            if (typeof window.runAutoGift === "function") await window.runAutoGift();
            // Check for AutoDonation
            if (typeof window.runAutoDonation === "function") window.runAutoDonation();
        } catch (error) {
            console.error(error);
        }
        setCartState((prev)=>({
                ...prev,
                open: false,
                loading: null
            }));
    };
    const breastCancerTag = hit.tags.find((tag)=>tag == "Breast Cancer");
    let badgeText;
    const badgeTag = hit.tags.find((tag)=>tag.startsWith("badge:") && tag.toLowerCase() != "badge:vegan friendly" && tag.toLowerCase() != "badge:new formula");
    const noReturns = hit.tags.some((tag)=>tag.toLowerCase() == "no-returns");
    if (noReturns) badgeText = "Final Sale";
    else if (badgeTag && !isLaunching) [badgeText] = badgeTag.slice(6).split(":");
    else if (hasPreorderTag) badgeText = "Pre-Order";
    else if (isRestocking && !shop_at) badgeText = "Restocking";
    else if (isLaunching) badgeText = "Coming Soon";
    else if (hit.available && variants.reduce((acc, { inventory_quantity: inventory_quantity, inventory_policy: inventory_policy })=>inventory_policy === "deny" && inventory_quantity <= 10 ? acc + 1 : acc, 0) >= Math.ceil(variants.length / 2)) // badgeText = "Going fast";
    badgeText = "";
    else if (new Date(hit.created_at) >= (0, $5dGri.default)(new Date(), 30) && !isGroupProduct && !productOnSale) badgeText = "New";
    // Overwrite if sold out supplement.
    if (isSupplement && isSoldOut && !notRestocking && !grocerSupplement) badgeText = "Restocking";
    // const hasVisual25 = hit.tags.some((tag) => tag.toLowerCase().includes('visual-25-off'));
    // if(hasVisual25 && hit.compare_at_price == 0){
    //   badgeText = "CODE: SUPPS25 - 25% OFF";
    // }
    let messageText, messageColor, messageContrastColor;
    const messageTag = hit.tags.find((tag)=>tag.startsWith("message:"));
    if (messageTag) {
        [messageText, messageColor] = messageTag.slice(8).split(":");
        if (!messageColor) {
            messageColor = "#52525B";
            messageContrastColor = "#FFF";
        } else try {
            messageContrastColor = (0, (/*@__PURE__*/$parcel$interopDefault($cwQIK))).contrast(messageColor, "#FFF") >= 4.5 ? "#FFF" : "#18181B";
        } catch (error) {
            messageContrastColor = "#FFF";
        }
    }
    const src = atheleTagImage ? atheleTagImage : (hit.image = hit.images.filter((img)=>!img.src.includes("ATHLETE_"))[0]) ? window.Shopify.addSizeToImage(hit.image.src, 1280) : "";
    const secondSrc = hit.images.length > 1 ? window.Shopify.addSizeToImage(hit.images[1].src, 1280) : "";
    const preferedWomensImage = womensPhotoPreferred ? hit.images.filter((img)=>img.src.includes("-WOMENS-1"))[0] : "";
    const preferedWomensImageSRC = womensPhotoPreferred && preferedWomensImage != undefined ? window.Shopify.addSizeToImage(hit.images.filter((img)=>img.src.includes("-WOMENS-1"))[0].src, 1280) : "";
    const srcSet = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>atheleTagImage?.src ? atheleTagImage?.src : hit.image?.src ? [
            320,
            480,
            800,
            1280
        ].map((width, _, arr)=>`${window.Shopify.addSizeToImage(atheleTagImage?.src ? atheleTagImage.src : hit.image.src, width)} ${width / arr[0]}x`).join(",") : "", [
        atheleTagImage?.src ? atheleTagImage.src : hit.image?.src ? hit.image.src : null
    ]);
    const secondSrcSet = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>hit.images[1]?.src ? [
            320,
            480,
            800,
            1280
        ].map((width, _, arr)=>`${window.Shopify.addSizeToImage(hit.images[1].src, width)} ${width / arr[0]}x`).join(",") : "", [
        hit.images[1]?.src ? hit.images[1].src : null
    ]);
    const womensImageSRCSet = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>preferedWomensImage?.src ? [
            320,
            480,
            800,
            1280
        ].map((width, _, arr)=>`${window.Shopify.addSizeToImage(preferedWomensImage.src, width)} ${width / arr[0]}x`).join(",") : "", [
        preferedWomensImage?.src ? preferedWomensImage.src : null
    ]);
    const [currentSrc, setCurrentSrc] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(src);
    const [currentSrcSet, setCurrentSrcSet] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(src);
    const [showExtraImage, setShowExtraImage] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(false);
    const [bundleItem, setBundleState] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState([]);
    const toggleImage = ()=>{
        if (isGroupProduct) setShowExtraImage(!showExtraImage);
    };
    const toggleImageOn = (e)=>{
        e.preventDefault();
        toggleImage();
        if (isMedium && !hasOneVariant && document.querySelector("html").classList.contains("cardABTest") && !isSoldOut) setCartState((prev)=>({
                ...prev,
                open: true
            }));
    };
    const toggleImageOff = (e)=>{
        e.preventDefault();
        toggleImage();
        if (isMedium && !hasOneVariant && document.querySelector("html").classList.contains("cardABTest")) setCartState((prev)=>({
                ...prev,
                open: false
            }));
    };
    const handleBundleClick = async (variantId)=>{
        setBundleState((bundleItem)=>[
                ...bundleItem,
                variantId
            ]);
    };
    const handleWishClick = (variantId)=>async ()=>{
            setWishState((prev)=>({
                    ...prev,
                    loading: variantId
                }));
            const variant = variants.find(({ id: id })=>id === variantId);
            const data = {
                epi: variantId,
                empi: isGroupProduct ? variant.prod_id : hit.id,
                du: `${window.location.origin}/products/${isGroupProduct ? variant.handle : hit.handle}`,
                dt: isGroupProduct ? variant.title : hit.title,
                iu: isGroupProduct ? variant.image.src : atheleTagImage ? atheleTagImage.src : hit.image.src,
                pr: Number(variant.price),
                vi: variant.title
            };
            try {
                await new Promise((resolve)=>window._swat.addToWishList(data, resolve));
                setWishState((prev)=>({
                        ...prev,
                        wishedVariants: {
                            ...prev.wishedVariants,
                            [variantId]: true
                        }
                    }));
            } catch (error) {
                console.error(error);
            }
            setWishState((prev)=>({
                    ...prev,
                    loading: null,
                    open: false
                }));
        };
    // const aspectRatio = hit.image ? hit.image.width / hit.image.height : 0.8;
    const supportsLoading = "loading" in HTMLImageElement.prototype;
    const messageStyles = {
        "--color": messageColor,
        "--contrastColor": messageContrastColor
    };
    const sanitiseTitle = (title)=>{
        // Update size option if size variants.
        let result = title;
        switch(title){
            case "XXS":
                result = "2XS";
                break;
            case "XXL":
                result = "2XL";
                break;
            case "XXXL":
                result = "3XL";
                break;
            case "XXXXL":
                result = "4XL";
                break;
            default:
                result = title;
        }
        return result;
    };
    function filterGalleryImages() {
        let hitImages = hit.images.filter((img)=>!img.src.includes("ATHLETE_"));
        if (womensPhotoPreferred) hitImages.forEach((image, i)=>{
            if (image.src.includes("-WOMENS")) {
                hitImages.splice(i, 1);
                hitImages.unshift(image);
            }
        });
        return hitImages;
    }
    let enableVisualDiscountBadge = false;
    if (window?.sale != null && window?.sale > 0 && window?.sale_tag != null && window?.sale_text != null && !window?.B2B && hit.compare_at_price == 0 && hit.product_type != "Gift Cards") enableVisualDiscountBadge = hit.tags.some((tag)=>tag.toLowerCase().includes(window?.sale_tag)); //Check if Product has window sale tag
    else if (window?.sale != null && window?.sale > 0 && window?.sale_text != null && !window?.B2B && hit.compare_at_price == 0 && hit.product_type != "Gift Cards") enableVisualDiscountBadge = true;
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        ref: rootRef,
        className: $aeac63bef46804c0$var$classes.root + " productCardRoot" + (isGroupProduct ? " group-product" : ""),
        "data-product": hit.id,
        // data-supplement={isSupplement && hit.compare_at_price == 0}
        onMouseLeave: toggleImageOff,
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $aeac63bef46804c0$var$classes.mediaWrapper + " card-mediaWrapper" + (isMedium || isSupplement ? "" : " media-slider"),
                children: [
                    isMedium || isSupplement || atheleTagImage ? /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: $aeac63bef46804c0$var$classes.media + " media media--portrait",
                                children: [
                                    (!showExtraImage || !secondSrcSet || !womensPhotoPreferred) && /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                                        alt: hit.title,
                                        src: supportsLoading ? src : null,
                                        srcSet: supportsLoading ? srcSet : null,
                                        "data-src": src,
                                        "data-srcset": srcSet,
                                        className: "lazyload",
                                        loading: "eager"
                                    }),
                                    showExtraImage && secondSrcSet && isMedium && !womensPhotoPreferred && /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                                        alt: hit.title,
                                        src: supportsLoading ? secondSrc : null,
                                        srcSet: supportsLoading ? secondSrcSet : null,
                                        "data-src": secondSrc,
                                        "data-srcset": secondSrcSet,
                                        className: "lazyload",
                                        loading: "eager"
                                    }),
                                    womensPhotoPreferred && womensImageSRCSet && /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                                        alt: hit.title,
                                        src: supportsLoading ? preferedWomensImageSRC : null,
                                        srcSet: supportsLoading ? womensImageSRCSet : null,
                                        "data-src": preferedWomensImageSRC,
                                        "data-srcset": womensImageSRCSet,
                                        className: "lazyload",
                                        loading: "eager"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("a", {
                                href: url,
                                onClick: handleClickThrough,
                                onMouseEnter: toggleImage,
                                onMouseLeave: toggleImage,
                                onMouseUp: ()=>{
                                    window.location.href = url;
                                },
                                className: "link-unstyled",
                                children: /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                    className: "visually-hidden",
                                    children: hit.title
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $drmv2.jsx)("a", {
                        href: url,
                        className: "link-unstyled",
                        onClick: handleClickThrough,
                        children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $20OPj.default), {
                            gallery: filterGalleryImages(),
                            productLink: url,
                            hit: hit
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: (0, $biy3n.default)(`${$aeac63bef46804c0$var$classes.product_badge_wrapper} ${isSoldOut ? $aeac63bef46804c0$var$classes.productSoldOut : ""} ${isSupplement ? $aeac63bef46804c0$var$classes.isSupplement : ""}`),
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: $aeac63bef46804c0$var$classes.product_badges,
                                children: [
                                    !isSoldOut && enableVisualDiscountBadge && !isLaunching && window?.sale_text && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: $aeac63bef46804c0$var$classes.badge + ` badge sale_badge_text`,
                                        style: {
                                            backgroundColor: "var(--sale-badge-background) !important",
                                            color: "var(--sale-badge-color) !important"
                                        },
                                        children: window?.sale_text
                                    }),
                                    (!isSoldOut || isSupplement) && badgeText && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: $aeac63bef46804c0$var$classes.badge + ` badge __${badgeText.replace(" ", "_").replace(":", "_").replace("%", "_")}` + (hasPreorderTag && canAddToCart ? $aeac63bef46804c0$var$classes.badgePreorder : "") + " ",
                                        children: badgeText
                                    }),
                                    !isSoldOut && (isRTD12Pack || limitOne) && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                        children: (!isSoldOut || isSupplement) && badgeText && /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                                            className: $aeac63bef46804c0$var$classes.badge + " badge",
                                            children: [
                                                isRTD12Pack && title.indexOf("MNxEBT ENERGY DRINK") == -1 && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                    children: "Limit 2 Per Order Total"
                                                }),
                                                (isRTD12Pack || limitOne) && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                    children: "Limit 1 Per Order Total"
                                                })
                                            ]
                                        })
                                    }),
                                    womensPhotoPreferred && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: $aeac63bef46804c0$var$classes.badge + " badge",
                                        children: "Men's Sizing"
                                    }),
                                    breastCancerTag && /*#__PURE__*/ (0, $drmv2.jsxs)("svg", {
                                        className: $aeac63bef46804c0$var$classes.breastCancerBadge,
                                        width: "96",
                                        height: "121",
                                        viewBox: "0 0 96 121",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M62.82 77.5701L74.92 65.4801C82.41 57.9901 86.16 48.1701 86.16 38.3601C86.16 28.5501 82.4 18.7201 74.91 11.2301C59.93 -3.74988 35.64 -3.74988 20.65 11.2301C5.67 26.2101 5.67 50.4901 20.65 65.4701L32.74 77.5601L0 110.32L7.52 117.83C11.65 121.96 18.42 121.96 22.55 117.83L47.78 92.6001L73.02 117.83C77.15 121.96 83.92 121.96 88.05 117.83L95.57 110.32L62.82 77.5701ZM47.78 62.5401L35.69 50.4501C29.01 43.7701 29.01 32.9401 35.69 26.2601C42.37 19.5801 53.2 19.5801 59.88 26.2601C63.22 29.6001 64.89 33.9801 64.89 38.3501C64.89 42.7201 63.22 47.1001 59.88 50.4401L47.78 62.5401Z",
                                                fill: "#A30D47"
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M45.0598 95.3199L22.5398 117.83C18.4098 121.96 11.6398 121.96 7.50977 117.83L37.5398 87.8099L45.0598 95.3199ZM88.0498 117.83C83.9198 121.96 77.1498 121.96 73.0198 117.83L20.6598 65.4799C5.67977 50.4999 5.67977 26.2099 20.6598 11.2399C35.6398 -3.74012 59.9298 -3.74012 74.9198 11.2399C82.4098 18.7299 86.1598 28.5499 86.1598 38.3599C86.1598 48.1699 82.3998 57.9899 74.9098 65.4799L62.8098 77.5699L55.2898 70.0599L67.3898 57.9699C78.2198 47.1399 78.2198 29.5799 67.3898 18.7599C56.5598 7.92988 38.9998 7.92988 28.1698 18.7599C22.7498 24.1699 20.0498 31.2699 20.0498 38.3699C20.0498 45.4699 22.7598 52.5599 28.1698 57.9799L88.0498 117.83Z",
                                                fill: "#DB2463"
                                            })
                                        ]
                                    }),
                                    isSupplement && (veganFriendly || newFormula) && !isSoldOut && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: $aeac63bef46804c0$var$classes.badge + " badge " + " " + $aeac63bef46804c0$var$classes.badge_bottom + " " + $aeac63bef46804c0$var$classes.isSupplement,
                                        children: veganFriendly ? /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                            children: "Vegan Friendly"
                                        }) : newFormula && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                            children: "New Formula"
                                        })
                                    }),
                                    lowCarbSupplement && !isSoldOut && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: $aeac63bef46804c0$var$classes.badge + " badge " + " " + $aeac63bef46804c0$var$classes.badge_bottom + " " + $aeac63bef46804c0$var$classes.isSupplement,
                                        children: "Low Carb"
                                    })
                                ]
                            }),
                            isSoldOut && !shop_at && !collection?.forceWishlist && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: "sold-out",
                                children: "SOLD OUT"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)((0, $7i1rO.ProductTimer), {
                        hit: hit
                    }),
                    !shop_at && /*#__PURE__*/ (0, $drmv2.jsx)((0, $363gu.WishlistSelector), {
                        hit: hit,
                        isMedium: isMedium,
                        hasOneVariant: hasOneVariant,
                        canWishlist: canWishlist,
                        isGroupProduct: isGroupProduct,
                        variants: variants,
                        Dialog: $aeac63bef46804c0$var$Dialog,
                        badgeText: badgeText,
                        title: title,
                        subtitle: subtitle,
                        currency: currency,
                        messageStyles: messageStyles,
                        messageText: messageText,
                        wishState: wishState,
                        setWishState: setWishState,
                        handleWishClick: handleWishClick,
                        sanitiseTitle: sanitiseTitle,
                        cartState: cartState,
                        setCartState: setCartState
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $aeac63bef46804c0$var$classes.info + " card-info",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "card-info-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("a", {
                                tabIndex: -1,
                                href: url,
                                onClick: handleClickThrough,
                                className: $aeac63bef46804c0$var$classes.header,
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.title,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.subtitle,
                                        children: subtitle
                                    }),
                                    isBra && supportType && /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.subtitle,
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("i", {
                                            children: supportType
                                        })
                                    }),
                                    seamlessFabric && /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.subtitle,
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("i", {
                                            children: "Seamless Fabric"
                                        })
                                    }),
                                    isTee && fabricWeight && /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.subtitle,
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("i", {
                                            children: fabricWeight
                                        })
                                    }),
                                    productCut && /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                        className: $aeac63bef46804c0$var$classes.subtitle,
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("i", {
                                            children: productCut
                                        })
                                    })
                                ]
                            }),
                            !shop_at && /*#__PURE__*/ (0, $drmv2.jsx)((0, $bf1Az.ProductPrice), {
                                forceWishlist: collection?.forceWishlist,
                                product: hit,
                                currency: currency
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                className: (0, $biy3n.default)($aeac63bef46804c0$var$classes.message, "hit__message"),
                                style: messageStyles,
                                children: messageText
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                className: "tester"
                            })
                        ]
                    }),
                    (!appExclusive && !loginRequired || hasSoonTag) && /*#__PURE__*/ (0, $drmv2.jsx)((0, $lga73.VariantSelector), {
                        cartState: cartState,
                        setCartState: setCartState,
                        hit: hit,
                        isMedium: isMedium,
                        hasSoonTag: hasSoonTag,
                        canWishlist: canWishlist,
                        hasOneVariant: hasOneVariant,
                        canAddToCart: canAddToCart,
                        isGroupProduct: isGroupProduct,
                        hasPreorderTag: hasPreorderTag,
                        selectionText: selectionText,
                        variants: variants,
                        Dialog: $aeac63bef46804c0$var$Dialog,
                        ProductPrice: (0, $bf1Az.ProductPrice),
                        badgeText: badgeText,
                        title: title,
                        subtitle: subtitle,
                        currency: currency,
                        messageText: messageText,
                        hasSizeVariant: hasSizeVariant,
                        messageStyles: messageStyles,
                        unavailableVariants: unavailableVariants,
                        wishState: wishState,
                        handleCartClick: handleCartClick,
                        handleWishClick: handleWishClick,
                        sanitiseTitle: sanitiseTitle,
                        comingSoonSignup: comingSoonSignup,
                        womensPhotoPreferred: womensPhotoPreferred
                    }),
                    shop_at && /*#__PURE__*/ (0, $drmv2.jsxs)("a", {
                        href: url,
                        "data-shop": shop_at,
                        children: [
                            "Shop at ",
                            shop_at
                        ]
                    }),
                    !appExclusive && (isSoldOut || comingSoonSignup) && !collection?.forceWishlist && !shop_at && /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                        "data-product": hit.id,
                        "data-title": hit.title,
                        "data-variants": btoa(JSON.stringify(variants)),
                        className: $aeac63bef46804c0$var$classes.notify + " notify link bis-link",
                        "aria-haspopup": "dialog",
                        type: "button",
                        children: [
                            "Notify when available",
                            /*#__PURE__*/ (0, $drmv2.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                className: "feather feather-chevron-right",
                                children: /*#__PURE__*/ (0, $drmv2.jsx)("polyline", {
                                    points: "9 18 15 12 9 6"
                                })
                            })
                        ]
                    }),
                    loginRequired && /*#__PURE__*/ (0, $drmv2.jsxs)("a", {
                        href: "/account/login",
                        type: "button",
                        "aria-haspopup": "dialog",
                        "aria-label": "Add to cart",
                        className: "login-request cartButton  button button--outlined",
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsx)("b", {
                                children: "MN Rewards Exclusive"
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                children: "Click here to Login or Create Account"
                            })
                        ]
                    }),
                    !hasSoonTag && appExclusive && /*#__PURE__*/ (0, $drmv2.jsxs)("a", {
                        className: $aeac63bef46804c0$var$classes.notify + " appExclusive link bis-link",
                        target: "_blank",
                        onClick: ()=>window.open("https://app.musclenation.org/", "_blank"),
                        children: [
                            "Shop in App",
                            /*#__PURE__*/ (0, $drmv2.jsx)("svg", {
                                "aria-hidden": "true",
                                focusable: "false",
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "icon icon-chevron-right",
                                width: "10",
                                height: "10",
                                fill: "currentColor",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                    d: "M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)((0, $6dE6X.default), {
                hit: hit,
                title: title,
                subtitle: subtitle,
                badgeText: badgeText,
                canAddToCart: canAddToCart,
                cartState: cartState,
                isMedium: isMedium,
                wishState: wishState,
                // setWishState={setWishState}
                canWishlist: canWishlist,
                Dialog: $aeac63bef46804c0$var$Dialog,
                currency: currency,
                ProductPrice: (0, $bf1Az.ProductPrice),
                messageStyles: messageStyles,
                messageText: messageText,
                handleWishClick: handleWishClick,
                hasOneVariant: hasOneVariant
            })
        ]
    });
};
$aeac63bef46804c0$export$e6cbe35324ccf844.Skeleton = ()=>/*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "media media--portrait",
                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                    className: $aeac63bef46804c0$var$classes.skeleton,
                    children: "\xa0"
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "product-card__info",
                children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                    className: "product-card__header",
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                            className: (0, $biy3n.default)($aeac63bef46804c0$var$classes.skeleton, $aeac63bef46804c0$var$classes.text, "product-card__title"),
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                            style: {
                                width: "50%"
                            },
                            className: (0, $biy3n.default)($aeac63bef46804c0$var$classes.skeleton, $aeac63bef46804c0$var$classes.text, "product-card__subtitle"),
                            children: "\xa0"
                        })
                    ]
                })
            })
        ]
    });

});
parcelRegister("5dGri", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ccf16309b6088f5$export$2e2bcd8739ae039; });

var $34DYQ = parcelRequire("34DYQ");

var $2ik1F = parcelRequire("2ik1F");

var $chDzA = parcelRequire("chDzA");
function $3ccf16309b6088f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2ik1F.default)(2, arguments);
    var amount = (0, $chDzA.default)(dirtyAmount);
    return (0, $34DYQ.default)(dirtyDate, -amount);
}

});
parcelRegister("34DYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23d0c217e596482c$export$2e2bcd8739ae039; });

var $chDzA = parcelRequire("chDzA");

var $j8yMH = parcelRequire("j8yMH");

var $2ik1F = parcelRequire("2ik1F");
function $23d0c217e596482c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $2ik1F.default)(2, arguments);
    var date = (0, $j8yMH.default)(dirtyDate);
    var amount = (0, $chDzA.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("chDzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f15c4f0c0446265$export$2e2bcd8739ae039; });
function $8f15c4f0c0446265$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("j8yMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dee9bf233c4fdba5$export$2e2bcd8739ae039; });

var $937GK = parcelRequire("937GK");

var $2ik1F = parcelRequire("2ik1F");
function $dee9bf233c4fdba5$export$2e2bcd8739ae039(argument) {
    (0, $2ik1F.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $937GK.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("937GK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01b3438ad5b068a2$export$2e2bcd8739ae039; });
function $01b3438ad5b068a2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $01b3438ad5b068a2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01b3438ad5b068a2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2ik1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1abccbee046261bd$export$2e2bcd8739ae039; });
function $1abccbee046261bd$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});




parcelRegister("keJQj", function(module, exports) {

$parcel$export(module.exports, "badge", function () { return $ebb8ace3dea1dfe6$export$4aebd143f31d0c0d; }, function (v) { return $ebb8ace3dea1dfe6$export$4aebd143f31d0c0d = v; });
$parcel$export(module.exports, "badgePreorder", function () { return $ebb8ace3dea1dfe6$export$9fce305cf6635a4e; }, function (v) { return $ebb8ace3dea1dfe6$export$9fce305cf6635a4e = v; });
$parcel$export(module.exports, "badge_bottom", function () { return $ebb8ace3dea1dfe6$export$34685c6d417ebeea; }, function (v) { return $ebb8ace3dea1dfe6$export$34685c6d417ebeea = v; });
$parcel$export(module.exports, "banner", function () { return $ebb8ace3dea1dfe6$export$bb5ee47d9ea2348e; }, function (v) { return $ebb8ace3dea1dfe6$export$bb5ee47d9ea2348e = v; });
$parcel$export(module.exports, "breastCancerBadge", function () { return $ebb8ace3dea1dfe6$export$55de6974ac20d2c7; }, function (v) { return $ebb8ace3dea1dfe6$export$55de6974ac20d2c7 = v; });
$parcel$export(module.exports, "bubble", function () { return $ebb8ace3dea1dfe6$export$f5dbf5ce556e97fb; }, function (v) { return $ebb8ace3dea1dfe6$export$f5dbf5ce556e97fb = v; });
$parcel$export(module.exports, "card-info", function () { return $ebb8ace3dea1dfe6$export$da50228e50e36a03; }, function (v) { return $ebb8ace3dea1dfe6$export$da50228e50e36a03 = v; });
$parcel$export(module.exports, "card-mediaWrapper", function () { return $ebb8ace3dea1dfe6$export$f3283c3c0febe5e5; }, function (v) { return $ebb8ace3dea1dfe6$export$f3283c3c0febe5e5 = v; });
$parcel$export(module.exports, "cartActions", function () { return $ebb8ace3dea1dfe6$export$1559335452eb3ad1; }, function (v) { return $ebb8ace3dea1dfe6$export$1559335452eb3ad1 = v; });
$parcel$export(module.exports, "cartButton", function () { return $ebb8ace3dea1dfe6$export$7861863ea30be33c; }, function (v) { return $ebb8ace3dea1dfe6$export$7861863ea30be33c = v; });
$parcel$export(module.exports, "cartContainer", function () { return $ebb8ace3dea1dfe6$export$23d88d7faee02730; }, function (v) { return $ebb8ace3dea1dfe6$export$23d88d7faee02730 = v; });
$parcel$export(module.exports, "cartDialog", function () { return $ebb8ace3dea1dfe6$export$cadf897607eb7fa2; }, function (v) { return $ebb8ace3dea1dfe6$export$cadf897607eb7fa2 = v; });
$parcel$export(module.exports, "cartModal", function () { return $ebb8ace3dea1dfe6$export$993975c2c0bcc1b2; }, function (v) { return $ebb8ace3dea1dfe6$export$993975c2c0bcc1b2 = v; });
$parcel$export(module.exports, "decreaseBundleBtn", function () { return $ebb8ace3dea1dfe6$export$3d182a7cda7aa254; }, function (v) { return $ebb8ace3dea1dfe6$export$3d182a7cda7aa254 = v; });
$parcel$export(module.exports, "dialogCloseButton", function () { return $ebb8ace3dea1dfe6$export$a6a9de45b3e89eae; }, function (v) { return $ebb8ace3dea1dfe6$export$a6a9de45b3e89eae = v; });
$parcel$export(module.exports, "dialogHeader", function () { return $ebb8ace3dea1dfe6$export$9bb6a6f2774dc082; }, function (v) { return $ebb8ace3dea1dfe6$export$9bb6a6f2774dc082 = v; });
$parcel$export(module.exports, "dialogItem", function () { return $ebb8ace3dea1dfe6$export$7bc9bb8e672db931; }, function (v) { return $ebb8ace3dea1dfe6$export$7bc9bb8e672db931 = v; });
$parcel$export(module.exports, "dialogItemBadge", function () { return $ebb8ace3dea1dfe6$export$ea6b507bffd6ff93; }, function (v) { return $ebb8ace3dea1dfe6$export$ea6b507bffd6ff93 = v; });
$parcel$export(module.exports, "dialogItemHeader", function () { return $ebb8ace3dea1dfe6$export$c14a8e9254fede1d; }, function (v) { return $ebb8ace3dea1dfe6$export$c14a8e9254fede1d = v; });
$parcel$export(module.exports, "dialogItemImage", function () { return $ebb8ace3dea1dfe6$export$fda5b028bdfdb891; }, function (v) { return $ebb8ace3dea1dfe6$export$fda5b028bdfdb891 = v; });
$parcel$export(module.exports, "dialogItemMessage", function () { return $ebb8ace3dea1dfe6$export$91e258c032e0038; }, function (v) { return $ebb8ace3dea1dfe6$export$91e258c032e0038 = v; });
$parcel$export(module.exports, "dialogItemSubtitle", function () { return $ebb8ace3dea1dfe6$export$2a336f0d40a188cb; }, function (v) { return $ebb8ace3dea1dfe6$export$2a336f0d40a188cb = v; });
$parcel$export(module.exports, "dialogItemTitle", function () { return $ebb8ace3dea1dfe6$export$579da1ae1f15a516; }, function (v) { return $ebb8ace3dea1dfe6$export$579da1ae1f15a516 = v; });
$parcel$export(module.exports, "dialogList", function () { return $ebb8ace3dea1dfe6$export$77992838df855a1b; }, function (v) { return $ebb8ace3dea1dfe6$export$77992838df855a1b = v; });
$parcel$export(module.exports, "dialogListItem", function () { return $ebb8ace3dea1dfe6$export$3da00676f3da1f45; }, function (v) { return $ebb8ace3dea1dfe6$export$3da00676f3da1f45 = v; });
$parcel$export(module.exports, "dialogTitle", function () { return $ebb8ace3dea1dfe6$export$b8772d08938399e8; }, function (v) { return $ebb8ace3dea1dfe6$export$b8772d08938399e8 = v; });
$parcel$export(module.exports, "drawerContainer", function () { return $ebb8ace3dea1dfe6$export$e2ebc74040679039; }, function (v) { return $ebb8ace3dea1dfe6$export$e2ebc74040679039 = v; });
$parcel$export(module.exports, "grocer_badges", function () { return $ebb8ace3dea1dfe6$export$d5ecb1531e598446; }, function (v) { return $ebb8ace3dea1dfe6$export$d5ecb1531e598446 = v; });
$parcel$export(module.exports, "groupProductDialogListItem", function () { return $ebb8ace3dea1dfe6$export$691942c407d9422f; }, function (v) { return $ebb8ace3dea1dfe6$export$691942c407d9422f = v; });
$parcel$export(module.exports, "h4", function () { return $ebb8ace3dea1dfe6$export$51a85cc1b68f452c; }, function (v) { return $ebb8ace3dea1dfe6$export$51a85cc1b68f452c = v; });
$parcel$export(module.exports, "header", function () { return $ebb8ace3dea1dfe6$export$38e42c68cf43b5d4; }, function (v) { return $ebb8ace3dea1dfe6$export$38e42c68cf43b5d4 = v; });
$parcel$export(module.exports, "hitButton", function () { return $ebb8ace3dea1dfe6$export$e96ee27a4fed463; }, function (v) { return $ebb8ace3dea1dfe6$export$e96ee27a4fed463 = v; });
$parcel$export(module.exports, "hoverQuickButton", function () { return $ebb8ace3dea1dfe6$export$810bf9dc777a3a23; }, function (v) { return $ebb8ace3dea1dfe6$export$810bf9dc777a3a23 = v; });
$parcel$export(module.exports, "increaseBundleBtn", function () { return $ebb8ace3dea1dfe6$export$9c3da3f97a572147; }, function (v) { return $ebb8ace3dea1dfe6$export$9c3da3f97a572147 = v; });
$parcel$export(module.exports, "info", function () { return $ebb8ace3dea1dfe6$export$a80b3bd66acc52ff; }, function (v) { return $ebb8ace3dea1dfe6$export$a80b3bd66acc52ff = v; });
$parcel$export(module.exports, "isGroupProduct", function () { return $ebb8ace3dea1dfe6$export$6bcece69506205ac; }, function (v) { return $ebb8ace3dea1dfe6$export$6bcece69506205ac = v; });
$parcel$export(module.exports, "isSupplement", function () { return $ebb8ace3dea1dfe6$export$bb689d55babb3b6e; }, function (v) { return $ebb8ace3dea1dfe6$export$bb689d55babb3b6e = v; });
$parcel$export(module.exports, "loading", function () { return $ebb8ace3dea1dfe6$export$46c1c92549715335; }, function (v) { return $ebb8ace3dea1dfe6$export$46c1c92549715335 = v; });
$parcel$export(module.exports, "lowStockLabel", function () { return $ebb8ace3dea1dfe6$export$2f1445b034d04eb5; }, function (v) { return $ebb8ace3dea1dfe6$export$2f1445b034d04eb5 = v; });
$parcel$export(module.exports, "media", function () { return $ebb8ace3dea1dfe6$export$987d49ffe1b0900f; }, function (v) { return $ebb8ace3dea1dfe6$export$987d49ffe1b0900f = v; });
$parcel$export(module.exports, "mediaWrapper", function () { return $ebb8ace3dea1dfe6$export$a326285446bc1148; }, function (v) { return $ebb8ace3dea1dfe6$export$a326285446bc1148 = v; });
$parcel$export(module.exports, "message", function () { return $ebb8ace3dea1dfe6$export$a8ecead220dd38a6; }, function (v) { return $ebb8ace3dea1dfe6$export$a8ecead220dd38a6 = v; });
$parcel$export(module.exports, "newSoldOut", function () { return $ebb8ace3dea1dfe6$export$e18341c0b15cf4c5; }, function (v) { return $ebb8ace3dea1dfe6$export$e18341c0b15cf4c5 = v; });
$parcel$export(module.exports, "noOptionsSelected", function () { return $ebb8ace3dea1dfe6$export$a67d3dda20d61d26; }, function (v) { return $ebb8ace3dea1dfe6$export$a67d3dda20d61d26 = v; });
$parcel$export(module.exports, "nonSizeButtonVariant", function () { return $ebb8ace3dea1dfe6$export$448a45a39987666c; }, function (v) { return $ebb8ace3dea1dfe6$export$448a45a39987666c = v; });
$parcel$export(module.exports, "nonSizeVariant", function () { return $ebb8ace3dea1dfe6$export$f26b206ba80182f2; }, function (v) { return $ebb8ace3dea1dfe6$export$f26b206ba80182f2 = v; });
$parcel$export(module.exports, "notify", function () { return $ebb8ace3dea1dfe6$export$5e14cdade93d6f7b; }, function (v) { return $ebb8ace3dea1dfe6$export$5e14cdade93d6f7b = v; });
$parcel$export(module.exports, "open", function () { return $ebb8ace3dea1dfe6$export$3ce6949f20cea765; }, function (v) { return $ebb8ace3dea1dfe6$export$3ce6949f20cea765 = v; });
$parcel$export(module.exports, "optionsSelected", function () { return $ebb8ace3dea1dfe6$export$7e0e26aa76886a19; }, function (v) { return $ebb8ace3dea1dfe6$export$7e0e26aa76886a19 = v; });
$parcel$export(module.exports, "productSoldOut", function () { return $ebb8ace3dea1dfe6$export$251af7694229a026; }, function (v) { return $ebb8ace3dea1dfe6$export$251af7694229a026 = v; });
$parcel$export(module.exports, "product_badge_wrapper", function () { return $ebb8ace3dea1dfe6$export$b9c94339c550a78b; }, function (v) { return $ebb8ace3dea1dfe6$export$b9c94339c550a78b = v; });
$parcel$export(module.exports, "product_badges", function () { return $ebb8ace3dea1dfe6$export$fcf5fee572fe30e4; }, function (v) { return $ebb8ace3dea1dfe6$export$fcf5fee572fe30e4 = v; });
$parcel$export(module.exports, "pulse", function () { return $ebb8ace3dea1dfe6$export$f3aaf94dc96a60de; }, function (v) { return $ebb8ace3dea1dfe6$export$f3aaf94dc96a60de = v; });
$parcel$export(module.exports, "qty_count", function () { return $ebb8ace3dea1dfe6$export$416d53f4a0513999; }, function (v) { return $ebb8ace3dea1dfe6$export$416d53f4a0513999 = v; });
$parcel$export(module.exports, "quickAddWrapper", function () { return $ebb8ace3dea1dfe6$export$715c0cf56e95b21; }, function (v) { return $ebb8ace3dea1dfe6$export$715c0cf56e95b21 = v; });
$parcel$export(module.exports, "quickBadge", function () { return $ebb8ace3dea1dfe6$export$b0e796f799b39eeb; }, function (v) { return $ebb8ace3dea1dfe6$export$b0e796f799b39eeb = v; });
$parcel$export(module.exports, "quickBuy", function () { return $ebb8ace3dea1dfe6$export$292a1a95288df1ad; }, function (v) { return $ebb8ace3dea1dfe6$export$292a1a95288df1ad = v; });
$parcel$export(module.exports, "quickMessage", function () { return $ebb8ace3dea1dfe6$export$8883db8dec99eec8; }, function (v) { return $ebb8ace3dea1dfe6$export$8883db8dec99eec8 = v; });
$parcel$export(module.exports, "root", function () { return $ebb8ace3dea1dfe6$export$e8e78c978b129247; }, function (v) { return $ebb8ace3dea1dfe6$export$e8e78c978b129247 = v; });
$parcel$export(module.exports, "singleVariantButtonDecrease", function () { return $ebb8ace3dea1dfe6$export$1e765ae0073f15d4; }, function (v) { return $ebb8ace3dea1dfe6$export$1e765ae0073f15d4 = v; });
$parcel$export(module.exports, "singleVariantButtonIncrease", function () { return $ebb8ace3dea1dfe6$export$51b5f541a4c6e23a; }, function (v) { return $ebb8ace3dea1dfe6$export$51b5f541a4c6e23a = v; });
$parcel$export(module.exports, "skeleton", function () { return $ebb8ace3dea1dfe6$export$2a0674ff2eb10214; }, function (v) { return $ebb8ace3dea1dfe6$export$2a0674ff2eb10214 = v; });
$parcel$export(module.exports, "soldOut", function () { return $ebb8ace3dea1dfe6$export$c476e9b2d170f91c; }, function (v) { return $ebb8ace3dea1dfe6$export$c476e9b2d170f91c = v; });
$parcel$export(module.exports, "subtitle", function () { return $ebb8ace3dea1dfe6$export$c96745152eb2740f; }, function (v) { return $ebb8ace3dea1dfe6$export$c96745152eb2740f = v; });
$parcel$export(module.exports, "text", function () { return $ebb8ace3dea1dfe6$export$6f093cfa640b7166; }, function (v) { return $ebb8ace3dea1dfe6$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "title", function () { return $ebb8ace3dea1dfe6$export$fb184b623420d9be; }, function (v) { return $ebb8ace3dea1dfe6$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "variantButtonWrapper", function () { return $ebb8ace3dea1dfe6$export$b20a8a3a75f491dd; }, function (v) { return $ebb8ace3dea1dfe6$export$b20a8a3a75f491dd = v; });
$parcel$export(module.exports, "variantHitbntWrapper", function () { return $ebb8ace3dea1dfe6$export$82212356bf8d58d5; }, function (v) { return $ebb8ace3dea1dfe6$export$82212356bf8d58d5 = v; });
$parcel$export(module.exports, "wishButton", function () { return $ebb8ace3dea1dfe6$export$5a2fcf6e0be4246d; }, function (v) { return $ebb8ace3dea1dfe6$export$5a2fcf6e0be4246d = v; });
$parcel$export(module.exports, "wishContainer", function () { return $ebb8ace3dea1dfe6$export$54bcf1d3de27ba89; }, function (v) { return $ebb8ace3dea1dfe6$export$54bcf1d3de27ba89 = v; });
$parcel$export(module.exports, "wishDialog", function () { return $ebb8ace3dea1dfe6$export$a2b44a59693d8fc6; }, function (v) { return $ebb8ace3dea1dfe6$export$a2b44a59693d8fc6 = v; });
$parcel$export(module.exports, "wishModal", function () { return $ebb8ace3dea1dfe6$export$576200997c9bed5c; }, function (v) { return $ebb8ace3dea1dfe6$export$576200997c9bed5c = v; });
$parcel$export(module.exports, "wrap", function () { return $ebb8ace3dea1dfe6$export$4997ffc0176396a6; }, function (v) { return $ebb8ace3dea1dfe6$export$4997ffc0176396a6 = v; });
var $ebb8ace3dea1dfe6$export$4aebd143f31d0c0d;
var $ebb8ace3dea1dfe6$export$9fce305cf6635a4e;
var $ebb8ace3dea1dfe6$export$34685c6d417ebeea;
var $ebb8ace3dea1dfe6$export$bb5ee47d9ea2348e;
var $ebb8ace3dea1dfe6$export$55de6974ac20d2c7;
var $ebb8ace3dea1dfe6$export$f5dbf5ce556e97fb;
var $ebb8ace3dea1dfe6$export$da50228e50e36a03;
var $ebb8ace3dea1dfe6$export$f3283c3c0febe5e5;
var $ebb8ace3dea1dfe6$export$1559335452eb3ad1;
var $ebb8ace3dea1dfe6$export$7861863ea30be33c;
var $ebb8ace3dea1dfe6$export$23d88d7faee02730;
var $ebb8ace3dea1dfe6$export$cadf897607eb7fa2;
var $ebb8ace3dea1dfe6$export$993975c2c0bcc1b2;
var $ebb8ace3dea1dfe6$export$3d182a7cda7aa254;
var $ebb8ace3dea1dfe6$export$a6a9de45b3e89eae;
var $ebb8ace3dea1dfe6$export$9bb6a6f2774dc082;
var $ebb8ace3dea1dfe6$export$7bc9bb8e672db931;
var $ebb8ace3dea1dfe6$export$ea6b507bffd6ff93;
var $ebb8ace3dea1dfe6$export$c14a8e9254fede1d;
var $ebb8ace3dea1dfe6$export$fda5b028bdfdb891;
var $ebb8ace3dea1dfe6$export$91e258c032e0038;
var $ebb8ace3dea1dfe6$export$2a336f0d40a188cb;
var $ebb8ace3dea1dfe6$export$579da1ae1f15a516;
var $ebb8ace3dea1dfe6$export$77992838df855a1b;
var $ebb8ace3dea1dfe6$export$3da00676f3da1f45;
var $ebb8ace3dea1dfe6$export$b8772d08938399e8;
var $ebb8ace3dea1dfe6$export$e2ebc74040679039;
var $ebb8ace3dea1dfe6$export$d5ecb1531e598446;
var $ebb8ace3dea1dfe6$export$691942c407d9422f;
var $ebb8ace3dea1dfe6$export$51a85cc1b68f452c;
var $ebb8ace3dea1dfe6$export$38e42c68cf43b5d4;
var $ebb8ace3dea1dfe6$export$e96ee27a4fed463;
var $ebb8ace3dea1dfe6$export$810bf9dc777a3a23;
var $ebb8ace3dea1dfe6$export$9c3da3f97a572147;
var $ebb8ace3dea1dfe6$export$a80b3bd66acc52ff;
var $ebb8ace3dea1dfe6$export$6bcece69506205ac;
var $ebb8ace3dea1dfe6$export$bb689d55babb3b6e;
var $ebb8ace3dea1dfe6$export$46c1c92549715335;
var $ebb8ace3dea1dfe6$export$2f1445b034d04eb5;
var $ebb8ace3dea1dfe6$export$987d49ffe1b0900f;
var $ebb8ace3dea1dfe6$export$a326285446bc1148;
var $ebb8ace3dea1dfe6$export$a8ecead220dd38a6;
var $ebb8ace3dea1dfe6$export$e18341c0b15cf4c5;
var $ebb8ace3dea1dfe6$export$a67d3dda20d61d26;
var $ebb8ace3dea1dfe6$export$448a45a39987666c;
var $ebb8ace3dea1dfe6$export$f26b206ba80182f2;
var $ebb8ace3dea1dfe6$export$5e14cdade93d6f7b;
var $ebb8ace3dea1dfe6$export$3ce6949f20cea765;
var $ebb8ace3dea1dfe6$export$7e0e26aa76886a19;
var $ebb8ace3dea1dfe6$export$251af7694229a026;
var $ebb8ace3dea1dfe6$export$b9c94339c550a78b;
var $ebb8ace3dea1dfe6$export$fcf5fee572fe30e4;
var $ebb8ace3dea1dfe6$export$f3aaf94dc96a60de;
var $ebb8ace3dea1dfe6$export$416d53f4a0513999;
var $ebb8ace3dea1dfe6$export$715c0cf56e95b21;
var $ebb8ace3dea1dfe6$export$b0e796f799b39eeb;
var $ebb8ace3dea1dfe6$export$292a1a95288df1ad;
var $ebb8ace3dea1dfe6$export$8883db8dec99eec8;
var $ebb8ace3dea1dfe6$export$e8e78c978b129247;
var $ebb8ace3dea1dfe6$export$1e765ae0073f15d4;
var $ebb8ace3dea1dfe6$export$51b5f541a4c6e23a;
var $ebb8ace3dea1dfe6$export$2a0674ff2eb10214;
var $ebb8ace3dea1dfe6$export$c476e9b2d170f91c;
var $ebb8ace3dea1dfe6$export$c96745152eb2740f;
var $ebb8ace3dea1dfe6$export$6f093cfa640b7166;
var $ebb8ace3dea1dfe6$export$fb184b623420d9be;
var $ebb8ace3dea1dfe6$export$b20a8a3a75f491dd;
var $ebb8ace3dea1dfe6$export$82212356bf8d58d5;
var $ebb8ace3dea1dfe6$export$5a2fcf6e0be4246d;
var $ebb8ace3dea1dfe6$export$54bcf1d3de27ba89;
var $ebb8ace3dea1dfe6$export$a2b44a59693d8fc6;
var $ebb8ace3dea1dfe6$export$576200997c9bed5c;
var $ebb8ace3dea1dfe6$export$4997ffc0176396a6;
$ebb8ace3dea1dfe6$export$4aebd143f31d0c0d = `Le6hOa_badge`;
$ebb8ace3dea1dfe6$export$9fce305cf6635a4e = `Le6hOa_badgePreorder`;
$ebb8ace3dea1dfe6$export$34685c6d417ebeea = `Le6hOa_badge_bottom`;
$ebb8ace3dea1dfe6$export$bb5ee47d9ea2348e = `Le6hOa_banner`;
$ebb8ace3dea1dfe6$export$55de6974ac20d2c7 = `Le6hOa_breastCancerBadge`;
$ebb8ace3dea1dfe6$export$f5dbf5ce556e97fb = `Le6hOa_bubble`;
$ebb8ace3dea1dfe6$export$da50228e50e36a03 = `Le6hOa_card-info`;
$ebb8ace3dea1dfe6$export$f3283c3c0febe5e5 = `Le6hOa_card-mediaWrapper`;
$ebb8ace3dea1dfe6$export$1559335452eb3ad1 = `Le6hOa_cartActions`;
$ebb8ace3dea1dfe6$export$7861863ea30be33c = `Le6hOa_cartButton`;
$ebb8ace3dea1dfe6$export$23d88d7faee02730 = `Le6hOa_cartContainer`;
$ebb8ace3dea1dfe6$export$cadf897607eb7fa2 = `Le6hOa_cartDialog`;
$ebb8ace3dea1dfe6$export$993975c2c0bcc1b2 = `Le6hOa_cartModal`;
$ebb8ace3dea1dfe6$export$3d182a7cda7aa254 = `Le6hOa_decreaseBundleBtn`;
$ebb8ace3dea1dfe6$export$a6a9de45b3e89eae = `Le6hOa_dialogCloseButton`;
$ebb8ace3dea1dfe6$export$9bb6a6f2774dc082 = `Le6hOa_dialogHeader`;
$ebb8ace3dea1dfe6$export$7bc9bb8e672db931 = `Le6hOa_dialogItem`;
$ebb8ace3dea1dfe6$export$ea6b507bffd6ff93 = `Le6hOa_dialogItemBadge`;
$ebb8ace3dea1dfe6$export$c14a8e9254fede1d = `Le6hOa_dialogItemHeader`;
$ebb8ace3dea1dfe6$export$fda5b028bdfdb891 = `Le6hOa_dialogItemImage`;
$ebb8ace3dea1dfe6$export$91e258c032e0038 = `Le6hOa_dialogItemMessage`;
$ebb8ace3dea1dfe6$export$2a336f0d40a188cb = `Le6hOa_dialogItemSubtitle`;
$ebb8ace3dea1dfe6$export$579da1ae1f15a516 = `Le6hOa_dialogItemTitle`;
$ebb8ace3dea1dfe6$export$77992838df855a1b = `Le6hOa_dialogList`;
$ebb8ace3dea1dfe6$export$3da00676f3da1f45 = `Le6hOa_dialogListItem`;
$ebb8ace3dea1dfe6$export$b8772d08938399e8 = `Le6hOa_dialogTitle`;
$ebb8ace3dea1dfe6$export$e2ebc74040679039 = `Le6hOa_drawerContainer`;
$ebb8ace3dea1dfe6$export$d5ecb1531e598446 = `Le6hOa_grocer_badges`;
$ebb8ace3dea1dfe6$export$691942c407d9422f = `Le6hOa_groupProductDialogListItem`;
$ebb8ace3dea1dfe6$export$51a85cc1b68f452c = `Le6hOa_h4`;
$ebb8ace3dea1dfe6$export$38e42c68cf43b5d4 = `Le6hOa_header`;
$ebb8ace3dea1dfe6$export$e96ee27a4fed463 = `Le6hOa_hitButton`;
$ebb8ace3dea1dfe6$export$810bf9dc777a3a23 = `Le6hOa_hoverQuickButton`;
$ebb8ace3dea1dfe6$export$9c3da3f97a572147 = `Le6hOa_increaseBundleBtn`;
$ebb8ace3dea1dfe6$export$a80b3bd66acc52ff = `Le6hOa_info`;
$ebb8ace3dea1dfe6$export$6bcece69506205ac = `Le6hOa_isGroupProduct`;
$ebb8ace3dea1dfe6$export$bb689d55babb3b6e = `Le6hOa_isSupplement`;
$ebb8ace3dea1dfe6$export$46c1c92549715335 = `Le6hOa_loading`;
$ebb8ace3dea1dfe6$export$46c1c92549715335;
$ebb8ace3dea1dfe6$export$2f1445b034d04eb5 = `Le6hOa_lowStockLabel`;
$ebb8ace3dea1dfe6$export$987d49ffe1b0900f = `Le6hOa_media`;
$ebb8ace3dea1dfe6$export$a326285446bc1148 = `Le6hOa_mediaWrapper`;
$ebb8ace3dea1dfe6$export$a8ecead220dd38a6 = `Le6hOa_message`;
$ebb8ace3dea1dfe6$export$e18341c0b15cf4c5 = `Le6hOa_newSoldOut`;
$ebb8ace3dea1dfe6$export$a67d3dda20d61d26 = `Le6hOa_noOptionsSelected`;
$ebb8ace3dea1dfe6$export$448a45a39987666c = `Le6hOa_nonSizeButtonVariant`;
$ebb8ace3dea1dfe6$export$f26b206ba80182f2 = `Le6hOa_nonSizeVariant`;
$ebb8ace3dea1dfe6$export$5e14cdade93d6f7b = `Le6hOa_notify`;
$ebb8ace3dea1dfe6$export$3ce6949f20cea765 = `Le6hOa_open`;
$ebb8ace3dea1dfe6$export$7e0e26aa76886a19 = `Le6hOa_optionsSelected`;
$ebb8ace3dea1dfe6$export$251af7694229a026 = `Le6hOa_productSoldOut`;
$ebb8ace3dea1dfe6$export$b9c94339c550a78b = `Le6hOa_product_badge_wrapper`;
$ebb8ace3dea1dfe6$export$fcf5fee572fe30e4 = `Le6hOa_product_badges`;
$ebb8ace3dea1dfe6$export$f3aaf94dc96a60de = `Le6hOa_pulse`;
$ebb8ace3dea1dfe6$export$f3aaf94dc96a60de;
$ebb8ace3dea1dfe6$export$416d53f4a0513999 = `Le6hOa_qty_count`;
$ebb8ace3dea1dfe6$export$715c0cf56e95b21 = `Le6hOa_quickAddWrapper`;
$ebb8ace3dea1dfe6$export$b0e796f799b39eeb = `Le6hOa_quickBadge`;
$ebb8ace3dea1dfe6$export$292a1a95288df1ad = `Le6hOa_quickBuy`;
$ebb8ace3dea1dfe6$export$8883db8dec99eec8 = `Le6hOa_quickMessage`;
$ebb8ace3dea1dfe6$export$e8e78c978b129247 = `Le6hOa_root`;
$ebb8ace3dea1dfe6$export$1e765ae0073f15d4 = `Le6hOa_singleVariantButtonDecrease`;
$ebb8ace3dea1dfe6$export$51b5f541a4c6e23a = `Le6hOa_singleVariantButtonIncrease`;
$ebb8ace3dea1dfe6$export$2a0674ff2eb10214 = `Le6hOa_skeleton`;
$ebb8ace3dea1dfe6$export$c476e9b2d170f91c = `Le6hOa_soldOut`;
$ebb8ace3dea1dfe6$export$c96745152eb2740f = `Le6hOa_subtitle`;
$ebb8ace3dea1dfe6$export$6f093cfa640b7166 = `Le6hOa_text`;
$ebb8ace3dea1dfe6$export$fb184b623420d9be = `Le6hOa_title`;
$ebb8ace3dea1dfe6$export$b20a8a3a75f491dd = `Le6hOa_variantButtonWrapper`;
$ebb8ace3dea1dfe6$export$82212356bf8d58d5 = `Le6hOa_variantHitbntWrapper`;
$ebb8ace3dea1dfe6$export$5a2fcf6e0be4246d = `Le6hOa_wishButton`;
$ebb8ace3dea1dfe6$export$54bcf1d3de27ba89 = `Le6hOa_wishContainer`;
$ebb8ace3dea1dfe6$export$a2b44a59693d8fc6 = `Le6hOa_wishDialog`;
$ebb8ace3dea1dfe6$export$576200997c9bed5c = `Le6hOa_wishModal`;
$ebb8ace3dea1dfe6$export$4997ffc0176396a6 = `Le6hOa_wrap`;

});

parcelRegister("cwQIK", function(module, exports) {
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var limit$2 = function(x, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;
        return x < min ? min : x > max ? max : x;
    };
    var limit$1 = limit$2;
    var clip_rgb$3 = function(rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(var i = 0; i <= 3; i++){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                rgb[i] = limit$1(rgb[i], 0, 255);
            } else if (i === 3) rgb[i] = limit$1(rgb[i], 0, 1);
        }
        return rgb;
    };
    // ported from jQuery's $.type
    var classToType = {};
    for(var i$1 = 0, list$1 = [
        "Boolean",
        "Number",
        "String",
        "Function",
        "Array",
        "Date",
        "RegExp",
        "Undefined",
        "Null"
    ]; i$1 < list$1.length; i$1 += 1){
        var name = list$1[i$1];
        classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type$p = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var type$o = type$p;
    var unpack$B = function(args, keyOrder) {
        if (keyOrder === void 0) keyOrder = null;
        // if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) return Array.prototype.slice.call(args);
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
        if (type$o(args[0]) == "object" && keyOrder) return keyOrder.split("").filter(function(k) {
            return args[0][k] !== undefined;
        }).map(function(k) {
            return args[0][k];
        });
        // otherwise we just return the first argument
        // (which we suppose is an array of args)
        return args[0];
    };
    var type$n = type$p;
    var last$4 = function(args) {
        if (args.length < 2) return null;
        var l = args.length - 1;
        if (type$n(args[l]) == "string") return args[l].toLowerCase();
        return null;
    };
    var PI$2 = Math.PI;
    var utils = {
        clip_rgb: clip_rgb$3,
        limit: limit$2,
        type: type$p,
        unpack: unpack$B,
        last: last$4,
        PI: PI$2,
        TWOPI: PI$2 * 2,
        PITHIRD: PI$2 / 3,
        DEG2RAD: PI$2 / 180,
        RAD2DEG: 180 / PI$2
    };
    var input$h = {
        format: {},
        autodetect: []
    };
    var last$3 = utils.last;
    var clip_rgb$2 = utils.clip_rgb;
    var type$m = utils.type;
    var _input = input$h;
    var Color$D = function Color() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var me = this;
        if (type$m(args[0]) === "object" && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        var mode = last$3(args);
        var autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!_input.sorted) {
                _input.autodetect = _input.autodetect.sort(function(a, b) {
                    return b.p - a.p;
                });
                _input.sorted = true;
            }
            // auto-detect format
            for(var i = 0, list = _input.autodetect; i < list.length; i += 1){
                var chk = list[i];
                mode = chk.test.apply(chk, args);
                if (mode) break;
            }
        }
        if (_input.format[mode]) {
            var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = clip_rgb$2(rgb);
        } else throw new Error("unknown format: " + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    };
    Color$D.prototype.toString = function toString() {
        if (type$m(this.hex) == "function") return this.hex();
        return "[" + this._rgb.join(",") + "]";
    };
    var Color_1 = Color$D;
    var chroma$k = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(chroma$k.Color, [
            null
        ].concat(args)));
    };
    chroma$k.Color = Color_1;
    chroma$k.version = "2.4.2";
    var chroma_1 = chroma$k;
    var unpack$A = utils.unpack;
    var max$2 = Math.max;
    var rgb2cmyk$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$A(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max$2(r, max$2(g, b));
        var f = k < 1 ? 1 / (1 - k) : 0;
        var c = (1 - r - k) * f;
        var m = (1 - g - k) * f;
        var y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    var rgb2cmyk_1 = rgb2cmyk$1;
    var unpack$z = utils.unpack;
    var cmyk2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$z(args, "cmyk");
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        return [
            c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
            m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
            y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
            alpha
        ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var chroma$j = chroma_1;
    var Color$C = Color_1;
    var input$g = input$h;
    var unpack$y = utils.unpack;
    var type$l = utils.type;
    var rgb2cmyk = rgb2cmyk_1;
    Color$C.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    chroma$j.cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$C, [
            null
        ].concat(args, [
            "cmyk"
        ])));
    };
    input$g.format.cmyk = cmyk2rgb_1;
    input$g.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$y(args, "cmyk");
            if (type$l(args) === "array" && args.length === 4) return "cmyk";
        }
    });
    var unpack$x = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a) {
        return Math.round(a * 100) / 100;
    };
    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */ var hsl2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hsla = unpack$x(args, "hsla");
        var mode = last$2(args) || "lsa";
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1] * 100) + "%";
        hsla[2] = rnd(hsla[2] * 100) + "%";
        if (mode === "hsla" || hsla.length > 3 && hsla[3] < 1) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = "hsla";
        } else hsla.length = 3;
        return mode + "(" + hsla.join(",") + ")";
    };
    var hsl2css_1 = hsl2css$1;
    var unpack$w = utils.unpack;
    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */ var rgb2hsl$3 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$w(args, "rgba");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var l = (max + min) / 2;
        var s, h;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r == max) h = (g - b) / (max - min);
        else if (g == max) h = 2 + (b - r) / (max - min);
        else if (b == max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        if (args.length > 3 && args[3] !== undefined) return [
            h,
            s,
            l,
            args[3]
        ];
        return [
            h,
            s,
            l
        ];
    };
    var rgb2hsl_1 = rgb2hsl$3;
    var unpack$v = utils.unpack;
    var last$1 = utils.last;
    var hsl2css = hsl2css_1;
    var rgb2hsl$2 = rgb2hsl_1;
    var round$6 = Math.round;
    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */ var rgb2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$v(args, "rgba");
        var mode = last$1(args) || "rgb";
        if (mode.substr(0, 3) == "hsl") return hsl2css(rgb2hsl$2(rgba), mode);
        rgba[0] = round$6(rgba[0]);
        rgba[1] = round$6(rgba[1]);
        rgba[2] = round$6(rgba[2]);
        if (mode === "rgba" || rgba.length > 3 && rgba[3] < 1) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = "rgba";
        }
        return mode + "(" + rgba.slice(0, mode === "rgb" ? 3 : 4).join(",") + ")";
    };
    var rgb2css_1 = rgb2css$1;
    var unpack$u = utils.unpack;
    var round$5 = Math.round;
    var hsl2rgb$1 = function() {
        var assign;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$u(args, "hsl");
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r, g, b;
        if (s === 0) r = g = b = l * 255;
        else {
            var t3 = [
                0,
                0,
                0
            ];
            var c = [
                0,
                0,
                0
            ];
            var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1 / 3;
            t3[1] = h_;
            t3[2] = h_ - 1 / 3;
            for(var i = 0; i < 3; i++){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            assign = [
                round$5(c[0] * 255),
                round$5(c[1] * 255),
                round$5(c[2] * 255)
            ], r = assign[0], g = assign[1], b = assign[2];
        }
        if (args.length > 3) // keep alpha channel
        return [
            r,
            g,
            b,
            args[3]
        ];
        return [
            r,
            g,
            b,
            1
        ];
    };
    var hsl2rgb_1 = hsl2rgb$1;
    var hsl2rgb = hsl2rgb_1;
    var input$f = input$h;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$4 = Math.round;
    var css2rgb$1 = function(css) {
        css = css.toLowerCase().trim();
        var m;
        if (input$f.format.named) try {
            return input$f.format.named(css);
        } catch (e) {
        // eslint-disable-next-line
        }
        // rgb(250,20,0)
        if (m = css.match(RE_RGB)) {
            var rgb = m.slice(1, 4);
            for(var i = 0; i < 3; i++)rgb[i] = +rgb[i];
            rgb[3] = 1; // default alpha
            return rgb;
        }
        // rgba(250,20,0,0.4)
        if (m = css.match(RE_RGBA)) {
            var rgb$1 = m.slice(1, 5);
            for(var i$1 = 0; i$1 < 4; i$1++)rgb$1[i$1] = +rgb$1[i$1];
            return rgb$1;
        }
        // rgb(100%,0%,0%)
        if (m = css.match(RE_RGB_PCT)) {
            var rgb$2 = m.slice(1, 4);
            for(var i$2 = 0; i$2 < 3; i$2++)rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
            rgb$2[3] = 1; // default alpha
            return rgb$2;
        }
        // rgba(100%,0%,0%,0.4)
        if (m = css.match(RE_RGBA_PCT)) {
            var rgb$3 = m.slice(1, 5);
            for(var i$3 = 0; i$3 < 3; i$3++)rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }
        // hsl(0,100%,50%)
        if (m = css.match(RE_HSL)) {
            var hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }
        // hsla(0,100%,50%,0.5)
        if (m = css.match(RE_HSLA)) {
            var hsl$1 = m.slice(1, 4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb(hsl$1);
            rgb$5[3] = +m[4]; // default alpha = 1
            return rgb$5;
        }
    };
    css2rgb$1.test = function(s) {
        return RE_RGB.test(s) || RE_RGBA.test(s) || RE_RGB_PCT.test(s) || RE_RGBA_PCT.test(s) || RE_HSL.test(s) || RE_HSLA.test(s);
    };
    var css2rgb_1 = css2rgb$1;
    var chroma$i = chroma_1;
    var Color$B = Color_1;
    var input$e = input$h;
    var type$k = utils.type;
    var rgb2css = rgb2css_1;
    var css2rgb = css2rgb_1;
    Color$B.prototype.css = function(mode) {
        return rgb2css(this._rgb, mode);
    };
    chroma$i.css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$B, [
            null
        ].concat(args, [
            "css"
        ])));
    };
    input$e.format.css = css2rgb;
    input$e.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$k(h) === "string" && css2rgb.test(h)) return "css";
        }
    });
    var Color$A = Color_1;
    var chroma$h = chroma_1;
    var input$d = input$h;
    var unpack$t = utils.unpack;
    input$d.format.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$t(args, "rgba");
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };
    chroma$h.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$A, [
            null
        ].concat(args, [
            "gl"
        ])));
    };
    Color$A.prototype.gl = function() {
        var rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    var unpack$s = utils.unpack;
    var rgb2hcg$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$s(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    var rgb2hcg_1 = rgb2hcg$1;
    var unpack$r = utils.unpack;
    var floor$3 = Math.floor;
    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */ var hcg2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$r(args, "hcg");
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r, g, b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$3(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$q = utils.unpack;
    var type$j = utils.type;
    var chroma$g = chroma_1;
    var Color$z = Color_1;
    var input$c = input$h;
    var rgb2hcg = rgb2hcg_1;
    Color$z.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    chroma$g.hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$z, [
            null
        ].concat(args, [
            "hcg"
        ])));
    };
    input$c.format.hcg = hcg2rgb_1;
    input$c.autodetect.push({
        p: 1,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$q(args, "hcg");
            if (type$j(args) === "array" && args.length === 3) return "hcg";
        }
    });
    var unpack$p = utils.unpack;
    var last = utils.last;
    var round$3 = Math.round;
    var rgb2hex$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$p(args, "rgba");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last(args) || "auto";
        if (a === undefined) a = 1;
        if (mode === "auto") mode = a < 1 ? "rgba" : "rgb";
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = "0" + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch(mode.toLowerCase()){
            case "rgba":
                return "#" + str + hxa;
            case "argb":
                return "#" + hxa + str;
            default:
                return "#" + str;
        }
    };
    var rgb2hex_1 = rgb2hex$2;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb$1 = function(hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) // remove optional leading #
            hex = hex.substr(1);
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [
                r$1,
                g$1,
                b$1,
                a
            ];
        }
        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb
        throw new Error("unknown hex color: " + hex);
    };
    var hex2rgb_1 = hex2rgb$1;
    var chroma$f = chroma_1;
    var Color$y = Color_1;
    var type$i = utils.type;
    var input$b = input$h;
    var rgb2hex$1 = rgb2hex_1;
    Color$y.prototype.hex = function(mode) {
        return rgb2hex$1(this._rgb, mode);
    };
    chroma$f.hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$y, [
            null
        ].concat(args, [
            "hex"
        ])));
    };
    input$b.format.hex = hex2rgb_1;
    input$b.autodetect.push({
        p: 4,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$i(h) === "string" && [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ].indexOf(h.length) >= 0) return "hex";
        }
    });
    var unpack$o = utils.unpack;
    var TWOPI$2 = utils.TWOPI;
    var min$2 = Math.min;
    var sqrt$4 = Math.sqrt;
    var acos = Math.acos;
    var rgb2hsi$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */ var ref = unpack$o(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min$2(r, g, b);
        var i = (r + g + b) / 3;
        var s = i > 0 ? 1 - min_ / i : 0;
        if (s === 0) h = NaN;
        else {
            h = (r - g + (r - b)) / 2;
            h /= sqrt$4((r - g) * (r - g) + (r - b) * (g - b));
            h = acos(h);
            if (b > g) h = TWOPI$2 - h;
            h /= TWOPI$2;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    var rgb2hsi_1 = rgb2hsi$1;
    var unpack$n = utils.unpack;
    var limit = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos$4 = Math.cos;
    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */ var hsi2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */ args = unpack$n(args, "hsi");
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r, g, b;
        if (isNaN(h)) h = 0;
        if (isNaN(s)) s = 0;
        // normalize hue
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$m = utils.unpack;
    var type$h = utils.type;
    var chroma$e = chroma_1;
    var Color$x = Color_1;
    var input$a = input$h;
    var rgb2hsi = rgb2hsi_1;
    Color$x.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    chroma$e.hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$x, [
            null
        ].concat(args, [
            "hsi"
        ])));
    };
    input$a.format.hsi = hsi2rgb_1;
    input$a.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$m(args, "hsi");
            if (type$h(args) === "array" && args.length === 3) return "hsi";
        }
    });
    var unpack$l = utils.unpack;
    var type$g = utils.type;
    var chroma$d = chroma_1;
    var Color$w = Color_1;
    var input$9 = input$h;
    var rgb2hsl$1 = rgb2hsl_1;
    Color$w.prototype.hsl = function() {
        return rgb2hsl$1(this._rgb);
    };
    chroma$d.hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$w, [
            null
        ].concat(args, [
            "hsl"
        ])));
    };
    input$9.format.hsl = hsl2rgb_1;
    input$9.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$l(args, "hsl");
            if (type$g(args) === "array" && args.length === 3) return "hsl";
        }
    });
    var unpack$k = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;
    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */ var rgb2hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$k(args, "rgb");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h, s, v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) h = (g - b) / delta;
            if (g === max_) h = 2 + (b - r) / delta;
            if (b === max_) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    var rgb2hsv$1 = rgb2hsl;
    var unpack$j = utils.unpack;
    var floor$2 = Math.floor;
    var hsv2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$j(args, "hsv");
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r, g, b;
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$2(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$i = utils.unpack;
    var type$f = utils.type;
    var chroma$c = chroma_1;
    var Color$v = Color_1;
    var input$8 = input$h;
    var rgb2hsv = rgb2hsv$1;
    Color$v.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    chroma$c.hsv = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$v, [
            null
        ].concat(args, [
            "hsv"
        ])));
    };
    input$8.format.hsv = hsv2rgb_1;
    input$8.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$i(args, "hsv");
            if (type$f(args) === "array" && args.length === 3) return "hsv";
        }
    });
    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,
        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    var LAB_CONSTANTS$3 = labConstants;
    var unpack$h = utils.unpack;
    var pow$a = Math.pow;
    var rgb2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$h(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r, g, b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [
            l < 0 ? 0 : l,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    var rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        return pow$a((r + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t) {
        if (t > LAB_CONSTANTS$3.t3) return pow$a(t, 1 / 3);
        return t / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
    };
    var rgb2xyz = function(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS$3.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
        return [
            x,
            y,
            z
        ];
    };
    var rgb2lab_1 = rgb2lab$2;
    var LAB_CONSTANTS$2 = labConstants;
    var unpack$g = utils.unpack;
    var pow$9 = Math.pow;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var lab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$g(args, "lab");
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x, y, z, r, g, b_;
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS$2.Yn * lab_xyz(y);
        x = LAB_CONSTANTS$2.Xn * lab_xyz(x);
        z = LAB_CONSTANTS$2.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b_,
            args.length > 3 ? args[3] : 1
        ];
    };
    var xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$9(r, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t) {
        return t > LAB_CONSTANTS$2.t1 ? t * t * t : LAB_CONSTANTS$2.t2 * (t - LAB_CONSTANTS$2.t0);
    };
    var lab2rgb_1 = lab2rgb$1;
    var unpack$f = utils.unpack;
    var type$e = utils.type;
    var chroma$b = chroma_1;
    var Color$u = Color_1;
    var input$7 = input$h;
    var rgb2lab$1 = rgb2lab_1;
    Color$u.prototype.lab = function() {
        return rgb2lab$1(this._rgb);
    };
    chroma$b.lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$u, [
            null
        ].concat(args, [
            "lab"
        ])));
    };
    input$7.format.lab = lab2rgb_1;
    input$7.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$f(args, "lab");
            if (type$e(args) === "array" && args.length === 3) return "lab";
        }
    });
    var unpack$e = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$3 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var round$2 = Math.round;
    var lab2lch$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$e(args, "lab");
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$3(a * a + b * b);
        var h = (atan2$2(b, a) * RAD2DEG + 360) % 360;
        if (round$2(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    var lab2lch_1 = lab2lch$2;
    var unpack$d = utils.unpack;
    var rgb2lab = rgb2lab_1;
    var lab2lch$1 = lab2lch_1;
    var rgb2lch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$d(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch$1(l, a, b_);
    };
    var rgb2lch_1 = rgb2lch$1;
    var unpack$c = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin$3 = Math.sin;
    var cos$3 = Math.cos;
    var lch2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */ var ref = unpack$c(args, "lch");
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) h = 0;
        h = h * DEG2RAD;
        return [
            l,
            cos$3(h) * c,
            sin$3(h) * c
        ];
    };
    var lch2lab_1 = lch2lab$2;
    var unpack$b = utils.unpack;
    var lch2lab$1 = lch2lab_1;
    var lab2rgb = lab2rgb_1;
    var lch2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$b(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab$1(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var lch2rgb_1 = lch2rgb$1;
    var unpack$a = utils.unpack;
    var lch2rgb = lch2rgb_1;
    var hcl2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hcl = unpack$a(args, "hcl").reverse();
        return lch2rgb.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$9 = utils.unpack;
    var type$d = utils.type;
    var chroma$a = chroma_1;
    var Color$t = Color_1;
    var input$6 = input$h;
    var rgb2lch = rgb2lch_1;
    Color$t.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color$t.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    chroma$a.lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "lch"
        ])));
    };
    chroma$a.hcl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "hcl"
        ])));
    };
    input$6.format.lch = lch2rgb_1;
    input$6.format.hcl = hcl2rgb_1;
    [
        "lch",
        "hcl"
    ].forEach(function(m) {
        return input$6.autodetect.push({
            p: 2,
            test: function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                args = unpack$9(args, m);
                if (type$d(args) === "array" && args.length === 3) return m;
            }
        });
    });
    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */ var w3cx11$1 = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    };
    var w3cx11_1 = w3cx11$1;
    var Color$s = Color_1;
    var input$5 = input$h;
    var type$c = utils.type;
    var w3cx11 = w3cx11_1;
    var hex2rgb = hex2rgb_1;
    var rgb2hex = rgb2hex_1;
    Color$s.prototype.name = function() {
        var hex = rgb2hex(this._rgb, "rgb");
        for(var i = 0, list = Object.keys(w3cx11); i < list.length; i += 1){
            var n = list[i];
            if (w3cx11[n] === hex) return n.toLowerCase();
        }
        return hex;
    };
    input$5.format.named = function(name) {
        name = name.toLowerCase();
        if (w3cx11[name]) return hex2rgb(w3cx11[name]);
        throw new Error("unknown color name: " + name);
    };
    input$5.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$c(h) === "string" && w3cx11[h.toLowerCase()]) return "named";
        }
    });
    var unpack$8 = utils.unpack;
    var rgb2num$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$8(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num$1;
    var type$b = utils.type;
    var num2rgb = function(num) {
        if (type$b(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = num >> 8 & 0xFF;
            var b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        throw new Error("unknown num color: " + num);
    };
    var num2rgb_1 = num2rgb;
    var chroma$9 = chroma_1;
    var Color$r = Color_1;
    var input$4 = input$h;
    var type$a = utils.type;
    var rgb2num = rgb2num_1;
    Color$r.prototype.num = function() {
        return rgb2num(this._rgb);
    };
    chroma$9.num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$r, [
            null
        ].concat(args, [
            "num"
        ])));
    };
    input$4.format.num = num2rgb_1;
    input$4.autodetect.push({
        p: 5,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            if (args.length === 1 && type$a(args[0]) === "number" && args[0] >= 0 && args[0] <= 0xFFFFFF) return "num";
        }
    });
    var chroma$8 = chroma_1;
    var Color$q = Color_1;
    var input$3 = input$h;
    var unpack$7 = utils.unpack;
    var type$9 = utils.type;
    var round$1 = Math.round;
    Color$q.prototype.rgb = function(rnd) {
        if (rnd === void 0) rnd = true;
        if (rnd === false) return this._rgb.slice(0, 3);
        return this._rgb.slice(0, 3).map(round$1);
    };
    Color$q.prototype.rgba = function(rnd) {
        if (rnd === void 0) rnd = true;
        return this._rgb.slice(0, 4).map(function(v, i) {
            return i < 3 ? rnd === false ? v : round$1(v) : v;
        });
    };
    chroma$8.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$q, [
            null
        ].concat(args, [
            "rgb"
        ])));
    };
    input$3.format.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$7(args, "rgba");
        if (rgba[3] === undefined) rgba[3] = 1;
        return rgba;
    };
    input$3.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$7(args, "rgba");
            if (type$9(args) === "array" && (args.length === 3 || args.length === 4 && type$9(args[3]) == "number" && args[3] >= 0 && args[3] <= 1)) return "rgb";
        }
    });
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */ var log$1 = Math.log;
    var temperature2rgb$1 = function(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log$1(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log$1(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log$1(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log$1(g);
            b = 255;
        }
        return [
            r,
            g,
            b,
            1
        ];
    };
    var temperature2rgb_1 = temperature2rgb$1;
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/ var temperature2rgb = temperature2rgb_1;
    var unpack$6 = utils.unpack;
    var round = Math.round;
    var rgb2temperature$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$6(args, "rgb");
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb(temp);
            if (rgb$1[2] / rgb$1[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    var rgb2temperature_1 = rgb2temperature$1;
    var chroma$7 = chroma_1;
    var Color$p = Color_1;
    var input$2 = input$h;
    var rgb2temperature = rgb2temperature_1;
    Color$p.prototype.temp = Color$p.prototype.kelvin = Color$p.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    chroma$7.temp = chroma$7.kelvin = chroma$7.temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$p, [
            null
        ].concat(args, [
            "temp"
        ])));
    };
    input$2.format.temp = input$2.format.kelvin = input$2.format.temperature = temperature2rgb_1;
    var unpack$5 = utils.unpack;
    var cbrt = Math.cbrt;
    var pow$8 = Math.pow;
    var sign$1 = Math.sign;
    var rgb2oklab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // OKLab color space implementation taken from
        // https://bottosson.github.io/posts/oklab/
        var ref = unpack$5(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = [
            rgb2lrgb(r / 255),
            rgb2lrgb(g / 255),
            rgb2lrgb(b / 255)
        ];
        var lr = ref$1[0];
        var lg = ref$1[1];
        var lb = ref$1[2];
        var l = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
        var m = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
        var s = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
        return [
            0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
            1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
            0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
        ];
    };
    var rgb2oklab_1 = rgb2oklab$2;
    function rgb2lrgb(c) {
        var abs = Math.abs(c);
        if (abs < 0.04045) return c / 12.92;
        return (sign$1(c) || 1) * pow$8((abs + 0.055) / 1.055, 2.4);
    }
    var unpack$4 = utils.unpack;
    var pow$7 = Math.pow;
    var sign = Math.sign;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var oklab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$4(args, "lab");
        var L = args[0];
        var a = args[1];
        var b = args[2];
        var l = pow$7(L + 0.3963377774 * a + 0.2158037573 * b, 3);
        var m = pow$7(L - 0.1055613458 * a - 0.0638541728 * b, 3);
        var s = pow$7(L - 0.0894841775 * a - 1.291485548 * b, 3);
        return [
            255 * lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
            255 * lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
            255 * lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklab2rgb_1 = oklab2rgb$1;
    function lrgb2rgb(c) {
        var abs = Math.abs(c);
        if (abs > 0.0031308) return (sign(c) || 1) * (1.055 * pow$7(abs, 1 / 2.4) - 0.055);
        return c * 12.92;
    }
    var unpack$3 = utils.unpack;
    var type$8 = utils.type;
    var chroma$6 = chroma_1;
    var Color$o = Color_1;
    var input$1 = input$h;
    var rgb2oklab$1 = rgb2oklab_1;
    Color$o.prototype.oklab = function() {
        return rgb2oklab$1(this._rgb);
    };
    chroma$6.oklab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$o, [
            null
        ].concat(args, [
            "oklab"
        ])));
    };
    input$1.format.oklab = oklab2rgb_1;
    input$1.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$3(args, "oklab");
            if (type$8(args) === "array" && args.length === 3) return "oklab";
        }
    });
    var unpack$2 = utils.unpack;
    var rgb2oklab = rgb2oklab_1;
    var lab2lch = lab2lch_1;
    var rgb2oklch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$2(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2oklab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch(l, a, b_);
    };
    var rgb2oklch_1 = rgb2oklch$1;
    var unpack$1 = utils.unpack;
    var lch2lab = lch2lab_1;
    var oklab2rgb = oklab2rgb_1;
    var oklch2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$1(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = oklab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklch2rgb_1 = oklch2rgb;
    var unpack = utils.unpack;
    var type$7 = utils.type;
    var chroma$5 = chroma_1;
    var Color$n = Color_1;
    var input = input$h;
    var rgb2oklch = rgb2oklch_1;
    Color$n.prototype.oklch = function() {
        return rgb2oklch(this._rgb);
    };
    chroma$5.oklch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$n, [
            null
        ].concat(args, [
            "oklch"
        ])));
    };
    input.format.oklch = oklch2rgb_1;
    input.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack(args, "oklch");
            if (type$7(args) === "array" && args.length === 3) return "oklch";
        }
    });
    var Color$m = Color_1;
    var type$6 = utils.type;
    Color$m.prototype.alpha = function(a, mutate) {
        if (mutate === void 0) mutate = false;
        if (a !== undefined && type$6(a) === "number") {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color$m([
                this._rgb[0],
                this._rgb[1],
                this._rgb[2],
                a
            ], "rgb");
        }
        return this._rgb[3];
    };
    var Color$l = Color_1;
    Color$l.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    var Color$k = Color_1;
    var LAB_CONSTANTS$1 = labConstants;
    Color$k.prototype.darken = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lab = me.lab();
        lab[0] -= LAB_CONSTANTS$1.Kn * amount;
        return new Color$k(lab, "lab").alpha(me.alpha(), true);
    };
    Color$k.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 1;
        return this.darken(-amount);
    };
    Color$k.prototype.darker = Color$k.prototype.darken;
    Color$k.prototype.brighter = Color$k.prototype.brighten;
    var Color$j = Color_1;
    Color$j.prototype.get = function(mc) {
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) return src[i];
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$i = Color_1;
    var type$5 = utils.type;
    var pow$6 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color$i.prototype.luminance = function(lum) {
        if (lum !== undefined && type$5(lum) === "number") {
            if (lum === 0) // return pure black
            return new Color$i([
                0,
                0,
                0,
                this._rgb[3]
            ], "rgb");
            if (lum === 1) // return pure white
            return new Color$i([
                255,
                255,
                255,
                this._rgb[3]
            ], "rgb");
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = "rgb";
            var max_iter = MAX_ITER;
            var test = function(low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) // close enough
                return mid;
                return lm > lum ? test(low, mid) : test(mid, high);
            };
            var rgb = (cur_lum > lum ? test(new Color$i([
                0,
                0,
                0
            ]), this) : test(this, new Color$i([
                255,
                255,
                255
            ]))).rgb();
            return new Color$i(rgb.concat([
                this._rgb[3]
            ]));
        }
        return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r, g, b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x) {
        x /= 255;
        return x <= 0.03928 ? x / 12.92 : pow$6((x + 0.055) / 1.055, 2.4);
    };
    var interpolator$1 = {};
    var Color$h = Color_1;
    var type$4 = utils.type;
    var interpolator = interpolator$1;
    var mix$1 = function(col1, col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 3;
        while(len-- > 0)rest[len] = arguments[len + 3];
        var mode = rest[0] || "lrgb";
        if (!interpolator[mode] && !rest.length) // fall back to the first supported mode
        mode = Object.keys(interpolator)[0];
        if (!interpolator[mode]) throw new Error("interpolation mode " + mode + " is not defined");
        if (type$4(col1) !== "object") col1 = new Color$h(col1);
        if (type$4(col2) !== "object") col2 = new Color$h(col2);
        return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    var Color$g = Color_1;
    var mix = mix$1;
    Color$g.prototype.mix = Color$g.prototype.interpolate = function(col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 2;
        while(len-- > 0)rest[len] = arguments[len + 2];
        return mix.apply(void 0, [
            this,
            col2,
            f
        ].concat(rest));
    };
    var Color$f = Color_1;
    Color$f.prototype.premultiply = function(mutate) {
        if (mutate === void 0) mutate = false;
        var rgb = this._rgb;
        var a = rgb[3];
        if (mutate) {
            this._rgb = [
                rgb[0] * a,
                rgb[1] * a,
                rgb[2] * a,
                a
            ];
            return this;
        } else return new Color$f([
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ], "rgb");
    };
    var Color$e = Color_1;
    var LAB_CONSTANTS = labConstants;
    Color$e.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lch = me.lch();
        lch[1] += LAB_CONSTANTS.Kn * amount;
        if (lch[1] < 0) lch[1] = 0;
        return new Color$e(lch, "lch").alpha(me.alpha(), true);
    };
    Color$e.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 1;
        return this.saturate(-amount);
    };
    var Color$d = Color_1;
    var type$3 = utils.type;
    Color$d.prototype.set = function(mc, value, mutate) {
        if (mutate === void 0) mutate = false;
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) {
                if (type$3(value) == "string") switch(value.charAt(0)){
                    case "+":
                        src[i] += +value;
                        break;
                    case "-":
                        src[i] += +value;
                        break;
                    case "*":
                        src[i] *= +value.substr(1);
                        break;
                    case "/":
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else if (type$3(value) === "number") src[i] = value;
                else throw new Error("unsupported value for Color.set");
                var out = new Color$d(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$c = Color_1;
    var rgb = function(col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color$c(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "rgb");
    };
    // register interpolator
    interpolator$1.rgb = rgb;
    var Color$b = Color_1;
    var sqrt$2 = Math.sqrt;
    var pow$5 = Math.pow;
    var lrgb = function(col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color$b(sqrt$2(pow$5(x1, 2) * (1 - f) + pow$5(x2, 2) * f), sqrt$2(pow$5(y1, 2) * (1 - f) + pow$5(y2, 2) * f), sqrt$2(pow$5(z1, 2) * (1 - f) + pow$5(z2, 2) * f), "rgb");
    };
    // register interpolator
    interpolator$1.lrgb = lrgb;
    var Color$a = Color_1;
    var lab = function(col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color$a(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "lab");
    };
    // register interpolator
    interpolator$1.lab = lab;
    var Color$9 = Color_1;
    var _hsx = function(col1, col2, f, m) {
        var assign, assign$1;
        var xyz0, xyz1;
        if (m === "hsl") {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === "hsv") {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === "hcg") {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === "hsi") {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === "lch" || m === "hcl") {
            m = "hcl";
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        } else if (m === "oklch") {
            xyz0 = col1.oklch().reverse();
            xyz1 = col2.oklch().reverse();
        }
        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === "h" || m === "oklch") {
            assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2];
            assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2];
        }
        var sat, hue, lbv, dh;
        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != "hsv") sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != "hsv") sat = sat1;
        } else hue = Number.NaN;
        if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return m === "oklch" ? new Color$9([
            lbv,
            sat,
            hue
        ], m) : new Color$9([
            hue,
            sat,
            lbv
        ], m);
    };
    var interpolate_hsx$5 = _hsx;
    var lch = function(col1, col2, f) {
        return interpolate_hsx$5(col1, col2, f, "lch");
    };
    // register interpolator
    interpolator$1.lch = lch;
    interpolator$1.hcl = lch;
    var Color$8 = Color_1;
    var num = function(col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color$8(c1 + f * (c2 - c1), "num");
    };
    // register interpolator
    interpolator$1.num = num;
    var interpolate_hsx$4 = _hsx;
    var hcg = function(col1, col2, f) {
        return interpolate_hsx$4(col1, col2, f, "hcg");
    };
    // register interpolator
    interpolator$1.hcg = hcg;
    var interpolate_hsx$3 = _hsx;
    var hsi = function(col1, col2, f) {
        return interpolate_hsx$3(col1, col2, f, "hsi");
    };
    // register interpolator
    interpolator$1.hsi = hsi;
    var interpolate_hsx$2 = _hsx;
    var hsl = function(col1, col2, f) {
        return interpolate_hsx$2(col1, col2, f, "hsl");
    };
    // register interpolator
    interpolator$1.hsl = hsl;
    var interpolate_hsx$1 = _hsx;
    var hsv = function(col1, col2, f) {
        return interpolate_hsx$1(col1, col2, f, "hsv");
    };
    // register interpolator
    interpolator$1.hsv = hsv;
    var Color$7 = Color_1;
    var oklab = function(col1, col2, f) {
        var xyz0 = col1.oklab();
        var xyz1 = col2.oklab();
        return new Color$7(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "oklab");
    };
    // register interpolator
    interpolator$1.oklab = oklab;
    var interpolate_hsx = _hsx;
    var oklch = function(col1, col2, f) {
        return interpolate_hsx(col1, col2, f, "oklch");
    };
    // register interpolator
    interpolator$1.oklch = oklch;
    var Color$6 = Color_1;
    var clip_rgb$1 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$1 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors, mode, weights) {
        if (mode === void 0) mode = "lrgb";
        if (weights === void 0) weights = null;
        var l = colors.length;
        if (!weights) weights = Array.from(new Array(l)).map(function() {
            return 1;
        });
        // normalize weights
        var k = l / weights.reduce(function(a, b) {
            return a + b;
        });
        weights.forEach(function(w, i) {
            weights[i] *= k;
        });
        // convert colors to Color objects
        colors = colors.map(function(c) {
            return new Color$6(c);
        });
        if (mode === "lrgb") return _average_lrgb(colors, weights);
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for(var i = 0; i < xyz.length; i++){
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === "h" && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$2(A) * weights[0];
            }
        }
        var alpha = first.alpha() * weights[0];
        colors.forEach(function(c, ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci + 1];
            for(var i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
                cnt[i] += weights[ci + 1];
                if (mode.charAt(i) === "h") {
                    var A = xyz2[i] / 180 * PI$1;
                    dx += cos$2(A) * weights[ci + 1];
                    dy += sin$2(A) * weights[ci + 1];
                } else xyz[i] += xyz2[i] * weights[ci + 1];
            }
        });
        for(var i$1 = 0; i$1 < xyz.length; i$1++)if (mode.charAt(i$1) === "h") {
            var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
            while(A$1 < 0)A$1 += 360;
            while(A$1 >= 360)A$1 -= 360;
            xyz[i$1] = A$1;
        } else xyz[i$1] = xyz[i$1] / cnt[i$1];
        alpha /= l;
        return new Color$6(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors, weights) {
        var l = colors.length;
        var xyz = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < colors.length; i++){
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0], 2) * f;
            xyz[1] += pow$4(rgb[1], 2) * f;
            xyz[2] += pow$4(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$1(xyz[0]);
        xyz[1] = sqrt$1(xyz[1]);
        xyz[2] = sqrt$1(xyz[2]);
        if (xyz[3] > 0.9999999) xyz[3] = 1;
        return new Color$6(clip_rgb$1(xyz));
    };
    // minimal multi-purpose interface
    // @requires utils color analyze
    var chroma$4 = chroma_1;
    var type$2 = utils.type;
    var pow$3 = Math.pow;
    var scale$2 = function(colors) {
        // constructor
        var _mode = "rgb";
        var _nacol = chroma$4("#ccc");
        var _spread = 0;
        // const _fixed = false;
        var _domain = [
            0,
            1
        ];
        var _pos = [];
        var _padding = [
            0,
            0
        ];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;
        // private methods
        var setColors = function(colors) {
            colors = colors || [
                "#fff",
                "#000"
            ];
            if (colors && type$2(colors) === "string" && chroma$4.brewer && chroma$4.brewer[colors.toLowerCase()]) colors = chroma$4.brewer[colors.toLowerCase()];
            if (type$2(colors) === "array") {
                // handle single color
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for(var c = 0; c < colors.length; c++)colors[c] = chroma$4(colors[c]);
                // auto-fill color position
                _pos.length = 0;
                for(var c$1 = 0; c$1 < colors.length; c$1++)_pos.push(c$1 / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length - 1;
                var i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        var tMapLightness = function(t) {
            return t;
        };
        var tMapDomain = function(t) {
            return t;
        };
        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };
        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) // just interpolate between min/max
                t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            // domain map
            t = tMapDomain(t);
            if (!bypassMap) t = tMapLightness(t); // lightness correction
            if (_gamma !== 1) t = pow$3(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            var k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type$2(_colors) === "array") //for i in [0.._pos.length-1]
                for(var i = 0; i < _pos.length; i++){
                    var p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma$4.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type$2(_colors) === "function") col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        var resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        // public interface
        var f = function(v) {
            var c = chroma$4(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            if (classes != null) {
                if (type$2(classes) === "array") {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    var d = chroma$4.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma$4.limits(d, "e", classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            var k = _colors.length;
            if (domain.length === k && _min !== _max) // update positions
            for(var i = 0, list = Array.from(domain); i < list.length; i += 1){
                var d = list[i];
                _pos.push((d - _min) / (_max - _min));
            }
            else {
                for(var c = 0; c < k; c++)_pos.push(c / (k - 1));
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function(d, i) {
                        return i / (domain.length - 1);
                    });
                    var tBreaks = domain.map(function(d) {
                        return (d - _min) / (_max - _min);
                    });
                    if (!tBreaks.every(function(val, i) {
                        return tOut[i] === val;
                    })) tMapDomain = function(t) {
                        if (t <= 0 || t >= 1) return t;
                        var i = 0;
                        while(t >= tBreaks[i + 1])i++;
                        var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                        var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                        return out;
                    };
                }
            }
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tMapLightness = function(t) {
                var L0 = getColor(0, true).lab()[0];
                var L1 = getColor(1, true).lab()[0];
                var pol = L0 > L1;
                var L_actual = getColor(t, true).lab()[0];
                var L_ideal = L0 + (L1 - L0) * t;
                var L_diff = L_actual - L_ideal;
                var t0 = 0;
                var t1 = 1;
                var max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tMapLightness = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type$2(p) === "number") p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) out = "hex";
            var result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                var samples = [];
                if (_classes && _classes.length > 2) for(var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma$4[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma$4(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
        return range;
    }
    //
    // interpolates between a set of colors uzing a bezier spline
    //
    // @requires utils lab
    var Color$5 = Color_1;
    var scale$1 = scale$2;
    // nth row of the pascal triangle
    var binom_row = function(n) {
        var row = [
            1,
            1
        ];
        for(var i = 1; i < n; i++){
            var newrow = [
                1
            ];
            for(var j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
            row = newrow;
        }
        return row;
    };
    var bezier = function(colors) {
        var assign, assign$1, assign$2;
        var I, lab0, lab1, lab2;
        colors = colors.map(function(c) {
            return new Color$5(c);
        });
        if (colors.length === 2) {
            // linear interpolation
            assign = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign[0], lab1 = assign[1];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return lab0[i] + t * (lab1[i] - lab0[i]);
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            assign$1 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            assign$2 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length >= 5) {
            // general case (degree n bezier)
            var labs, row, n;
            labs = colors.map(function(c) {
                return c.lab();
            });
            n = colors.length - 1;
            row = binom_row(n);
            I = function(t) {
                var u = 1 - t;
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return labs.reduce(function(sum, el, j) {
                        return sum + row[j] * Math.pow(u, n - j) * Math.pow(t, j) * el[i];
                    }, 0);
                });
                return new Color$5(lab, "lab");
            };
        } else throw new RangeError("No point in running bezier with only one color.");
        return I;
    };
    var bezier_1 = function(colors) {
        var f = bezier(colors);
        f.scale = function() {
            return scale$1(f);
        };
        return f;
    };
    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */ var chroma$3 = chroma_1;
    var blend = function(bottom, top, mode) {
        if (!blend[mode]) throw new Error("unknown blend mode " + mode);
        return blend[mode](bottom, top);
    };
    var blend_f = function(f) {
        return function(bottom, top) {
            var c0 = chroma$3(top).rgb();
            var c1 = chroma$3(bottom).rgb();
            return chroma$3.rgb(f(c0, c1));
        };
    };
    var each = function(f) {
        return function(c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        };
    };
    var normal = function(a) {
        return a;
    };
    var multiply = function(a, b) {
        return a * b / 255;
    };
    var darken = function(a, b) {
        return a > b ? b : a;
    };
    var lighten = function(a, b) {
        return a > b ? a : b;
    };
    var screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    var overlay = function(a, b) {
        return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    var burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    var dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a;
    };
    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));
    var blend_1 = blend;
    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf
    var type$1 = utils.type;
    var clip_rgb = utils.clip_rgb;
    var TWOPI = utils.TWOPI;
    var pow$2 = Math.pow;
    var sin$1 = Math.sin;
    var cos$1 = Math.cos;
    var chroma$2 = chroma_1;
    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if (start === void 0) start = 300;
        if (rotations === void 0) rotations = -1.5;
        if (hue === void 0) hue = 1;
        if (gamma === void 0) gamma = 1;
        if (lightness === void 0) lightness = [
            0,
            1
        ];
        var dh = 0, dl;
        if (type$1(lightness) === "array") dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        var f = function(fract) {
            var a = TWOPI * ((start + 120) / 360 + rotations * fract);
            var l = pow$2(lightness[0] + dl * fract, gamma);
            var h = dh !== 0 ? hue[0] + fract * dh : hue;
            var amp = h * l * (1 - l) / 2;
            var cos_a = cos$1(a);
            var sin_a = sin$1(a);
            var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            var b = l + amp * (1.97294 * cos_a);
            return chroma$2(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type$1(hue) === "array") {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type$1(h) === "array") {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma$2.scale(f);
        };
        f.hue(hue);
        return f;
    };
    var Color$4 = Color_1;
    var digits = "0123456789abcdef";
    var floor$1 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
        var code = "#";
        for(var i = 0; i < 6; i++)code += digits.charAt(floor$1(random() * 16));
        return new Color$4(code, "hex");
    };
    var type = type$p;
    var log = Math.log;
    var pow$1 = Math.pow;
    var floor = Math.floor;
    var abs$1 = Math.abs;
    var analyze = function(data, key) {
        if (key === void 0) key = null;
        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === "object") data = Object.values(data);
        data.forEach(function(val) {
            if (key && type(val) === "object") val = val[key];
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        });
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return limits(r, mode, num);
        };
        return r;
    };
    var limits = function(data, mode, num) {
        if (mode === void 0) mode = "equal";
        if (num === void 0) num = 7;
        if (type(data) == "array") data = analyze(data);
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        var limits = [];
        if (mode.substr(0, 1) === "c") {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === "e") {
            limits.push(min);
            for(var i = 1; i < num; i++)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === "l") {
            if (min <= 0) throw new Error("Logarithmic scales are only possible for values > 0");
            var min_log = Math.LOG10E * log(min);
            var max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(var i$1 = 1; i$1 < num; i$1++)limits.push(pow$1(10, min_log + i$1 / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === "q") {
            limits.push(min);
            for(var i$2 = 1; i$2 < num; i$2++){
                var p = (values.length - 1) * i$2 / num;
                var pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    var pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === "k") {
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */ var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;
            // get seed values
            centroids = [];
            centroids.push(min);
            for(var i$3 = 1; i$3 < num; i$3++)centroids.push(min + i$3 / num * (max - min));
            centroids.push(max);
            while(repeat){
                // assignment step
                for(var j = 0; j < num; j++)clusterSizes[j] = 0;
                for(var i$4 = 0; i$4 < n; i$4++){
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = void 0;
                    for(var j$1 = 0; j$1 < num; j$1++){
                        var dist = abs$1(centroids[j$1] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }
                // update centroids step
                var newCentroids = new Array(num);
                for(var j$2 = 0; j$2 < num; j$2++)newCentroids[j$2] = null;
                for(var i$5 = 0; i$5 < n; i$5++){
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i$5];
                    else newCentroids[cluster] += values[i$5];
                }
                for(var j$3 = 0; j$3 < num; j$3++)newCentroids[j$3] *= 1 / clusterSizes[j$3];
                // check convergence
                repeat = false;
                for(var j$4 = 0; j$4 < num; j$4++)if (newCentroids[j$4] !== centroids[j$4]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for(var j$5 = 0; j$5 < num; j$5++)kClusters[j$5] = [];
            for(var i$6 = 0; i$6 < n; i$6++){
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for(var j$6 = 0; j$6 < num; j$6++){
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2){
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    var analyze_1 = {
        analyze: analyze,
        limits: limits
    };
    var Color$3 = Color_1;
    var contrast = function(a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color$3(a);
        b = new Color$3(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var Color$2 = Color_1;
    var sqrt = Math.sqrt;
    var pow = Math.pow;
    var min = Math.min;
    var max = Math.max;
    var atan2 = Math.atan2;
    var abs = Math.abs;
    var cos = Math.cos;
    var sin = Math.sin;
    var exp = Math.exp;
    var PI = Math.PI;
    var deltaE = function(a, b, Kl, Kc, Kh) {
        if (Kl === void 0) Kl = 1;
        if (Kc === void 0) Kc = 1;
        if (Kh === void 0) Kh = 1;
        // Delta E (CIE 2000)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
        var rad2deg = function(rad) {
            return 360 * rad / (2 * PI);
        };
        var deg2rad = function(deg) {
            return 2 * PI * deg / 360;
        };
        a = new Color$2(a);
        b = new Color$2(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var avgL = (L1 + L2) / 2;
        var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
        var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
        var avgC = (C1 + C2) / 2;
        var G = 0.5 * (1 - sqrt(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
        var a1p = a1 * (1 + G);
        var a2p = a2 * (1 + G);
        var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
        var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
        var avgCp = (C1p + C2p) / 2;
        var arctan1 = rad2deg(atan2(b1, a1p));
        var arctan2 = rad2deg(atan2(b2, a2p));
        var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
        var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
        var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
        var T = 1 - 0.17 * cos(deg2rad(avgHp - 30)) + 0.24 * cos(deg2rad(2 * avgHp)) + 0.32 * cos(deg2rad(3 * avgHp + 6)) - 0.2 * cos(deg2rad(4 * avgHp - 63));
        var deltaHp = h2p - h1p;
        deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
        deltaHp = 2 * sqrt(C1p * C2p) * sin(deg2rad(deltaHp) / 2);
        var deltaL = L2 - L1;
        var deltaCp = C2p - C1p;
        var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt(20 + pow(avgL - 50, 2));
        var sc = 1 + 0.045 * avgCp;
        var sh = 1 + 0.015 * avgCp * T;
        var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
        var Rc = 2 * sqrt(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
        var Rt = -Rc * sin(2 * deg2rad(deltaTheta));
        var result = sqrt(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
        return max(0, min(100, result));
    };
    var Color$1 = Color_1;
    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if (mode === void 0) mode = "lab";
        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color$1(a);
        b = new Color$1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for(var i in l1){
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    var Color = Color_1;
    var valid = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        try {
            new (Function.prototype.bind.apply(Color, [
                null
            ].concat(args)));
            return true;
        } catch (e) {
            return false;
        }
    };
    // some pre-defined color scales:
    var chroma$1 = chroma_1;
    var scale = scale$2;
    var scales = {
        cool: function cool() {
            return scale([
                chroma$1.hsl(180, 1, .9),
                chroma$1.hsl(250, .7, .4)
            ]);
        },
        hot: function hot() {
            return scale([
                "#000",
                "#f00",
                "#ff0",
                "#fff"
            ]).mode("rgb");
        }
    };
    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */ var colorbrewer = {
        // sequential
        OrRd: [
            "#fff7ec",
            "#fee8c8",
            "#fdd49e",
            "#fdbb84",
            "#fc8d59",
            "#ef6548",
            "#d7301f",
            "#b30000",
            "#7f0000"
        ],
        PuBu: [
            "#fff7fb",
            "#ece7f2",
            "#d0d1e6",
            "#a6bddb",
            "#74a9cf",
            "#3690c0",
            "#0570b0",
            "#045a8d",
            "#023858"
        ],
        BuPu: [
            "#f7fcfd",
            "#e0ecf4",
            "#bfd3e6",
            "#9ebcda",
            "#8c96c6",
            "#8c6bb1",
            "#88419d",
            "#810f7c",
            "#4d004b"
        ],
        Oranges: [
            "#fff5eb",
            "#fee6ce",
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#f16913",
            "#d94801",
            "#a63603",
            "#7f2704"
        ],
        BuGn: [
            "#f7fcfd",
            "#e5f5f9",
            "#ccece6",
            "#99d8c9",
            "#66c2a4",
            "#41ae76",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlOrBr: [
            "#ffffe5",
            "#fff7bc",
            "#fee391",
            "#fec44f",
            "#fe9929",
            "#ec7014",
            "#cc4c02",
            "#993404",
            "#662506"
        ],
        YlGn: [
            "#ffffe5",
            "#f7fcb9",
            "#d9f0a3",
            "#addd8e",
            "#78c679",
            "#41ab5d",
            "#238443",
            "#006837",
            "#004529"
        ],
        Reds: [
            "#fff5f0",
            "#fee0d2",
            "#fcbba1",
            "#fc9272",
            "#fb6a4a",
            "#ef3b2c",
            "#cb181d",
            "#a50f15",
            "#67000d"
        ],
        RdPu: [
            "#fff7f3",
            "#fde0dd",
            "#fcc5c0",
            "#fa9fb5",
            "#f768a1",
            "#dd3497",
            "#ae017e",
            "#7a0177",
            "#49006a"
        ],
        Greens: [
            "#f7fcf5",
            "#e5f5e0",
            "#c7e9c0",
            "#a1d99b",
            "#74c476",
            "#41ab5d",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlGnBu: [
            "#ffffd9",
            "#edf8b1",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#1d91c0",
            "#225ea8",
            "#253494",
            "#081d58"
        ],
        Purples: [
            "#fcfbfd",
            "#efedf5",
            "#dadaeb",
            "#bcbddc",
            "#9e9ac8",
            "#807dba",
            "#6a51a3",
            "#54278f",
            "#3f007d"
        ],
        GnBu: [
            "#f7fcf0",
            "#e0f3db",
            "#ccebc5",
            "#a8ddb5",
            "#7bccc4",
            "#4eb3d3",
            "#2b8cbe",
            "#0868ac",
            "#084081"
        ],
        Greys: [
            "#ffffff",
            "#f0f0f0",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#737373",
            "#525252",
            "#252525",
            "#000000"
        ],
        YlOrRd: [
            "#ffffcc",
            "#ffeda0",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#fc4e2a",
            "#e31a1c",
            "#bd0026",
            "#800026"
        ],
        PuRd: [
            "#f7f4f9",
            "#e7e1ef",
            "#d4b9da",
            "#c994c7",
            "#df65b0",
            "#e7298a",
            "#ce1256",
            "#980043",
            "#67001f"
        ],
        Blues: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6",
            "#2171b5",
            "#08519c",
            "#08306b"
        ],
        PuBuGn: [
            "#fff7fb",
            "#ece2f0",
            "#d0d1e6",
            "#a6bddb",
            "#67a9cf",
            "#3690c0",
            "#02818a",
            "#016c59",
            "#014636"
        ],
        Viridis: [
            "#440154",
            "#482777",
            "#3f4a8a",
            "#31678e",
            "#26838f",
            "#1f9d8a",
            "#6cce5a",
            "#b6de2b",
            "#fee825"
        ],
        // diverging
        Spectral: [
            "#9e0142",
            "#d53e4f",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#e6f598",
            "#abdda4",
            "#66c2a5",
            "#3288bd",
            "#5e4fa2"
        ],
        RdYlGn: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#d9ef8b",
            "#a6d96a",
            "#66bd63",
            "#1a9850",
            "#006837"
        ],
        RdBu: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#f7f7f7",
            "#d1e5f0",
            "#92c5de",
            "#4393c3",
            "#2166ac",
            "#053061"
        ],
        PiYG: [
            "#8e0152",
            "#c51b7d",
            "#de77ae",
            "#f1b6da",
            "#fde0ef",
            "#f7f7f7",
            "#e6f5d0",
            "#b8e186",
            "#7fbc41",
            "#4d9221",
            "#276419"
        ],
        PRGn: [
            "#40004b",
            "#762a83",
            "#9970ab",
            "#c2a5cf",
            "#e7d4e8",
            "#f7f7f7",
            "#d9f0d3",
            "#a6dba0",
            "#5aae61",
            "#1b7837",
            "#00441b"
        ],
        RdYlBu: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee090",
            "#ffffbf",
            "#e0f3f8",
            "#abd9e9",
            "#74add1",
            "#4575b4",
            "#313695"
        ],
        BrBG: [
            "#543005",
            "#8c510a",
            "#bf812d",
            "#dfc27d",
            "#f6e8c3",
            "#f5f5f5",
            "#c7eae5",
            "#80cdc1",
            "#35978f",
            "#01665e",
            "#003c30"
        ],
        RdGy: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#ffffff",
            "#e0e0e0",
            "#bababa",
            "#878787",
            "#4d4d4d",
            "#1a1a1a"
        ],
        PuOr: [
            "#7f3b08",
            "#b35806",
            "#e08214",
            "#fdb863",
            "#fee0b6",
            "#f7f7f7",
            "#d8daeb",
            "#b2abd2",
            "#8073ac",
            "#542788",
            "#2d004b"
        ],
        // qualitative
        Set2: [
            "#66c2a5",
            "#fc8d62",
            "#8da0cb",
            "#e78ac3",
            "#a6d854",
            "#ffd92f",
            "#e5c494",
            "#b3b3b3"
        ],
        Accent: [
            "#7fc97f",
            "#beaed4",
            "#fdc086",
            "#ffff99",
            "#386cb0",
            "#f0027f",
            "#bf5b17",
            "#666666"
        ],
        Set1: [
            "#e41a1c",
            "#377eb8",
            "#4daf4a",
            "#984ea3",
            "#ff7f00",
            "#ffff33",
            "#a65628",
            "#f781bf",
            "#999999"
        ],
        Set3: [
            "#8dd3c7",
            "#ffffb3",
            "#bebada",
            "#fb8072",
            "#80b1d3",
            "#fdb462",
            "#b3de69",
            "#fccde5",
            "#d9d9d9",
            "#bc80bd",
            "#ccebc5",
            "#ffed6f"
        ],
        Dark2: [
            "#1b9e77",
            "#d95f02",
            "#7570b3",
            "#e7298a",
            "#66a61e",
            "#e6ab02",
            "#a6761d",
            "#666666"
        ],
        Paired: [
            "#a6cee3",
            "#1f78b4",
            "#b2df8a",
            "#33a02c",
            "#fb9a99",
            "#e31a1c",
            "#fdbf6f",
            "#ff7f00",
            "#cab2d6",
            "#6a3d9a",
            "#ffff99",
            "#b15928"
        ],
        Pastel2: [
            "#b3e2cd",
            "#fdcdac",
            "#cbd5e8",
            "#f4cae4",
            "#e6f5c9",
            "#fff2ae",
            "#f1e2cc",
            "#cccccc"
        ],
        Pastel1: [
            "#fbb4ae",
            "#b3cde3",
            "#ccebc5",
            "#decbe4",
            "#fed9a6",
            "#ffffcc",
            "#e5d8bd",
            "#fddaec",
            "#f2f2f2"
        ]
    };
    // add lowercase aliases for case-insensitive matches
    for(var i = 0, list = Object.keys(colorbrewer); i < list.length; i += 1){
        var key = list[i];
        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    var chroma = chroma_1;
    // feel free to comment out anything to rollup
    // a smaller chroma.js built
    // io --> convert colors
    // operators --> modify existing Colors
    // interpolators
    // generators -- > create new colors
    chroma.average = average;
    chroma.bezier = bezier_1;
    chroma.blend = blend_1;
    chroma.cubehelix = cubehelix;
    chroma.mix = chroma.interpolate = mix$1;
    chroma.random = random_1;
    chroma.scale = scale$2;
    // other utility methods
    chroma.analyze = analyze_1.analyze;
    chroma.contrast = contrast;
    chroma.deltaE = deltaE;
    chroma.distance = distance;
    chroma.limits = analyze_1.limits;
    chroma.valid = valid;
    // scale
    chroma.scales = scales;
    // colors
    chroma.colors = w3cx11_1;
    chroma.brewer = colorbrewer_1;
    var chroma_js = chroma;
    return chroma_js;
});

});

parcelRegister("dkhsa", function(module, exports) {

$parcel$export(module.exports, "ProductPrice", function () { return (parcelRequire("bf1Az")).ProductPrice; });

var $bf1Az = parcelRequire("bf1Az");

});
parcelRegister("bf1Az", function(module, exports) {

$parcel$export(module.exports, "ProductPrice", function () { return $b8db4e404b64920d$export$2ce953db205a18d3; });

var $drmv2 = parcelRequire("drmv2");

var $biy3n = parcelRequire("biy3n");

var $9Sqzr = parcelRequire("9Sqzr");

var $8pqQQ = parcelRequire("8pqQQ");

var $7mAg3 = parcelRequire("7mAg3");
const $b8db4e404b64920d$export$2ce953db205a18d3 = ({ product: product, currency: currency, className: className, forceWishlist: forceWishlist, ...props })=>{
    const { b2b: b2b, visual_percentage_off_tab: visual_percentage_off_tab } = (0, $7mAg3.usePLPContext)();
    const isSupplement = product.tags.some((tag)=>tag.toLowerCase().includes("all products: supplements")); //Check if Supplement Product
    let enableVisualDiscount = false;
    if (visual_percentage_off_tab) enableVisualDiscount = true;
    else if (window?.sale != null && window?.sale > 0 && window?.sale_tag != null && !window?.B2B) enableVisualDiscount = product.tags.some((tag)=>tag.toLowerCase().includes(window?.sale_tag)); //Check if Product has window sale tag
    else if (window?.sale != null && window?.sale > 0 && !window?.B2B) enableVisualDiscount = true;
    const isGiftCard = product.product_type == "Gift Cards";
    // const visualPercentageApplies = product.compare_at_price == 0 
    //   ?
    //     false
    //     window?.sale > 0 && enableVisualDiscount == true
    //     ? 
    //       true 
    //     : 
    //       false
    //   :
    //     Math.round( (1 - product.price / product.compare_at_price) * 100 ) < window?.sale
    //   ;
    const visualPercentageApplies = b2b ? true : product.compare_at_price == 0 && enableVisualDiscount;
    // const salePercentage = !visualPercentageApplies ? Math.round( (1 - product.price / product.compare_at_price) * 100 ) : Math.round( window?.sale/100 * 100 );
    const salePercentage = !visualPercentageApplies ? Math.round((1 - product.price / product.compare_at_price) * 100) : b2b ? b2b == "facets.On_b2b_mode2" || b2b == "facets.On_b2b_mode3" ? Math.round(40) : Math.round(50) : Math.round(window?.sale / 100 * 100);
    const onSale = visualPercentageApplies ? true : product.price < product.compare_at_price;
    const noCompare = visualPercentageApplies ? isGiftCard ? true : false : !product.price_varies && product.compare_at_price_varies;
    // const current_compare_at_price = isSupplement && product.compare_at_price == 0 ? product.price : product.compare_at_price
    // const current_price = isSupplement && product.compare_at_price == 0 ? product.price * 0.8 : product.price
    // const salePercentage = !visualPercentageApplies
    //   ?  
    //     Math.round( (1 - current_price / current_compare_at_price) * 100 )
    //   :
    //     Math.round( window?.sale/100 * 100 )
    //   ;
    // const onSale = visualPercentageApplies ? true : current_price < current_compare_at_price;
    // const noCompare = visualPercentageApplies ? false : !product.price_varies && product.compare_at_price_varies;
    const formatPrice = (price)=>{
        if (window.default_currency === currency) return price;
        else return window.Currency?.convert(price, window.default_currency, currency);
    };
    // Custom pill for products.
    const saleTag = product.tags.find((tag)=>tag.startsWith("sale:"));
    // const saleTag = 'sale:AP25 - 25% OFF:#9b5de5:#feeb08';
    let saleTagArray = [];
    if (saleTag) saleTagArray = saleTag.split(":");
    const promoBadgeAllowedOnSaleItems = (!onSale || window.productStrings.productPromoBadgeAllowSale) && b2b == "";
    const promoBadgeHasSpecificTag = window.productStrings.productPromoBadgeSpecificTag ? product.tags.some((tag)=>tag.toLowerCase().includes(window.productStrings.productPromoBadgeSpecificTag.toLowerCase())) : true;
    const compare_at_price = visualPercentageApplies ? b2b && product.price < product.compare_at_price ? product.compare_at_price : product.price : product.compare_at_price;
    const product_price = visualPercentageApplies ? (1 - (b2b ? b2b == "facets.On_b2b_mode2" || b2b == "facets.On_b2b_mode3" ? Math.round(40) : Math.round(50) : parseInt(visual_percentage_off_tab) ? parseInt(visual_percentage_off_tab) : window.sale) / 100) * (product.price < product.compare_at_price && b2b ? product.compare_at_price : product.price) : product.price;
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        ...props,
        className: (0, $biy3n.default)($8pqQQ.price + " price ", {
            [$8pqQQ.onSale]: onSale,
            [$8pqQQ.noCompare]: noCompare
        }, className),
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $8pqQQ.regularPrice + " regularPrice",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        className: "visually-hidden visually-hidden--inline",
                        children: window.productStrings.regularPrice
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                        children: [
                            product.price_varies && "From ",
                            formatPrice(product.price)?.toLocaleString(navigator.language, {
                                currency: currency,
                                currencyDisplay: "symbol",
                                style: "currency"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $8pqQQ.salePrice + " salePrice",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        className: "visually-hidden visually-hidden--inline",
                        children: window.productStrings.regularPrice
                    }),
                    (product.compare_at_price != 0 && !enableVisualDiscount || enableVisualDiscount || b2b) && /*#__PURE__*/ (0, $drmv2.jsx)("s", {
                        children: /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                            children: formatPrice(compare_at_price)?.toLocaleString(navigator.language, {
                                currency: currency,
                                currencyDisplay: "symbol",
                                style: "currency"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        className: "visually-hidden visually-hidden--inline",
                        children: window.productStrings.salePrice
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        children: formatPrice(product_price)?.toLocaleString(navigator.language, {
                            currency: currency,
                            currencyDisplay: "symbol",
                            style: "currency"
                        })
                    }),
                    !visual_percentage_off_tab && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                        className: $8pqQQ.saleBadge,
                        "aria-hidden": "true",
                        children: (0, $9Sqzr.formatLocaleString)(window.productStrings.save, {
                            label: window.productStrings.saleText,
                            percentage: salePercentage
                        })
                    })
                ]
            }),
            !isGiftCard && promoBadgeAllowedOnSaleItems && promoBadgeHasSpecificTag && window.productStrings.productPromoBadgeEnable && !visual_percentage_off_tab && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                className: $8pqQQ.saleBadge + ` promoBadge`,
                "aria-hidden": "true",
                style: {
                    backgroundColor: window.productStrings.productPromoBadgeBackgroundColour,
                    color: window.productStrings.productPromoBadgeTextColour
                },
                children: window.productStrings.productPromoBadgeText
            }),
            saleTagArray.length && !visual_percentage_off_tab ? /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                className: $8pqQQ.saleTag,
                style: {
                    backgroundColor: saleTagArray[2],
                    color: saleTagArray[3]
                },
                children: saleTagArray[1]
            }) : /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {}),
            forceWishlist && visual_percentage_off_tab ? /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                className: (0, $biy3n.default)($8pqQQ.promotionBadge, $8pqQQ.saleBadge),
                children: [
                    "Save ",
                    visual_percentage_off_tab,
                    "%"
                ]
            }) : forceWishlist && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                className: (0, $biy3n.default)($8pqQQ.promotionBadge, $8pqQQ.saleBadge),
                children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                    children: window.productStrings.promoText
                })
            })
        ]
    });
};

});
parcelRegister("8pqQQ", function(module, exports) {

$parcel$export(module.exports, "noCompare", function () { return $61f57ca5de44df7e$export$63483a33e9201366; }, function (v) { return $61f57ca5de44df7e$export$63483a33e9201366 = v; });
$parcel$export(module.exports, "onSale", function () { return $61f57ca5de44df7e$export$17e05139018a7da3; }, function (v) { return $61f57ca5de44df7e$export$17e05139018a7da3 = v; });
$parcel$export(module.exports, "price", function () { return $61f57ca5de44df7e$export$321c0b1a406de31f; }, function (v) { return $61f57ca5de44df7e$export$321c0b1a406de31f = v; });
$parcel$export(module.exports, "promotionBadge", function () { return $61f57ca5de44df7e$export$3a2ca04c6f02321f; }, function (v) { return $61f57ca5de44df7e$export$3a2ca04c6f02321f = v; });
$parcel$export(module.exports, "regularPrice", function () { return $61f57ca5de44df7e$export$52311362f17fecfd; }, function (v) { return $61f57ca5de44df7e$export$52311362f17fecfd = v; });
$parcel$export(module.exports, "saleBadge", function () { return $61f57ca5de44df7e$export$c216489e398a758c; }, function (v) { return $61f57ca5de44df7e$export$c216489e398a758c = v; });
$parcel$export(module.exports, "salePrice", function () { return $61f57ca5de44df7e$export$85a28b6b66082880; }, function (v) { return $61f57ca5de44df7e$export$85a28b6b66082880 = v; });
$parcel$export(module.exports, "saleTag", function () { return $61f57ca5de44df7e$export$5e9818ec099e82; }, function (v) { return $61f57ca5de44df7e$export$5e9818ec099e82 = v; });
var $61f57ca5de44df7e$export$37ba693ca40ab124;
var $61f57ca5de44df7e$export$63483a33e9201366;
var $61f57ca5de44df7e$export$17e05139018a7da3;
var $61f57ca5de44df7e$export$321c0b1a406de31f;
var $61f57ca5de44df7e$export$3a2ca04c6f02321f;
var $61f57ca5de44df7e$export$52311362f17fecfd;
var $61f57ca5de44df7e$export$c216489e398a758c;
var $61f57ca5de44df7e$export$85a28b6b66082880;
var $61f57ca5de44df7e$export$5e9818ec099e82;
$61f57ca5de44df7e$export$37ba693ca40ab124 = `X4P9TW_bf40`;
$61f57ca5de44df7e$export$63483a33e9201366 = `X4P9TW_noCompare`;
$61f57ca5de44df7e$export$17e05139018a7da3 = `X4P9TW_onSale`;
$61f57ca5de44df7e$export$321c0b1a406de31f = `X4P9TW_price`;
$61f57ca5de44df7e$export$3a2ca04c6f02321f = `X4P9TW_promotionBadge`;
$61f57ca5de44df7e$export$52311362f17fecfd = `X4P9TW_regularPrice`;
$61f57ca5de44df7e$export$c216489e398a758c = `X4P9TW_saleBadge`;
$61f57ca5de44df7e$export$85a28b6b66082880 = `X4P9TW_salePrice`;
$61f57ca5de44df7e$export$5e9818ec099e82 = `X4P9TW_saleTag`;

});



parcelRegister("6dE6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2704fc046a3f46dd$export$2e2bcd8739ae039; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $keJQj = parcelRequire("keJQj");

var $biy3n = parcelRequire("biy3n");

var $20OPj = parcelRequire("20OPj");
const $2704fc046a3f46dd$var$ProductLightBox = ({ hit: hit, title: title, subtitle: subtitle, badgeText: badgeText, canAddToCart: canAddToCart, cartState: cartState, isMedium: isMedium, wishState: wishState, canWishlist: // setWishState, 
canWishlist, Dialog: Dialog, currency: currency, ProductPrice: ProductPrice, messageStyles: messageStyles, messageText: messageText, handleWishClick: handleWishClick, hasOneVariant: hasOneVariant, Wrapper: Wrapper = "div" })=>{
    const [isOpen, setIsOpen] = (0, $1vrWl.useState)(false);
    const [descriptionOpen, setDescriptionOpen] = (0, $1vrWl.useState)("closed");
    const [description, setDescription] = (0, $1vrWl.useState)("");
    const toggleIsOpen = ()=>{
        setIsOpen(!isOpen);
        /* Disable / Enable scroll for <body> if lightbox is open. */ if (isOpen) document.body.style.overflow = "auto";
        else document.body.style.overflow = "hidden";
        // Fetch Product Description
        fetch("/products/" + hit.handle + ".json").then((res)=>res.json()).then((json)=>{
            setDescription(json.product.body_html);
        });
    };
    const toggleDescriptionOpen = ()=>{
        if (descriptionOpen == "closed") setDescriptionOpen("open");
        else setDescriptionOpen("closed");
    };
    // Variant is null by default unless there is only 1 a single variant.
    const [variation, setVariation] = (0, $1vrWl.useState)(()=>{
        if (hit.variants.length == 1) return hit.variants[0].id;
        else return "";
    });
    // Wishlist button disabled unless variant is selected or has a single variant.
    const [enableWishButton, setEnableWishButton] = (0, $1vrWl.useState)(()=>{
        if (hit.variants.length == 1) return "active";
        else return "";
    });
    const handleChange = (event)=>{
        setVariation(event.target.value);
        setEnableWishButton("active");
    };
    //Check if there is more for the user to scroll.
    const [moreTop, setMoreTop] = (0, $1vrWl.useState)(false);
    const [moreBottom, setMoreBottom] = (0, $1vrWl.useState)(true);
    function difference(first, sec) {
        return Math.abs(first - sec);
    }
    //Check if content in scrollable content is at the top or bottom.
    const checkContentEnd = (e)=>{
        var topOfElement = e.target.scrollTop;
        var diff = difference(topOfElement + e.target.clientHeight, e.target.scrollHeight);
        setMoreTop(topOfElement > 10);
        setMoreBottom(diff > 10);
    };
    (0, $1vrWl.useEffect)(()=>{
        //Scroll Event for mobile when content in lightbox is scrolled.
        if (isOpen) document.getElementById("content-" + hit.id).addEventListener("scroll", checkContentEnd);
    });
    const isSupplement = hit.tags.some((tag)=>tag.toLowerCase().includes("all products: supplements")); //Check if Supplement Product
    const hasSizeVariant = hit.options.some(({ name: name })=>name.toLowerCase() === "size");
    // const hasSizeVariant = hit.options.some(({ name }) => name.toLowerCase() === "size");
    const updateVariantTitle = (title)=>{
        switch(title){
            case "XXS":
                title = "2XS";
                break;
            case "XXL":
                title = "2XL";
                break;
            case "XXXL":
                title = "3XL";
                break;
            case "XXXXL":
                title = "4XL";
                break;
            default:
                break;
        }
        return title;
    };
    return /*#__PURE__*/ (0, $drmv2.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: "lightbox-trap",
                onClick: toggleIsOpen
            }),
            isOpen ? /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: "lightbox " + (isOpen ? "open" : "") + (isSupplement ? " supplement" : ""),
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: "lightbox-close",
                        onClick: toggleIsOpen
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: "lightbox-wrapper" + (moreTop ? " moreTop" : "") + (moreBottom ? " moreBottom" : ""),
                        children: [
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: "close",
                                onClick: toggleIsOpen,
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        children: "CLOSE"
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 320 512",
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                            d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                id: "content-" + hit.id,
                                className: "content container",
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        className: "content-wrapper",
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $20OPj.default), {
                                            gallery: hit.images
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                        className: "content-wrapper desc",
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                className: "h2",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                className: "h4",
                                                children: subtitle
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                className: "price",
                                                children: /*#__PURE__*/ (0, $drmv2.jsx)(ProductPrice, {
                                                    forceWishlist: true,
                                                    product: hit,
                                                    currency: currency
                                                })
                                            }),
                                            hit.variants.length != 1 && /*#__PURE__*/ (0, $drmv2.jsxs)("a", {
                                                href: `#options-${hit.id}`,
                                                className: "selectForWishlist",
                                                children: [
                                                    "Select your ",
                                                    hit.options[0].name != "ONE" ? hit.options[0].name : "type",
                                                    " then add to wishlist"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsxs)("form", {
                                                id: `options-${hit.id}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                        role: "group",
                                                        className: $keJQj.dialogList + " wishlist-wrapper ",
                                                        children: hit.variants.map((variant)=>/*#__PURE__*/ (0, $drmv2.jsxs)("label", {
                                                                className: `radio-button ${hit.variants.length == 1 ? "single" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $drmv2.jsx)("input", {
                                                                        type: "radio",
                                                                        name: "wish-variant",
                                                                        value: variant.id,
                                                                        onChange: handleChange,
                                                                        defaultChecked: hit.variants.length == 1
                                                                    }),
                                                                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                        children: updateVariantTitle(variant.title)
                                                                    })
                                                                ]
                                                            }, variant.id))
                                                    }),
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                                                            type: "button",
                                                            onClick: handleWishClick(parseInt(variation)),
                                                            className: `wishlist-add ${enableWishButton} ${wishState.wishedVariants[variation] ? "added" : ""} ` + (0, $biy3n.default)({
                                                                loading: wishState.loading === variation,
                                                                [$keJQj.hitButton]: !isMedium,
                                                                [$keJQj.dialogListItem]: isMedium
                                                            }),
                                                            children: [
                                                                !wishState.wishedVariants[variation] && /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                            children: "Add to Wishlist"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $drmv2.jsx)("svg", {
                                                                            "aria-hidden": "true",
                                                                            focusable: "false",
                                                                            "data-prefix": "far",
                                                                            "data-icon": "heart",
                                                                            className: "svg-inline--fa fa-heart ",
                                                                            role: "img",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            viewBox: "0 0 512 512",
                                                                            width: "20",
                                                                            height: "20",
                                                                            children: /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                                                                fill: "currentColor",
                                                                                d: "M244 84L255.1 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 0 232.4 0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84C243.1 84 244 84.01 244 84L244 84zM255.1 163.9L210.1 117.1C188.4 96.28 157.6 86.4 127.3 91.44C81.55 99.07 48 138.7 48 185.1V190.9C48 219.1 59.71 246.1 80.34 265.3L256 429.3L431.7 265.3C452.3 246.1 464 219.1 464 190.9V185.1C464 138.7 430.4 99.07 384.7 91.44C354.4 86.4 323.6 96.28 301.9 117.1L255.1 163.9z"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                wishState.wishedVariants[variation] && /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                            children: "Added to Wishlist"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $drmv2.jsxs)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "currentColor",
                                                                            stroke: "currentColor",
                                                                            "stroke-width": "2",
                                                                            "stroke-linecap": "round",
                                                                            "stroke-linejoin": "round",
                                                                            className: "icon svg-inline--fa fa-heart",
                                                                            children: [
                                                                                "  ",
                                                                                /*#__PURE__*/ (0, $drmv2.jsx)("path", {
                                                                                    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            description && /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                        className: "description " + descriptionOpen,
                                                        dangerouslySetInnerHTML: {
                                                            __html: "<h3>Description</h3>" + description
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                        className: "descriptionToggle",
                                                        onClick: toggleDescriptionOpen,
                                                        children: [
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                className: "toggleOn " + descriptionOpen,
                                                                children: "Show More"
                                                            }),
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                className: "toggleOff " + descriptionOpen,
                                                                children: "Show Less"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};
var $2704fc046a3f46dd$export$2e2bcd8739ae039 = $2704fc046a3f46dd$var$ProductLightBox;

});
parcelRegister("20OPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edfb646f738c6120$export$2e2bcd8739ae039; });

var $drmv2 = parcelRequire("drmv2");
parcelRequire("1vrWl");

var $jqb5V = parcelRequire("jqb5V");


function $edfb646f738c6120$export$2e2bcd8739ae039({ gallery: gallery, preSettings: preSettings, productLink: productLink, handleClickThrough: handleClickThrough, hit: hit }) {
    var settings = preSettings ? preSettings : {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    function handleSlickInteraction() {
    // window.dataLayer.push({ 
    //   event: "hitGallerySwipe",
    //   eventModel: {
    //     objectID: [hit.objectID],
    //   },
    // });
    }
    return /*#__PURE__*/ (0, $drmv2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jqb5V))), {
        ...settings,
        onSwipe: handleSlickInteraction,
        children: gallery.map((image, index)=>/*#__PURE__*/ (0, $drmv2.jsx)("div", {
                children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                    alt: `${hit?.title} ${index != 0 ? `Image - ${index}` : ""}`,
                    loading: index === 0 ? "eager" : "lazy",
                    srcSet: `
                  ${window.Shopify.addSizeToImage(image.src, 800)} 800w,
                  ${window.Shopify.addSizeToImage(image.src, 700)} 700w,
                  ${window.Shopify.addSizeToImage(image.src, 600)} 600w,
                  ${window.Shopify.addSizeToImage(image.src, 500)} 500w
                `,
                    sizes: `(min-width: 700px) 800px, (min-width: 600px) 700px, (min-width: 500px) 600px, 500px`,
                    src: `${window.Shopify.addSizeToImage(image.src, 500)}`
                })
            }, index))
    });
}

});
parcelRegister("jqb5V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e2390d28d0033279$var$_slider = $e2390d28d0033279$var$_interopRequireDefault((parcelRequire("aQvyC")));
function $e2390d28d0033279$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e2390d28d0033279$var$_default = $e2390d28d0033279$var$_slider["default"];
module.exports["default"] = $e2390d28d0033279$var$_default;

});
parcelRegister("aQvyC", function(module, exports) {
"use strict";
function $7e573d5e8682eed7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7e573d5e8682eed7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7e573d5e8682eed7$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7e573d5e8682eed7$var$_react = $7e573d5e8682eed7$var$_interopRequireDefault((parcelRequire("1vrWl")));

var $gFvOY = parcelRequire("gFvOY");

var $7e573d5e8682eed7$var$_json2mq = $7e573d5e8682eed7$var$_interopRequireDefault((parcelRequire("7OVTR")));

var $7e573d5e8682eed7$var$_defaultProps = $7e573d5e8682eed7$var$_interopRequireDefault((parcelRequire("jE6Nx")));

var $SD9E4 = parcelRequire("SD9E4");
function $7e573d5e8682eed7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7e573d5e8682eed7$var$_extends() {
    $7e573d5e8682eed7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7e573d5e8682eed7$var$_extends.apply(this, arguments);
}
function $7e573d5e8682eed7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7e573d5e8682eed7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7e573d5e8682eed7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7e573d5e8682eed7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7e573d5e8682eed7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7e573d5e8682eed7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e573d5e8682eed7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7e573d5e8682eed7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7e573d5e8682eed7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7e573d5e8682eed7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7e573d5e8682eed7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7e573d5e8682eed7$var$_setPrototypeOf(subClass, superClass);
}
function $7e573d5e8682eed7$var$_setPrototypeOf(o, p) {
    $7e573d5e8682eed7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7e573d5e8682eed7$var$_setPrototypeOf(o, p);
}
function $7e573d5e8682eed7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7e573d5e8682eed7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7e573d5e8682eed7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7e573d5e8682eed7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7e573d5e8682eed7$var$_possibleConstructorReturn(this, result);
    };
}
function $7e573d5e8682eed7$var$_possibleConstructorReturn(self, call) {
    if (call && ($7e573d5e8682eed7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7e573d5e8682eed7$var$_assertThisInitialized(self);
}
function $7e573d5e8682eed7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7e573d5e8682eed7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7e573d5e8682eed7$var$_getPrototypeOf(o) {
    $7e573d5e8682eed7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7e573d5e8682eed7$var$_getPrototypeOf(o);
}
function $7e573d5e8682eed7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $7e573d5e8682eed7$var$enquire = (0, $SD9E4.canUseDOM)() && (parcelRequire("jK6gB"));
var $7e573d5e8682eed7$var$Slider = /*#__PURE__*/ function(_React$Component) {
    $7e573d5e8682eed7$var$_inherits(Slider, _React$Component);
    var _super = $7e573d5e8682eed7$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $7e573d5e8682eed7$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $7e573d5e8682eed7$var$_defineProperty($7e573d5e8682eed7$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $7e573d5e8682eed7$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $7e573d5e8682eed7$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    }); // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $7e573d5e8682eed7$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $7e573d5e8682eed7$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                         // when not using server side rendering
                        (0, $SD9E4.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    }); // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $7e573d5e8682eed7$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $SD9E4.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $7e573d5e8682eed7$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $7e573d5e8682eed7$var$_objectSpread($7e573d5e8682eed7$var$_objectSpread($7e573d5e8682eed7$var$_objectSpread({}, $7e573d5e8682eed7$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $7e573d5e8682eed7$var$_objectSpread($7e573d5e8682eed7$var$_objectSpread({}, $7e573d5e8682eed7$var$_defaultProps["default"]), this.props);
                 // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                } // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                } // makes sure that children is an array, even when there is only 1 child
                var children = $7e573d5e8682eed7$var$_react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                }); // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ $7e573d5e8682eed7$var$_react["default"].createElement($gFvOY.InnerSlider, $7e573d5e8682eed7$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, settings), newChildren);
            }
        }
    ]);
    return Slider;
}($7e573d5e8682eed7$var$_react["default"].Component);
module.exports["default"] = $7e573d5e8682eed7$var$Slider;

});
parcelRegister("gFvOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $c22928ae91b0419d$var$_react = $c22928ae91b0419d$var$_interopRequireDefault((parcelRequire("1vrWl")));

var $c22928ae91b0419d$var$_initialState = $c22928ae91b0419d$var$_interopRequireDefault((parcelRequire("bfn1J")));

var $c22928ae91b0419d$var$_lodash = $c22928ae91b0419d$var$_interopRequireDefault((parcelRequire("21IRG")));

var $c22928ae91b0419d$var$_classnames = $c22928ae91b0419d$var$_interopRequireDefault((parcelRequire("kCPCa")));

var $SD9E4 = parcelRequire("SD9E4");

var $gPbFw = parcelRequire("gPbFw");

var $04upc = parcelRequire("04upc");

var $a2Ekm = parcelRequire("a2Ekm");

var $c22928ae91b0419d$var$_resizeObserverPolyfill = $c22928ae91b0419d$var$_interopRequireDefault((parcelRequire("6L99Y")));
function $c22928ae91b0419d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c22928ae91b0419d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c22928ae91b0419d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c22928ae91b0419d$var$_typeof(obj);
}
function $c22928ae91b0419d$var$_extends() {
    $c22928ae91b0419d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c22928ae91b0419d$var$_extends.apply(this, arguments);
}
function $c22928ae91b0419d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c22928ae91b0419d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c22928ae91b0419d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c22928ae91b0419d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c22928ae91b0419d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c22928ae91b0419d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c22928ae91b0419d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c22928ae91b0419d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c22928ae91b0419d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c22928ae91b0419d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c22928ae91b0419d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c22928ae91b0419d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c22928ae91b0419d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c22928ae91b0419d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c22928ae91b0419d$var$_setPrototypeOf(subClass, superClass);
}
function $c22928ae91b0419d$var$_setPrototypeOf(o, p) {
    $c22928ae91b0419d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c22928ae91b0419d$var$_setPrototypeOf(o, p);
}
function $c22928ae91b0419d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c22928ae91b0419d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c22928ae91b0419d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c22928ae91b0419d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c22928ae91b0419d$var$_possibleConstructorReturn(this, result);
    };
}
function $c22928ae91b0419d$var$_possibleConstructorReturn(self, call) {
    if (call && ($c22928ae91b0419d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c22928ae91b0419d$var$_assertThisInitialized(self);
}
function $c22928ae91b0419d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c22928ae91b0419d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c22928ae91b0419d$var$_getPrototypeOf(o) {
    $c22928ae91b0419d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c22928ae91b0419d$var$_getPrototypeOf(o);
}
function $c22928ae91b0419d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c22928ae91b0419d$var$InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $c22928ae91b0419d$var$_inherits(InnerSlider, _React$Component);
    var _super = $c22928ae91b0419d$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $c22928ae91b0419d$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $SD9E4.getHeight)(elem) + "px";
            }
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $SD9E4.getOnDemandLazySlides)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $c22928ae91b0419d$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $c22928ae91b0419d$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $SD9E4.getOnDemandLazySlides)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            } // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $c22928ae91b0419d$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $c22928ae91b0419d$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $c22928ae91b0419d$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            }); // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $SD9E4.initializedState)(spec);
            spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $SD9E4.getTrackLeft)(spec);
            spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $SD9E4.getTrackCSS)(spec);
            if (setTrackStyle || $c22928ae91b0419d$var$_react["default"].Children.count(_this.props.children) !== $c22928ae91b0419d$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $SD9E4.getPreClones)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $SD9E4.getPostClones)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $c22928ae91b0419d$var$_react["default"].Children.count(_this.props.children);
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $SD9E4.getPreClones)(spec) + (0, $SD9E4.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $SD9E4.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function() {
                        prevClickHandler();
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $SD9E4.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $SD9E4.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $SD9E4.slideHandler)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $c22928ae91b0419d$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $SD9E4.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $SD9E4.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $SD9E4.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $SD9E4.swipeMove)(e, $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $SD9E4.swipeEnd)(e, $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $SD9E4.canGoNext)($c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $c22928ae91b0419d$var$_defineProperty($c22928ae91b0419d$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $c22928ae91b0419d$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $SD9E4.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $SD9E4.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement($04upc.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $SD9E4.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement($a2Ekm.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement($a2Ekm.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement("div", $c22928ae91b0419d$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $c22928ae91b0419d$var$_react["default"].createElement($gPbFw.Track, $c22928ae91b0419d$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, $c22928ae91b0419d$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            slideCount: $c22928ae91b0419d$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $c22928ae91b0419d$var$_objectSpread($c22928ae91b0419d$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $c22928ae91b0419d$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($c22928ae91b0419d$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $c22928ae91b0419d$var$_react["default"].Children.count(this.props.children) !== $c22928ae91b0419d$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($c22928ae91b0419d$var$_react["default"].Component);
module.exports.InnerSlider = $c22928ae91b0419d$var$InnerSlider;

});
parcelRegister("bfn1J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $8302f51d8d7d0811$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $8302f51d8d7d0811$var$_default = $8302f51d8d7d0811$var$initialState;
module.exports["default"] = $8302f51d8d7d0811$var$_default;

});

parcelRegister("21IRG", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $179e7a03a4b7c575$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $179e7a03a4b7c575$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $179e7a03a4b7c575$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $179e7a03a4b7c575$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $179e7a03a4b7c575$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $179e7a03a4b7c575$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $179e7a03a4b7c575$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $179e7a03a4b7c575$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $179e7a03a4b7c575$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $179e7a03a4b7c575$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $179e7a03a4b7c575$var$root = $179e7a03a4b7c575$var$freeGlobal || $179e7a03a4b7c575$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $179e7a03a4b7c575$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $179e7a03a4b7c575$var$objectToString = $179e7a03a4b7c575$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $179e7a03a4b7c575$var$nativeMax = Math.max, $179e7a03a4b7c575$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $179e7a03a4b7c575$var$now = function() {
    return $179e7a03a4b7c575$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $179e7a03a4b7c575$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($179e7a03a4b7c575$var$FUNC_ERROR_TEXT);
    wait = $179e7a03a4b7c575$var$toNumber(wait) || 0;
    if ($179e7a03a4b7c575$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $179e7a03a4b7c575$var$nativeMax($179e7a03a4b7c575$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $179e7a03a4b7c575$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $179e7a03a4b7c575$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($179e7a03a4b7c575$var$now());
    }
    function debounced() {
        var time = $179e7a03a4b7c575$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $179e7a03a4b7c575$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $179e7a03a4b7c575$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $179e7a03a4b7c575$var$isSymbol(value) {
    return typeof value == "symbol" || $179e7a03a4b7c575$var$isObjectLike(value) && $179e7a03a4b7c575$var$objectToString.call(value) == $179e7a03a4b7c575$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $179e7a03a4b7c575$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($179e7a03a4b7c575$var$isSymbol(value)) return $179e7a03a4b7c575$var$NAN;
    if ($179e7a03a4b7c575$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $179e7a03a4b7c575$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($179e7a03a4b7c575$var$reTrim, "");
    var isBinary = $179e7a03a4b7c575$var$reIsBinary.test(value);
    return isBinary || $179e7a03a4b7c575$var$reIsOctal.test(value) ? $179e7a03a4b7c575$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $179e7a03a4b7c575$var$reIsBadHex.test(value) ? $179e7a03a4b7c575$var$NAN : +value;
}
module.exports = $179e7a03a4b7c575$var$debounce;

});

parcelRegister("SD9E4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $0a436a8adb877746$var$clamp;
module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = module.exports.extractObject = void 0;

var $0a436a8adb877746$var$_react = $0a436a8adb877746$var$_interopRequireDefault((parcelRequire("1vrWl")));
function $0a436a8adb877746$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0a436a8adb877746$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0a436a8adb877746$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0a436a8adb877746$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0a436a8adb877746$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0a436a8adb877746$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0a436a8adb877746$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a436a8adb877746$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $0a436a8adb877746$var$safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
module.exports.safePreventDefault = $0a436a8adb877746$var$safePreventDefault;
var $0a436a8adb877746$var$getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $0a436a8adb877746$var$lazyStartIndex(spec);
    var endIndex = $0a436a8adb877746$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
}; // return list of slides that need to be present
module.exports.getOnDemandLazySlides = $0a436a8adb877746$var$getOnDemandLazySlides;
var $0a436a8adb877746$var$getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $0a436a8adb877746$var$lazyStartIndex(spec);
    var endIndex = $0a436a8adb877746$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
}; // startIndex that needs to be present
module.exports.getRequiredLazySlides = $0a436a8adb877746$var$getRequiredLazySlides;
var $0a436a8adb877746$var$lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $0a436a8adb877746$var$lazySlidesOnLeft(spec);
};
module.exports.lazyStartIndex = $0a436a8adb877746$var$lazyStartIndex;
var $0a436a8adb877746$var$lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $0a436a8adb877746$var$lazySlidesOnRight(spec);
};
module.exports.lazyEndIndex = $0a436a8adb877746$var$lazyEndIndex;
var $0a436a8adb877746$var$lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
module.exports.lazySlidesOnLeft = $0a436a8adb877746$var$lazySlidesOnLeft;
var $0a436a8adb877746$var$lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element
module.exports.lazySlidesOnRight = $0a436a8adb877746$var$lazySlidesOnRight;
var $0a436a8adb877746$var$getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
module.exports.getWidth = $0a436a8adb877746$var$getWidth;
var $0a436a8adb877746$var$getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
module.exports.getHeight = $0a436a8adb877746$var$getHeight;
var $0a436a8adb877746$var$getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
}; // whether or not we can go next
module.exports.getSwipeDirection = $0a436a8adb877746$var$getSwipeDirection;
var $0a436a8adb877746$var$canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
}; // given an object and a list of keys, return new object with given keys
module.exports.canGoNext = $0a436a8adb877746$var$canGoNext;
var $0a436a8adb877746$var$extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
}; // get initialized state
module.exports.extractObject = $0a436a8adb877746$var$extractObject;
var $0a436a8adb877746$var$initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $0a436a8adb877746$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($0a436a8adb877746$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($0a436a8adb877746$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $0a436a8adb877746$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $0a436a8adb877746$var$getOnDemandLazySlides($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
module.exports.initializedState = $0a436a8adb877746$var$initializedState;
var $0a436a8adb877746$var$slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $0a436a8adb877746$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$0a436a8adb877746$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $0a436a8adb877746$var$getTrackLeft($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $0a436a8adb877746$var$getTrackLeft($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($0a436a8adb877746$var$getOnDemandLazySlides($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $0a436a8adb877746$var$getTrackCSS($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $0a436a8adb877746$var$getTrackAnimateCSS($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $0a436a8adb877746$var$getTrackCSS($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
module.exports.slideHandler = $0a436a8adb877746$var$slideHandler;
var $0a436a8adb877746$var$changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $0a436a8adb877746$var$siblingDirection($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
module.exports.changeSlide = $0a436a8adb877746$var$changeSlide;
var $0a436a8adb877746$var$keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
module.exports.keyHandler = $0a436a8adb877746$var$keyHandler;
var $0a436a8adb877746$var$swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $0a436a8adb877746$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
module.exports.swipeStart = $0a436a8adb877746$var$swipeStart;
var $0a436a8adb877746$var$swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $0a436a8adb877746$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $0a436a8adb877746$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $0a436a8adb877746$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $0a436a8adb877746$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$0a436a8adb877746$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $0a436a8adb877746$var$getTrackCSS($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $0a436a8adb877746$var$safePreventDefault(e);
    }
    return state;
};
module.exports.swipeMove = $0a436a8adb877746$var$swipeMove;
var $0a436a8adb877746$var$swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $0a436a8adb877746$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $0a436a8adb877746$var$getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $0a436a8adb877746$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $0a436a8adb877746$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $0a436a8adb877746$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $0a436a8adb877746$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $0a436a8adb877746$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $0a436a8adb877746$var$getTrackLeft(spec);
        state["trackStyle"] = $0a436a8adb877746$var$getTrackAnimateCSS($0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
module.exports.swipeEnd = $0a436a8adb877746$var$swipeEnd;
var $0a436a8adb877746$var$getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
module.exports.getNavigableIndexes = $0a436a8adb877746$var$getNavigableIndexes;
var $0a436a8adb877746$var$checkNavigable = function checkNavigable(spec, index) {
    var navigables = $0a436a8adb877746$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
module.exports.checkNavigable = $0a436a8adb877746$var$checkNavigable;
var $0a436a8adb877746$var$getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $0a436a8adb877746$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $0a436a8adb877746$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
module.exports.getSlideCount = $0a436a8adb877746$var$getSlideCount;
var $0a436a8adb877746$var$checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
module.exports.checkSpecKeys = $0a436a8adb877746$var$checkSpecKeys;
var $0a436a8adb877746$var$getTrackCSS = function getTrackCSS(spec) {
    $0a436a8adb877746$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $0a436a8adb877746$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $0a436a8adb877746$var$_objectSpread($0a436a8adb877746$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight; // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
module.exports.getTrackCSS = $0a436a8adb877746$var$getTrackCSS;
var $0a436a8adb877746$var$getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $0a436a8adb877746$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $0a436a8adb877746$var$getTrackCSS(spec); // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
module.exports.getTrackAnimateCSS = $0a436a8adb877746$var$getTrackAnimateCSS;
var $0a436a8adb877746$var$getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $0a436a8adb877746$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$0a436a8adb877746$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
         // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $0a436a8adb877746$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $0a436a8adb877746$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
module.exports.getTrackLeft = $0a436a8adb877746$var$getTrackLeft;
var $0a436a8adb877746$var$getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
module.exports.getPreClones = $0a436a8adb877746$var$getPreClones;
var $0a436a8adb877746$var$getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
module.exports.getPostClones = $0a436a8adb877746$var$getPostClones;
var $0a436a8adb877746$var$getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $0a436a8adb877746$var$getPreClones(spec) + spec.slideCount + $0a436a8adb877746$var$getPostClones(spec);
};
module.exports.getTotalSlides = $0a436a8adb877746$var$getTotalSlides;
var $0a436a8adb877746$var$siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $0a436a8adb877746$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $0a436a8adb877746$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
module.exports.siblingDirection = $0a436a8adb877746$var$siblingDirection;
var $0a436a8adb877746$var$slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
module.exports.slidesOnRight = $0a436a8adb877746$var$slidesOnRight;
var $0a436a8adb877746$var$slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
module.exports.slidesOnLeft = $0a436a8adb877746$var$slidesOnLeft;
var $0a436a8adb877746$var$canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
module.exports.canUseDOM = $0a436a8adb877746$var$canUseDOM;

});

parcelRegister("gPbFw", function(module, exports) {
"use strict";
function $c3fa75eb0a05f78b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c3fa75eb0a05f78b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c3fa75eb0a05f78b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $c3fa75eb0a05f78b$var$_react = $c3fa75eb0a05f78b$var$_interopRequireDefault((parcelRequire("1vrWl")));

var $c3fa75eb0a05f78b$var$_classnames = $c3fa75eb0a05f78b$var$_interopRequireDefault((parcelRequire("kCPCa")));

var $SD9E4 = parcelRequire("SD9E4");
function $c3fa75eb0a05f78b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c3fa75eb0a05f78b$var$_extends() {
    $c3fa75eb0a05f78b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3fa75eb0a05f78b$var$_extends.apply(this, arguments);
}
function $c3fa75eb0a05f78b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c3fa75eb0a05f78b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c3fa75eb0a05f78b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c3fa75eb0a05f78b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c3fa75eb0a05f78b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c3fa75eb0a05f78b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c3fa75eb0a05f78b$var$_setPrototypeOf(subClass, superClass);
}
function $c3fa75eb0a05f78b$var$_setPrototypeOf(o, p) {
    $c3fa75eb0a05f78b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c3fa75eb0a05f78b$var$_setPrototypeOf(o, p);
}
function $c3fa75eb0a05f78b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c3fa75eb0a05f78b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c3fa75eb0a05f78b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c3fa75eb0a05f78b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c3fa75eb0a05f78b$var$_possibleConstructorReturn(this, result);
    };
}
function $c3fa75eb0a05f78b$var$_possibleConstructorReturn(self, call) {
    if (call && ($c3fa75eb0a05f78b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c3fa75eb0a05f78b$var$_assertThisInitialized(self);
}
function $c3fa75eb0a05f78b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c3fa75eb0a05f78b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c3fa75eb0a05f78b$var$_getPrototypeOf(o) {
    $c3fa75eb0a05f78b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c3fa75eb0a05f78b$var$_getPrototypeOf(o);
}
function $c3fa75eb0a05f78b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c3fa75eb0a05f78b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c3fa75eb0a05f78b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c3fa75eb0a05f78b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c3fa75eb0a05f78b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c3fa75eb0a05f78b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $c3fa75eb0a05f78b$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $c3fa75eb0a05f78b$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $c3fa75eb0a05f78b$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $c3fa75eb0a05f78b$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $c3fa75eb0a05f78b$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $SD9E4.lazyStartIndex)(spec);
    var endIndex = (0, $SD9E4.lazyEndIndex)(spec);
    $c3fa75eb0a05f78b$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $c3fa75eb0a05f78b$var$_react["default"].createElement("div", null);
        var childStyle = $c3fa75eb0a05f78b$var$getSlideStyle($c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $c3fa75eb0a05f78b$var$getSlideClasses($c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, spec), {}, {
            index: index
        })); // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $c3fa75eb0a05f78b$var$_react["default"].cloneElement(child, {
            key: "original" + $c3fa75eb0a05f78b$var$getKey(child, index),
            "data-index": index,
            className: (0, $c3fa75eb0a05f78b$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        })); // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $SD9E4.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $c3fa75eb0a05f78b$var$getSlideClasses($c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $c3fa75eb0a05f78b$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $c3fa75eb0a05f78b$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $c3fa75eb0a05f78b$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (childrenCount !== spec.slidesToShow) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $c3fa75eb0a05f78b$var$getSlideClasses($c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ $c3fa75eb0a05f78b$var$_react["default"].cloneElement(child, {
                    key: "postcloned" + $c3fa75eb0a05f78b$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $c3fa75eb0a05f78b$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $c3fa75eb0a05f78b$var$_objectSpread($c3fa75eb0a05f78b$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $c3fa75eb0a05f78b$var$Track = /*#__PURE__*/ function(_React$PureComponent) {
    $c3fa75eb0a05f78b$var$_inherits(Track, _React$PureComponent);
    var _super = $c3fa75eb0a05f78b$var$_createSuper(Track);
    function Track() {
        var _this;
        $c3fa75eb0a05f78b$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c3fa75eb0a05f78b$var$_defineProperty($c3fa75eb0a05f78b$var$_assertThisInitialized(_this), "node", null);
        $c3fa75eb0a05f78b$var$_defineProperty($c3fa75eb0a05f78b$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $c3fa75eb0a05f78b$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $c3fa75eb0a05f78b$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $c3fa75eb0a05f78b$var$_react["default"].createElement("div", $c3fa75eb0a05f78b$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($c3fa75eb0a05f78b$var$_react["default"].PureComponent);
module.exports.Track = $c3fa75eb0a05f78b$var$Track;

});

parcelRegister("04upc", function(module, exports) {
"use strict";
function $00d7f5b3f2e79d7b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $00d7f5b3f2e79d7b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $00d7f5b3f2e79d7b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $00d7f5b3f2e79d7b$var$_react = $00d7f5b3f2e79d7b$var$_interopRequireDefault((parcelRequire("1vrWl")));

var $00d7f5b3f2e79d7b$var$_classnames = $00d7f5b3f2e79d7b$var$_interopRequireDefault((parcelRequire("kCPCa")));

var $SD9E4 = parcelRequire("SD9E4");
function $00d7f5b3f2e79d7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $00d7f5b3f2e79d7b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00d7f5b3f2e79d7b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $00d7f5b3f2e79d7b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $00d7f5b3f2e79d7b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $00d7f5b3f2e79d7b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $00d7f5b3f2e79d7b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $00d7f5b3f2e79d7b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $00d7f5b3f2e79d7b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $00d7f5b3f2e79d7b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $00d7f5b3f2e79d7b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $00d7f5b3f2e79d7b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $00d7f5b3f2e79d7b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $00d7f5b3f2e79d7b$var$_setPrototypeOf(subClass, superClass);
}
function $00d7f5b3f2e79d7b$var$_setPrototypeOf(o, p) {
    $00d7f5b3f2e79d7b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $00d7f5b3f2e79d7b$var$_setPrototypeOf(o, p);
}
function $00d7f5b3f2e79d7b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $00d7f5b3f2e79d7b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $00d7f5b3f2e79d7b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $00d7f5b3f2e79d7b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $00d7f5b3f2e79d7b$var$_possibleConstructorReturn(this, result);
    };
}
function $00d7f5b3f2e79d7b$var$_possibleConstructorReturn(self, call) {
    if (call && ($00d7f5b3f2e79d7b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $00d7f5b3f2e79d7b$var$_assertThisInitialized(self);
}
function $00d7f5b3f2e79d7b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $00d7f5b3f2e79d7b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $00d7f5b3f2e79d7b$var$_getPrototypeOf(o) {
    $00d7f5b3f2e79d7b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $00d7f5b3f2e79d7b$var$_getPrototypeOf(o);
}
var $00d7f5b3f2e79d7b$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $00d7f5b3f2e79d7b$var$Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $00d7f5b3f2e79d7b$var$_inherits(Dots, _React$PureComponent);
    var _super = $00d7f5b3f2e79d7b$var$_createSuper(Dots);
    function Dots() {
        $00d7f5b3f2e79d7b$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $00d7f5b3f2e79d7b$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $00d7f5b3f2e79d7b$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $SD9E4.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $SD9E4.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $00d7f5b3f2e79d7b$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $00d7f5b3f2e79d7b$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $00d7f5b3f2e79d7b$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $00d7f5b3f2e79d7b$var$_react["default"].cloneElement(this.props.appendDots(dots), $00d7f5b3f2e79d7b$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($00d7f5b3f2e79d7b$var$_react["default"].PureComponent);
module.exports.Dots = $00d7f5b3f2e79d7b$var$Dots;

});

parcelRegister("a2Ekm", function(module, exports) {
"use strict";
function $74f95f767ce33909$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $74f95f767ce33909$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $74f95f767ce33909$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $74f95f767ce33909$var$_react = $74f95f767ce33909$var$_interopRequireDefault((parcelRequire("1vrWl")));

var $74f95f767ce33909$var$_classnames = $74f95f767ce33909$var$_interopRequireDefault((parcelRequire("kCPCa")));

var $SD9E4 = parcelRequire("SD9E4");
function $74f95f767ce33909$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $74f95f767ce33909$var$_extends() {
    $74f95f767ce33909$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74f95f767ce33909$var$_extends.apply(this, arguments);
}
function $74f95f767ce33909$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74f95f767ce33909$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $74f95f767ce33909$var$ownKeys(Object(source), !0).forEach(function(key) {
            $74f95f767ce33909$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $74f95f767ce33909$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $74f95f767ce33909$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $74f95f767ce33909$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $74f95f767ce33909$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $74f95f767ce33909$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $74f95f767ce33909$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $74f95f767ce33909$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $74f95f767ce33909$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $74f95f767ce33909$var$_setPrototypeOf(subClass, superClass);
}
function $74f95f767ce33909$var$_setPrototypeOf(o, p) {
    $74f95f767ce33909$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $74f95f767ce33909$var$_setPrototypeOf(o, p);
}
function $74f95f767ce33909$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $74f95f767ce33909$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $74f95f767ce33909$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $74f95f767ce33909$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $74f95f767ce33909$var$_possibleConstructorReturn(this, result);
    };
}
function $74f95f767ce33909$var$_possibleConstructorReturn(self, call) {
    if (call && ($74f95f767ce33909$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $74f95f767ce33909$var$_assertThisInitialized(self);
}
function $74f95f767ce33909$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $74f95f767ce33909$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $74f95f767ce33909$var$_getPrototypeOf(o) {
    $74f95f767ce33909$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $74f95f767ce33909$var$_getPrototypeOf(o);
}
var $74f95f767ce33909$var$PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $74f95f767ce33909$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $74f95f767ce33909$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $74f95f767ce33909$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $74f95f767ce33909$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $74f95f767ce33909$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $74f95f767ce33909$var$_react["default"].cloneElement(this.props.prevArrow, $74f95f767ce33909$var$_objectSpread($74f95f767ce33909$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $74f95f767ce33909$var$_react["default"].createElement("button", $74f95f767ce33909$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($74f95f767ce33909$var$_react["default"].PureComponent);
module.exports.PrevArrow = $74f95f767ce33909$var$PrevArrow;
var $74f95f767ce33909$var$NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $74f95f767ce33909$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $74f95f767ce33909$var$_createSuper(NextArrow);
    function NextArrow() {
        $74f95f767ce33909$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $74f95f767ce33909$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $SD9E4.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $74f95f767ce33909$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $74f95f767ce33909$var$_react["default"].cloneElement(this.props.nextArrow, $74f95f767ce33909$var$_objectSpread($74f95f767ce33909$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $74f95f767ce33909$var$_react["default"].createElement("button", $74f95f767ce33909$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($74f95f767ce33909$var$_react["default"].PureComponent);
module.exports.NextArrow = $74f95f767ce33909$var$NextArrow;

});

parcelRegister("6L99Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4ebe3cd0c53c76d1$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $4ebe3cd0c53c76d1$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $4ebe3cd0c53c76d1$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $4ebe3cd0c53c76d1$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $4ebe3cd0c53c76d1$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($4ebe3cd0c53c76d1$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $4ebe3cd0c53c76d1$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $4ebe3cd0c53c76d1$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $4ebe3cd0c53c76d1$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $4ebe3cd0c53c76d1$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $4ebe3cd0c53c76d1$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $4ebe3cd0c53c76d1$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $4ebe3cd0c53c76d1$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $4ebe3cd0c53c76d1$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $4ebe3cd0c53c76d1$var$throttle(this.refresh.bind(this), $4ebe3cd0c53c76d1$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$4ebe3cd0c53c76d1$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($4ebe3cd0c53c76d1$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$4ebe3cd0c53c76d1$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $4ebe3cd0c53c76d1$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $4ebe3cd0c53c76d1$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $4ebe3cd0c53c76d1$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $4ebe3cd0c53c76d1$var$global$1;
};
// Placeholder of an empty content rectangle.
var $4ebe3cd0c53c76d1$var$emptyRect = $4ebe3cd0c53c76d1$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $4ebe3cd0c53c76d1$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $4ebe3cd0c53c76d1$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $4ebe3cd0c53c76d1$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $4ebe3cd0c53c76d1$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $4ebe3cd0c53c76d1$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $4ebe3cd0c53c76d1$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $4ebe3cd0c53c76d1$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $4ebe3cd0c53c76d1$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $4ebe3cd0c53c76d1$var$emptyRect;
    var styles = $4ebe3cd0c53c76d1$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $4ebe3cd0c53c76d1$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $4ebe3cd0c53c76d1$var$toFloat(styles.width), height = $4ebe3cd0c53c76d1$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $4ebe3cd0c53c76d1$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $4ebe3cd0c53c76d1$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$4ebe3cd0c53c76d1$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $4ebe3cd0c53c76d1$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $4ebe3cd0c53c76d1$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $4ebe3cd0c53c76d1$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $4ebe3cd0c53c76d1$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $4ebe3cd0c53c76d1$var$isDocumentElement(target) {
    return target === $4ebe3cd0c53c76d1$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $4ebe3cd0c53c76d1$var$getContentRect(target) {
    if (!$4ebe3cd0c53c76d1$var$isBrowser) return $4ebe3cd0c53c76d1$var$emptyRect;
    if ($4ebe3cd0c53c76d1$var$isSVGGraphicsElement(target)) return $4ebe3cd0c53c76d1$var$getSVGContentRect(target);
    return $4ebe3cd0c53c76d1$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $4ebe3cd0c53c76d1$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $4ebe3cd0c53c76d1$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $4ebe3cd0c53c76d1$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $4ebe3cd0c53c76d1$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $4ebe3cd0c53c76d1$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $4ebe3cd0c53c76d1$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $4ebe3cd0c53c76d1$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $4ebe3cd0c53c76d1$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $4ebe3cd0c53c76d1$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $4ebe3cd0c53c76d1$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $4ebe3cd0c53c76d1$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $4ebe3cd0c53c76d1$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $4ebe3cd0c53c76d1$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $4ebe3cd0c53c76d1$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $4ebe3cd0c53c76d1$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $4ebe3cd0c53c76d1$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $4ebe3cd0c53c76d1$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $4ebe3cd0c53c76d1$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $4ebe3cd0c53c76d1$var$ResizeObserverController.getInstance();
        var observer = new $4ebe3cd0c53c76d1$var$ResizeObserverSPI(callback, controller, this);
        $4ebe3cd0c53c76d1$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $4ebe3cd0c53c76d1$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $4ebe3cd0c53c76d1$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $4ebe3cd0c53c76d1$var$index = function() {
    // Export existing implementation if available.
    if (typeof $4ebe3cd0c53c76d1$var$global$1.ResizeObserver !== "undefined") return $4ebe3cd0c53c76d1$var$global$1.ResizeObserver;
    return $4ebe3cd0c53c76d1$var$ResizeObserver;
}();
var $4ebe3cd0c53c76d1$export$2e2bcd8739ae039 = $4ebe3cd0c53c76d1$var$index;

});


parcelRegister("7OVTR", function(module, exports) {

var $dnclM = parcelRequire("dnclM");
var $5b1a1d9fbe9904be$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $5b1a1d9fbe9904be$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $dnclM(feature);
        // Add px to dimension features
        if ($5b1a1d9fbe9904be$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $5b1a1d9fbe9904be$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $5b1a1d9fbe9904be$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $5b1a1d9fbe9904be$var$obj2mq(query);
};
module.exports = $5b1a1d9fbe9904be$var$json2mq;

});
parcelRegister("dnclM", function(module, exports) {
var $9bc700e0b6693e48$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $9bc700e0b6693e48$var$camel2hyphen;

});


parcelRegister("jE6Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e4d706b38b8cc76d$var$_react = $e4d706b38b8cc76d$var$_interopRequireDefault((parcelRequire("1vrWl")));
function $e4d706b38b8cc76d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e4d706b38b8cc76d$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $e4d706b38b8cc76d$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $e4d706b38b8cc76d$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
};
var $e4d706b38b8cc76d$var$_default = $e4d706b38b8cc76d$var$defaultProps;
module.exports["default"] = $e4d706b38b8cc76d$var$_default;

});

parcelRegister("jK6gB", function(module, exports) {

var $dKTP6 = parcelRequire("dKTP6");
module.exports = new $dKTP6();

});
parcelRegister("dKTP6", function(module, exports) {

var $90wrl = parcelRequire("90wrl");

var $8lWh1 = parcelRequire("8lWh1");
var $a03adf8d38f42392$var$each = $8lWh1.each;
var $a03adf8d38f42392$var$isFunction = $8lWh1.isFunction;
var $a03adf8d38f42392$var$isArray = $8lWh1.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $a03adf8d38f42392$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia("only all").matches;
}
$a03adf8d38f42392$var$MediaQueryDispatch.prototype = {
    constructor: $a03adf8d38f42392$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $90wrl(q, isUnconditional);
        //normalise to object in an array
        if ($a03adf8d38f42392$var$isFunction(options)) options = {
            match: options
        };
        if (!$a03adf8d38f42392$var$isArray(options)) options = [
            options
        ];
        $a03adf8d38f42392$var$each(options, function(handler) {
            if ($a03adf8d38f42392$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $a03adf8d38f42392$var$MediaQueryDispatch;

});
parcelRegister("90wrl", function(module, exports) {

var $feyF1 = parcelRequire("feyF1");

var $8lWh1 = parcelRequire("8lWh1");
var $68ed470d6b1d64e7$require$each = $8lWh1.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $68ed470d6b1d64e7$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$68ed470d6b1d64e7$var$MediaQuery.prototype = {
    constuctor: $68ed470d6b1d64e7$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $feyF1(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $68ed470d6b1d64e7$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $68ed470d6b1d64e7$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? "on" : "off";
        $68ed470d6b1d64e7$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $68ed470d6b1d64e7$var$MediaQuery;

});
parcelRegister("feyF1", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $b1730cb140964a33$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$b1730cb140964a33$var$QueryHandler.prototype = {
    constructor: $b1730cb140964a33$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $b1730cb140964a33$var$QueryHandler;

});

parcelRegister("8lWh1", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $614d7cd0df356d8c$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $614d7cd0df356d8c$var$isArray(target) {
    return Object.prototype.toString.apply(target) === "[object Array]";
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $614d7cd0df356d8c$var$isFunction(target) {
    return typeof target === "function";
}
module.exports = {
    isFunction: $614d7cd0df356d8c$var$isFunction,
    isArray: $614d7cd0df356d8c$var$isArray,
    each: $614d7cd0df356d8c$var$each
};

});








parcelRegister("lga73", function(module, exports) {

$parcel$export(module.exports, "VariantSelector", function () { return $96985ecd348b7f1b$export$867776d444e5a870; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $7mAg3 = parcelRequire("7mAg3");

var $biy3n = parcelRequire("biy3n");

var $33dni = parcelRequire("33dni");


var $gH7Rp = parcelRequire("gH7Rp");

var $20OPj = parcelRequire("20OPj");

var $keJQj = parcelRequire("keJQj");
const $96985ecd348b7f1b$var$classes = $keJQj;
const $96985ecd348b7f1b$export$867776d444e5a870 = ({ cartState: cartState, setCartState: setCartState, hit: hit, isMedium: isMedium, hasSoonTag: hasSoonTag, canWishlist: canWishlist, hasOneVariant: hasOneVariant, canAddToCart: canAddToCart, isGroupProduct: isGroupProduct, hasPreorderTag: hasPreorderTag, selectionText: selectionText, variants: variants, Dialog: Dialog, ProductPrice: ProductPrice, badgeText: badgeText, title: title, subtitle: subtitle, currency: currency, messageText: messageText, hasSizeVariant: hasSizeVariant, messageStyles: messageStyles, unavailableVariants: unavailableVariants, wishState: wishState, handleCartClick: handleCartClick, handleWishClick: handleWishClick, sanitiseTitle: sanitiseTitle, comingSoonSignup: comingSoonSignup, womensPhotoPreferred: womensPhotoPreferred })=>{
    const { bundleFunctions: bundleFunctions, collection: collection, customerTags: customerTags } = (0, $7mAg3.usePLPContext)();
    // const { utilities } = usePLPContext();
    const soonTagExists = hit.tags.some((tag)=>tag.toLowerCase() === "soon");
    const ignoreSoonTag = soonTagExists && customerTags ? customerTags.some((tag)=>tag.toLowerCase().includes("ignore-soon")) : false; // Ignore Soon tag | Meant for Admin product testing.
    const hasColourVariant = hit.options.some(({ name: name })=>name.toLowerCase() === "colour");
    const variantType = hit.options[0].name;
    const [selectedVariant, setSelectedVariant] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(`Selected ${variantType.toLowerCase()}`);
    // let variantsTMP = variants
    // variantsTMP.forEach(variant => {
    //   variant.quantity = 0
    //   variant.product_title = title
    //   variant.featured_image = hit.image.src
    //   variant.option_name = hasColourVariant ? 'Colour' : hasSizeVariant ? 'Size' : ''
    // })
    // const [bogoCount, setBogoCount] = React.useState(variantsTMP)
    // const [totalSelected, setTotalSelected] = React.useState(0);
    function filterGalleryImages() {
        let hitImages = hit.images.filter((img)=>!img.src.includes("ATHLETE_"));
        if (womensPhotoPreferred) hitImages.forEach((image, i)=>{
            if (image.src.includes("-WOMENS")) {
                hitImages.splice(i, 1);
                hitImages.unshift(image);
            }
        });
        return hitImages;
    }
    const totalSelected = ()=>{
        let count = 0;
        let relatedProducts = bundleFunctions?.bundleProducts.filter((prod)=>prod.product_id == hit.id);
        if (relatedProducts) relatedProducts.forEach((prod)=>{
            count = count + prod.quantity;
        });
        return count;
    };
    const bundleTag = hit.tags.find((tag)=>tag.startsWith("bundle:")) ? hit.tags.find((tag)=>tag.startsWith("bundle:")).split(":") : false;
    const handleAddToDecider = (variant, increment)=>{
        if (hasSoonTag) {
            handleWishClick(variant.id)(); // Run Wishlist function
            setCartState((prev)=>({
                    ...prev,
                    open: false
                }));
        } else if (bundleFunctions?.bundleType == "bogo" || bundleFunctions?.bundleType == "fixed-price-bundle" || bundleFunctions?.bundleType == "rollover-bundle") {
            if (bundleFunctions.bundleCanAddMore() || increment < 0) {
                let variantsTMP = variants;
                variantsTMP.forEach((vari, i)=>{
                    const currentBundles = bundleFunctions?.bundleProducts;
                    const existingVariant = currentBundles.find((ele)=>ele.id == vari.id);
                    vari.quantity = existingVariant != undefined ? existingVariant.quantity : 0;
                    vari.product_title = title;
                    vari.featured_image = hit.image.src;
                    vari.option_name = hasColourVariant ? "Colour" : hasSizeVariant ? "Size" : "";
                    if (vari.id == variant.id && (vari.quantity != variant.inventory_quantity || increment < 0)) //Keep track of total individual variant selected quantites
                    variant.quantity = variant.quantity + increment;
                });
                bundleFunctions.updateBundleProducts(variantsTMP);
                setTimeout(()=>{
                    setCartState((prev)=>({
                            ...prev,
                            open: false
                        }));
                }, 850);
            }
        } else {
            let bundleArray = {};
            if (bundleTag) switch(bundleTag[1]){
                case "bogo":
                    bundleArray["_Special"] = "bogo";
                    bundleArray["_Discount"] = bundleTag[2];
                    bundleArray["_Key"] = bundleTag[4];
                    break;
                case "fixed":
                    bundleArray["_Special"] = "fixed-price-bundle";
                    bundleArray["_Threshold"] = bundleTag[2];
                    bundleArray["_Discount"] = bundleTag[3];
                    bundleArray["_Key"] = bundleTag[4];
                    break;
                case "rollover":
                    bundleArray["_Special"] = "rollover-bundle";
                    bundleArray["_Threshold"] = bundleTag[2];
                    bundleArray["_Discount"] = bundleTag[3];
                    bundleArray["_Key"] = bundleTag[4];
                    break;
            }
            handleCartClick(variant.id, bundleArray); // Otherwise, run Add to Cart function
        }
    };
    // const soldOut = variants.reduce((accumulator, currentVariant) => accumulator + currentVariant.inventory_quantity, 0) > 0 || hasSoonTag ? true : false;
    let buttonText;
    if (hasSoonTag || collection?.forceWishlist) buttonText = "Add to Wishlist";
    else if (bundleFunctions?.bundleType == "bogo" || bundleFunctions?.bundleType == "fixed-price-bundle" || bundleFunctions?.bundleType == "rollover-bundle") {
        if (totalSelected() > 0) buttonText = `${totalSelected()} Selected`;
        else buttonText = "Add to Bundle";
    } else if (hasColourVariant && !hasOneVariant) buttonText = "Select Colour";
    else if (isGroupProduct) buttonText = selectionText;
    else if (hasPreorderTag && canAddToCart) buttonText = window.variantStrings.preOrder;
    else if (!canAddToCart) buttonText = "Add to Wishlist";
    else // buttonText = window.variantStrings.addToCart;
    buttonText = ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd;
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: $96985ecd348b7f1b$var$classes.cartContainer + " cartContainer",
        onMouseLeave: ()=>{
            isMedium && !hasOneVariant && (canAddToCart || canWishlist) && (isGroupProduct || !isGroupProduct) && setCartState((prev)=>({
                    ...prev,
                    open: false
                }));
        },
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $96985ecd348b7f1b$var$classes.variantButtonWrapper + " variantButtonWrapper",
                children: [
                    totalSelected() > 0 && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                        children: hasOneVariant && !isGroupProduct && /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                            className: $96985ecd348b7f1b$var$classes.singleVariantButtonDecrease,
                            onClick: (event)=>{
                                event.preventDefault();
                                let increment = -1;
                                handleAddToDecider(variants[0], increment);
                            },
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                        // disabled={ !bundleFunctions.bundleCanAddMore() && !bundleFunctions.productVariantInBundle(hit.id) }
                        type: "button",
                        onClick: (event)=>{
                            event.preventDefault();
                            let increment = 1;
                            hasOneVariant && !isGroupProduct ? handleAddToDecider(variants[0], increment) : setCartState((prev)=>({
                                    ...prev,
                                    open: true
                                }));
                        },
                        "aria-haspopup": "dialog",
                        "aria-label": hasPreorderTag && canAddToCart ? window.variantStrings.preOrder : ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd,
                        className: (0, $biy3n.default)($96985ecd348b7f1b$var$classes.cartButton + " cartButton ", {
                            fab: !isMedium,
                            loading: hasSoonTag // If 'Soon' Tag present
                             ? isMedium && wishState.loading !== null // Check wishState to display
                             : cartState.loading && hasOneVariant // Otherwise check cartState to display
                            ,
                            "button button--outlined": isMedium,
                            hidden: collection?.forceWishlist ? !wishState.ready : hasSoonTag // If 'Soon' Tag present
                             ? !wishState.ready || comingSoonSignup && !collection?.forceWishlist // Hide if wishState is not ready or if coming soon signups is enabled.
                             : !canAddToCart && !hasSoonTag // Otherwise, check if can add to cart
                        }),
                        onMouseEnter: ()=>{
                            isMedium && !hasOneVariant && (canAddToCart || hasSoonTag) && (isGroupProduct || !isGroupProduct) && setCartState((prev)=>({
                                    ...prev,
                                    open: true
                                }));
                        },
                        children: [
                            buttonText,
                            buttonText == "Quick Add" && /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                children: "+"
                            })
                        ]
                    }),
                    totalSelected() > 0 && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                        children: hasOneVariant && !isGroupProduct && bundleFunctions?.bundleProducts.find((ele)=>ele.id == variants[0].id && ele.quantity > 0 && variants[0].inventory_quantity != ele.quantity) && bundleFunctions.bundleCanAddMore() && /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                            className: $96985ecd348b7f1b$var$classes.singleVariantButtonIncrease,
                            onClick: (event)=>{
                                event.preventDefault();
                                let increment = 1;
                                handleAddToDecider(variants[0], increment);
                            },
                            children: "+"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: (0, $biy3n.default)($96985ecd348b7f1b$var$classes.cartModal + " cartModal ", {
                    [$96985ecd348b7f1b$var$classes.open + " open"]: cartState.open
                }),
                children: /*#__PURE__*/ (0, $drmv2.jsxs)(Dialog, {
                    open: cartState.open,
                    onClose: ()=>{
                        setCartState((prev)=>({
                                ...prev,
                                open: false
                            }));
                    },
                    lockScroll: !isMedium,
                    className: $96985ecd348b7f1b$var$classes.cartDialog + " cartDialog",
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                            type: "button",
                            className: (0, $biy3n.default)("fab", $96985ecd348b7f1b$var$classes.dialogCloseButton),
                            onClick: (event)=>{
                                event.preventDefault();
                                setCartState((prev)=>({
                                        ...prev,
                                        open: false
                                    }));
                            },
                            children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                                icon: (0, $gH7Rp.faXmark),
                                width: 16,
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            className: $96985ecd348b7f1b$var$classes.dialogHeader,
                            children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                className: $96985ecd348b7f1b$var$classes.dialogTitle,
                                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                    className: "uppercase h4",
                                    children: hasSoonTag ? buttonText : hasPreorderTag && canAddToCart ? window.variantStrings.preOrder : ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd
                                })
                            })
                        }),
                        !isMedium && /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                    className: "variant-gallery-slider",
                                    children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $20OPj.default), {
                                        gallery: filterGalleryImages(),
                                        preSettings: {
                                            dots: false,
                                            infinite: false,
                                            speed: 500,
                                            arrows: false,
                                            slidesToShow: 3.5,
                                            slidesToScroll: 3
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: `${$96985ecd348b7f1b$var$classes.dialogItem} info`,
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                            className: $96985ecd348b7f1b$var$classes.dialogItemHeader,
                                            children: [
                                                /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                    className: $96985ecd348b7f1b$var$classes.quickBadge,
                                                    children: badgeText
                                                }),
                                                /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                    className: $96985ecd348b7f1b$var$classes.dialogItemTitle,
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                    className: $96985ecd348b7f1b$var$classes.dialogItemSubtitle,
                                                    children: subtitle
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)(ProductPrice, {
                                            product: hit,
                                            currency: currency
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: "variant-title",
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsxs)("b", {
                                            children: [
                                                variantType.toUpperCase(),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                            children: selectedVariant
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            role: "group",
                            className: $96985ecd348b7f1b$var$classes.cartActions + " cartActions " + `${!hasSizeVariant ? $96985ecd348b7f1b$var$classes.nonSizeVariant + " nonSizeVariant" : "hasSizeVariant"}`,
                            children: variants.map((variant)=>/*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: $96985ecd348b7f1b$var$classes.variantHitbntWrapper + " variantHitbntWrapper",
                                    children: [
                                        bundleFunctions?.bundleProducts.find((ele)=>ele.id == variant.id && ele.quantity > 0) && /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                            className: $96985ecd348b7f1b$var$classes.decreaseBundleBtn,
                                            onClick: (event)=>{
                                                event.preventDefault();
                                                let increment = -1;
                                                handleAddToDecider(variant, increment);
                                            },
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                                            disabled: variant.inventory_policy === "deny" && !hasSoonTag && variant.inventory_quantity <= 0,
                                            type: "button",
                                            onClick: (event)=>{
                                                event.preventDefault();
                                                setSelectedVariant(sanitiseTitle(variant.title));
                                                let increment = 1;
                                                handleAddToDecider(variant, increment);
                                            },
                                            className: (0, $biy3n.default)($96985ecd348b7f1b$var$classes.hitButton + " hitButton " + `${!hasSizeVariant ? $96985ecd348b7f1b$var$classes.nonSizeButtonVariant + " nonSizeButtonVariant" : "sizeButtonVariant"}`, {
                                                [$96985ecd348b7f1b$var$classes.loading + " loading"]: cartState.loading === variant.id,
                                                [$96985ecd348b7f1b$var$classes.isGroupProduct]: isGroupProduct
                                            }),
                                            children: [
                                                false,
                                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                    children: [
                                                        sanitiseTitle(variant.title),
                                                        bundleFunctions?.bundleProducts.find((ele)=>ele.id == variant.id && ele.quantity > 0) && /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                            className: $96985ecd348b7f1b$var$classes.bubble,
                                                            children: bundleFunctions?.bundleProducts.find((ele)=>ele.id == variant.id).quantity
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, variant.id),
                                        bundleFunctions?.bundleProducts.find((ele)=>ele.id == variant.id && ele.quantity > 0 && variant.inventory_quantity != ele.quantity) && bundleFunctions.bundleCanAddMore() && /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                            className: $96985ecd348b7f1b$var$classes.increaseBundleBtn,
                                            children: "+"
                                        })
                                    ]
                                }, variant.id))
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("363gu", function(module, exports) {

$parcel$export(module.exports, "WishlistSelector", function () { return $9185671510240e3f$export$bb1f4d75d2821fa3; });

var $drmv2 = parcelRequire("drmv2");
parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $keJQj = parcelRequire("keJQj");

var $33dni = parcelRequire("33dni");

var $hrXY5 = parcelRequire("hrXY5");

var $gH7Rp = parcelRequire("gH7Rp");
parcelRequire("dkhsa");
var $bf1Az = parcelRequire("bf1Az");
const $9185671510240e3f$var$classes = $keJQj;
const $9185671510240e3f$export$bb1f4d75d2821fa3 = ({ hit: hit, isMedium: isMedium, hasOneVariant: hasOneVariant, canWishlist: canWishlist, isGroupProduct: isGroupProduct, variants: variants, Dialog: Dialog, badgeText: badgeText, title: title, subtitle: subtitle, currency: currency, messageStyles: messageStyles, messageText: messageText, wishState: wishState, setWishState: setWishState, handleWishClick: handleWishClick, sanitiseTitle: sanitiseTitle, cartState: cartState, setCartState: setCartState })=>{
    // const [wishState, setWishState] = React.useState({
    //     loading: null,
    //     open: false,
    //     ready: false,
    //     wishedVariants: {},
    // });
    // const handleWishClick = (variantId: number) => async () => {
    //     setWishState((prev) => ({
    //       ...prev,
    //       loading: variantId,
    //     }));
    //     const variant = variants.find(({ id }) => id === variantId);
    //     const data = {
    //       epi: variantId,
    //       empi: isGroupProduct ? variant.prod_id : hit.id,
    //       du: `${window.location.origin}/products/${isGroupProduct ? variant.handle : hit.handle}`,
    //       dt: isGroupProduct ? variant.title : hit.title,
    //       iu: isGroupProduct ? variant.image.src : hit.image.src,
    //       pr: Number(variant.price),
    //       vi: variant.title,
    //     };
    //     try {
    //       await new Promise<void>((resolve) =>
    //         window._swat.addToWishList(data, resolve)
    //       );
    //       setWishState((prev) => ({
    //         ...prev,
    //         wishedVariants: {
    //           ...prev.wishedVariants,
    //           [variantId]: true,
    //         },
    //       }));
    //     } catch (error) {
    //       console.error(error);
    //     }
    //     setWishState((prev) => ({
    //       ...prev,
    //       loading: null,
    //       open: false,
    //     }));
    // };
    // React.useEffect(() => {
    //     let mounted = true;
    //     const onInit = (products) => {
    //       const wishedVariants = products
    //         .filter(({ empi }) => empi === hit.id && !isGroupProduct || isGroupProduct && variants.filter(x => x.prod === empi))
    //         .reduce(
    //           (acc, { epi }) => ({
    //             ...acc,
    //             [epi]: true,
    //           }),
    //           {}
    //         );
    //       if (mounted) {
    //         setWishState((prev) => ({
    //           ...prev,
    //           ready: true,
    //           wishedVariants,
    //         }));
    //       }
    //     };
    //     if ("_swat" in window) {
    //       window._swat.fetch(onInit);
    //     } else {
    //       window.SwymCallbacks = window.SwymCallbacks || [];
    //       window.SwymCallbacks.push((swat) => {
    //         swat.fetch(onInit);
    //       });
    //     }
    //     return () => {
    //       mounted = false;
    //     };
    // }, []);
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: "wishContainer " + (0, $biy3n.default)($9185671510240e3f$var$classes.wishContainer, {
            hidden: !wishState.ready || !canWishlist
        }),
        onMouseEnter: ()=>{
            isMedium && !hasOneVariant && setWishState((prev)=>({
                    ...prev,
                    open: true
                }));
            isMedium && !hasOneVariant && setCartState((prev)=>({
                    ...prev,
                    open: false
                }));
        },
        onMouseLeave: ()=>{
            isMedium && !hasOneVariant && setWishState((prev)=>({
                    ...prev,
                    open: false
                }));
        },
        children: [
            /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                type: "button",
                "aria-label": window.accessibilityStrings.addToWishlist,
                "aria-haspopup": "dialog",
                className: (0, $biy3n.default)("fab wishlistButton ", $9185671510240e3f$var$classes.wishButton, {
                    loading: isMedium && wishState.loading !== null
                }),
                onClick: ()=>{
                    hasOneVariant && !isGroupProduct ? handleWishClick(variants[0].id)() : setWishState((prev)=>({
                            ...prev,
                            open: true
                        }));
                },
                children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                    icon: Object.keys(wishState.wishedVariants).length > 0 ? (0, $hrXY5.faHeart) : (0, $gH7Rp.faHeart),
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                className: (0, $biy3n.default)($9185671510240e3f$var$classes.wishModal, {
                    [$9185671510240e3f$var$classes.open]: wishState.open
                }),
                children: /*#__PURE__*/ (0, $drmv2.jsxs)(Dialog, {
                    lockScroll: !isMedium,
                    open: wishState.open,
                    onClose: ()=>{
                        setWishState((prev)=>({
                                ...prev,
                                open: false
                            }));
                    },
                    className: (0, $biy3n.default)($9185671510240e3f$var$classes.wishDialog, {
                        [$9185671510240e3f$var$classes.open]: wishState.open
                    }),
                    children: [
                        /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                            type: "button",
                            className: (0, $biy3n.default)("fab", $9185671510240e3f$var$classes.dialogCloseButton),
                            onClick: (event)=>{
                                event.preventDefault();
                                setWishState((prev)=>({
                                        ...prev,
                                        open: false
                                    }));
                            },
                            children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                                icon: (0, $gH7Rp.faXmark),
                                width: 16,
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                            className: $9185671510240e3f$var$classes.dialogHeader,
                            children: [
                                /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                    className: $9185671510240e3f$var$classes.dialogTitle,
                                    children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                        className: "uppercase h4",
                                        children: window.variantStrings.addToWishlist
                                    })
                                }),
                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: $9185671510240e3f$var$classes.dialogItem,
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                            className: $9185671510240e3f$var$classes.dialogItemImage,
                                            children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                className: "media media--portrait",
                                                children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                                                    alt: hit.image?.alt,
                                                    src: wishState.open ? window.Shopify.addSizeToImage(hit.image.src, 128) : null,
                                                    srcSet: wishState.open ? `${window.Shopify.addSizeToImage(hit.image.src, 128)} 1x, ${window.Shopify.addSizeToImage(hit.image.src, 256)} 2x` : null,
                                                    width: 128,
                                                    height: 160
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                    className: $9185671510240e3f$var$classes.dialogItemHeader,
                                                    children: [
                                                        /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                            className: $9185671510240e3f$var$classes.quickBadge,
                                                            children: badgeText
                                                        }),
                                                        /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                            className: $9185671510240e3f$var$classes.dialogItemTitle,
                                                            children: title
                                                        }),
                                                        /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                            className: $9185671510240e3f$var$classes.dialogItemSubtitle,
                                                            children: subtitle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $drmv2.jsx)((0, $bf1Az.ProductPrice), {
                                                    product: hit,
                                                    currency: currency
                                                }),
                                                /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                    className: $9185671510240e3f$var$classes.quickMessage,
                                                    style: messageStyles,
                                                    children: messageText
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                            role: "group",
                            className: $9185671510240e3f$var$classes.dialogList,
                            children: variants.map((variant)=>/*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                    type: "button",
                                    onClick: handleWishClick(variant.id),
                                    className: (0, $biy3n.default)({
                                        loading: wishState.loading === variant.id,
                                        [$9185671510240e3f$var$classes.hitButton]: !isMedium,
                                        [$9185671510240e3f$var$classes.dialogListItem]: isMedium,
                                        [$9185671510240e3f$var$classes.groupProductDialogListItem]: isGroupProduct
                                    }),
                                    children: sanitiseTitle(variant.title)
                                }, variant.id))
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("7i1rO", function(module, exports) {

$parcel$export(module.exports, "ProductTimer", function () { return $2cb64f39f11078ba$export$399332db1e0dca19; });

var $drmv2 = parcelRequire("drmv2");
const $2cb64f39f11078ba$export$399332db1e0dca19 = ({ hit: hit })=>{
    const countDownTag = document.querySelector("body").dataset?.countdownTag;
    const countText = document.querySelector("body").dataset?.countdownText;
    const hasSoonTag = hit.tags.some((tag)=>tag.toLowerCase() === "soon");
    const hasCountdownTag = hit.tags.some((tag)=>tag.toLowerCase() === countDownTag);
    return /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
        children: hasCountdownTag && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
            className: "productTimerContainer"
        })
    });
};

});



parcelRegister("2a9eH", function(module, exports) {

$parcel$export(module.exports, "Advert", function () { return $fb6e3cd9a9db3ad0$export$cc61619f53a781bf; });

var $drmv2 = parcelRequire("drmv2");

var $60uP6 = parcelRequire("60uP6");

var $1vrWl = parcelRequire("1vrWl");

var $biy3n = parcelRequire("biy3n");

var $3aT1w = parcelRequire("3aT1w");

var $cLwUY = parcelRequire("cLwUY");
const $fb6e3cd9a9db3ad0$var$ImageAsset = ({ creative: creative })=>{
    const [measureRef, measureRect] = (0, $3aT1w.default)();
    const widths = [
        320,
        480,
        640
    ];
    const src = creative.value;
    const srcSet = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>widths.map((width, _, arr)=>`${src}?width${width} ${width / arr[0]}x`).join(", "), [
        src
    ]);
    return /*#__PURE__*/ (0, $drmv2.jsx)("div", {
        ref: measureRef,
        className: "media",
        style: {
            paddingBottom: `${Math.floor(100 / creative.aspect_ratio)}%`
        },
        children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
            alt: creative.alt,
            width: 320,
            height: Math.ceil(320 / creative.aspect_ratio),
            src: src,
            srcSet: srcSet,
            loading: "lazy",
            sizes: measureRect.width + "px"
        })
    });
};
const $fb6e3cd9a9db3ad0$var$VideoAsset = ({ creative: creative })=>{
    const [measureRef, measureRect] = (0, $3aT1w.default)();
    const videoRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const combinedRef = (0, $60uP6.default)(measureRef, videoRef);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const observer = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                const video = entry.target;
                video.load();
                video.play();
                observer.unobserve(video);
            }
        }, {
            rootMargin: "400px 0px"
        });
        observer.observe(videoRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    const targetSource = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useMemo(()=>{
        const mpegSources = creative.value.sources.filter(({ format: format })=>format === "mp4");
        const source = creative.value.sources.find(({ width: width })=>width >= measureRect.width * window.devicePixelRatio);
        return source || mpegSources[mpegSources.length - 1];
    }, [
        measureRect.width
    ]);
    return /*#__PURE__*/ (0, $drmv2.jsx)("div", {
        className: "media",
        style: {
            paddingBottom: `${100 / creative.aspect_ratio}%`
        },
        children: /*#__PURE__*/ (0, $drmv2.jsx)("video", {
            ref: combinedRef,
            poster: creative.preview_image,
            preload: "metadata",
            disablePictureInPicture: true,
            disableRemotePlayback: true,
            loop: true,
            autoPlay: true,
            muted: true,
            playsInline: true,
            children: /*#__PURE__*/ (0, $drmv2.jsx)("source", {
                src: targetSource.url,
                type: targetSource.mime_type
            })
        })
    });
};
const $fb6e3cd9a9db3ad0$export$cc61619f53a781bf = ({ advert: advert, slot: slot })=>{
    const rootRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    ecommerce: null
                });
                window.dataLayer.push({
                    event: "promotionView",
                    ecommerce: {
                        promoView: {
                            promotions: [
                                {
                                    id: advert.campaign_id,
                                    name: advert.campaign_name,
                                    creative: advert.creative,
                                    asset_link: typeof advert.creative.value !== "string" ? advert.creative.value.sources[0].url : advert.creative.value,
                                    position: slot
                                }
                            ]
                        }
                    }
                });
                observer.disconnect();
            }
        });
        observer.observe(rootRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    const handleClick = (event)=>{
        event.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ecommerce: null
        });
        const navigate = ()=>{
            window.location.href = href;
        };
        window.dataLayer.push({
            event: "promotionClick",
            ecommerce: {
                promoClick: {
                    promotions: [
                        {
                            name: advert.campaign_name,
                            id: advert.campaign_id,
                            creative: advert.creative,
                            asset_link: typeof advert.creative.value !== "string" ? advert.creative.value.sources[0].url : advert.creative.value,
                            position: slot
                        }
                    ]
                }
            },
            eventCallback: navigate,
            eventTimeout: 1000
        });
        setTimeout(navigate, 1000);
    };
    if (advert.link != null) {
        var href = advert.link;
        var target = new URL(href).origin !== window.location.origin ? "_blank" : "_self";
    }
    return /*#__PURE__*/ (0, $drmv2.jsx)("article", {
        className: $cLwUY.root,
        ref: rootRef,
        children: /*#__PURE__*/ (0, $drmv2.jsx)("a", {
            onClick: handleClick,
            className: (0, $biy3n.default)("link-unstyled", {
                pointer_events_none: advert.link == null
            }),
            href: href,
            target: target,
            children: advert.creative.media_type === "video" ? /*#__PURE__*/ (0, $drmv2.jsx)($fb6e3cd9a9db3ad0$var$VideoAsset, {
                creative: advert.creative
            }) : /*#__PURE__*/ (0, $drmv2.jsx)($fb6e3cd9a9db3ad0$var$ImageAsset, {
                creative: advert.creative
            })
        })
    });
};

});
parcelRegister("cLwUY", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $94b368a2591412f8$export$e8e78c978b129247; }, function (v) { return $94b368a2591412f8$export$e8e78c978b129247 = v; });
var $94b368a2591412f8$export$fec86d37f1b64e30;
var $94b368a2591412f8$export$987d49ffe1b0900f;
var $94b368a2591412f8$export$e8e78c978b129247;
$94b368a2591412f8$export$fec86d37f1b64e30 = `_4U4vG_advert`;
$94b368a2591412f8$export$987d49ffe1b0900f = `_4U4vG_media`;
$94b368a2591412f8$export$e8e78c978b129247 = `_4U4vG_root`;

});



parcelRegister("47EJY", function(module, exports) {

var $hVPr9 = parcelRequire("hVPr9");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $30076b1ca915c4b2$var$isEqual(value, other) {
    return $hVPr9(value, other);
}
module.exports = $30076b1ca915c4b2$var$isEqual;

});
parcelRegister("hVPr9", function(module, exports) {

var $4LFzi = parcelRequire("4LFzi");

var $1RG6v = parcelRequire("1RG6v");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d0dfa8da7d97a1a4$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$1RG6v(value) && !$1RG6v(other)) return value !== value && other !== other;
    return $4LFzi(value, other, bitmask, customizer, $d0dfa8da7d97a1a4$var$baseIsEqual, stack);
}
module.exports = $d0dfa8da7d97a1a4$var$baseIsEqual;

});
parcelRegister("4LFzi", function(module, exports) {

var $2h3ag = parcelRequire("2h3ag");

var $8j7RO = parcelRequire("8j7RO");

var $dbauZ = parcelRequire("dbauZ");

var $ghiZc = parcelRequire("ghiZc");

var $iMJUu = parcelRequire("iMJUu");

var $jeaYM = parcelRequire("jeaYM");

var $ikJFa = parcelRequire("ikJFa");

var $9XN7W = parcelRequire("9XN7W");
/** Used to compose bitmasks for value comparisons. */ var $378bcbc9535b5f5c$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $378bcbc9535b5f5c$var$argsTag = "[object Arguments]", $378bcbc9535b5f5c$var$arrayTag = "[object Array]", $378bcbc9535b5f5c$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $378bcbc9535b5f5c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $378bcbc9535b5f5c$var$hasOwnProperty = $378bcbc9535b5f5c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $378bcbc9535b5f5c$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $jeaYM(object), othIsArr = $jeaYM(other), objTag = objIsArr ? $378bcbc9535b5f5c$var$arrayTag : $iMJUu(object), othTag = othIsArr ? $378bcbc9535b5f5c$var$arrayTag : $iMJUu(other);
    objTag = objTag == $378bcbc9535b5f5c$var$argsTag ? $378bcbc9535b5f5c$var$objectTag : objTag;
    othTag = othTag == $378bcbc9535b5f5c$var$argsTag ? $378bcbc9535b5f5c$var$objectTag : othTag;
    var objIsObj = objTag == $378bcbc9535b5f5c$var$objectTag, othIsObj = othTag == $378bcbc9535b5f5c$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ikJFa(object)) {
        if (!$ikJFa(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $2h3ag);
        return objIsArr || $9XN7W(object) ? $8j7RO(object, other, bitmask, customizer, equalFunc, stack) : $dbauZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $378bcbc9535b5f5c$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $378bcbc9535b5f5c$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $378bcbc9535b5f5c$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $2h3ag);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $2h3ag);
    return $ghiZc(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $378bcbc9535b5f5c$var$baseIsEqualDeep;

});
parcelRegister("2h3ag", function(module, exports) {

var $g58gv = parcelRequire("g58gv");

var $i02U9 = parcelRequire("i02U9");

var $6xkQz = parcelRequire("6xkQz");

var $gmO48 = parcelRequire("gmO48");

var $jjhw0 = parcelRequire("jjhw0");

var $2a1Rc = parcelRequire("2a1Rc");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1a7f9fbc880ef994$var$Stack(entries) {
    var data = this.__data__ = new $g58gv(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1a7f9fbc880ef994$var$Stack.prototype.clear = $i02U9;
$1a7f9fbc880ef994$var$Stack.prototype["delete"] = $6xkQz;
$1a7f9fbc880ef994$var$Stack.prototype.get = $gmO48;
$1a7f9fbc880ef994$var$Stack.prototype.has = $jjhw0;
$1a7f9fbc880ef994$var$Stack.prototype.set = $2a1Rc;
module.exports = $1a7f9fbc880ef994$var$Stack;

});
parcelRegister("g58gv", function(module, exports) {

var $9wZBo = parcelRequire("9wZBo");

var $1EzaP = parcelRequire("1EzaP");

var $bKzrr = parcelRequire("bKzrr");

var $4D2aJ = parcelRequire("4D2aJ");

var $kHuNd = parcelRequire("kHuNd");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bb53863f91cc8a22$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$bb53863f91cc8a22$var$ListCache.prototype.clear = $9wZBo;
$bb53863f91cc8a22$var$ListCache.prototype["delete"] = $1EzaP;
$bb53863f91cc8a22$var$ListCache.prototype.get = $bKzrr;
$bb53863f91cc8a22$var$ListCache.prototype.has = $4D2aJ;
$bb53863f91cc8a22$var$ListCache.prototype.set = $kHuNd;
module.exports = $bb53863f91cc8a22$var$ListCache;

});
parcelRegister("9wZBo", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6f06e3177a720603$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $6f06e3177a720603$var$listCacheClear;

});

parcelRegister("1EzaP", function(module, exports) {

var $bbdTe = parcelRequire("bbdTe");
/** Used for built-in method references. */ var $1344cfa6f0480f15$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $1344cfa6f0480f15$var$splice = $1344cfa6f0480f15$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1344cfa6f0480f15$var$listCacheDelete(key) {
    var data = this.__data__, index = $bbdTe(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $1344cfa6f0480f15$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $1344cfa6f0480f15$var$listCacheDelete;

});
parcelRegister("bbdTe", function(module, exports) {

var $3wRDn = parcelRequire("3wRDn");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0219bbdafe61b18f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3wRDn(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $0219bbdafe61b18f$var$assocIndexOf;

});
parcelRegister("3wRDn", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $291df6e409d6cf61$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $291df6e409d6cf61$var$eq;

});



parcelRegister("bKzrr", function(module, exports) {

var $bbdTe = parcelRequire("bbdTe");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $88df7b899b63edb5$var$listCacheGet(key) {
    var data = this.__data__, index = $bbdTe(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $88df7b899b63edb5$var$listCacheGet;

});

parcelRegister("4D2aJ", function(module, exports) {

var $bbdTe = parcelRequire("bbdTe");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $35ec7d432d9cfb1d$var$listCacheHas(key) {
    return $bbdTe(this.__data__, key) > -1;
}
module.exports = $35ec7d432d9cfb1d$var$listCacheHas;

});

parcelRegister("kHuNd", function(module, exports) {

var $bbdTe = parcelRequire("bbdTe");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $f11fb59e35d31452$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bbdTe(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $f11fb59e35d31452$var$listCacheSet;

});


parcelRegister("i02U9", function(module, exports) {

var $g58gv = parcelRequire("g58gv");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d1aa7addf7b995c0$var$stackClear() {
    this.__data__ = new $g58gv;
    this.size = 0;
}
module.exports = $d1aa7addf7b995c0$var$stackClear;

});

parcelRegister("6xkQz", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4c25fee487510399$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $4c25fee487510399$var$stackDelete;

});

parcelRegister("gmO48", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bea5896547d73621$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $bea5896547d73621$var$stackGet;

});

parcelRegister("jjhw0", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e0ed60d1bfadbe34$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $e0ed60d1bfadbe34$var$stackHas;

});

parcelRegister("2a1Rc", function(module, exports) {

var $g58gv = parcelRequire("g58gv");

var $2IDap = parcelRequire("2IDap");

var $9MyXR = parcelRequire("9MyXR");
/** Used as the size to enable large array optimizations. */ var $192df4b2d4845576$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $192df4b2d4845576$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $g58gv) {
        var pairs = data.__data__;
        if (!$2IDap || pairs.length < $192df4b2d4845576$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9MyXR(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $192df4b2d4845576$var$stackSet;

});
parcelRegister("2IDap", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");

var $ctdLC = parcelRequire("ctdLC");
/* Built-in method references that are verified to be native. */ var $1fae129405fc280c$var$Map = $l9Joq($ctdLC, "Map");
module.exports = $1fae129405fc280c$var$Map;

});
parcelRegister("l9Joq", function(module, exports) {

var $9q8mT = parcelRequire("9q8mT");

var $6oLBO = parcelRequire("6oLBO");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f66da657d049d204$var$getNative(object, key) {
    var value = $6oLBO(object, key);
    return $9q8mT(value) ? value : undefined;
}
module.exports = $f66da657d049d204$var$getNative;

});
parcelRegister("9q8mT", function(module, exports) {

var $442Qd = parcelRequire("442Qd");

var $80XfP = parcelRequire("80XfP");

var $8fVgZ = parcelRequire("8fVgZ");

var $g6TeD = parcelRequire("g6TeD");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6dbd088782fe37d9$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6dbd088782fe37d9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $6dbd088782fe37d9$var$funcProto = Function.prototype, $6dbd088782fe37d9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6dbd088782fe37d9$var$funcToString = $6dbd088782fe37d9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6dbd088782fe37d9$var$hasOwnProperty = $6dbd088782fe37d9$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $6dbd088782fe37d9$var$reIsNative = RegExp("^" + $6dbd088782fe37d9$var$funcToString.call($6dbd088782fe37d9$var$hasOwnProperty).replace($6dbd088782fe37d9$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6dbd088782fe37d9$var$baseIsNative(value) {
    if (!$8fVgZ(value) || $80XfP(value)) return false;
    var pattern = $442Qd(value) ? $6dbd088782fe37d9$var$reIsNative : $6dbd088782fe37d9$var$reIsHostCtor;
    return pattern.test($g6TeD(value));
}
module.exports = $6dbd088782fe37d9$var$baseIsNative;

});
parcelRegister("442Qd", function(module, exports) {

var $8J3X3 = parcelRequire("8J3X3");

var $8fVgZ = parcelRequire("8fVgZ");
/** `Object#toString` result references. */ var $2f59bd5b8b3dd942$var$asyncTag = "[object AsyncFunction]", $2f59bd5b8b3dd942$var$funcTag = "[object Function]", $2f59bd5b8b3dd942$var$genTag = "[object GeneratorFunction]", $2f59bd5b8b3dd942$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $2f59bd5b8b3dd942$var$isFunction(value) {
    if (!$8fVgZ(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $8J3X3(value);
    return tag == $2f59bd5b8b3dd942$var$funcTag || tag == $2f59bd5b8b3dd942$var$genTag || tag == $2f59bd5b8b3dd942$var$asyncTag || tag == $2f59bd5b8b3dd942$var$proxyTag;
}
module.exports = $2f59bd5b8b3dd942$var$isFunction;

});
parcelRegister("8J3X3", function(module, exports) {

var $c32eD = parcelRequire("c32eD");

var $dxXK7 = parcelRequire("dxXK7");

var $8u9pa = parcelRequire("8u9pa");
/** `Object#toString` result references. */ var $65a5975eed19ef3a$var$nullTag = "[object Null]", $65a5975eed19ef3a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $65a5975eed19ef3a$var$symToStringTag = $c32eD ? $c32eD.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $65a5975eed19ef3a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $65a5975eed19ef3a$var$undefinedTag : $65a5975eed19ef3a$var$nullTag;
    return $65a5975eed19ef3a$var$symToStringTag && $65a5975eed19ef3a$var$symToStringTag in Object(value) ? $dxXK7(value) : $8u9pa(value);
}
module.exports = $65a5975eed19ef3a$var$baseGetTag;

});
parcelRegister("c32eD", function(module, exports) {

var $ctdLC = parcelRequire("ctdLC");
/** Built-in value references. */ var $8c577fac7db2dfb2$var$Symbol = $ctdLC.Symbol;
module.exports = $8c577fac7db2dfb2$var$Symbol;

});
parcelRegister("ctdLC", function(module, exports) {

var $ffhbC = parcelRequire("ffhbC");
/** Detect free variable `self`. */ var $9142df55ee9a22df$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9142df55ee9a22df$var$root = $ffhbC || $9142df55ee9a22df$var$freeSelf || Function("return this")();
module.exports = $9142df55ee9a22df$var$root;

});
parcelRegister("ffhbC", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $b195969d281d778b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $b195969d281d778b$var$freeGlobal;

});



parcelRegister("dxXK7", function(module, exports) {

var $c32eD = parcelRequire("c32eD");
/** Used for built-in method references. */ var $9dccb32372adc26b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9dccb32372adc26b$var$hasOwnProperty = $9dccb32372adc26b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9dccb32372adc26b$var$nativeObjectToString = $9dccb32372adc26b$var$objectProto.toString;
/** Built-in value references. */ var $9dccb32372adc26b$var$symToStringTag = $c32eD ? $c32eD.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9dccb32372adc26b$var$getRawTag(value) {
    var isOwn = $9dccb32372adc26b$var$hasOwnProperty.call(value, $9dccb32372adc26b$var$symToStringTag), tag = value[$9dccb32372adc26b$var$symToStringTag];
    try {
        value[$9dccb32372adc26b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9dccb32372adc26b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9dccb32372adc26b$var$symToStringTag] = tag;
        else delete value[$9dccb32372adc26b$var$symToStringTag];
    }
    return result;
}
module.exports = $9dccb32372adc26b$var$getRawTag;

});

parcelRegister("8u9pa", function(module, exports) {
/** Used for built-in method references. */ var $62d86baaf479a41d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $62d86baaf479a41d$var$nativeObjectToString = $62d86baaf479a41d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $62d86baaf479a41d$var$objectToString(value) {
    return $62d86baaf479a41d$var$nativeObjectToString.call(value);
}
module.exports = $62d86baaf479a41d$var$objectToString;

});


parcelRegister("8fVgZ", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $602c26ad340d7561$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $602c26ad340d7561$var$isObject;

});


parcelRegister("80XfP", function(module, exports) {

var $aZksy = parcelRequire("aZksy");
/** Used to detect methods masquerading as native. */ var $5d5c497d79c9fa79$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($aZksy && $aZksy.keys && $aZksy.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5d5c497d79c9fa79$var$isMasked(func) {
    return !!$5d5c497d79c9fa79$var$maskSrcKey && $5d5c497d79c9fa79$var$maskSrcKey in func;
}
module.exports = $5d5c497d79c9fa79$var$isMasked;

});
parcelRegister("aZksy", function(module, exports) {

var $ctdLC = parcelRequire("ctdLC");
/** Used to detect overreaching core-js shims. */ var $021081f277e4de91$var$coreJsData = $ctdLC["__core-js_shared__"];
module.exports = $021081f277e4de91$var$coreJsData;

});


parcelRegister("g6TeD", function(module, exports) {
/** Used for built-in method references. */ var $bba80d65461296cb$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $bba80d65461296cb$var$funcToString = $bba80d65461296cb$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $bba80d65461296cb$var$toSource(func) {
    if (func != null) {
        try {
            return $bba80d65461296cb$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $bba80d65461296cb$var$toSource;

});


parcelRegister("6oLBO", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4a89ea15cf7734a2$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $4a89ea15cf7734a2$var$getValue;

});



parcelRegister("9MyXR", function(module, exports) {

var $cQf9T = parcelRequire("cQf9T");

var $l6bhn = parcelRequire("l6bhn");

var $kLKqX = parcelRequire("kLKqX");

var $goNPS = parcelRequire("goNPS");

var $lRlVk = parcelRequire("lRlVk");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $71f3b7fa514dc119$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$71f3b7fa514dc119$var$MapCache.prototype.clear = $cQf9T;
$71f3b7fa514dc119$var$MapCache.prototype["delete"] = $l6bhn;
$71f3b7fa514dc119$var$MapCache.prototype.get = $kLKqX;
$71f3b7fa514dc119$var$MapCache.prototype.has = $goNPS;
$71f3b7fa514dc119$var$MapCache.prototype.set = $lRlVk;
module.exports = $71f3b7fa514dc119$var$MapCache;

});
parcelRegister("cQf9T", function(module, exports) {

var $6hSwA = parcelRequire("6hSwA");

var $g58gv = parcelRequire("g58gv");

var $2IDap = parcelRequire("2IDap");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $95961989c0e1b4eb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $6hSwA,
        "map": new ($2IDap || $g58gv),
        "string": new $6hSwA
    };
}
module.exports = $95961989c0e1b4eb$var$mapCacheClear;

});
parcelRegister("6hSwA", function(module, exports) {

var $luh3W = parcelRequire("luh3W");

var $bEi88 = parcelRequire("bEi88");

var $5uP4N = parcelRequire("5uP4N");

var $kfP2i = parcelRequire("kfP2i");

var $6Zzuz = parcelRequire("6Zzuz");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $493ea00ce4ff17e2$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$493ea00ce4ff17e2$var$Hash.prototype.clear = $luh3W;
$493ea00ce4ff17e2$var$Hash.prototype["delete"] = $bEi88;
$493ea00ce4ff17e2$var$Hash.prototype.get = $5uP4N;
$493ea00ce4ff17e2$var$Hash.prototype.has = $kfP2i;
$493ea00ce4ff17e2$var$Hash.prototype.set = $6Zzuz;
module.exports = $493ea00ce4ff17e2$var$Hash;

});
parcelRegister("luh3W", function(module, exports) {

var $9y5fQ = parcelRequire("9y5fQ");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $fa49a2934d775359$var$hashClear() {
    this.__data__ = $9y5fQ ? $9y5fQ(null) : {};
    this.size = 0;
}
module.exports = $fa49a2934d775359$var$hashClear;

});
parcelRegister("9y5fQ", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");
/* Built-in method references that are verified to be native. */ var $6f3b5d757fc5c34f$var$nativeCreate = $l9Joq(Object, "create");
module.exports = $6f3b5d757fc5c34f$var$nativeCreate;

});


parcelRegister("bEi88", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $87b17e6c0e22ace8$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $87b17e6c0e22ace8$var$hashDelete;

});

parcelRegister("5uP4N", function(module, exports) {

var $9y5fQ = parcelRequire("9y5fQ");
/** Used to stand-in for `undefined` hash values. */ var $40075fd15c8497c6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $40075fd15c8497c6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $40075fd15c8497c6$var$hasOwnProperty = $40075fd15c8497c6$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $40075fd15c8497c6$var$hashGet(key) {
    var data = this.__data__;
    if ($9y5fQ) {
        var result = data[key];
        return result === $40075fd15c8497c6$var$HASH_UNDEFINED ? undefined : result;
    }
    return $40075fd15c8497c6$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $40075fd15c8497c6$var$hashGet;

});

parcelRegister("kfP2i", function(module, exports) {

var $9y5fQ = parcelRequire("9y5fQ");
/** Used for built-in method references. */ var $ebeccc0df6b7b6a4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ebeccc0df6b7b6a4$var$hasOwnProperty = $ebeccc0df6b7b6a4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ebeccc0df6b7b6a4$var$hashHas(key) {
    var data = this.__data__;
    return $9y5fQ ? data[key] !== undefined : $ebeccc0df6b7b6a4$var$hasOwnProperty.call(data, key);
}
module.exports = $ebeccc0df6b7b6a4$var$hashHas;

});

parcelRegister("6Zzuz", function(module, exports) {

var $9y5fQ = parcelRequire("9y5fQ");
/** Used to stand-in for `undefined` hash values. */ var $5173f894911a8d01$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5173f894911a8d01$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9y5fQ && value === undefined ? $5173f894911a8d01$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $5173f894911a8d01$var$hashSet;

});



parcelRegister("l6bhn", function(module, exports) {

var $i9tKz = parcelRequire("i9tKz");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f5c2e8556ff3dc2b$var$mapCacheDelete(key) {
    var result = $i9tKz(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f5c2e8556ff3dc2b$var$mapCacheDelete;

});
parcelRegister("i9tKz", function(module, exports) {

var $cAcQT = parcelRequire("cAcQT");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d370250a72932f47$var$getMapData(map, key) {
    var data = map.__data__;
    return $cAcQT(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $d370250a72932f47$var$getMapData;

});
parcelRegister("cAcQT", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9292d1023c4a9700$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $9292d1023c4a9700$var$isKeyable;

});



parcelRegister("kLKqX", function(module, exports) {

var $i9tKz = parcelRequire("i9tKz");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f1ec3737584f7106$var$mapCacheGet(key) {
    return $i9tKz(this, key).get(key);
}
module.exports = $f1ec3737584f7106$var$mapCacheGet;

});

parcelRegister("goNPS", function(module, exports) {

var $i9tKz = parcelRequire("i9tKz");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bf058b92520b9325$var$mapCacheHas(key) {
    return $i9tKz(this, key).has(key);
}
module.exports = $bf058b92520b9325$var$mapCacheHas;

});

parcelRegister("lRlVk", function(module, exports) {

var $i9tKz = parcelRequire("i9tKz");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $fe9f8dc9271ae0ff$var$mapCacheSet(key, value) {
    var data = $i9tKz(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $fe9f8dc9271ae0ff$var$mapCacheSet;

});




parcelRegister("8j7RO", function(module, exports) {

var $4V8Dc = parcelRequire("4V8Dc");

var $3xISo = parcelRequire("3xISo");

var $lBWD9 = parcelRequire("lBWD9");
/** Used to compose bitmasks for value comparisons. */ var $60c63350053de041$var$COMPARE_PARTIAL_FLAG = 1, $60c63350053de041$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $60c63350053de041$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $60c63350053de041$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $60c63350053de041$var$COMPARE_UNORDERED_FLAG ? new $4V8Dc : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$3xISo(other, function(othValue, othIndex) {
                if (!$lBWD9(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $60c63350053de041$var$equalArrays;

});
parcelRegister("4V8Dc", function(module, exports) {

var $9MyXR = parcelRequire("9MyXR");

var $8Btgi = parcelRequire("8Btgi");

var $45Uju = parcelRequire("45Uju");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $39532e47e366671e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9MyXR;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$39532e47e366671e$var$SetCache.prototype.add = $39532e47e366671e$var$SetCache.prototype.push = $8Btgi;
$39532e47e366671e$var$SetCache.prototype.has = $45Uju;
module.exports = $39532e47e366671e$var$SetCache;

});
parcelRegister("8Btgi", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $64387a3fac7f3fbd$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $64387a3fac7f3fbd$var$setCacheAdd(value) {
    this.__data__.set(value, $64387a3fac7f3fbd$var$HASH_UNDEFINED);
    return this;
}
module.exports = $64387a3fac7f3fbd$var$setCacheAdd;

});

parcelRegister("45Uju", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2fb34fbb09569ac8$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $2fb34fbb09569ac8$var$setCacheHas;

});


parcelRegister("3xISo", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $294743a3fb0b5068$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $294743a3fb0b5068$var$arraySome;

});

parcelRegister("lBWD9", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fbba887546011cc8$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $fbba887546011cc8$var$cacheHas;

});


parcelRegister("dbauZ", function(module, exports) {

var $c32eD = parcelRequire("c32eD");

var $795H0 = parcelRequire("795H0");

var $3wRDn = parcelRequire("3wRDn");

var $8j7RO = parcelRequire("8j7RO");

var $cQfHy = parcelRequire("cQfHy");

var $hVeaH = parcelRequire("hVeaH");
/** Used to compose bitmasks for value comparisons. */ var $99847245ee5f14ea$var$COMPARE_PARTIAL_FLAG = 1, $99847245ee5f14ea$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $99847245ee5f14ea$var$boolTag = "[object Boolean]", $99847245ee5f14ea$var$dateTag = "[object Date]", $99847245ee5f14ea$var$errorTag = "[object Error]", $99847245ee5f14ea$var$mapTag = "[object Map]", $99847245ee5f14ea$var$numberTag = "[object Number]", $99847245ee5f14ea$var$regexpTag = "[object RegExp]", $99847245ee5f14ea$var$setTag = "[object Set]", $99847245ee5f14ea$var$stringTag = "[object String]", $99847245ee5f14ea$var$symbolTag = "[object Symbol]";
var $99847245ee5f14ea$var$arrayBufferTag = "[object ArrayBuffer]", $99847245ee5f14ea$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $99847245ee5f14ea$var$symbolProto = $c32eD ? $c32eD.prototype : undefined, $99847245ee5f14ea$var$symbolValueOf = $99847245ee5f14ea$var$symbolProto ? $99847245ee5f14ea$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $99847245ee5f14ea$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $99847245ee5f14ea$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $99847245ee5f14ea$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $795H0(object), new $795H0(other))) return false;
            return true;
        case $99847245ee5f14ea$var$boolTag:
        case $99847245ee5f14ea$var$dateTag:
        case $99847245ee5f14ea$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $3wRDn(+object, +other);
        case $99847245ee5f14ea$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $99847245ee5f14ea$var$regexpTag:
        case $99847245ee5f14ea$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $99847245ee5f14ea$var$mapTag:
            var convert = $cQfHy;
        case $99847245ee5f14ea$var$setTag:
            var isPartial = bitmask & $99847245ee5f14ea$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $hVeaH);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $99847245ee5f14ea$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $8j7RO(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $99847245ee5f14ea$var$symbolTag:
            if ($99847245ee5f14ea$var$symbolValueOf) return $99847245ee5f14ea$var$symbolValueOf.call(object) == $99847245ee5f14ea$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $99847245ee5f14ea$var$equalByTag;

});
parcelRegister("795H0", function(module, exports) {

var $ctdLC = parcelRequire("ctdLC");
/** Built-in value references. */ var $533dca1e0fa8f8b9$var$Uint8Array = $ctdLC.Uint8Array;
module.exports = $533dca1e0fa8f8b9$var$Uint8Array;

});

parcelRegister("cQfHy", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $95968555498e7464$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $95968555498e7464$var$mapToArray;

});

parcelRegister("hVeaH", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $d0c2c0b9f59d1840$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $d0c2c0b9f59d1840$var$setToArray;

});


parcelRegister("ghiZc", function(module, exports) {

var $5sD7W = parcelRequire("5sD7W");
/** Used to compose bitmasks for value comparisons. */ var $bd9cf61e9cbfd0b0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $bd9cf61e9cbfd0b0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bd9cf61e9cbfd0b0$var$hasOwnProperty = $bd9cf61e9cbfd0b0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bd9cf61e9cbfd0b0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $bd9cf61e9cbfd0b0$var$COMPARE_PARTIAL_FLAG, objProps = $5sD7W(object), objLength = objProps.length, othProps = $5sD7W(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $bd9cf61e9cbfd0b0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $bd9cf61e9cbfd0b0$var$equalObjects;

});
parcelRegister("5sD7W", function(module, exports) {

var $76AKV = parcelRequire("76AKV");

var $5g2hz = parcelRequire("5g2hz");

var $aKpYu = parcelRequire("aKpYu");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3f9deb1354af1e33$var$getAllKeys(object) {
    return $76AKV(object, $aKpYu, $5g2hz);
}
module.exports = $3f9deb1354af1e33$var$getAllKeys;

});
parcelRegister("76AKV", function(module, exports) {

var $cQIjd = parcelRequire("cQIjd");

var $jeaYM = parcelRequire("jeaYM");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $52c59aea32e92d8e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $jeaYM(object) ? result : $cQIjd(result, symbolsFunc(object));
}
module.exports = $52c59aea32e92d8e$var$baseGetAllKeys;

});
parcelRegister("cQIjd", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $95acb6350984d221$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $95acb6350984d221$var$arrayPush;

});

parcelRegister("jeaYM", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $dff7d76a6de39bbe$var$isArray = Array.isArray;
module.exports = $dff7d76a6de39bbe$var$isArray;

});


parcelRegister("5g2hz", function(module, exports) {

var $erh6c = parcelRequire("erh6c");

var $3EaYO = parcelRequire("3EaYO");
/** Used for built-in method references. */ var $3d40379802ad9052$var$objectProto = Object.prototype;
/** Built-in value references. */ var $3d40379802ad9052$var$propertyIsEnumerable = $3d40379802ad9052$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3d40379802ad9052$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3d40379802ad9052$var$getSymbols = !$3d40379802ad9052$var$nativeGetSymbols ? $3EaYO : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $erh6c($3d40379802ad9052$var$nativeGetSymbols(object), function(symbol) {
        return $3d40379802ad9052$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $3d40379802ad9052$var$getSymbols;

});
parcelRegister("erh6c", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a830d9cd2c7bac35$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $a830d9cd2c7bac35$var$arrayFilter;

});

parcelRegister("3EaYO", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2a7d9fea8936a3f8$var$stubArray() {
    return [];
}
module.exports = $2a7d9fea8936a3f8$var$stubArray;

});


parcelRegister("aKpYu", function(module, exports) {

var $lbjfp = parcelRequire("lbjfp");

var $9DAEU = parcelRequire("9DAEU");

var $iWnCL = parcelRequire("iWnCL");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $7d32594518ac7795$var$keys(object) {
    return $iWnCL(object) ? $lbjfp(object) : $9DAEU(object);
}
module.exports = $7d32594518ac7795$var$keys;

});
parcelRegister("lbjfp", function(module, exports) {

var $6j6xR = parcelRequire("6j6xR");

var $ccPMv = parcelRequire("ccPMv");

var $jeaYM = parcelRequire("jeaYM");

var $ikJFa = parcelRequire("ikJFa");

var $jHbXc = parcelRequire("jHbXc");

var $9XN7W = parcelRequire("9XN7W");
/** Used for built-in method references. */ var $f6b98e394b9f16ff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f6b98e394b9f16ff$var$hasOwnProperty = $f6b98e394b9f16ff$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $f6b98e394b9f16ff$var$arrayLikeKeys(value, inherited) {
    var isArr = $jeaYM(value), isArg = !isArr && $ccPMv(value), isBuff = !isArr && !isArg && $ikJFa(value), isType = !isArr && !isArg && !isBuff && $9XN7W(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6j6xR(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $f6b98e394b9f16ff$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $jHbXc(key, length)))) result.push(key);
    return result;
}
module.exports = $f6b98e394b9f16ff$var$arrayLikeKeys;

});
parcelRegister("6j6xR", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $49799829eb4eaa80$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $49799829eb4eaa80$var$baseTimes;

});

parcelRegister("ccPMv", function(module, exports) {

var $9P5Pt = parcelRequire("9P5Pt");

var $1RG6v = parcelRequire("1RG6v");
/** Used for built-in method references. */ var $8e2ec5b353baf1e3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8e2ec5b353baf1e3$var$hasOwnProperty = $8e2ec5b353baf1e3$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8e2ec5b353baf1e3$var$propertyIsEnumerable = $8e2ec5b353baf1e3$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8e2ec5b353baf1e3$var$isArguments = $9P5Pt(function() {
    return arguments;
}()) ? $9P5Pt : function(value) {
    return $1RG6v(value) && $8e2ec5b353baf1e3$var$hasOwnProperty.call(value, "callee") && !$8e2ec5b353baf1e3$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $8e2ec5b353baf1e3$var$isArguments;

});
parcelRegister("9P5Pt", function(module, exports) {

var $8J3X3 = parcelRequire("8J3X3");

var $1RG6v = parcelRequire("1RG6v");
/** `Object#toString` result references. */ var $726d660660a9f2b9$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $726d660660a9f2b9$var$baseIsArguments(value) {
    return $1RG6v(value) && $8J3X3(value) == $726d660660a9f2b9$var$argsTag;
}
module.exports = $726d660660a9f2b9$var$baseIsArguments;

});
parcelRegister("1RG6v", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $15bb66a14521551c$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $15bb66a14521551c$var$isObjectLike;

});



parcelRegister("ikJFa", function(module, exports) {

var $ctdLC = parcelRequire("ctdLC");

var $1Yu1L = parcelRequire("1Yu1L");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $ctdLC.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Yu1L;
module.exports = isBuffer;

});
parcelRegister("1Yu1L", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $1702afe415c7d5a6$var$stubFalse() {
    return false;
}
module.exports = $1702afe415c7d5a6$var$stubFalse;

});


parcelRegister("jHbXc", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e56b4e446153f976$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $e56b4e446153f976$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e56b4e446153f976$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $e56b4e446153f976$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $e56b4e446153f976$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $e56b4e446153f976$var$isIndex;

});

parcelRegister("9XN7W", function(module, exports) {

var $44N66 = parcelRequire("44N66");

var $2fLLu = parcelRequire("2fLLu");

var $bcBH8 = parcelRequire("bcBH8");
/* Node.js helper references. */ var $740fbb56be8f7041$var$nodeIsTypedArray = $bcBH8 && $bcBH8.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $740fbb56be8f7041$var$isTypedArray = $740fbb56be8f7041$var$nodeIsTypedArray ? $2fLLu($740fbb56be8f7041$var$nodeIsTypedArray) : $44N66;
module.exports = $740fbb56be8f7041$var$isTypedArray;

});
parcelRegister("44N66", function(module, exports) {

var $8J3X3 = parcelRequire("8J3X3");

var $fIdBb = parcelRequire("fIdBb");

var $1RG6v = parcelRequire("1RG6v");
/** `Object#toString` result references. */ var $2f7d9ed9a67ab4fe$var$argsTag = "[object Arguments]", $2f7d9ed9a67ab4fe$var$arrayTag = "[object Array]", $2f7d9ed9a67ab4fe$var$boolTag = "[object Boolean]", $2f7d9ed9a67ab4fe$var$dateTag = "[object Date]", $2f7d9ed9a67ab4fe$var$errorTag = "[object Error]", $2f7d9ed9a67ab4fe$var$funcTag = "[object Function]", $2f7d9ed9a67ab4fe$var$mapTag = "[object Map]", $2f7d9ed9a67ab4fe$var$numberTag = "[object Number]", $2f7d9ed9a67ab4fe$var$objectTag = "[object Object]", $2f7d9ed9a67ab4fe$var$regexpTag = "[object RegExp]", $2f7d9ed9a67ab4fe$var$setTag = "[object Set]", $2f7d9ed9a67ab4fe$var$stringTag = "[object String]", $2f7d9ed9a67ab4fe$var$weakMapTag = "[object WeakMap]";
var $2f7d9ed9a67ab4fe$var$arrayBufferTag = "[object ArrayBuffer]", $2f7d9ed9a67ab4fe$var$dataViewTag = "[object DataView]", $2f7d9ed9a67ab4fe$var$float32Tag = "[object Float32Array]", $2f7d9ed9a67ab4fe$var$float64Tag = "[object Float64Array]", $2f7d9ed9a67ab4fe$var$int8Tag = "[object Int8Array]", $2f7d9ed9a67ab4fe$var$int16Tag = "[object Int16Array]", $2f7d9ed9a67ab4fe$var$int32Tag = "[object Int32Array]", $2f7d9ed9a67ab4fe$var$uint8Tag = "[object Uint8Array]", $2f7d9ed9a67ab4fe$var$uint8ClampedTag = "[object Uint8ClampedArray]", $2f7d9ed9a67ab4fe$var$uint16Tag = "[object Uint16Array]", $2f7d9ed9a67ab4fe$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $2f7d9ed9a67ab4fe$var$typedArrayTags = {};
$2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$float32Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$float64Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$int8Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$int16Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$int32Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$uint8Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$uint8ClampedTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$uint16Tag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$uint32Tag] = true;
$2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$argsTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$arrayTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$arrayBufferTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$boolTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$dataViewTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$dateTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$errorTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$funcTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$mapTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$numberTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$objectTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$regexpTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$setTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$stringTag] = $2f7d9ed9a67ab4fe$var$typedArrayTags[$2f7d9ed9a67ab4fe$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $2f7d9ed9a67ab4fe$var$baseIsTypedArray(value) {
    return $1RG6v(value) && $fIdBb(value.length) && !!$2f7d9ed9a67ab4fe$var$typedArrayTags[$8J3X3(value)];
}
module.exports = $2f7d9ed9a67ab4fe$var$baseIsTypedArray;

});
parcelRegister("fIdBb", function(module, exports) {
/** Used as references for various `Number` constants. */ var $b705838112511b6a$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b705838112511b6a$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $b705838112511b6a$var$MAX_SAFE_INTEGER;
}
module.exports = $b705838112511b6a$var$isLength;

});


parcelRegister("2fLLu", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1a4208999af78d05$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1a4208999af78d05$var$baseUnary;

});

parcelRegister("bcBH8", function(module, exports) {

var $ffhbC = parcelRequire("ffhbC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ffhbC.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("9DAEU", function(module, exports) {

var $1DJ29 = parcelRequire("1DJ29");

var $8dN1p = parcelRequire("8dN1p");
/** Used for built-in method references. */ var $7044313ed09ddaeb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7044313ed09ddaeb$var$hasOwnProperty = $7044313ed09ddaeb$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7044313ed09ddaeb$var$baseKeys(object) {
    if (!$1DJ29(object)) return $8dN1p(object);
    var result = [];
    for(var key in Object(object))if ($7044313ed09ddaeb$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $7044313ed09ddaeb$var$baseKeys;

});
parcelRegister("1DJ29", function(module, exports) {
/** Used for built-in method references. */ var $131c5dbb53b16816$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $131c5dbb53b16816$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $131c5dbb53b16816$var$objectProto;
    return value === proto;
}
module.exports = $131c5dbb53b16816$var$isPrototype;

});

parcelRegister("8dN1p", function(module, exports) {

var $6zaWy = parcelRequire("6zaWy");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5fc59056fa7d1e4b$var$nativeKeys = $6zaWy(Object.keys, Object);
module.exports = $5fc59056fa7d1e4b$var$nativeKeys;

});
parcelRegister("6zaWy", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4c7e8014ccd0eec1$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $4c7e8014ccd0eec1$var$overArg;

});



parcelRegister("iWnCL", function(module, exports) {

var $442Qd = parcelRequire("442Qd");

var $fIdBb = parcelRequire("fIdBb");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $dc9ff809cbddc3b9$var$isArrayLike(value) {
    return value != null && $fIdBb(value.length) && !$442Qd(value);
}
module.exports = $dc9ff809cbddc3b9$var$isArrayLike;

});




parcelRegister("iMJUu", function(module, exports) {

var $8vfRx = parcelRequire("8vfRx");

var $2IDap = parcelRequire("2IDap");

var $j2XyS = parcelRequire("j2XyS");

var $glcO6 = parcelRequire("glcO6");

var $iQI9p = parcelRequire("iQI9p");

var $8J3X3 = parcelRequire("8J3X3");

var $g6TeD = parcelRequire("g6TeD");
/** `Object#toString` result references. */ var $dad05276b1e4f52a$var$mapTag = "[object Map]", $dad05276b1e4f52a$var$objectTag = "[object Object]", $dad05276b1e4f52a$var$promiseTag = "[object Promise]", $dad05276b1e4f52a$var$setTag = "[object Set]", $dad05276b1e4f52a$var$weakMapTag = "[object WeakMap]";
var $dad05276b1e4f52a$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $dad05276b1e4f52a$var$dataViewCtorString = $g6TeD($8vfRx), $dad05276b1e4f52a$var$mapCtorString = $g6TeD($2IDap), $dad05276b1e4f52a$var$promiseCtorString = $g6TeD($j2XyS), $dad05276b1e4f52a$var$setCtorString = $g6TeD($glcO6), $dad05276b1e4f52a$var$weakMapCtorString = $g6TeD($iQI9p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $dad05276b1e4f52a$var$getTag = $8J3X3;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($8vfRx && $dad05276b1e4f52a$var$getTag(new $8vfRx(new ArrayBuffer(1))) != $dad05276b1e4f52a$var$dataViewTag || $2IDap && $dad05276b1e4f52a$var$getTag(new $2IDap) != $dad05276b1e4f52a$var$mapTag || $j2XyS && $dad05276b1e4f52a$var$getTag($j2XyS.resolve()) != $dad05276b1e4f52a$var$promiseTag || $glcO6 && $dad05276b1e4f52a$var$getTag(new $glcO6) != $dad05276b1e4f52a$var$setTag || $iQI9p && $dad05276b1e4f52a$var$getTag(new $iQI9p) != $dad05276b1e4f52a$var$weakMapTag) $dad05276b1e4f52a$var$getTag = function(value) {
    var result = $8J3X3(value), Ctor = result == $dad05276b1e4f52a$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $g6TeD(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $dad05276b1e4f52a$var$dataViewCtorString:
            return $dad05276b1e4f52a$var$dataViewTag;
        case $dad05276b1e4f52a$var$mapCtorString:
            return $dad05276b1e4f52a$var$mapTag;
        case $dad05276b1e4f52a$var$promiseCtorString:
            return $dad05276b1e4f52a$var$promiseTag;
        case $dad05276b1e4f52a$var$setCtorString:
            return $dad05276b1e4f52a$var$setTag;
        case $dad05276b1e4f52a$var$weakMapCtorString:
            return $dad05276b1e4f52a$var$weakMapTag;
    }
    return result;
};
module.exports = $dad05276b1e4f52a$var$getTag;

});
parcelRegister("8vfRx", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");

var $ctdLC = parcelRequire("ctdLC");
/* Built-in method references that are verified to be native. */ var $630d85f67c7cdfa7$var$DataView = $l9Joq($ctdLC, "DataView");
module.exports = $630d85f67c7cdfa7$var$DataView;

});

parcelRegister("j2XyS", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");

var $ctdLC = parcelRequire("ctdLC");
/* Built-in method references that are verified to be native. */ var $dddc67e5209a8119$var$Promise = $l9Joq($ctdLC, "Promise");
module.exports = $dddc67e5209a8119$var$Promise;

});

parcelRegister("glcO6", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");

var $ctdLC = parcelRequire("ctdLC");
/* Built-in method references that are verified to be native. */ var $be588abc691b8b3a$var$Set = $l9Joq($ctdLC, "Set");
module.exports = $be588abc691b8b3a$var$Set;

});

parcelRegister("iQI9p", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");

var $ctdLC = parcelRequire("ctdLC");
/* Built-in method references that are verified to be native. */ var $db8f54be985e45ce$var$WeakMap = $l9Joq($ctdLC, "WeakMap");
module.exports = $db8f54be985e45ce$var$WeakMap;

});





parcelRegister("iMC13", function(module, exports) {

var $lEobI = parcelRequire("lEobI");

var $2EF3c = parcelRequire("2EF3c");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $daca32d9eac164c5$var$pick = $2EF3c(function(object, paths) {
    return object == null ? {} : $lEobI(object, paths);
});
module.exports = $daca32d9eac164c5$var$pick;

});
parcelRegister("lEobI", function(module, exports) {

var $bJby9 = parcelRequire("bJby9");

var $hIRtT = parcelRequire("hIRtT");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $fc3018a3bc78cfc1$var$basePick(object, paths) {
    return $bJby9(object, paths, function(value, path) {
        return $hIRtT(object, path);
    });
}
module.exports = $fc3018a3bc78cfc1$var$basePick;

});
parcelRegister("bJby9", function(module, exports) {

var $bn2gh = parcelRequire("bn2gh");

var $cNiFm = parcelRequire("cNiFm");

var $kMSRF = parcelRequire("kMSRF");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $889cdb3c0a94ad10$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $bn2gh(object, path);
        if (predicate(value, path)) $cNiFm(result, $kMSRF(path, object), value);
    }
    return result;
}
module.exports = $889cdb3c0a94ad10$var$basePickBy;

});
parcelRegister("bn2gh", function(module, exports) {

var $kMSRF = parcelRequire("kMSRF");

var $l5LmB = parcelRequire("l5LmB");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $847398cfe622292a$var$baseGet(object, path) {
    path = $kMSRF(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$l5LmB(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $847398cfe622292a$var$baseGet;

});
parcelRegister("kMSRF", function(module, exports) {

var $jeaYM = parcelRequire("jeaYM");

var $1soNa = parcelRequire("1soNa");

var $dDvTW = parcelRequire("dDvTW");

var $5Go2g = parcelRequire("5Go2g");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $f222d95276ee1cf5$var$castPath(value, object) {
    if ($jeaYM(value)) return value;
    return $1soNa(value, object) ? [
        value
    ] : $dDvTW($5Go2g(value));
}
module.exports = $f222d95276ee1cf5$var$castPath;

});
parcelRegister("1soNa", function(module, exports) {

var $jeaYM = parcelRequire("jeaYM");

var $aiPWz = parcelRequire("aiPWz");
/** Used to match property names within property paths. */ var $10fba32a6f2ce409$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $10fba32a6f2ce409$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $10fba32a6f2ce409$var$isKey(value, object) {
    if ($jeaYM(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $aiPWz(value)) return true;
    return $10fba32a6f2ce409$var$reIsPlainProp.test(value) || !$10fba32a6f2ce409$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $10fba32a6f2ce409$var$isKey;

});
parcelRegister("aiPWz", function(module, exports) {

var $8J3X3 = parcelRequire("8J3X3");

var $1RG6v = parcelRequire("1RG6v");
/** `Object#toString` result references. */ var $7803e0c56253d5ca$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7803e0c56253d5ca$var$isSymbol(value) {
    return typeof value == "symbol" || $1RG6v(value) && $8J3X3(value) == $7803e0c56253d5ca$var$symbolTag;
}
module.exports = $7803e0c56253d5ca$var$isSymbol;

});


parcelRegister("dDvTW", function(module, exports) {

var $dmhUi = parcelRequire("dmhUi");
/** Used to match property names within property paths. */ var $9ed7a9ced267b3c3$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $9ed7a9ced267b3c3$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9ed7a9ced267b3c3$var$stringToPath = $dmhUi(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($9ed7a9ced267b3c3$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($9ed7a9ced267b3c3$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $9ed7a9ced267b3c3$var$stringToPath;

});
parcelRegister("dmhUi", function(module, exports) {

var $gojMP = parcelRequire("gojMP");
/** Used as the maximum memoize cache size. */ var $9b9b38677fb3c3e4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $9b9b38677fb3c3e4$var$memoizeCapped(func) {
    var result = $gojMP(func, function(key) {
        if (cache.size === $9b9b38677fb3c3e4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $9b9b38677fb3c3e4$var$memoizeCapped;

});
parcelRegister("gojMP", function(module, exports) {

var $9MyXR = parcelRequire("9MyXR");
/** Error message constants. */ var $beee3c71034070fa$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $beee3c71034070fa$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($beee3c71034070fa$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($beee3c71034070fa$var$memoize.Cache || $9MyXR);
    return memoized;
}
// Expose `MapCache`.
$beee3c71034070fa$var$memoize.Cache = $9MyXR;
module.exports = $beee3c71034070fa$var$memoize;

});



parcelRegister("5Go2g", function(module, exports) {

var $l1ENU = parcelRequire("l1ENU");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $423384f40427cbfc$var$toString(value) {
    return value == null ? "" : $l1ENU(value);
}
module.exports = $423384f40427cbfc$var$toString;

});
parcelRegister("l1ENU", function(module, exports) {

var $c32eD = parcelRequire("c32eD");

var $7pnUh = parcelRequire("7pnUh");

var $jeaYM = parcelRequire("jeaYM");

var $aiPWz = parcelRequire("aiPWz");
/** Used as references for various `Number` constants. */ var $f4e957cd29dd5209$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f4e957cd29dd5209$var$symbolProto = $c32eD ? $c32eD.prototype : undefined, $f4e957cd29dd5209$var$symbolToString = $f4e957cd29dd5209$var$symbolProto ? $f4e957cd29dd5209$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f4e957cd29dd5209$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($jeaYM(value)) // Recursively convert values (susceptible to call stack limits).
    return $7pnUh(value, $f4e957cd29dd5209$var$baseToString) + "";
    if ($aiPWz(value)) return $f4e957cd29dd5209$var$symbolToString ? $f4e957cd29dd5209$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f4e957cd29dd5209$var$INFINITY ? "-0" : result;
}
module.exports = $f4e957cd29dd5209$var$baseToString;

});
parcelRegister("7pnUh", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $564d6990657c94c8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $564d6990657c94c8$var$arrayMap;

});




parcelRegister("l5LmB", function(module, exports) {

var $aiPWz = parcelRequire("aiPWz");
/** Used as references for various `Number` constants. */ var $f5aece05b6eaa340$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f5aece05b6eaa340$var$toKey(value) {
    if (typeof value == "string" || $aiPWz(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$f5aece05b6eaa340$var$INFINITY ? "-0" : result;
}
module.exports = $f5aece05b6eaa340$var$toKey;

});


parcelRegister("cNiFm", function(module, exports) {

var $3Ukrd = parcelRequire("3Ukrd");

var $kMSRF = parcelRequire("kMSRF");

var $jHbXc = parcelRequire("jHbXc");

var $8fVgZ = parcelRequire("8fVgZ");

var $l5LmB = parcelRequire("l5LmB");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $95088a5136cacc10$var$baseSet(object, path, value, customizer) {
    if (!$8fVgZ(object)) return object;
    path = $kMSRF(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $l5LmB(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $8fVgZ(objValue) ? objValue : $jHbXc(path[index + 1]) ? [] : {};
        }
        $3Ukrd(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $95088a5136cacc10$var$baseSet;

});
parcelRegister("3Ukrd", function(module, exports) {

var $cTf3R = parcelRequire("cTf3R");

var $3wRDn = parcelRequire("3wRDn");
/** Used for built-in method references. */ var $2d86749c18acaaad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2d86749c18acaaad$var$hasOwnProperty = $2d86749c18acaaad$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2d86749c18acaaad$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($2d86749c18acaaad$var$hasOwnProperty.call(object, key) && $3wRDn(objValue, value)) || value === undefined && !(key in object)) $cTf3R(object, key, value);
}
module.exports = $2d86749c18acaaad$var$assignValue;

});
parcelRegister("cTf3R", function(module, exports) {

var $9Lu45 = parcelRequire("9Lu45");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96264df3d31fb344$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $9Lu45) $9Lu45(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $96264df3d31fb344$var$baseAssignValue;

});
parcelRegister("9Lu45", function(module, exports) {

var $l9Joq = parcelRequire("l9Joq");
var $71bfd31eddd775cc$var$defineProperty = function() {
    try {
        var func = $l9Joq(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $71bfd31eddd775cc$var$defineProperty;

});





parcelRegister("hIRtT", function(module, exports) {

var $eP8D2 = parcelRequire("eP8D2");

var $9VVA0 = parcelRequire("9VVA0");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ce7007f4357314e3$var$hasIn(object, path) {
    return object != null && $9VVA0(object, path, $eP8D2);
}
module.exports = $ce7007f4357314e3$var$hasIn;

});
parcelRegister("eP8D2", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $acac859958716524$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $acac859958716524$var$baseHasIn;

});

parcelRegister("9VVA0", function(module, exports) {

var $kMSRF = parcelRequire("kMSRF");

var $ccPMv = parcelRequire("ccPMv");

var $jeaYM = parcelRequire("jeaYM");

var $jHbXc = parcelRequire("jHbXc");

var $fIdBb = parcelRequire("fIdBb");

var $l5LmB = parcelRequire("l5LmB");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $73b61a0dc4560f6f$var$hasPath(object, path, hasFunc) {
    path = $kMSRF(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $l5LmB(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $fIdBb(length) && $jHbXc(key, length) && ($jeaYM(object) || $ccPMv(object));
}
module.exports = $73b61a0dc4560f6f$var$hasPath;

});



parcelRegister("2EF3c", function(module, exports) {

var $gGjIS = parcelRequire("gGjIS");

var $3gL50 = parcelRequire("3gL50");

var $2xmkH = parcelRequire("2xmkH");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $1eef28f9e18bd463$var$flatRest(func) {
    return $2xmkH($3gL50(func, undefined, $gGjIS), func + "");
}
module.exports = $1eef28f9e18bd463$var$flatRest;

});
parcelRegister("gGjIS", function(module, exports) {

var $1vp3h = parcelRequire("1vp3h");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $c24fde1e1a8fa1c5$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $1vp3h(array, 1) : [];
}
module.exports = $c24fde1e1a8fa1c5$var$flatten;

});
parcelRegister("1vp3h", function(module, exports) {

var $cQIjd = parcelRequire("cQIjd");

var $3nXpW = parcelRequire("3nXpW");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $118c1e7c30fe983d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $3nXpW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $118c1e7c30fe983d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $cQIjd(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $118c1e7c30fe983d$var$baseFlatten;

});
parcelRegister("3nXpW", function(module, exports) {

var $c32eD = parcelRequire("c32eD");

var $ccPMv = parcelRequire("ccPMv");

var $jeaYM = parcelRequire("jeaYM");
/** Built-in value references. */ var $27719c2257c75416$var$spreadableSymbol = $c32eD ? $c32eD.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $27719c2257c75416$var$isFlattenable(value) {
    return $jeaYM(value) || $ccPMv(value) || !!($27719c2257c75416$var$spreadableSymbol && value && value[$27719c2257c75416$var$spreadableSymbol]);
}
module.exports = $27719c2257c75416$var$isFlattenable;

});



parcelRegister("3gL50", function(module, exports) {

var $iNSXf = parcelRequire("iNSXf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $261762cb4675e83e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $261762cb4675e83e$var$overRest(func, start, transform) {
    start = $261762cb4675e83e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $261762cb4675e83e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $iNSXf(func, this, otherArgs);
    };
}
module.exports = $261762cb4675e83e$var$overRest;

});
parcelRegister("iNSXf", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $db076e6c3bd918de$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $db076e6c3bd918de$var$apply;

});


parcelRegister("2xmkH", function(module, exports) {

var $l8gK2 = parcelRequire("l8gK2");

var $dmWM4 = parcelRequire("dmWM4");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1d8ffca7a184d83b$var$setToString = $dmWM4($l8gK2);
module.exports = $1d8ffca7a184d83b$var$setToString;

});
parcelRegister("l8gK2", function(module, exports) {

var $7eko1 = parcelRequire("7eko1");

var $9Lu45 = parcelRequire("9Lu45");

var $3tWIV = parcelRequire("3tWIV");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $f62754d42399a176$var$baseSetToString = !$9Lu45 ? $3tWIV : function(func, string) {
    return $9Lu45(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $7eko1(string),
        "writable": true
    });
};
module.exports = $f62754d42399a176$var$baseSetToString;

});
parcelRegister("7eko1", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $5439a785e49b47bd$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $5439a785e49b47bd$var$constant;

});

parcelRegister("3tWIV", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $2891a1d1fb560659$var$identity(value) {
    return value;
}
module.exports = $2891a1d1fb560659$var$identity;

});


parcelRegister("dmWM4", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9bbaebcaf23f8c94$var$HOT_COUNT = 800, $9bbaebcaf23f8c94$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9bbaebcaf23f8c94$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9bbaebcaf23f8c94$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9bbaebcaf23f8c94$var$nativeNow(), remaining = $9bbaebcaf23f8c94$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9bbaebcaf23f8c94$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $9bbaebcaf23f8c94$var$shortOut;

});




parcelRegister("jkqLX", function(module, exports) {

$parcel$export(module.exports, "Summary", function () { return $dcc9abc87f849024$export$46453a0401d6cd1a; });

var $drmv2 = parcelRequire("drmv2");

var $1vrWl = parcelRequire("1vrWl");

var $gH7Rp = parcelRequire("gH7Rp");

var $7mAg3 = parcelRequire("7mAg3");

var $33dni = parcelRequire("33dni");

var $biy3n = parcelRequire("biy3n");

var $9Sqzr = parcelRequire("9Sqzr");

var $5zf8M = parcelRequire("5zf8M");

var $3aT1w = parcelRequire("3aT1w");
const $dcc9abc87f849024$export$46453a0401d6cd1a = ({ bundle: bundle, offerText: offerText })=>{
    const { bundleFunctions: bundleFunctions } = (0, $7mAg3.usePLPContext)();
    const [currency, setCurrency] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(()=>{
        return window.localStorage.getItem("activeCurrency") || window.default_currency;
    });
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useRef(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState(bundleFunctions.triggerSummary ? bundleFunctions.triggerSummary : false);
    const [formState, setFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useState({
        submitting: false,
        submitted: false,
        error: null
    });
    const [toggleRef, { height: toggleHeight }] = (0, $3aT1w.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        bundleFunctions.handleLowestProduct();
        if (bundleFunctions.triggerSummary) setOpen(true);
        if (bundleFunctions.bundleCount == 0) setOpen(false);
        if (open || bundleFunctions.triggerSummary) {
            bundleFunctions.setTriggerSummary(false);
            const handleClickAway = (event)=>{
                if (document.contains(event.target) && !wrapperRef.current.contains(event.target)) {
                    bundleFunctions.setTriggerSummary(false);
                    setOpen(false);
                }
            };
            document.addEventListener("click", handleClickAway);
            return ()=>{
                document.removeEventListener("click", handleClickAway);
            };
        }
    }, [
        open,
        bundleFunctions.bundleCount,
        bundleFunctions.triggerSummary
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1vrWl))).useEffect(()=>{
        if (open) {
            document.body.classList.add("overflow-hidden");
            return ()=>{
                document.body.classList.remove("overflow-hidden");
            };
        }
    }, [
        open
    ]);
    const handleClick = async (event)=>{
        setFormState((prev)=>({
                ...prev,
                submitting: true,
                submitted: true
            }));
        try {
            const cartNotification = document.querySelector("cart-notification");
            const lineItems = bundle.reduce((acc, product)=>{
                const variantId = product.id;
                acc[variantId] = product.quantity;
                return acc;
            }, {});
            let specialProperties = {};
            if (bundleFunctions.bundleType != "no_bundle") specialProperties["_Special"] = bundleFunctions.bundleType;
            switch(bundleFunctions.bundleType){
                case "bogo":
                    specialProperties["_Discount"] = bundleFunctions.bundleDiscount;
                    specialProperties["_Key"] = bundleFunctions.bundleKey;
                    break;
                case "fixed-price-bundle":
                    specialProperties["_Threshold"] = bundleFunctions.bundleMax;
                    specialProperties["_Discount"] = bundleFunctions.bundleDiscount;
                    specialProperties["_Key"] = bundleFunctions.bundleKey;
                    break;
                case "rollover-bundle":
                    specialProperties["_Threshold"] = bundleFunctions.bundleMax;
                    specialProperties["_Discount"] = bundleFunctions.bundleDiscount;
                    specialProperties["_Key"] = bundleFunctions.bundleKey;
                    break;
            }
            const json = await fetch(`${window.routes.cart_add_url}`, {
                ...window.fetchConfig("javascript"),
                body: JSON.stringify({
                    items: Object.entries(lineItems).map(([id, quantity])=>({
                            id: id,
                            quantity: quantity,
                            properties: specialProperties //{ _Special : 'BOGO50' }
                        })),
                    sections: cartNotification.getSectionsToRender().map((section)=>section.section),
                    sections_url: window.location.pathname
                })
            }).then((response)=>response.json());
            cartNotification.renderContents(json);
            setFormState((prev)=>({
                    ...prev,
                    submitting: false
                }));
            setOpen(false);
            bundleFunctions.clearBundleProducts();
        } catch (error) {
            console.error(error);
            setFormState((prev)=>({
                    ...prev,
                    submitting: false,
                    error: true
                }));
        }
    };
    const styles = {
        "--toggle-height": toggleHeight + "px"
    };
    const regularPrice = bundle.reduce((subtotal, product)=>parseFloat(subtotal) + parseFloat(product.price) * product.quantity, 0);
    const formatPrice = (price)=>{
        if (window.default_currency === currency) return price;
        else return window.Currency?.convert(price, window.default_currency, currency);
    };
    return /*#__PURE__*/ (0, $drmv2.jsx)("div", {
        style: styles,
        className: (0, $biy3n.default)($5zf8M.root, {
            [$5zf8M.open]: bundleFunctions.bundleCount == 0 ? false : open
        }),
        children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
            className: (0, $biy3n.default)($5zf8M.wrapper, {
                [$5zf8M.closed]: !open
            }),
            ref: wrapperRef,
            children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: $5zf8M.container,
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                        "aria-label": window.accessibilityStrings.backToTop,
                        type: "button",
                        className: (0, $biy3n.default)($5zf8M.topButton, "fab"),
                        onClick: (event)=>{
                            event.preventDefault();
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        },
                        children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                            width: 16,
                            height: 16,
                            icon: (0, $gH7Rp.faArrowToTop)
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        ref: toggleRef,
                        children: /*#__PURE__*/ (0, $drmv2.jsxs)("button", {
                            type: "button",
                            className: $5zf8M.toggle,
                            onClick: (event)=>{
                                event.preventDefault();
                                setOpen((prev)=>!prev);
                            },
                            children: [
                                /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                    className: $5zf8M.toggleLabel,
                                    children: [
                                        /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                            className: $5zf8M.toggleTitle,
                                            children: offerText
                                        }),
                                        /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                            className: $5zf8M.toggleSubtitle,
                                            dangerouslySetInnerHTML: {
                                                __html: (0, $9Sqzr.formatLocaleString)(window.bundleStrings.selectedItems, {
                                                    selected: bundleFunctions.bundleCount,
                                                    total: bundleFunctions.currentMax()
                                                })
                                            }
                                        })
                                    ]
                                }),
                                bundleFunctions.bundleCount > 0 && /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                    className: $5zf8M.toggleIcon,
                                    children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                                        icon: (0, $gH7Rp.faPlus),
                                        width: 24,
                                        height: 24
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                        className: $5zf8M.listWrapper,
                        children: /*#__PURE__*/ (0, $drmv2.jsx)("ol", {
                            className: $5zf8M.list,
                            children: bundle.map((product, index)=>{
                                const src = window.Shopify.addSizeToImage(product.featured_image, 320);
                                const srcSet = [
                                    320,
                                    480,
                                    640
                                ].map((width, _, widths)=>`${window.Shopify.addSizeToImage(product.featured_image, width)} ${width / widths[0]}x`).join(", ");
                                const title = product.title.split(" - ")[0];
                                const subtitle = product.title.split(" - ").slice(1).join(" - ");
                                const isDiscountProduct = bundleFunctions.lowestProduct.length && bundleFunctions.lowestProduct.find((prod)=>prod.id == product.id) != undefined;
                                const regularProductPrice = parseFloat(product.price) * product.quantity;
                                let discountedProductPrice = regularProductPrice;
                                switch(bundleFunctions.bundleType){
                                    case "bogo":
                                        let productsTotalWithoutDiscount = parseFloat(product.price) * (product.quantity - product.quantityToDiscount);
                                        let productsTotalWithDiscount = parseFloat(product.price) * (1 - bundleFunctions.bundleDiscount) * product.quantityToDiscount;
                                        // let productTotal = productsTotalWithoutDiscount + productsTotalWithDiscount
                                        // * bundleFunctions.bundleDiscount
                                        // let dif = product.quantityToDiscount * parseFloat(product.price) * (1 - bundleFunctions.bundleDiscount)
                                        discountedProductPrice = parseFloat(productsTotalWithoutDiscount) + parseFloat(productsTotalWithDiscount);
                                        break;
                                    case "fixed-price-bundle":
                                        if (isDiscountProduct) discountedProductPrice = regularProductPrice - product.saved * product.quantityToDiscount;
                                        break;
                                    case "rollover-bundle":
                                        if (isDiscountProduct) discountedProductPrice = regularProductPrice - product.saved * product.quantityToDiscount;
                                        break;
                                }
                                // for (let i = 0; i <= product.quantity; i++) {
                                return /*#__PURE__*/ (0, $drmv2.jsx)("li", {
                                    className: $5zf8M.listItem,
                                    children: /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                        className: $5zf8M.product,
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                className: $5zf8M.productImageWrapper,
                                                children: /*#__PURE__*/ (0, $drmv2.jsx)("div", {
                                                    className: $5zf8M.productImage,
                                                    children: /*#__PURE__*/ (0, $drmv2.jsx)("img", {
                                                        alt: product.title,
                                                        width: 320,
                                                        height: 400,
                                                        src: src,
                                                        srcSet: srcSet,
                                                        loading: "lazy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                className: $5zf8M.productInfo,
                                                children: [
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                        className: $5zf8M.productTitle,
                                                        children: product.product_title
                                                    }),
                                                    product.option1 != "ONE" && /*#__PURE__*/ (0, $drmv2.jsxs)("p", {
                                                        className: $5zf8M.productOption,
                                                        children: [
                                                            product.option_name && /*#__PURE__*/ (0, $drmv2.jsxs)("strong", {
                                                                children: [
                                                                    product.option_name,
                                                                    ": "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                children: product.option1
                                                            })
                                                        ]
                                                    }),
                                                    bundleFunctions.bundleType == "bogo" ? /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {}) : /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {}),
                                                    isDiscountProduct ? /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                                        className: $5zf8M.total,
                                                        children: [
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("s", {
                                                                children: /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                                    className: $5zf8M.productVariantPrice,
                                                                    children: formatPrice(regularProductPrice).toLocaleString(window.Shopify.locale, {
                                                                        currency: currency,
                                                                        style: "currency"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                                className: $5zf8M.productVariantPrice,
                                                                children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                                    children: formatPrice(discountedProductPrice).toLocaleString(window.Shopify.locale, {
                                                                        currency: currency,
                                                                        style: "currency"
                                                                    })
                                                                })
                                                            }),
                                                            isDiscountProduct && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                                children: /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                                                                    className: $5zf8M.itemSavingsBadge,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                            children: bundleFunctions.bundleType == "bogo" ? /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                                                children: formatPrice((parseFloat(product.price) - parseFloat(product.price) * (1 - bundleFunctions.bundleDiscount)) * product.quantityToDiscount).toLocaleString(window.Shopify.locale, {
                                                                                    style: "currency",
                                                                                    currency: currency
                                                                                })
                                                                            }) : bundleFunctions.bundleType == "fixed-price-bundle" && /*#__PURE__*/ (0, $drmv2.jsx)((0, $drmv2.Fragment), {
                                                                                children: formatPrice(parseFloat(regularProductPrice - discountedProductPrice)).toLocaleString(window.Shopify.locale, {
                                                                                    style: "currency",
                                                                                    currency: currency
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                                            children: " Saved"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $drmv2.jsx)("p", {
                                                        className: $5zf8M.productVariantPrice,
                                                        children: formatPrice(regularProductPrice).toLocaleString(window.Shopify.locale, {
                                                            currency: currency,
                                                            style: "currency"
                                                        })
                                                    }),
                                                    product.quantity > 1 && /*#__PURE__*/ (0, $drmv2.jsxs)("p", {
                                                        className: $5zf8M.productQuantity,
                                                        children: [
                                                            /*#__PURE__*/ (0, $drmv2.jsx)("strong", {
                                                                children: "Quantity:"
                                                            }),
                                                            /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    product.quantity
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    bundleFunctions.removeFromBundle(product);
                                                },
                                                className: $5zf8M.productButton,
                                                children: /*#__PURE__*/ (0, $drmv2.jsx)((0, $33dni.FontAwesomeIcon), {
                                                    icon: (0, $gH7Rp.faXmark),
                                                    width: 10,
                                                    height: 10
                                                })
                                            })
                                        ]
                                    })
                                }, product.id + index);
                            // }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                        className: $5zf8M.button,
                        children: [
                            bundle.length > 0 && /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                                className: $5zf8M.total,
                                children: [
                                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        className: "visually-hidden visually-hidden--inline",
                                        children: window.productStrings.regularPrice
                                    }),
                                    bundleFunctions.bundleCount >= bundleFunctions.bundleMax ? /*#__PURE__*/ (0, $drmv2.jsx)("s", {
                                        children: /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                            children: formatPrice(regularPrice).toLocaleString(navigator.language, {
                                                style: "currency",
                                                currency: currency
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                        children: formatPrice(regularPrice).toLocaleString(navigator.language, {
                                            style: "currency",
                                            currency: currency
                                        })
                                    }),
                                    bundleFunctions.bundleCount >= bundleFunctions.bundleMax && /*#__PURE__*/ (0, $drmv2.jsxs)((0, $drmv2.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                className: "visually-hidden visually-hidden--inline",
                                                children: window.productStrings.salePrice
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                children: formatPrice(regularPrice - bundleFunctions.totalSaved).toLocaleString(navigator.language, {
                                                    style: "currency",
                                                    currency: currency
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $drmv2.jsxs)("span", {
                                                className: $5zf8M.badge,
                                                children: [
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                        children: formatPrice(bundleFunctions.totalSaved).toLocaleString(navigator.language, {
                                                            style: "currency",
                                                            currency: currency
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $drmv2.jsx)("span", {
                                                        children: " Saved"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                                onClick: handleClick,
                                type: "button",
                                className: (0, $biy3n.default)($5zf8M.button, {
                                    [$5zf8M.loading]: formState.submitting
                                }) + " " + (0, $biy3n.default)("button button--contained button--full-width", {
                                    loading: formState.submitting
                                }),
                                // className={clsx("button button--contained button--full-width", {
                                //   loading: formState.submitting,
                                // })}
                                //   disabled={!bundleComplete || bundleOversized}
                                disabled: bundleFunctions.bundleMax > bundleFunctions.bundleCount,
                                children: bundleFunctions.bundleMax <= bundleFunctions.bundleCount ? (0, $9Sqzr.formatLocaleString)(window.variantStrings.addToCart) : (0, $9Sqzr.formatLocaleString)(window.bundleStrings.selectMoreItems, {
                                    count: bundleFunctions.bundleMax - bundleFunctions.bundleCount
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});



parcelRegister("bpC5m", function(module, exports) {

$parcel$export(module.exports, "Results", function () { return $9166e5bce8ae41ba$export$4a34de49b46a2bfa; });

var $drmv2 = parcelRequire("drmv2");
parcelRequire("1vrWl");

var $dcsJ5 = parcelRequire("dcsJ5");

var $7mAg3 = parcelRequire("7mAg3");
const $9166e5bce8ae41ba$export$4a34de49b46a2bfa = ()=>{
    const { quizFunctions: quizFunctions } = (0, $dcsJ5.useQuizContext)();
    const { quiz: quiz } = (0, $7mAg3.usePLPContext)();
    return /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
        className: "quiz-results-wrapper container",
        children: [
            /*#__PURE__*/ (0, $drmv2.jsxs)("div", {
                className: "redo",
                children: [
                    /*#__PURE__*/ (0, $drmv2.jsx)("b", {
                        style: {
                            marginRight: "8px"
                        },
                        children: "Something not right?"
                    }),
                    /*#__PURE__*/ (0, $drmv2.jsx)("button", {
                        className: "start-over",
                        onClick: quizFunctions.handleQuizReset,
                        children: "Start Over"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $drmv2.jsx)("h1", {
                children: quizFunctions.title
            })
        ]
    });
}; // OLD DATA
 /*
[
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Clothing Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for shorts?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Short Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What’s your preferred length for leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Legging Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        },
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "black"
        },
        {
          "answer": "Tonal Colours",
          "value": "tonal"
        },
        {
          "answer": "Coloured",
          "value": "coloured"
        },
        {
          "answer": "Patterns",
          "value": "patterns"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
  ]
*/  // NEW DATA
 /*
[
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "facet": "facets.Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Clothing Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for shorts?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Short Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What’s your preferred length for leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Legging Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        },
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "facet": "facets.Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "Black"
        },
        {
          "answer": "Tonal Colours",
          "value": "tonal"
        },
        {
          "answer": "Coloured",
          "value": "coloured"
        },
        {
          "answer": "Patterns",
          "value": "patterns"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "facet": "optionAvailability.Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
]
*/  /* Updated
  [
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Product Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "facet": "facets.Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "Black"
        },
        {
          "answer": "White",
          "value": "White"
        },
        {
          "answer": "Blue",
          "value": "Blue"
        },
        {
          "answer": "Print",
          "value": "Print"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "facet": "optionAvailability.Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
]
*/ 

});



})();
//# sourceMappingURL=QuizCollection.279962d1.js.map
